/*! signiant-javascript-transfer-api - v##transfer_api_version## - 2019-07-30 */

// Copyright (c) Signiant Inc. 
//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

(function() {
  var _global = this;

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng;

  // Allow for MSIE11 msCrypto
  var _crypto = _global.crypto || _global.msCrypto;

  // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
  //
  // Moderately fast, high quality
  if (typeof(_global.require) == 'function') {
    try {
      var _rb = _global.require('crypto').randomBytes;
      _rng = _rb && function() {return _rb(16);};
    } catch(e) {}
  }

  if (!_rng && _crypto && _crypto.getRandomValues) {
    // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
    //
    // Moderately fast, high quality
    var _rnds8 = new Uint8Array(16);
    _rng = function whatwgRNG() {
      _crypto.getRandomValues(_rnds8);
      return _rnds8;
    };
  }

  if (!_rng) {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var  _rnds = new Array(16);
    _rng = function() {
      for (var i = 0, r; i < 16; i++) {
        if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
        _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
      }

      return _rnds;
    };
  }

  // Buffer class to use
  var BufferClass = typeof(_global.Buffer) == 'function' ? _global.Buffer : Array;

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = (buf && offset) || 0, ii = 0;

    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
      if (ii < 16) { // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }

    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return  bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
  ];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0, _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];

    options = options || {};

    var clockseq = options.clockseq != null ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs != null ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs != null ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq == null) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }

    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;

    if (typeof(options) == 'string') {
      buf = options == 'binary' ? new BufferClass(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  uuid.BufferClass = BufferClass;

  if (typeof(module) != 'undefined' && module.exports) {
    // Publish as node.js module
    module.exports = uuid;
  } else { // if (typeof define === 'function' && define.amd) {
    // Publish as AMD module
    //define(function() {return uuid;});

//If require is being used in the app but transfer api is not loaded by require
//uuid is not put into scope. we can load both to be sure we capture uuid in global scope
  //} else {
    // Publish as global (in browsers)
    var _previousRoot = _global.uuid;

    // **`noConflict()` - (browser only) to reset global 'uuid' var**
    uuid.noConflict = function() {
      _global.uuid = _previousRoot;
      return uuid;
    };

    _global.uuid = uuid;
  }
}).call(this);
;/**
 * Created by tvasile on 2015-08-04.
 */
// Version: 3.7.13
(function(){
    var r=!0,y=null,A=!1;function C(){return function(){}}
    window.JSON&&window.JSON.stringify||function(){function a(){try{return this.valueOf()}catch(a){return y}}function c(a){e.lastIndex=0;return e.test(a)?'"'+a.replace(e,function(a){var b=E[a];return"string"===typeof b?b:"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+a+'"'}function b(e,ba){var J,g,N,u,G,E=f,s=ba[e];s&&"object"===typeof s&&(s=a.call(s));"function"===typeof q&&(s=q.call(ba,e,s));switch(typeof s){case "string":return c(s);case "number":return isFinite(s)?String(s):"null";
        case "boolean":case "null":return String(s);case "object":if(!s)return"null";f+=w;G=[];if("[object Array]"===Object.prototype.toString.apply(s)){u=s.length;for(J=0;J<u;J+=1)G[J]=b(J,s)||"null";N=0===G.length?"[]":f?"[\n"+f+G.join(",\n"+f)+"\n"+E+"]":"["+G.join(",")+"]";f=E;return N}if(q&&"object"===typeof q){u=q.length;for(J=0;J<u;J+=1)g=q[J],"string"===typeof g&&(N=b(g,s))&&G.push(c(g)+(f?": ":":")+N)}else for(g in s)Object.hasOwnProperty.call(s,g)&&(N=b(g,s))&&G.push(c(g)+(f?": ":":")+N);N=0===
        G.length?"{}":f?"{\n"+f+G.join(",\n"+f)+"\n"+E+"}":"{"+G.join(",")+"}";f=E;return N}}window.JSON||(window.JSON={});var e=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,f,w,E={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},q;"function"!==typeof JSON.stringify&&(JSON.stringify=function(a,c,e){var g;w=f="";if("number"===typeof e)for(g=0;g<e;g+=1)w+=" ";else"string"===typeof e&&(w=e);if((q=c)&&"function"!==
        typeof c&&("object"!==typeof c||"number"!==typeof c.length))throw Error("JSON.stringify");return b("",{"":a})});"function"!==typeof JSON.parse&&(JSON.parse=function(a){return eval("("+a+")")})}();var aa=1,ca=A,da=[],ea="-pnpres",F=1E3,fa="/",ia="&",la=/{([\w\-]+)}/g;function ma(){return"x"+ ++aa+""+ +new Date}function K(){return+new Date}var na,oa=Math.floor(20*Math.random());na=function(a,c){return 0<a.indexOf("pubsub.")&&a.replace("pubsub","ps"+(c?pa().split("-")[0]:20>++oa?oa:oa=1))||a};
    function qa(a,c){var b=a.join(fa),e=[];if(!c)return b;$(c,function(a,b){var c="object"==typeof b?JSON.stringify(b):b;"undefined"!=typeof b&&(b!=y&&0<encodeURIComponent(c).length)&&e.push(a+"="+encodeURIComponent(c))});return b+="?"+e.join(ia)}function ra(a,c){function b(){f+c>K()?(clearTimeout(e),e=setTimeout(b,c)):(f=K(),a())}var e,f=0;return b}function ta(a,c){var b=[];$(a||[],function(a){c(a)&&b.push(a)});return b}function ua(a,c){return a.replace(la,function(a,e){return c[e]||a})}
    function pa(a){var c="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(a){var c=16*Math.random()|0;return("x"==a?c:c&3|8).toString(16)});a&&a(c);return c}function va(a){return!!a&&"string"!==typeof a&&(Array.isArray&&Array.isArray(a)||"number"===typeof a.length)}function $(a,c){if(a&&c)if(va(a))for(var b=0,e=a.length;b<e;)c.call(a[b],a[b],b++);else for(b in a)a.hasOwnProperty&&a.hasOwnProperty(b)&&c.call(a[b],b,a[b])}
    function wa(a,c){var b=[];$(a||[],function(a,f){b.push(c(a,f))});return b}function xa(a){return encodeURIComponent(a).replace(/[!'()*~]/g,function(a){return"%"+a.charCodeAt(0).toString(16).toUpperCase()})}function ya(a,c){var b=[];$(a,function(a,f){c?0>a.search("-pnpres")&&f.e&&b.push(a):f.e&&b.push(a)});return b.sort()}function za(a,c){var b=[];$(a,function(a,f){c?0>a.search("-pnpres")&&f.e&&b.push(a):f.e&&b.push(a)});return b.sort()}
    function Ha(){setTimeout(function(){ca||(ca=1,$(da,function(a){a()}))},F)}
    function Ia(){function a(a){a=a||{};a.hasOwnProperty("encryptKey")||(a.encryptKey=p.encryptKey);a.hasOwnProperty("keyEncoding")||(a.keyEncoding=p.keyEncoding);a.hasOwnProperty("keyLength")||(a.keyLength=p.keyLength);a.hasOwnProperty("mode")||(a.mode=p.mode);-1==w.indexOf(a.keyEncoding.toLowerCase())&&(a.keyEncoding=p.keyEncoding);-1==E.indexOf(parseInt(a.keyLength,10))&&(a.keyLength=p.keyLength);-1==q.indexOf(a.mode.toLowerCase())&&(a.mode=p.mode);return a}function c(a,b){a="base64"==b.keyEncoding?
        CryptoJS.enc.Base64.parse(a):"hex"==b.keyEncoding?CryptoJS.enc.Hex.parse(a):a;return b.encryptKey?CryptoJS.enc.Utf8.parse(CryptoJS.SHA256(a).toString(CryptoJS.enc.Hex).slice(0,32)):a}function b(a){return"ecb"==a.mode?CryptoJS.mode.ECB:CryptoJS.mode.CBC}function e(a){return"cbc"==a.mode?CryptoJS.enc.Utf8.parse(f):y}var f="0123456789012345",w=["hex","utf8","base64","binary"],E=[128,256],q=["ecb","cbc"],p={encryptKey:r,keyEncoding:"utf8",keyLength:256,mode:"cbc"};return{encrypt:function(f,q,g){if(!q)return f;
        var g=a(g),p=e(g),w=b(g),q=c(q,g),g=JSON.stringify(f);return CryptoJS.AES.encrypt(g,q,{iv:p,mode:w}).ciphertext.toString(CryptoJS.enc.Base64)||f},decrypt:function(f,q,g){if(!q)return f;var g=a(g),p=e(g),w=b(g),q=c(q,g);try{var G=CryptoJS.enc.Base64.parse(f),E=CryptoJS.AES.decrypt({ciphertext:G},q,{iv:p,mode:w}).toString(CryptoJS.enc.Utf8);return JSON.parse(E)}catch(s){}}}}
    if(!window.PUBNUB){var Ja=function(a,c){return CryptoJS.HmacSHA256(a,c).toString(CryptoJS.enc.Base64)},Ma=function(a){return document.getElementById(a)},Na=function(a){console.error(a)},Ta=function(a,c){var b=[];$(a.split(/\s+/),function(a){$((c||document).getElementsByTagName(a),function(a){b.push(a)})});return b},Ua=function(a,c,b){$(a.split(","),function(a){function f(a){a||(a=window.event);b(a)||(a.cancelBubble=r,a.preventDefault&&a.preventDefault(),a.stopPropagation&&a.stopPropagation())}c.addEventListener?
        c.addEventListener(a,f,A):c.attachEvent?c.attachEvent("on"+a,f):c["on"+a]=f})},Va=function(){return Ta("head")[0]},Wa=function(a,c,b){if(b)a.setAttribute(c,b);else return a&&a.getAttribute&&a.getAttribute(c)},Xa=function(a,c){for(var b in c)if(c.hasOwnProperty(b))try{a.style[b]=c[b]+(0<"|width|height|top|left|".indexOf(b)&&"number"==typeof c[b]?"px":"")}catch(e){}},Ya=function(a){return document.createElement(a)},cb=function(){return Za||$a()?0:ma()},db=function(a){function c(a,b){l||(l=1,s.onerror=
        y,clearTimeout(R),a||!b||Ka(b),setTimeout(function(){a&&La();var b=Ma(B),c=b&&b.parentNode;c&&c.removeChild(b)},F))}if(Za||$a()){a:{var b,e,f=function(){if(!E){E=1;clearTimeout(p);try{e=JSON.parse(b.responseText)}catch(a){return u(1)}w=1;g(e)}},w=0,E=0,q=a.timeout||1E4,p=setTimeout(function(){u(1,{message:"timeout"})},q),ba=a.b||C(),J=a.data||{},g=a.c||C(),N=!a.h,u=function(a,c){w||(w=1,clearTimeout(p),b&&(b.onerror=b.onload=y,b.abort&&b.abort(),b=y),a&&ba(c))};try{b=$a()||window.XDomainRequest&&
        new XDomainRequest||new XMLHttpRequest;b.onerror=b.onabort=function(a){u(1,a||b&&b.responseText||{error:"Network Connection Error"})};b.onload=b.onloadend=f;b.onreadystatechange=function(){if(b&&4==b.readyState)switch(b.status){case 200:break;default:try{e=JSON.parse(b.responseText),u(1,e)}catch(a){return u(1,{status:b.status,o:y,message:b.responseText})}}};var G=qa(a.url,J);b.open("GET",G,N);N&&(b.timeout=q);b.send()}catch(Ga){u(0);Za=0;a=db(a);break a}a=u}return a}var s=Ya("script"),f=a.a,B=ma(),
        l=0,R=setTimeout(function(){c(1,{message:"timeout"})},a.timeout||1E4),La=a.b||C(),q=a.data||{},Ka=a.c||C();window[f]=function(a){c(0,a)};a.h||(s[eb]=eb);s.onerror=function(){c(1)};s.src=qa(a.url,q);Wa(s,"id",B);Va().appendChild(s);return c},fb=function(){if(!("onLine"in navigator))return 1;try{return navigator.onLine}catch(a){return r}},$a=function(){if(!gb||!gb.get)return 0;var a={id:$a.id++,send:C(),abort:function(){a.id={}},open:function(c,b){$a[a.id]=a;gb.get(a.id,b)}};return a},eb="async",mb=
        navigator.userAgent,Za=-1==mb.indexOf("MSIE 6");window.console||(window.console=window.console||{});console.log||(console.log=console.error=(window.opera||{}).postError||C());var nb,ob={},pb=A;try{pb=window.localStorage}catch(qb){}var rb=function(a){return-1==document.cookie.indexOf(a)?y:((document.cookie||"").match(RegExp(a+"=([^;]+)"))||[])[1]||y},sb=function(a,c){document.cookie=a+"="+c+"; expires=Thu, 1 Aug 2030 20:00:00 UTC; path=/"},tb;try{sb("pnctest","1"),tb="1"===rb("pnctest")}catch(ub){tb=
        A}nb={get:function(a){try{return pb?pb.getItem(a):tb?rb(a):ob[a]}catch(c){return ob[a]}},set:function(a,c){try{if(pb)return pb.setItem(a,c)&&0;tb&&sb(a,c);ob[a]=c}catch(b){ob[a]=c}}};var vb={list:{},unbind:function(a){vb.list[a]=[]},bind:function(a,c){(vb.list[a]=vb.list[a]||[]).push(c)},fire:function(a,c){$(vb.list[a]||[],function(a){a(c)})}},wb=Ma("pubnub")||0,zb=function(a){function c(){}function b(j,a){function b(a){a&&(Oa=K()-(a/1E4+(K()-d)/2),j&&j(Oa))}var d=K();a&&b(a)||x.time(b)}function e(j,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               a){Aa&&Aa(j,a);Aa=y;clearTimeout(X);clearTimeout(Y)}function f(){yb&&x.time(function(j){b(C(),j);j||e(1,{error:"Heartbeat failed to connect to Pubnub Servers.Please check your network settings."});Y&&clearTimeout(Y);Y=setTimeout(f,ab)})}function w(){Ab()||e(1,{error:"Offline. Please check your network settings. "});X&&clearTimeout(X);X=setTimeout(w,F)}function E(j,a,b,d){var a=j.callback||a,c=j.error||m,v=M(),d=d||{};d.auth||(d.auth=j.auth_key||D);j=[O,"v1","channel-registration","sub-key",t];j.push.apply(j,
        b);v&&(d.callback=v);L({a:v,data:B(d),c:function(j){p(j,a,c)},b:function(j){q(j,c)},url:j})}function q(j,a){if("object"==typeof j&&j.error){var b={};j.message&&(b.message=j.message);j.payload&&(b.payload=j.payload);a&&a(b)}else a&&a(j)}function p(j,a,b){if("object"==typeof j){if(j.error){a={};j.message&&(a.message=j.message);j.payload&&(a.payload=j.payload);b&&b(a);return}if(j.payload){j.next_page?a&&a(j.payload,j.next_page):a&&a(j.payload);return}}a&&a(j)}function ba(j){var a=0;$(ya(H),function(b){if(b=
            H[b])a++,(j||C())(b)});return a}function J(a){var b=0;$(za(S),function(c){if(c=S[c])b++,(a||C())(c)})}function g(a){if(Bb){if(!V.length)return}else{a&&(V.l=0);if(V.l||!V.length)return;V.l=1}L(V.shift())}function N(){!Pa&&u()}function u(){clearTimeout(Ba);!P||500<=P||1>P||!ya(H,r).length&&!za(S,r).length?Pa=A:(Pa=r,x.presence_heartbeat({callback:function(){Ba=setTimeout(u,P*F)},error:function(a){m&&m("Presence Heartbeat unable to reach Pubnub servers."+JSON.stringify(a));Ba=setTimeout(u,P*F)}}))}function G(a,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           b){return Ca.decrypt(a,b||ja)||Ca.decrypt(a,ja)||a}function Ga(a,b,c){var d=A;if("undefined"===typeof a)return b;if("number"===typeof a)d=5<a||0==a?A:r;else{if("boolean"===typeof a)return a?30:0;d=r}return d?(c&&c("Presence Heartbeat value invalid. Valid range ( x > 5 or x = 0). Current Value : "+(b||5)),b||5):a}function s(a){var b="",c=[];$(a,function(a){c.push(a)});var d=c.sort(),i;for(i in d){var v=d[i],b=b+(v+"="+xa(a[v]));i!=d.length-1&&(b+="&")}return b}function B(a){a||(a={});$(hb,function(b,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 c){b in a||(a[b]=c)});return a}function l(a){return zb(a)}Za=a.jsonp?0:-1==mb.indexOf("MSIE 6");var R=a.subscribe_key||"";a.uuid||nb.get(R+"uuid");var La=a.leave_on_unload||0;a.xdr=db;a.db=nb;a.error=a.error||Na;a._is_online=fb;a.jsonp_cb=cb;a.hmac_SHA256=Ja;a.crypto_obj=Ia();a.params={pnsdk:"PubNub-JS-Web/3.7.13"};var Ka=+a.windowing||10,xb=(+a.timeout||310)*F,ab=(+a.keepalive||60)*F,yb=a.timecheck||0,bb=a.noleave||0,Q=a.publish_key||"demo",t=a.subscribe_key||"demo",D=a.auth_key||"",Da=a.secret_key||
        "",ib=a.hmac_SHA256,sa=a.ssl?"s":"",ka="http"+sa+"://"+(a.origin||"pubsub.pubnub.com"),O=na(ka),jb=na(ka),V=[],Qa=r,Oa=0,Ra=0,kb=0,Aa=0,Ea=a.restore||0,ga=0,Sa=A,H={},S={},W={},Ba=y,T=Ga(a.heartbeat||a.pnexpires||0,a.error),P=a.heartbeat_interval||T/2-1,Pa=A,Bb=a.no_wait_for_pending,lb=a["compatible_3.5"]||A,L=a.xdr,hb=a.params||{},m=a.error||C(),Ab=a._is_online||function(){return 1},M=a.jsonp_cb||function(){return 0},ha=a.db||{get:C(),set:C()},ja=a.cipher_key,I=a.uuid||!a.unique_uuid&&ha&&ha.get(t+
            "uuid")||"",Z=a.instance_id||A,U="",X,Y;2===T&&(P=1);var Ca=a.crypto_obj||{encrypt:function(a){return a},decrypt:function(a){return a}},x={LEAVE:function(a,b,c,d,i){var c={uuid:I,auth:c||D},v=na(ka),d=d||C(),z=i||C(),i=M();if(0<a.indexOf(ea))return r;if(lb&&(!sa||"0"==i)||bb)return A;"0"!=i&&(c.callback=i);Z&&(c.instanceid=U);L({h:b||sa,timeout:2E3,a:i,data:B(c),c:function(a){p(a,d,z)},b:function(a){q(a,z)},url:[v,"v2","presence","sub_key",t,"channel",encodeURIComponent(a),"leave"]});return r},LEAVE_GROUP:function(a,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    b,c,d,i){var c={uuid:I,auth:c||D},v=na(ka),d=d||C(),z=i||C(),i=M();if(0<a.indexOf(ea))return r;if(lb&&(!sa||"0"==i)||bb)return A;"0"!=i&&(c.callback=i);a&&0<a.length&&(c["channel-group"]=a);Z&&(c.instanceid=U);L({h:b||sa,timeout:5E3,a:i,data:B(c),c:function(a){p(a,d,z)},b:function(a){q(a,z)},url:[v,"v2","presence","sub_key",t,"channel",encodeURIComponent(","),"leave"]});return r},set_resumed:function(a){Sa=a},get_cipher_key:function(){return ja},set_cipher_key:function(a){ja=a},raw_encrypt:function(a,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            b){return Ca.encrypt(a,b||ja)||a},raw_decrypt:function(a,b){return G(a,b)},get_heartbeat:function(){return T},set_heartbeat:function(a,b){T=Ga(a,T,m);P=b||T/2-1;2==T&&(P=1);c();u()},get_heartbeat_interval:function(){return P},set_heartbeat_interval:function(a){P=a;u()},get_version:function(){return"3.7.13"},getGcmMessageObject:function(a){return{data:a}},getApnsMessageObject:function(a){var b={aps:{badge:1,alert:""}};for(k in a)k[b]=a[k];return b},newPnMessage:function(){var a={};gcm&&(a.pn_gcm=gcm);
        apns&&(a.pn_apns=apns);for(k in n)a[k]=n[k];return a},_add_param:function(a,b){hb[a]=b},channel_group:function(a,b){var c=a.channel_group,b=b||a.callback,d=a.channels||a.channel,i=a.cloak,v,z,h=[],e={},f=a.mode||"add";c&&(c=c.split(":"),1<c.length?(v="*"===c[0]?y:c[0],z=c[1]):z=c[0]);v&&h.push("namespace")&&h.push(encodeURIComponent(v));h.push("channel-group");z&&"*"!==z&&h.push(z);d?(va(d)&&(d=d.join(",")),e[f]=d,e.cloak=Qa?"true":"false"):"remove"===f&&h.push("remove");"undefined"!=typeof i&&(e.cloak=
        i?"true":"false");E(a,b,h,e)},channel_group_list_groups:function(a,b){var c;(c=a.namespace||a.ns||a.channel_group||y)&&(a.channel_group=c+":*");x.channel_group(a,b)},channel_group_list_channels:function(a,b){if(!a.channel_group)return m("Missing Channel Group");x.channel_group(a,b)},channel_group_remove_channel:function(a,b){if(!a.channel_group)return m("Missing Channel Group");if(!a.channel&&!a.channels)return m("Missing Channel");a.mode="remove";x.channel_group(a,b)},channel_group_remove_group:function(a,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      b){if(!a.channel_group)return m("Missing Channel Group");if(a.channel)return m("Use channel_group_remove_channel if you want to remove a channel from a group.");a.mode="remove";x.channel_group(a,b)},channel_group_add_channel:function(a,b){if(!a.channel_group)return m("Missing Channel Group");if(!a.channel&&!a.channels)return m("Missing Channel");x.channel_group(a,b)},channel_group_cloak:function(a,b){"undefined"==typeof a.cloak?b(Qa):(Qa=a.cloak,x.channel_group(a,b))},channel_group_list_namespaces:function(a,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      b){E(a,b,["namespace"])},channel_group_remove_namespace:function(a,b){E(a,b,["namespace",a.namespace,"remove"])},history:function(a,b){var b=a.callback||b,c=a.count||a.limit||100,d=a.reverse||"false",i=a.error||C(),v=a.auth_key||D,z=a.cipher_key,h=a.channel,e=a.channel_group,f=a.start,g=a.end,s=a.include_token,p={},l=M();if(!h&&!e)return m("Missing Channel");if(!b)return m("Missing Callback");if(!t)return m("Missing Subscribe Key");p.stringtoken="true";p.count=c;p.reverse=d;p.auth=v;e&&(p["channel-group"]=
        e,h||(h=","));l&&(p.callback=l);f&&(p.start=f);g&&(p.end=g);s&&(p.include_token="true");L({a:l,data:B(p),c:function(a){if("object"==typeof a&&a.error)i({message:a.message,payload:a.payload});else{for(var j=a[0],c=[],d=0;d<j.length;d++){var h=G(j[d],z);try{c.push(JSON.parse(h))}catch(v){c.push(h)}}b([c,a[1],a[2]])}},b:function(a){q(a,i)},url:[O,"v2","history","sub-key",t,"channel",encodeURIComponent(h)]})},replay:function(a,b){var b=b||a.callback||C(),c=a.auth_key||D,d=a.source,i=a.destination,v=a.stop,
        z=a.start,h=a.end,e=a.reverse,f=a.limit,q=M(),g={};if(!d)return m("Missing Source Channel");if(!i)return m("Missing Destination Channel");if(!Q)return m("Missing Publish Key");if(!t)return m("Missing Subscribe Key");"0"!=q&&(g.callback=q);v&&(g.stop="all");e&&(g.reverse="true");z&&(g.start=z);h&&(g.end=h);f&&(g.count=f);g.auth=c;L({a:q,c:function(a){p(a,b,err)},b:function(){b([0,"Disconnected"])},url:[O,"v1","replay",Q,t,d,i],data:B(g)})},auth:function(a){D=a;c()},time:function(a){var b=M(),c={uuid:I,
        auth:D};Z&&(c.instanceid=U);L({a:b,data:B(c),timeout:5*F,url:[O,"time",b],c:function(b){a(b[0])},b:function(){a(0)}})},publish:function(a,b){var c=a.message;if(!c)return m("Missing Message");var b=b||a.callback||c.callback||C(),d=a.channel||c.channel,i=a.auth_key||D,v=a.cipher_key,z=a.error||c.error||C(),h=a.post||A,e="store_in_history"in a?a.store_in_history:r,f=M(),s="push";a.prepend&&(s="unshift");if(!d)return m("Missing Channel");if(!Q)return m("Missing Publish Key");if(!t)return m("Missing Subscribe Key");
        c.getPubnubMessage&&(c=c.getPubnubMessage());c=JSON.stringify(Ca.encrypt(c,v||ja)||c);c=[O,"publish",Q,t,0,encodeURIComponent(d),f,encodeURIComponent(c)];i={uuid:I,auth:i};e||(i.store="0");Z&&(i.instanceid=U);V[s]({a:f,timeout:5*F,url:c,data:B(i),b:function(a){q(a,z);g(1)},c:function(a){p(a,b,z);g(1)},mode:h?"POST":"GET"});g()},unsubscribe:function(a,b){var e=a.channel,d=a.channel_group,i=a.auth_key||D,b=b||a.callback||C(),f=a.error||C();ga=0;e&&(e=wa((e.join?e.join(","):""+e).split(","),function(a){if(H[a])return a+
        ","+a+ea}).join(","),$(e.split(","),function(a){var c=r;a&&(H[a]=0,a in W&&delete W[a],ca&&(c=x.LEAVE(a,0,i,b,f)),c||b({action:"leave"}))}));d&&(d=wa((d.join?d.join(","):""+d).split(","),function(a){if(S[a])return a+","+a+ea}).join(","),$(d.split(","),function(a){var c=r;a&&(S[a]=0,a in W&&delete W[a],ca&&(c=x.LEAVE_GROUP(a,0,i,b,f)),c||b({action:"leave"}))}));c()},subscribe:function(a,b){function f(a){a?setTimeout(c,Q):(O=na(ka,1),jb=na(ka,1),setTimeout(function(){x.time(f)},F));ba(function(b){if(a&&
        b.d)return b.d=0,b.k(b.name);!a&&!b.d&&(b.d=1,b.j(b.name))});J(function(b){if(a&&b.d)return b.d=0,b.k(b.name);!a&&!b.d&&(b.d=1,b.j(b.name))})}function d(){var a=M(),b=ya(H).join(","),j=za(S).join(",");if(b||j){b||(b=",");e();var i=B({uuid:I,auth:D});j&&(i["channel-group"]=j);2<JSON.stringify(W).length&&(i.state=JSON.stringify(W));T&&(i.heartbeat=T);Z&&(i.instanceid=U);N();Aa=L({timeout:P,a:a,b:function(a){a&&a.error&&a.service?(q(a,p),f(1)):x.time(function(b){!b&&q(a,p);f(b)})},data:B(i),url:[jb,
        "subscribe",t,encodeURIComponent(b),a,ga],c:function(a){if(!a||"object"==typeof a&&"error"in a&&a.error)return p(a.error),setTimeout(c,F);s(a[1]);ga=!ga&&Ea&&ha.get(t)||a[1];ba(function(a){a.f||(a.f=1,a.i(a.name))});J(function(a){a.f||(a.f=1,a.i(a.name))});if(Sa&&!Ea)ga=0,Sa=A,ha.set(t,0);else{w&&(ga=1E4,w=0);ha.set(t,a[1]);var b,j="",i="";3<a.length?(j=a[3],i=a[2]):j=2<a.length?a[2]:wa(ya(H),function(b){return wa(Array(a[0].length).join(",").split(","),function(){return b})}).join(",");var e=j.split(","),
        f=i?i.split(","):[];b=function(){var a=e.shift()||kb,b=f.shift(),c={};b?(a&&(0<=a.indexOf("-pnpres")&&0>b.indexOf("-pnpres"))&&(b+="-pnpres"),c=S[b]||H[b]||{callback:C()}):c=H[a];a=[c.a||Ra,a.split(ea)[0]];b&&a.push(b.split(ea)[0]);return a};var h=K()-Oa-+a[1]/1E4;$(a[0],function(c){var j=b(),c=G(c,H[j[1]]?H[j[1]].cipher_key:y);j[0]&&j[0](c,a,j[2]||j[1],h,j[1])})}setTimeout(d,Q)}})}}var i=a.channel,v=a.channel_group,b=(b=b||a.callback)||a.message,z=a.connect||C(),h=a.reconnect||C(),g=a.disconnect||
        C(),p=a.error||p||C(),s=a.idle||C(),l=a.presence||0,u=a.noheresync||0,w=a.backfill||0,E=a.timetoken||0,P=a.timeout||xb,Q=a.windowing||Ka,R=a.state,V=a.heartbeat||a.pnexpires,X=a.heartbeat_interval,Y=a.restore||Ea;D=a.auth_key||D;Ea=Y;ga=E;if(!i&&!v)return m("Missing Channel");if(!b)return m("Missing Callback");if(!t)return m("Missing Subscribe Key");(V||0===V||X||0===X)&&x.set_heartbeat(V,X);i&&$((i.join?i.join(","):""+i).split(","),function(c){var d=H[c]||{};H[kb=c]={name:c,f:d.f,d:d.d,e:1,a:Ra=
        b,cipher_key:a.cipher_key,i:z,j:g,k:h};R&&(W[c]=c in R?R[c]:R);l&&(x.subscribe({channel:c+ea,callback:l,restore:Y}),!d.e&&!u&&x.here_now({channel:c,data:B({uuid:I,auth:D}),callback:function(a){$("uuids"in a?a.uuids:[],function(b){l({action:"join",uuid:b,timestamp:Math.floor(K()/1E3),occupancy:a.occupancy||1},a,c)})}}))});v&&$((v.join?v.join(","):""+v).split(","),function(c){var d=S[c]||{};S[c]={name:c,f:d.f,d:d.d,e:1,a:Ra=b,cipher_key:a.cipher_key,i:z,j:g,k:h};l&&(x.subscribe({channel_group:c+ea,
        callback:l,restore:Y,auth_key:D}),!d.e&&!u&&x.here_now({channel_group:c,data:B({uuid:I,auth:D}),callback:function(a){$("uuids"in a?a.uuids:[],function(b){l({action:"join",uuid:b,timestamp:Math.floor(K()/1E3),occupancy:a.occupancy||1},a,c)})}}))});c=function(){e();setTimeout(d,Q)};if(!ca)return da.push(c);c()},here_now:function(a,b){var b=a.callback||b,c=a.error||C(),d=a.auth_key||D,i=a.channel,e=a.channel_group,f=M(),h=a.state,d={uuid:I,auth:d};if(!("uuids"in a?a.uuids:1))d.disable_uuids=1;h&&(d.state=
        1);if(!b)return m("Missing Callback");if(!t)return m("Missing Subscribe Key");h=[O,"v2","presence","sub_key",t];i&&h.push("channel")&&h.push(encodeURIComponent(i));"0"!=f&&(d.callback=f);e&&(d["channel-group"]=e,!i&&h.push("channel")&&h.push(","));Z&&(d.instanceid=U);L({a:f,data:B(d),c:function(a){p(a,b,c)},b:function(a){q(a,c)},url:h})},where_now:function(a,b){var b=a.callback||b,c=a.error||C(),d=a.auth_key||D,i=M(),e=a.uuid||I,d={auth:d};if(!b)return m("Missing Callback");if(!t)return m("Missing Subscribe Key");
        "0"!=i&&(d.callback=i);Z&&(d.instanceid=U);L({a:i,data:B(d),c:function(a){p(a,b,c)},b:function(a){q(a,c)},url:[O,"v2","presence","sub_key",t,"uuid",encodeURIComponent(e)]})},state:function(a,b){var b=a.callback||b||C(),c=a.error||C(),d=a.auth_key||D,i=M(),e=a.state,f=a.uuid||I,h=a.channel,g=a.channel_group,d=B({auth:d});if(!t)return m("Missing Subscribe Key");if(!f)return m("Missing UUID");if(!h&&!g)return m("Missing Channel");"0"!=i&&(d.callback=i);"undefined"!=typeof h&&H[h]&&H[h].e&&e&&(W[h]=e);
        "undefined"!=typeof g&&(S[g]&&S[g].e)&&(e&&(W[g]=e),d["channel-group"]=g,h||(h=","));d.state=JSON.stringify(e);Z&&(d.instanceid=U);e=e?[O,"v2","presence","sub-key",t,"channel",h,"uuid",f,"data"]:[O,"v2","presence","sub-key",t,"channel",h,"uuid",encodeURIComponent(f)];L({a:i,data:B(d),c:function(a){p(a,b,c)},b:function(a){q(a,c)},url:e})},grant:function(a,b){var b=a.callback||b,c=a.error||C(),d=a.channel||a.channels,e=a.channel_group,f=M(),g=a.ttl,h=a.read?"1":"0",l=a.write?"1":"0",x=a.manage?"1":
        "0",u=a.auth_key||a.auth_keys;if(!b)return m("Missing Callback");if(!t)return m("Missing Subscribe Key");if(!Q)return m("Missing Publish Key");if(!Da)return m("Missing Secret Key");var w=t+"\n"+Q+"\ngrant\n",h={w:l,r:h,timestamp:Math.floor((new Date).getTime()/1E3)};a.manage&&(h.m=x);va(d)&&(d=d.join(","));va(u)&&(u=u.join(","));"undefined"!=typeof d&&(d!=y&&0<d.length)&&(h.channel=d);"undefined"!=typeof e&&(e!=y&&0<e.length)&&(h["channel-group"]=e);"0"!=f&&(h.callback=f);if(g||0===g)h.ttl=g;u&&(h.auth=
        u);h=B(h);u||delete h.auth;w+=s(h);d=ib(w,Da);d=d.replace(/\+/g,"-");d=d.replace(/\//g,"_");h.signature=d;L({a:f,data:h,c:function(a){p(a,b,c)},b:function(a){q(a,c)},url:[O,"v1","auth","grant","sub-key",t]})},mobile_gw_provision:function(a){var b=a.callback||C(),c=a.auth_key||D,d=a.error||C(),e=M(),f=a.channel,g=a.op,h=a.gw_type,a=a.device_id;if(!a)return m("Missing Device ID (device_id)");if(!h)return m("Missing GW Type (gw_type: gcm or apns)");if(!g)return m("Missing GW Operation (op: add or remove)");
        if(!f)return m("Missing gw destination Channel (channel)");if(!Q)return m("Missing Publish Key");if(!t)return m("Missing Subscribe Key");a=[O,"v1/push/sub-key",t,"devices",a];c={uuid:I,auth:c,type:h};"add"==g?c.add=f:"remove"==g&&(c.remove=f);Z&&(data.instanceid=U);L({a:e,data:c,c:function(a){p(a,b,d)},b:function(a){q(a,d)},url:a})},audit:function(a,b){var b=a.callback||b,c=a.error||C(),d=a.channel,e=a.channel_group,f=a.auth_key,g=M();if(!b)return m("Missing Callback");if(!t)return m("Missing Subscribe Key");
        if(!Q)return m("Missing Publish Key");if(!Da)return m("Missing Secret Key");var h=t+"\n"+Q+"\naudit\n",l={timestamp:Math.floor((new Date).getTime()/1E3)};"0"!=g&&(l.callback=g);"undefined"!=typeof d&&(d!=y&&0<d.length)&&(l.channel=d);"undefined"!=typeof e&&(e!=y&&0<e.length)&&(l["channel-group"]=e);f&&(l.auth=f);l=B(l);f||delete l.auth;h+=s(l);d=ib(h,Da);d=d.replace(/\+/g,"-");d=d.replace(/\//g,"_");l.signature=d;L({a:g,data:l,c:function(a){p(a,b,c)},b:function(a){q(a,c)},url:[O,"v1","auth","audit",
            "sub-key",t]})},revoke:function(a,b){a.read=A;a.write=A;x.grant(a,b)},set_uuid:function(a){I=a;c()},get_uuid:function(){return I},isArray:function(a){return va(a)},get_subscibed_channels:function(){return ya(H,r)},presence_heartbeat:function(a){var b=a.callback||C(),c=a.error||C(),a=M(),d={uuid:I,auth:D};2<JSON.stringify(W).length&&(d.state=JSON.stringify(W));0<T&&320>T&&(d.heartbeat=T);"0"!=a&&(d.callback=a);var e;e=ya(H,r).join(",");e=encodeURIComponent(e);var f=za(S,r).join(",");e||(e=",");f&&
    (d["channel-group"]=f);Z&&(d.instanceid=U);L({a:a,data:B(d),timeout:5*F,url:[O,"v2","presence","sub-key",t,"channel",e,"heartbeat"],c:function(a){p(a,b,c)},b:function(a){q(a,c)}})},stop_timers:function(){clearTimeout(X);clearTimeout(Y)},xdr:L,ready:Ha,db:ha,uuid:pa,map:wa,each:$,"each-channel":ba,grep:ta,offline:function(){e(1,{message:"Offline. Please check your network settings."})},supplant:ua,now:K,unique:ma,updater:ra};I||(I=x.uuid());U||(U=x.uuid());ha.set(t+"uuid",I);X=setTimeout(w,F);Y=setTimeout(f,
        ab);Ba=setTimeout(N,(P-3)*F);b();var R=x,Fa;for(Fa in R)R.hasOwnProperty(Fa)&&(l[Fa]=R[Fa]);l.css=Xa;l.$=Ma;l.create=Ya;l.bind=Ua;l.head=Va;l.search=Ta;l.attr=Wa;l.events=vb;l.init=l;l.secure=l;l.crypto_obj=Ia();Ua("beforeunload",window,function(){if(La)l["each-channel"](function(a){l.LEAVE(a.name,0)});return r});if(a.notest)return l;Ua("offline",window,l.offline);Ua("offline",document,l.offline);return l};zb.init=zb;zb.secure=zb;zb.crypto_obj=Ia();"complete"===document.readyState?setTimeout(Ha,0):
        Ua("load",window,function(){setTimeout(Ha,0)});var Cb=wb||{};PUBNUB=zb({notest:1,publish_key:Wa(Cb,"pub-key"),subscribe_key:Wa(Cb,"sub-key"),ssl:!document.location.href.indexOf("https")||"on"==Wa(Cb,"ssl"),origin:Wa(Cb,"origin"),uuid:Wa(Cb,"uuid")});window.jQuery&&(window.jQuery.PUBNUB=zb);"undefined"!==typeof module&&(module.exports=PUBNUB)&&Ha();var gb=Ma("pubnubs")||0;if(wb){Xa(wb,{position:"absolute",top:-F});if("opera"in window||Wa(wb,"flash"))wb.innerHTML="<object id=pubnubs data=https://pubnub.a.ssl.fastly.net/pubnub.swf><param name=movie value=https://pubnub.a.ssl.fastly.net/pubnub.swf><param name=allowscriptaccess value=always></object>";
        PUBNUB.rdx=function(a,c){if(!c)return $a[a].onerror();$a[a].responseText=unescape(c);$a[a].onload()};$a.id=F}}
    var Db=PUBNUB.ws=function(a,c){if(!(this instanceof Db))return new Db(a,c);var b=this,a=b.url=a||"";b.protocol=c||"Sec-WebSocket-Protocol";var e=a.split("/"),e={ssl:"wss:"===e[0],origin:e[2],publish_key:e[3],subscribe_key:e[4],channel:e[5]};b.CONNECTING=0;b.OPEN=1;b.CLOSING=2;b.CLOSED=3;b.CLOSE_NORMAL=1E3;b.CLOSE_GOING_AWAY=1001;b.CLOSE_PROTOCOL_ERROR=1002;b.CLOSE_UNSUPPORTED=1003;b.CLOSE_TOO_LARGE=1004;b.CLOSE_NO_STATUS=1005;b.CLOSE_ABNORMAL=1006;b.onclose=b.onerror=b.onmessage=b.onopen=b.onsend=
        C();b.binaryType="";b.extensions="";b.bufferedAmount=0;b.trasnmitting=A;b.buffer=[];b.readyState=b.CONNECTING;if(!a)return b.readyState=b.CLOSED,b.onclose({code:b.CLOSE_ABNORMAL,reason:"Missing URL",wasClean:r}),b;b.g=PUBNUB.init(e);b.g.n=e;b.n=e;b.g.subscribe({restore:A,channel:e.channel,disconnect:b.onerror,reconnect:b.onopen,error:function(){b.onclose({code:b.CLOSE_ABNORMAL,reason:"Missing URL",wasClean:A})},callback:function(a){b.onmessage({data:a})},connect:function(){b.readyState=b.OPEN;b.onopen()}})};
    Db.prototype.send=function(a){var c=this;c.g.publish({channel:c.g.n.channel,message:a,callback:function(a){c.onsend({data:a})}})};
})();
/*
 CryptoJS v3.1.2
 code.google.com/p/crypto-js
 (c) 2009-2013 by Jeff Mott. All rights reserved.
 code.google.com/p/crypto-js/wiki/License
 */
var CryptoJS=CryptoJS||function(h,s){var f={},g=f.lib={},q=function(){},m=g.Base={extend:function(a){q.prototype=this;var c=new q;a&&c.mixIn(a);c.hasOwnProperty("init")||(c.init=function(){c.$super.init.apply(this,arguments)});c.init.prototype=c;c.$super=this;return c},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var c in a)a.hasOwnProperty(c)&&(this[c]=a[c]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.init.prototype.extend(this)}},
        r=g.WordArray=m.extend({init:function(a,c){a=this.words=a||[];this.sigBytes=c!=s?c:4*a.length},toString:function(a){return(a||k).stringify(this)},concat:function(a){var c=this.words,d=a.words,b=this.sigBytes;a=a.sigBytes;this.clamp();if(b%4)for(var e=0;e<a;e++)c[b+e>>>2]|=(d[e>>>2]>>>24-8*(e%4)&255)<<24-8*((b+e)%4);else if(65535<d.length)for(e=0;e<a;e+=4)c[b+e>>>2]=d[e>>>2];else c.push.apply(c,d);this.sigBytes+=a;return this},clamp:function(){var a=this.words,c=this.sigBytes;a[c>>>2]&=4294967295<<
            32-8*(c%4);a.length=h.ceil(c/4)},clone:function(){var a=m.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var c=[],d=0;d<a;d+=4)c.push(4294967296*h.random()|0);return new r.init(c,a)}}),l=f.enc={},k=l.Hex={stringify:function(a){var c=a.words;a=a.sigBytes;for(var d=[],b=0;b<a;b++){var e=c[b>>>2]>>>24-8*(b%4)&255;d.push((e>>>4).toString(16));d.push((e&15).toString(16))}return d.join("")},parse:function(a){for(var c=a.length,d=[],b=0;b<c;b+=2)d[b>>>3]|=parseInt(a.substr(b,
                2),16)<<24-4*(b%8);return new r.init(d,c/2)}},n=l.Latin1={stringify:function(a){var c=a.words;a=a.sigBytes;for(var d=[],b=0;b<a;b++)d.push(String.fromCharCode(c[b>>>2]>>>24-8*(b%4)&255));return d.join("")},parse:function(a){for(var c=a.length,d=[],b=0;b<c;b++)d[b>>>2]|=(a.charCodeAt(b)&255)<<24-8*(b%4);return new r.init(d,c)}},j=l.Utf8={stringify:function(a){try{return decodeURIComponent(escape(n.stringify(a)))}catch(c){throw Error("Malformed UTF-8 data");}},parse:function(a){return n.parse(unescape(encodeURIComponent(a)))}},
        u=g.BufferedBlockAlgorithm=m.extend({reset:function(){this._data=new r.init;this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=j.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var c=this._data,d=c.words,b=c.sigBytes,e=this.blockSize,f=b/(4*e),f=a?h.ceil(f):h.max((f|0)-this._minBufferSize,0);a=f*e;b=h.min(4*a,b);if(a){for(var g=0;g<a;g+=e)this._doProcessBlock(d,g);g=d.splice(0,a);c.sigBytes-=b}return new r.init(g,b)},clone:function(){var a=m.clone.call(this);
            a._data=this._data.clone();return a},_minBufferSize:0});g.Hasher=u.extend({cfg:m.extend(),init:function(a){this.cfg=this.cfg.extend(a);this.reset()},reset:function(){u.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);return this._doFinalize()},blockSize:16,_createHelper:function(a){return function(c,d){return(new a.init(d)).finalize(c)}},_createHmacHelper:function(a){return function(c,d){return(new t.HMAC.init(a,
        d)).finalize(c)}}});var t=f.algo={};return f}(Math);

// SHA256
(function(h){for(var s=CryptoJS,f=s.lib,g=f.WordArray,q=f.Hasher,f=s.algo,m=[],r=[],l=function(a){return 4294967296*(a-(a|0))|0},k=2,n=0;64>n;){var j;a:{j=k;for(var u=h.sqrt(j),t=2;t<=u;t++)if(!(j%t)){j=!1;break a}j=!0}j&&(8>n&&(m[n]=l(h.pow(k,0.5))),r[n]=l(h.pow(k,1/3)),n++);k++}var a=[],f=f.SHA256=q.extend({_doReset:function(){this._hash=new g.init(m.slice(0))},_doProcessBlock:function(c,d){for(var b=this._hash.words,e=b[0],f=b[1],g=b[2],j=b[3],h=b[4],m=b[5],n=b[6],q=b[7],p=0;64>p;p++){if(16>p)a[p]=
    c[d+p]|0;else{var k=a[p-15],l=a[p-2];a[p]=((k<<25|k>>>7)^(k<<14|k>>>18)^k>>>3)+a[p-7]+((l<<15|l>>>17)^(l<<13|l>>>19)^l>>>10)+a[p-16]}k=q+((h<<26|h>>>6)^(h<<21|h>>>11)^(h<<7|h>>>25))+(h&m^~h&n)+r[p]+a[p];l=((e<<30|e>>>2)^(e<<19|e>>>13)^(e<<10|e>>>22))+(e&f^e&g^f&g);q=n;n=m;m=h;h=j+k|0;j=g;g=f;f=e;e=k+l|0}b[0]=b[0]+e|0;b[1]=b[1]+f|0;b[2]=b[2]+g|0;b[3]=b[3]+j|0;b[4]=b[4]+h|0;b[5]=b[5]+m|0;b[6]=b[6]+n|0;b[7]=b[7]+q|0},_doFinalize:function(){var a=this._data,d=a.words,b=8*this._nDataBytes,e=8*a.sigBytes;
    d[e>>>5]|=128<<24-e%32;d[(e+64>>>9<<4)+14]=h.floor(b/4294967296);d[(e+64>>>9<<4)+15]=b;a.sigBytes=4*d.length;this._process();return this._hash},clone:function(){var a=q.clone.call(this);a._hash=this._hash.clone();return a}});s.SHA256=q._createHelper(f);s.HmacSHA256=q._createHmacHelper(f)})(Math);

// HMAC SHA256
(function(){var h=CryptoJS,s=h.enc.Utf8;h.algo.HMAC=h.lib.Base.extend({init:function(f,g){f=this._hasher=new f.init;"string"==typeof g&&(g=s.parse(g));var h=f.blockSize,m=4*h;g.sigBytes>m&&(g=f.finalize(g));g.clamp();for(var r=this._oKey=g.clone(),l=this._iKey=g.clone(),k=r.words,n=l.words,j=0;j<h;j++)k[j]^=1549556828,n[j]^=909522486;r.sigBytes=l.sigBytes=m;this.reset()},reset:function(){var f=this._hasher;f.reset();f.update(this._iKey)},update:function(f){this._hasher.update(f);return this},finalize:function(f){var g=
    this._hasher;f=g.finalize(f);g.reset();return g.finalize(this._oKey.clone().concat(f))}})})();

// Base64
(function(){var u=CryptoJS,p=u.lib.WordArray;u.enc.Base64={stringify:function(d){var l=d.words,p=d.sigBytes,t=this._map;d.clamp();d=[];for(var r=0;r<p;r+=3)for(var w=(l[r>>>2]>>>24-8*(r%4)&255)<<16|(l[r+1>>>2]>>>24-8*((r+1)%4)&255)<<8|l[r+2>>>2]>>>24-8*((r+2)%4)&255,v=0;4>v&&r+0.75*v<p;v++)d.push(t.charAt(w>>>6*(3-v)&63));if(l=t.charAt(64))for(;d.length%4;)d.push(l);return d.join("")},parse:function(d){var l=d.length,s=this._map,t=s.charAt(64);t&&(t=d.indexOf(t),-1!=t&&(l=t));for(var t=[],r=0,w=0;w<
l;w++)if(w%4){var v=s.indexOf(d.charAt(w-1))<<2*(w%4),b=s.indexOf(d.charAt(w))>>>6-2*(w%4);t[r>>>2]|=(v|b)<<24-8*(r%4);r++}return p.create(t,r)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}})();

// BlockCipher
(function(u){function p(b,n,a,c,e,j,k){b=b+(n&a|~n&c)+e+k;return(b<<j|b>>>32-j)+n}function d(b,n,a,c,e,j,k){b=b+(n&c|a&~c)+e+k;return(b<<j|b>>>32-j)+n}function l(b,n,a,c,e,j,k){b=b+(n^a^c)+e+k;return(b<<j|b>>>32-j)+n}function s(b,n,a,c,e,j,k){b=b+(a^(n|~c))+e+k;return(b<<j|b>>>32-j)+n}for(var t=CryptoJS,r=t.lib,w=r.WordArray,v=r.Hasher,r=t.algo,b=[],x=0;64>x;x++)b[x]=4294967296*u.abs(u.sin(x+1))|0;r=r.MD5=v.extend({_doReset:function(){this._hash=new w.init([1732584193,4023233417,2562383102,271733878])},
    _doProcessBlock:function(q,n){for(var a=0;16>a;a++){var c=n+a,e=q[c];q[c]=(e<<8|e>>>24)&16711935|(e<<24|e>>>8)&4278255360}var a=this._hash.words,c=q[n+0],e=q[n+1],j=q[n+2],k=q[n+3],z=q[n+4],r=q[n+5],t=q[n+6],w=q[n+7],v=q[n+8],A=q[n+9],B=q[n+10],C=q[n+11],u=q[n+12],D=q[n+13],E=q[n+14],x=q[n+15],f=a[0],m=a[1],g=a[2],h=a[3],f=p(f,m,g,h,c,7,b[0]),h=p(h,f,m,g,e,12,b[1]),g=p(g,h,f,m,j,17,b[2]),m=p(m,g,h,f,k,22,b[3]),f=p(f,m,g,h,z,7,b[4]),h=p(h,f,m,g,r,12,b[5]),g=p(g,h,f,m,t,17,b[6]),m=p(m,g,h,f,w,22,b[7]),
        f=p(f,m,g,h,v,7,b[8]),h=p(h,f,m,g,A,12,b[9]),g=p(g,h,f,m,B,17,b[10]),m=p(m,g,h,f,C,22,b[11]),f=p(f,m,g,h,u,7,b[12]),h=p(h,f,m,g,D,12,b[13]),g=p(g,h,f,m,E,17,b[14]),m=p(m,g,h,f,x,22,b[15]),f=d(f,m,g,h,e,5,b[16]),h=d(h,f,m,g,t,9,b[17]),g=d(g,h,f,m,C,14,b[18]),m=d(m,g,h,f,c,20,b[19]),f=d(f,m,g,h,r,5,b[20]),h=d(h,f,m,g,B,9,b[21]),g=d(g,h,f,m,x,14,b[22]),m=d(m,g,h,f,z,20,b[23]),f=d(f,m,g,h,A,5,b[24]),h=d(h,f,m,g,E,9,b[25]),g=d(g,h,f,m,k,14,b[26]),m=d(m,g,h,f,v,20,b[27]),f=d(f,m,g,h,D,5,b[28]),h=d(h,f,
            m,g,j,9,b[29]),g=d(g,h,f,m,w,14,b[30]),m=d(m,g,h,f,u,20,b[31]),f=l(f,m,g,h,r,4,b[32]),h=l(h,f,m,g,v,11,b[33]),g=l(g,h,f,m,C,16,b[34]),m=l(m,g,h,f,E,23,b[35]),f=l(f,m,g,h,e,4,b[36]),h=l(h,f,m,g,z,11,b[37]),g=l(g,h,f,m,w,16,b[38]),m=l(m,g,h,f,B,23,b[39]),f=l(f,m,g,h,D,4,b[40]),h=l(h,f,m,g,c,11,b[41]),g=l(g,h,f,m,k,16,b[42]),m=l(m,g,h,f,t,23,b[43]),f=l(f,m,g,h,A,4,b[44]),h=l(h,f,m,g,u,11,b[45]),g=l(g,h,f,m,x,16,b[46]),m=l(m,g,h,f,j,23,b[47]),f=s(f,m,g,h,c,6,b[48]),h=s(h,f,m,g,w,10,b[49]),g=s(g,h,f,m,
            E,15,b[50]),m=s(m,g,h,f,r,21,b[51]),f=s(f,m,g,h,u,6,b[52]),h=s(h,f,m,g,k,10,b[53]),g=s(g,h,f,m,B,15,b[54]),m=s(m,g,h,f,e,21,b[55]),f=s(f,m,g,h,v,6,b[56]),h=s(h,f,m,g,x,10,b[57]),g=s(g,h,f,m,t,15,b[58]),m=s(m,g,h,f,D,21,b[59]),f=s(f,m,g,h,z,6,b[60]),h=s(h,f,m,g,C,10,b[61]),g=s(g,h,f,m,j,15,b[62]),m=s(m,g,h,f,A,21,b[63]);a[0]=a[0]+f|0;a[1]=a[1]+m|0;a[2]=a[2]+g|0;a[3]=a[3]+h|0},_doFinalize:function(){var b=this._data,n=b.words,a=8*this._nDataBytes,c=8*b.sigBytes;n[c>>>5]|=128<<24-c%32;var e=u.floor(a/
        4294967296);n[(c+64>>>9<<4)+15]=(e<<8|e>>>24)&16711935|(e<<24|e>>>8)&4278255360;n[(c+64>>>9<<4)+14]=(a<<8|a>>>24)&16711935|(a<<24|a>>>8)&4278255360;b.sigBytes=4*(n.length+1);this._process();b=this._hash;n=b.words;for(a=0;4>a;a++)c=n[a],n[a]=(c<<8|c>>>24)&16711935|(c<<24|c>>>8)&4278255360;return b},clone:function(){var b=v.clone.call(this);b._hash=this._hash.clone();return b}});t.MD5=v._createHelper(r);t.HmacMD5=v._createHmacHelper(r)})(Math);
(function(){var u=CryptoJS,p=u.lib,d=p.Base,l=p.WordArray,p=u.algo,s=p.EvpKDF=d.extend({cfg:d.extend({keySize:4,hasher:p.MD5,iterations:1}),init:function(d){this.cfg=this.cfg.extend(d)},compute:function(d,r){for(var p=this.cfg,s=p.hasher.create(),b=l.create(),u=b.words,q=p.keySize,p=p.iterations;u.length<q;){n&&s.update(n);var n=s.update(d).finalize(r);s.reset();for(var a=1;a<p;a++)n=s.finalize(n),s.reset();b.concat(n)}b.sigBytes=4*q;return b}});u.EvpKDF=function(d,l,p){return s.create(p).compute(d,
    l)}})();

// Cipher
CryptoJS.lib.Cipher||function(u){var p=CryptoJS,d=p.lib,l=d.Base,s=d.WordArray,t=d.BufferedBlockAlgorithm,r=p.enc.Base64,w=p.algo.EvpKDF,v=d.Cipher=t.extend({cfg:l.extend(),createEncryptor:function(e,a){return this.create(this._ENC_XFORM_MODE,e,a)},createDecryptor:function(e,a){return this.create(this._DEC_XFORM_MODE,e,a)},init:function(e,a,b){this.cfg=this.cfg.extend(b);this._xformMode=e;this._key=a;this.reset()},reset:function(){t.reset.call(this);this._doReset()},process:function(e){this._append(e);return this._process()},
    finalize:function(e){e&&this._append(e);return this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(e){return{encrypt:function(b,k,d){return("string"==typeof k?c:a).encrypt(e,b,k,d)},decrypt:function(b,k,d){return("string"==typeof k?c:a).decrypt(e,b,k,d)}}}});d.StreamCipher=v.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var b=p.mode={},x=function(e,a,b){var c=this._iv;c?this._iv=u:c=this._prevBlock;for(var d=0;d<b;d++)e[a+d]^=
    c[d]},q=(d.BlockCipherMode=l.extend({createEncryptor:function(e,a){return this.Encryptor.create(e,a)},createDecryptor:function(e,a){return this.Decryptor.create(e,a)},init:function(e,a){this._cipher=e;this._iv=a}})).extend();q.Encryptor=q.extend({processBlock:function(e,a){var b=this._cipher,c=b.blockSize;x.call(this,e,a,c);b.encryptBlock(e,a);this._prevBlock=e.slice(a,a+c)}});q.Decryptor=q.extend({processBlock:function(e,a){var b=this._cipher,c=b.blockSize,d=e.slice(a,a+c);b.decryptBlock(e,a);x.call(this,
    e,a,c);this._prevBlock=d}});b=b.CBC=q;q=(p.pad={}).Pkcs7={pad:function(a,b){for(var c=4*b,c=c-a.sigBytes%c,d=c<<24|c<<16|c<<8|c,l=[],n=0;n<c;n+=4)l.push(d);c=s.create(l,c);a.concat(c)},unpad:function(a){a.sigBytes-=a.words[a.sigBytes-1>>>2]&255}};d.BlockCipher=v.extend({cfg:v.cfg.extend({mode:b,padding:q}),reset:function(){v.reset.call(this);var a=this.cfg,b=a.iv,a=a.mode;if(this._xformMode==this._ENC_XFORM_MODE)var c=a.createEncryptor;else c=a.createDecryptor,this._minBufferSize=1;this._mode=c.call(a,
    this,b&&b.words)},_doProcessBlock:function(a,b){this._mode.processBlock(a,b)},_doFinalize:function(){var a=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){a.pad(this._data,this.blockSize);var b=this._process(!0)}else b=this._process(!0),a.unpad(b);return b},blockSize:4});var n=d.CipherParams=l.extend({init:function(a){this.mixIn(a)},toString:function(a){return(a||this.formatter).stringify(this)}}),b=(p.format={}).OpenSSL={stringify:function(a){var b=a.ciphertext;a=a.salt;return(a?s.create([1398893684,
    1701076831]).concat(a).concat(b):b).toString(r)},parse:function(a){a=r.parse(a);var b=a.words;if(1398893684==b[0]&&1701076831==b[1]){var c=s.create(b.slice(2,4));b.splice(0,4);a.sigBytes-=16}return n.create({ciphertext:a,salt:c})}},a=d.SerializableCipher=l.extend({cfg:l.extend({format:b}),encrypt:function(a,b,c,d){d=this.cfg.extend(d);var l=a.createEncryptor(c,d);b=l.finalize(b);l=l.cfg;return n.create({ciphertext:b,key:c,iv:l.iv,algorithm:a,mode:l.mode,padding:l.padding,blockSize:a.blockSize,formatter:d.format})},
    decrypt:function(a,b,c,d){d=this.cfg.extend(d);b=this._parse(b,d.format);return a.createDecryptor(c,d).finalize(b.ciphertext)},_parse:function(a,b){return"string"==typeof a?b.parse(a,this):a}}),p=(p.kdf={}).OpenSSL={execute:function(a,b,c,d){d||(d=s.random(8));a=w.create({keySize:b+c}).compute(a,d);c=s.create(a.words.slice(b),4*c);a.sigBytes=4*b;return n.create({key:a,iv:c,salt:d})}},c=d.PasswordBasedCipher=a.extend({cfg:a.cfg.extend({kdf:p}),encrypt:function(b,c,d,l){l=this.cfg.extend(l);d=l.kdf.execute(d,
    b.keySize,b.ivSize);l.iv=d.iv;b=a.encrypt.call(this,b,c,d.key,l);b.mixIn(d);return b},decrypt:function(b,c,d,l){l=this.cfg.extend(l);c=this._parse(c,l.format);d=l.kdf.execute(d,b.keySize,b.ivSize,c.salt);l.iv=d.iv;return a.decrypt.call(this,b,c,d.key,l)}})}();

// AES
(function(){for(var u=CryptoJS,p=u.lib.BlockCipher,d=u.algo,l=[],s=[],t=[],r=[],w=[],v=[],b=[],x=[],q=[],n=[],a=[],c=0;256>c;c++)a[c]=128>c?c<<1:c<<1^283;for(var e=0,j=0,c=0;256>c;c++){var k=j^j<<1^j<<2^j<<3^j<<4,k=k>>>8^k&255^99;l[e]=k;s[k]=e;var z=a[e],F=a[z],G=a[F],y=257*a[k]^16843008*k;t[e]=y<<24|y>>>8;r[e]=y<<16|y>>>16;w[e]=y<<8|y>>>24;v[e]=y;y=16843009*G^65537*F^257*z^16843008*e;b[k]=y<<24|y>>>8;x[k]=y<<16|y>>>16;q[k]=y<<8|y>>>24;n[k]=y;e?(e=z^a[a[a[G^z]]],j^=a[a[j]]):e=j=1}var H=[0,1,2,4,8,
    16,32,64,128,27,54],d=d.AES=p.extend({_doReset:function(){for(var a=this._key,c=a.words,d=a.sigBytes/4,a=4*((this._nRounds=d+6)+1),e=this._keySchedule=[],j=0;j<a;j++)if(j<d)e[j]=c[j];else{var k=e[j-1];j%d?6<d&&4==j%d&&(k=l[k>>>24]<<24|l[k>>>16&255]<<16|l[k>>>8&255]<<8|l[k&255]):(k=k<<8|k>>>24,k=l[k>>>24]<<24|l[k>>>16&255]<<16|l[k>>>8&255]<<8|l[k&255],k^=H[j/d|0]<<24);e[j]=e[j-d]^k}c=this._invKeySchedule=[];for(d=0;d<a;d++)j=a-d,k=d%4?e[j]:e[j-4],c[d]=4>d||4>=j?k:b[l[k>>>24]]^x[l[k>>>16&255]]^q[l[k>>>
8&255]]^n[l[k&255]]},encryptBlock:function(a,b){this._doCryptBlock(a,b,this._keySchedule,t,r,w,v,l)},decryptBlock:function(a,c){var d=a[c+1];a[c+1]=a[c+3];a[c+3]=d;this._doCryptBlock(a,c,this._invKeySchedule,b,x,q,n,s);d=a[c+1];a[c+1]=a[c+3];a[c+3]=d},_doCryptBlock:function(a,b,c,d,e,j,l,f){for(var m=this._nRounds,g=a[b]^c[0],h=a[b+1]^c[1],k=a[b+2]^c[2],n=a[b+3]^c[3],p=4,r=1;r<m;r++)var q=d[g>>>24]^e[h>>>16&255]^j[k>>>8&255]^l[n&255]^c[p++],s=d[h>>>24]^e[k>>>16&255]^j[n>>>8&255]^l[g&255]^c[p++],t=
    d[k>>>24]^e[n>>>16&255]^j[g>>>8&255]^l[h&255]^c[p++],n=d[n>>>24]^e[g>>>16&255]^j[h>>>8&255]^l[k&255]^c[p++],g=q,h=s,k=t;q=(f[g>>>24]<<24|f[h>>>16&255]<<16|f[k>>>8&255]<<8|f[n&255])^c[p++];s=(f[h>>>24]<<24|f[k>>>16&255]<<16|f[n>>>8&255]<<8|f[g&255])^c[p++];t=(f[k>>>24]<<24|f[n>>>16&255]<<16|f[g>>>8&255]<<8|f[h&255])^c[p++];n=(f[n>>>24]<<24|f[g>>>16&255]<<16|f[h>>>8&255]<<8|f[k&255])^c[p++];a[b]=q;a[b+1]=s;a[b+2]=t;a[b+3]=n},keySize:8});u.AES=p._createHelper(d)})();

// Mode ECB
CryptoJS.mode.ECB = (function () {
    var ECB = CryptoJS.lib.BlockCipherMode.extend();

    ECB.Encryptor = ECB.extend({
        processBlock: function (words, offset) {
            this._cipher.encryptBlock(words, offset);
        }
    });

    ECB.Decryptor = ECB.extend({
        processBlock: function (words, offset) {
            this._cipher.decryptBlock(words, offset);
        }
    });

    return ECB;
}());// Moved to hmac-sha-256.js
;/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/

(function UMD(name,context,definition){
	// special form of UMD for polyfilling across evironments
	context[name] = context[name] || definition();
    //PDH: Need to comment these out to get the system to when clients have RequireJS (like MediaShuttle)
	//if (typeof module != "undefined" && module.exports) { module.exports = context[name]; }
	//else if (typeof define == "function" && define.amd) { define(function $AMD$(){ return context[name]; }); }
})("Promise",typeof global != "undefined" ? global : this,function DEF(){
	/*jshint validthis:true */
	"use strict";

	var builtInProp, cycle, scheduling_queue,
		ToString = Object.prototype.toString,
		timer = (typeof setImmediate != "undefined") ?
			function timer(fn) { return setImmediate(fn); } :
			setTimeout
	;

	// dammit, IE8.
	try {
		Object.defineProperty({},"x",{});
		builtInProp = function builtInProp(obj,name,val,config) {
			return Object.defineProperty(obj,name,{
				value: val,
				writable: true,
				configurable: config !== false
			});
		};
	}
	catch (err) {
		builtInProp = function builtInProp(obj,name,val) {
			obj[name] = val;
			return obj;
		};
	}

	// Note: using a queue instead of array for efficiency
	scheduling_queue = (function Queue() {
		var first, last, item;

		function Item(fn,self) {
			this.fn = fn;
			this.self = self;
			this.next = void 0;
		}

		return {
			add: function add(fn,self) {
				item = new Item(fn,self);
				if (last) {
					last.next = item;
				}
				else {
					first = item;
				}
				last = item;
				item = void 0;
			},
			drain: function drain() {
				var f = first;
				first = last = cycle = void 0;

				while (f) {
					f.fn.call(f.self);
					f = f.next;
				}
			}
		};
	})();

	function schedule(fn,self) {
		scheduling_queue.add(fn,self);
		if (!cycle) {
			cycle = timer(scheduling_queue.drain);
		}
	}

	// promise duck typing
	function isThenable(o) {
		var _then, o_type = typeof o;

		if (o != null &&
			(
				o_type == "object" || o_type == "function"
			)
		) {
			_then = o.then;
		}
		return typeof _then == "function" ? _then : false;
	}

	function notify() {
		for (var i=0; i<this.chain.length; i++) {
			notifyIsolated(
				this,
				(this.state === 1) ? this.chain[i].success : this.chain[i].failure,
				this.chain[i]
			);
		}
		this.chain.length = 0;
	}

	// NOTE: This is a separate function to isolate
	// the `try..catch` so that other code can be
	// optimized better
	function notifyIsolated(self,cb,chain) {
		var ret, _then;
		try {
			if (cb === false) {
				chain.reject(self.msg);
			}
			else {
				if (cb === true) {
					ret = self.msg;
				}
				else {
					ret = cb.call(void 0,self.msg);
				}

				if (ret === chain.promise) {
					chain.reject(TypeError("Promise-chain cycle"));
				}
				else if (_then = isThenable(ret)) {
					_then.call(ret,chain.resolve,chain.reject);
				}
				else {
					chain.resolve(ret);
				}
			}
		}
		catch (err) {
			chain.reject(err);
		}
	}

	function resolve(msg) {
		var _then, self = this;

		// already triggered?
		if (self.triggered) { return; }

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		try {
			if (_then = isThenable(msg)) {
				schedule(function(){
					var def_wrapper = new MakeDefWrapper(self);
					try {
						_then.call(msg,
							function $resolve$(){ resolve.apply(def_wrapper,arguments); },
							function $reject$(){ reject.apply(def_wrapper,arguments); }
						);
					}
					catch (err) {
						reject.call(def_wrapper,err);
					}
				})
			}
			else {
				self.msg = msg;
				self.state = 1;
				if (self.chain.length > 0) {
					schedule(notify,self);
				}
			}
		}
		catch (err) {
			reject.call(new MakeDefWrapper(self),err);
		}
	}

	function reject(msg) {
		var self = this;

		// already triggered?
		if (self.triggered) { return; }

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		self.msg = msg;
		self.state = 2;
		if (self.chain.length > 0) {
			schedule(notify,self);
		}
	}

	function iteratePromises(Constructor,arr,resolver,rejecter) {
		for (var idx=0; idx<arr.length; idx++) {
			(function IIFE(idx){
				Constructor.resolve(arr[idx])
				.then(
					function $resolver$(msg){
						resolver(idx,msg);
					},
					rejecter
				);
			})(idx);
		}
	}

	function MakeDefWrapper(self) {
		this.def = self;
		this.triggered = false;
	}

	function MakeDef(self) {
		this.promise = self;
		this.state = 0;
		this.triggered = false;
		this.chain = [];
		this.msg = void 0;
	}

	function Promise(executor) {
		if (typeof executor != "function") {
			throw TypeError("Not a function");
		}

		if (this.__NPO__ !== 0) {
			throw TypeError("Not a promise");
		}

		// instance shadowing the inherited "brand"
		// to signal an already "initialized" promise
		this.__NPO__ = 1;

		var def = new MakeDef(this);

		this["then"] = function then(success,failure) {
			var o = {
				success: typeof success == "function" ? success : true,
				failure: typeof failure == "function" ? failure : false
			};
			// Note: `then(..)` itself can be borrowed to be used against
			// a different promise constructor for making the chained promise,
			// by substituting a different `this` binding.
			o.promise = new this.constructor(function extractChain(resolve,reject) {
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}

				o.resolve = resolve;
				o.reject = reject;
			});
			def.chain.push(o);

			if (def.state !== 0) {
				schedule(notify,def);
			}

			return o.promise;
		};
		this["catch"] = function $catch$(failure) {
			return this.then(void 0,failure);
		};

		try {
			executor.call(
				void 0,
				function publicResolve(msg){
					resolve.call(def,msg);
				},
				function publicReject(msg) {
					reject.call(def,msg);
				}
			);
		}
		catch (err) {
			reject.call(def,err);
		}
	}

	var PromisePrototype = builtInProp({},"constructor",Promise,
		/*configurable=*/false
	);

	// Note: Android 4 cannot use `Object.defineProperty(..)` here
	Promise.prototype = PromisePrototype;

	// built-in "brand" to signal an "uninitialized" promise
	builtInProp(PromisePrototype,"__NPO__",0,
		/*configurable=*/false
	);

	builtInProp(Promise,"resolve",function Promise$resolve(msg) {
		var Constructor = this;

		// spec mandated checks
		// note: best "isPromise" check that's practical for now
		if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
			return msg;
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			resolve(msg);
		});
	});

	builtInProp(Promise,"reject",function Promise$reject(msg) {
		return new this(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			reject(msg);
		});
	});

	builtInProp(Promise,"all",function Promise$all(arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}
		if (arr.length === 0) {
			return Constructor.resolve([]);
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			var len = arr.length, msgs = Array(len), count = 0;

			iteratePromises(Constructor,arr,function resolver(idx,msg) {
				msgs[idx] = msg;
				if (++count === len) {
					resolve(msgs);
				}
			},reject);
		});
	});

	builtInProp(Promise,"race",function Promise$race(arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			iteratePromises(Constructor,arr,function resolver(idx,msg){
				resolve(msg);
			},reject);
		});
	});

	return Promise;
});
;/*!
 * Platform.js v1.3.0 <http://mths.be/platform>
 * Copyright 2010-2014 John-David Dalton <http://allyoucanleet.com/>
 * Available under MIT license <http://mths.be/mit>
 */
;(function() {
  'use strict';

  /** Used to determine if values are of the language type `Object` */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object */
  var root = (objectTypes[typeof window] && window) || this;

  /** Backup possible global object */
  var oldRoot = root;

  /** Detect free variable `exports` */
  var freeExports = objectTypes[typeof exports] && exports;

  /** Detect free variable `module` */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root` */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Opera regexp */
  var reOpera = /\bOpera/;

  /** Possible global object */
  var thisBinding = this;

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // platform tokens defined at
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '6.4':  '10',
      '6.3':  '8.1',
      '6.2':  '8',
      '6.1':  'Server 2008 R2 / 7',
      '6.0':  'Server 2008 / Vista',
      '5.2':  'Server 2003 / XP 64-bit',
      '5.1':  'XP',
      '5.01': '2000 SP1',
      '5.0':  '2000',
      '4.0':  'NT',
      '4.90': 'ME'
    };
    // detect Windows version from platform tokens
    if (pattern && label && /^Win/i.test(os) &&
        (data = data[0/*Opera 9.25 fix*/, /[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // correct character case and cleanup
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(
      os.replace(/ ce$/i, ' CE')
        .replace(/\bhpw/i, 'web')
        .replace(/\bMacintosh\b/, 'Mac OS')
        .replace(/_PowerPC\b/i, ' OS')
        .replace(/\b(OS X) [^ \d]+/i, '$1')
        .replace(/\bMac (OS X)\b/, '$1')
        .replace(/\/(\d)/, ' $1')
        .replace(/_/g, '.')
        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
        .replace(/\bx86\.64\b/gi, 'x86_64')
        .replace(/\b(Windows Phone) OS\b/, '$1')
        .split(' on ')[0]
    );

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return /^(?:webOS|i(?:OS|P))/.test(string)
      ? string
      : capitalize(string);
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null
      ? capitalize(value)
      : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? typeof object[property] : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
      (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function(value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object */
    var context = root;

    /** Used to flag when a custom context is provided */
    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

    // juggle arguments
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object */
    var nav = context.navigator || {};

    /** Browser user agent string */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope] */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome */
    var likeChrome = isCustomContext
      ? !!nav.likeChrome
      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environment */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha */
    var alpha = java ? 'a' : '\u03b1';

    /** A character to represent beta */
    var beta = java ? 'b' : '\u03b2';

    /** Browser document object */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based)
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]` */
    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
      ? operaClass
      : (opera = null);

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime */
    var data;

    /** The CPU architecture */
    var arch = ua;

    /** Platform description array */
    var description = [];

    /** Platform alpha/beta indicator */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform */
    var useFeatures = ua == userAgent;

    /** The browser/environment version */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important) */
    var layout = getLayout([
      'Trident',
      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
      'iCab',
      'Presto',
      'NetFront',
      'Tasman',
      'KHTML',
      'Gecko'
    ]);

    /* Detectable browser names (order is important) */
    var name = getName([
      'Adobe AIR',
      'Arora',
      'Avant Browser',
      'Breach',
      'Camino',
      'Epiphany',
      'Fennec',
      'Flock',
      'Galeon',
      'GreenBrowser',
      'iCab',
      'Iceweasel',
      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
      'K-Meleon',
      'Konqueror',
      'Lunascape',
      'Maxthon',
      'Midori',
      'Nook Browser',
      'PhantomJS',
      'Raven',
      'Rekonq',
      'RockMelt',
      'SeaMonkey',
      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Sleipnir',
      'SlimBrowser',
      'Sunrise',
      'Swiftfox',
      'WebPositive',
      'Opera Mini',
      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
      'Opera',
      { 'label': 'Opera', 'pattern': 'OPR' },
      'Chrome',
      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
      { 'label': 'IE', 'pattern': 'IEMobile' },
      { 'label': 'IE', 'pattern': 'MSIE' },
      'Safari'
    ]);

    /* Detectable products (order is important) */
    var product = getProduct([
      { 'label': 'BlackBerry', 'pattern': 'BB10' },
      'BlackBerry',
      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
      'Google TV',
      'Lumia',
      'iPad',
      'iPod',
      'iPhone',
      'Kindle',
      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Nook',
      'PlayBook',
      'PlayStation 4',
      'PlayStation 3',
      'PlayStation Vita',
      'TouchPad',
      'Transformer',
      { 'label': 'Wii U', 'pattern': 'WiiU' },
      'Wii',
      'Xbox One',
      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
      'Xoom'
    ]);

    /* Detectable manufacturers */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation 4': 1, 'PlayStation 3': 1, 'PlayStation Vita': 1 }
    });

    /* Detectable OSes (order is important) */
    var os = getOS([
      'Windows Phone ',
      'Android',
      'CentOS',
      'Debian',
      'Fedora',
      'FreeBSD',
      'Gentoo',
      'Haiku',
      'Kubuntu',
      'Linux Mint',
      'Red Hat',
      'SuSE',
      'Ubuntu',
      'Xubuntu',
      'Cygwin',
      'Symbian OS',
      'hpwOS',
      'webOS ',
      'webOS',
      'Tablet OS',
      'Linux',
      'Mac OS X',
      'Macintosh',
      'Mac',
      'Windows 98;',
      'Windows '
    ]);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function(result, value, key) {
        // lookup the manufacturer by product or scan the UA for the manufacturer
        return result || (
          value[product] ||
          value[0/*Opera 9.25 fix*/, /^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
        ) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
            )) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
            )) {
          // split by forward slash and append product version if needed
          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // correct character case and cleanup
          guess = guess.label || guess;
          result = format(result[0]
            .replace(RegExp(pattern, 'i'), guess)
            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function(result, pattern) {
        return result || (RegExp(pattern +
          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // convert layout to an array so we can add extra details
    layout && (layout = [layout]);

    // detect product names that contain their manufacturer's name
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    }
    // clean up Google TV
    if ((data = /\bGoogle TV\b/.exec(product))) {
      product = data[0];
    }
    // detect simulators
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // detect iOS
    if (/^iP/.test(product)) {
      name || (name = 'Safari');
      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
        ? ' ' + data[1].replace(/_/g, '.')
        : '');
    }
    // detect Kubuntu
    else if (name == 'Konqueror' && !/buntu/i.test(os)) {
      os = 'Kubuntu';
    }
    // detect Android browsers
    else if (manufacturer && manufacturer != 'Google' &&
        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) {
      name = 'Android Browser';
      os = /\bAndroid\b/.test(os) ? os : 'Android';
    }
    // detect false positives for Firefox/Safari
    else if (!name || (data = !/\bMinefield\b|\(Android;/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
      // escape the `/` for Firefox 1
      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
        // clear name of false positives
        name = null;
      }
      // reassign a generic name
      if ((data = product || manufacturer || os) &&
          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
      }
    }
    // detect Firefox OS
    if ((data = /\((Mobile|Tablet).*?Firefox\b/i.exec(ua)) && data[1]) {
      os = 'Firefox OS';
      if (!product) {
        product = data[1];
      }
    }
    // detect non-Opera versions (order is important)
    if (!version) {
      version = getVersion([
        '(?:Cloud9|CriOS|CrMo|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|Silk(?!/[\\d.]+$))',
        'Version',
        qualify(name),
        '(?:Firefox|Minefield|NetFront)'
      ]);
    }
    // detect stubborn layout engines
    if (layout == 'iCab' && parseFloat(version) > 3) {
      layout = ['WebKit'];
    } else if (
        layout != 'Trident' &&
        (data =
          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && 'WebKit' ||
          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident')
        )
    ) {
      layout = [data];
    }
    // detect NetFront on PlayStation
    else if (/\bPlayStation\b(?! Vita\b)/i.test(name) && layout == 'WebKit') {
      layout = ['NetFront'];
    }
    // detect Windows Phone 7 desktop mode
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // detect Windows Phone 8+ desktop mode
    else if (/\bWPDesktop\b/i.test(ua)) {
      name = 'IE Mobile';
      os = 'Windows Phone 8+';
      description.unshift('desktop mode');
      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
    }
    // detect IE 11 and above
    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
      if (!/\bWPDesktop\b/i.test(ua)) {
        if (name) {
          description.push('identifying as ' + name + (version ? ' ' + version : ''));
        }
        name = 'IE';
      }
      version = data[1];
    }
    // detect IE Tech Preview
    else if ((name == 'Chrome' || name != 'IE') && (data = /\bEdge\/([\d.]+)/.exec(ua))) {
      name = 'IE';
      version = data[1];
      layout = ['Trident'];
      description.unshift('platform preview');
    }
    // leverage environment features
    if (useFeatures) {
      // detect server-side environments
      // Rhino has a global function while others have a global object
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (isModuleScope && isHostType(context, 'system') && (data = [context.system])[0]) {
          os || (os = data[0].os || null);
          try {
            data[1] = context.require('ringo/engine').version;
            version = data[1].join('.');
            name = 'RingoJS';
          } catch(e) {
            if (data[0].global.system == context.system) {
              name = 'Narwhal';
            }
          }
        }
        else if (typeof context.process == 'object' && (data = context.process)) {
          name = 'Node.js';
          arch = data.arch;
          os = data.platform;
          version = /[\d.]+/.exec(data.version)[0];
        }
        else if (rhino) {
          name = 'Rhino';
        }
      }
      // detect Adobe AIR
      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
        name = 'Adobe AIR';
        os = data.flash.system.Capabilities.os;
      }
      // detect PhantomJS
      else if (getClassOf((data = context.phantom)) == phantomClass) {
        name = 'PhantomJS';
        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
      }
      // detect IE compatibility modes
      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
        // we're in compatibility mode when the Trident version + 4 doesn't
        // equal the document mode
        version = [version, doc.documentMode];
        if ((data = +data[1] + 4) != version[1]) {
          description.push('IE ' + version[1] + ' mode');
          layout && (layout[1] = '');
          version[1] = data;
        }
        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
      }
      os = os && format(os);
    }
    // detect prerelease phases
    if (version && (data =
          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
          /\bMinefield\b/i.test(ua) && 'a'
        )) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') +
        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // detect Firefox Mobile
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // obscure Maxthon's unreliable version
    else if (name == 'Maxthon' && version) {
      version = version.replace(/\.[\d.]+/, '.x');
    }
    // detect Silk desktop/accelerated modes
    else if (name == 'Silk') {
      if (!/\bMobi/i.test(ua)) {
        os = 'Android';
        description.unshift('desktop mode');
      }
      if (/Accelerated *= *true/i.test(ua)) {
        description.unshift('accelerated');
      }
    }
    // detect Xbox 360 and Xbox One
    else if (/\bXbox\b/i.test(product)) {
      os = null;
      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
        description.unshift('mobile mode');
      }
    }
    // add mobile postfix
    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
        (os == 'Windows CE' || /Mobi/i.test(ua))) {
      name += ' Mobile';
    }
    // detect IE platform preview
    else if (name == 'IE' && useFeatures && context.external === null) {
      description.unshift('platform preview');
    }
    // detect BlackBerry OS version
    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
          version
        )) {
      data = [data, /BB10/.test(ua)];
      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
      version = null;
    }
    // detect Opera identifying/masking itself as another browser
    // http://www.opera.com/support/kb/view/843/
    else if (this != forOwn && (
          product != 'Wii' && (
            (useFeatures && opera) ||
            (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
            (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
            (name == 'IE' && (
              (os && !/^Win/.test(os) && version > 5.5) ||
              /\bWindows XP\b/.test(os) && version > 8 ||
              version == 8 && !/\bTrident\b/.test(ua)
            ))
          )
        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {

      // when "indentifying", the UA contains both Opera and the other browser's name
      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
      if (reOpera.test(name)) {
        if (/\bIE\b/.test(data) && os == 'Mac OS') {
          os = null;
        }
        data = 'identify' + data;
      }
      // when "masking", the UA contains only the other browser's name
      else {
        data = 'mask' + data;
        if (operaClass) {
          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
        } else {
          name = 'Opera';
        }
        if (/\bIE\b/.test(data)) {
          os = null;
        }
        if (!useFeatures) {
          version = null;
        }
      }
      layout = ['Presto'];
      description.push(data);
    }
    // detect WebKit Nightly and approximate Chrome/Safari versions
    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
      // correct build for numeric comparison
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // nightly builds are postfixed with a `+`
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // clear incorrect browser versions
      else if (version == data[1] ||
          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
        version = null;
      }
      // use the full Chrome version when available
      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // detect Blink layout engine
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && name != 'IE') {
        layout = ['Blink'];
      }
      // detect JavaScriptCore
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || (!likeChrome && !data[1])) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // add the postfix of ".x" or "+" for approximate versions
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // obscure version for some Safari 1-2 releases
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      }
    }
    // detect Opera desktop modes
    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // detect Chrome desktop mode
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
      description.unshift('desktop mode');
      name = 'Chrome Mobile';
      version = null;

      if (/\bOS X\b/.test(os)) {
        manufacturer = 'Apple';
        os = 'iOS 4.3+';
      } else {
        os = null;
      }
    }
    // strip incorrect OS versions
    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
        ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // add layout engine
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
        /Browser|Lunascape|Maxthon/.test(name) ||
        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Sleipnir|Web)/.test(name) && layout[1])) {
      // don't add layout details to description if they are falsey
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // combine contextual information
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // append manufacturer
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // append product
    if (product) {
      description.push((/^on /.test(description[description.length -1]) ? '' : 'on ') + product);
    }
    // parse OS into an object
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function() {
          var version = this.version;
          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // add browser/OS architecture
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (
          name && (/\bWOW64\b/i.test(ua) ||
          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
      ) {
        description.unshift('32-bit');
      }
    }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
       * "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function() { return 'null'; }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

    
    //PDH: We have to force the export to the browser because customers
    // may have some of these systems implemented which will screw up our libraries
    
  // export platform
  // some AMD build optimizers, like r.js, check for condition patterns like the following:
  //if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
  //  // define as an anonymous module so, through path mapping, it can be aliased
  //  define(function() {
  //    return parse();
  //  });
  //}
  //// check for `exports` after `define` in case a build optimizer adds an `exports` object
  //else if (freeExports && freeModule) {
  //  // in Narwhal, Node.js, Rhino -require, or RingoJS
  //  forOwn(parse(), function(value, key) {
  //    freeExports[key] = value;
  //  });
  //}
  //// in a browser or Rhino
  //else {
    root.platform = parse();
  //}
}.call(this));
;;(function(exports) {

// export the class if we are in a Node-like system.
if (typeof module === 'object' && module.exports === exports)
  exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  ;
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  ;
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.inspect = function() {
  return '<SemVer "' + this + '">';
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  ;
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    ;
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  ;
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  ;
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.inspect = function() {
  return '<SemVer Comparator "' + this + '">';
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  ;

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.inspect = function() {
  return '<SemVer Range "' + this.range + '">';
};

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  ;
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  ;
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  ;

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  ;
  comp = replaceCarets(comp, loose);
  ;
  comp = replaceTildes(comp, loose);
  ;
  comp = replaceXRanges(comp, loose);
  ;
  comp = replaceStars(comp, loose);
  ;
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    ;
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0- <1.3.0-
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      ;
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    ;
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  ;
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    ;
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      ;
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      ;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    ;
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  ;
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    ;
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<'
        if (xm)
          M = +M + 1
        else
          m = +m + 1
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    ;

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  ;
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      ;
      if (set[i].semver === ANY)
        return true;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

// We have to force the export to the browser because customers
// may have some of these systems implemented which will screw up our libraries

// Use the define() function if we're in AMD land
//if (typeof define === 'function' && define.amd)
//  define(exports);
})(
//  typeof exports === 'object' ? exports :
//  typeof define === 'function' && define.amd ? {} :
  semver = {}
);
;(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["forge"] = factory();
	else
		root["forge"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */
module.exports = {
  // default options
  options: {
    usePureJavaScript: false
  }
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Utility functions for web applications.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */
var forge = __webpack_require__(0);

/* Utilities API */
var util = module.exports = forge.util = forge.util || {};

// define setImmediate and nextTick
(function() {
  // use native nextTick
  if(typeof process !== 'undefined' && process.nextTick) {
    util.nextTick = process.nextTick;
    if(typeof setImmediate === 'function') {
      util.setImmediate = setImmediate;
    } else {
      // polyfill setImmediate with nextTick, older versions of node
      // (those w/o setImmediate) won't totally starve IO
      util.setImmediate = util.nextTick;
    }
    return;
  }

  // polyfill nextTick with native setImmediate
  if(typeof setImmediate === 'function') {
    util.setImmediate = function() { return setImmediate.apply(undefined, arguments); };
    util.nextTick = function(callback) {
      return setImmediate(callback);
    };
    return;
  }

  /* Note: A polyfill upgrade pattern is used here to allow combining
  polyfills. For example, MutationObserver is fast, but blocks UI updates,
  so it needs to allow UI updates periodically, so it falls back on
  postMessage or setTimeout. */

  // polyfill with setTimeout
  util.setImmediate = function(callback) {
    setTimeout(callback, 0);
  };

  // upgrade polyfill to use postMessage
  if(typeof window !== 'undefined' &&
    typeof window.postMessage === 'function') {
    var msg = 'forge.setImmediate';
    var callbacks = [];
    util.setImmediate = function(callback) {
      callbacks.push(callback);
      // only send message when one hasn't been sent in
      // the current turn of the event loop
      if(callbacks.length === 1) {
        window.postMessage(msg, '*');
      }
    };
    function handler(event) {
      if(event.source === window && event.data === msg) {
        event.stopPropagation();
        var copy = callbacks.slice();
        callbacks.length = 0;
        copy.forEach(function(callback) {
          callback();
        });
      }
    }
    window.addEventListener('message', handler, true);
  }

  // upgrade polyfill to use MutationObserver
  if(typeof MutationObserver !== 'undefined') {
    // polyfill with MutationObserver
    var now = Date.now();
    var attr = true;
    var div = document.createElement('div');
    var callbacks = [];
    new MutationObserver(function() {
      var copy = callbacks.slice();
      callbacks.length = 0;
      copy.forEach(function(callback) {
        callback();
      });
    }).observe(div, {attributes: true});
    var oldSetImmediate = util.setImmediate;
    util.setImmediate = function(callback) {
      if(Date.now() - now > 15) {
        now = Date.now();
        oldSetImmediate(callback);
      } else {
        callbacks.push(callback);
        // only trigger observer when it hasn't been triggered in
        // the current turn of the event loop
        if(callbacks.length === 1) {
          div.setAttribute('a', attr = !attr);
        }
      }
    };
  }

  util.nextTick = util.setImmediate;
})();

// check if running under Node.js
util.isNodejs =
  typeof process !== 'undefined' && process.versions && process.versions.node;

// define isArray
util.isArray = Array.isArray || function(x) {
  return Object.prototype.toString.call(x) === '[object Array]';
};

// define isArrayBuffer
util.isArrayBuffer = function(x) {
  return typeof ArrayBuffer !== 'undefined' && x instanceof ArrayBuffer;
};

// define isArrayBufferView
util.isArrayBufferView = function(x) {
  return x && util.isArrayBuffer(x.buffer) && x.byteLength !== undefined;
};

/**
 * Ensure a bits param is 8, 16, 24, or 32. Used to validate input for
 * algorithms where bit manipulation, JavaScript limitations, and/or algorithm
 * design only allow for byte operations of a limited size.
 *
 * @param n number of bits.
 *
 * Throw Error if n invalid.
 */
function _checkBitsParam(n) {
  if(!(n === 8 || n === 16 || n === 24 || n === 32)) {
    throw new Error('Only 8, 16, 24, or 32 bits supported: ' + n);
  }
}

// TODO: set ByteBuffer to best available backing
util.ByteBuffer = ByteStringBuffer;

/** Buffer w/BinaryString backing */

/**
 * Constructor for a binary string backed byte buffer.
 *
 * @param [b] the bytes to wrap (either encoded as string, one byte per
 *          character, or as an ArrayBuffer or Typed Array).
 */
function ByteStringBuffer(b) {
  // TODO: update to match DataBuffer API

  // the data in this buffer
  this.data = '';
  // the pointer for reading from this buffer
  this.read = 0;

  if(typeof b === 'string') {
    this.data = b;
  } else if(util.isArrayBuffer(b) || util.isArrayBufferView(b)) {
    // convert native buffer to forge buffer
    // FIXME: support native buffers internally instead
    var arr = new Uint8Array(b);
    try {
      this.data = String.fromCharCode.apply(null, arr);
    } catch(e) {
      for(var i = 0; i < arr.length; ++i) {
        this.putByte(arr[i]);
      }
    }
  } else if(b instanceof ByteStringBuffer ||
    (typeof b === 'object' && typeof b.data === 'string' &&
    typeof b.read === 'number')) {
    // copy existing buffer
    this.data = b.data;
    this.read = b.read;
  }

  // used for v8 optimization
  this._constructedStringLength = 0;
}
util.ByteStringBuffer = ByteStringBuffer;

/* Note: This is an optimization for V8-based browsers. When V8 concatenates
  a string, the strings are only joined logically using a "cons string" or
  "constructed/concatenated string". These containers keep references to one
  another and can result in very large memory usage. For example, if a 2MB
  string is constructed by concatenating 4 bytes together at a time, the
  memory usage will be ~44MB; so ~22x increase. The strings are only joined
  together when an operation requiring their joining takes place, such as
  substr(). This function is called when adding data to this buffer to ensure
  these types of strings are periodically joined to reduce the memory
  footprint. */
var _MAX_CONSTRUCTED_STRING_LENGTH = 4096;
util.ByteStringBuffer.prototype._optimizeConstructedString = function(x) {
  this._constructedStringLength += x;
  if(this._constructedStringLength > _MAX_CONSTRUCTED_STRING_LENGTH) {
    // this substr() should cause the constructed string to join
    this.data.substr(0, 1);
    this._constructedStringLength = 0;
  }
};

/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */
util.ByteStringBuffer.prototype.length = function() {
  return this.data.length - this.read;
};

/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */
util.ByteStringBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};

/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putByte = function(b) {
  return this.putBytes(String.fromCharCode(b));
};

/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.fillWithByte = function(b, n) {
  b = String.fromCharCode(b);
  var d = this.data;
  while(n > 0) {
    if(n & 1) {
      d += b;
    }
    n >>>= 1;
    if(n > 0) {
      b += b;
    }
  }
  this.data = d;
  this._optimizeConstructedString(n);
  return this;
};

/**
 * Puts bytes in this buffer.
 *
 * @param bytes the bytes (as a UTF-8 encoded string) to put.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putBytes = function(bytes) {
  this.data += bytes;
  this._optimizeConstructedString(bytes.length);
  return this;
};

/**
 * Puts a UTF-16 encoded string into this buffer.
 *
 * @param str the string to put.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putString = function(str) {
  return this.putBytes(util.encodeUtf8(str));
};

/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putInt16 = function(i) {
  return this.putBytes(
    String.fromCharCode(i >> 8 & 0xFF) +
    String.fromCharCode(i & 0xFF));
};

/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putInt24 = function(i) {
  return this.putBytes(
    String.fromCharCode(i >> 16 & 0xFF) +
    String.fromCharCode(i >> 8 & 0xFF) +
    String.fromCharCode(i & 0xFF));
};

/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putInt32 = function(i) {
  return this.putBytes(
    String.fromCharCode(i >> 24 & 0xFF) +
    String.fromCharCode(i >> 16 & 0xFF) +
    String.fromCharCode(i >> 8 & 0xFF) +
    String.fromCharCode(i & 0xFF));
};

/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putInt16Le = function(i) {
  return this.putBytes(
    String.fromCharCode(i & 0xFF) +
    String.fromCharCode(i >> 8 & 0xFF));
};

/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putInt24Le = function(i) {
  return this.putBytes(
    String.fromCharCode(i & 0xFF) +
    String.fromCharCode(i >> 8 & 0xFF) +
    String.fromCharCode(i >> 16 & 0xFF));
};

/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putInt32Le = function(i) {
  return this.putBytes(
    String.fromCharCode(i & 0xFF) +
    String.fromCharCode(i >> 8 & 0xFF) +
    String.fromCharCode(i >> 16 & 0xFF) +
    String.fromCharCode(i >> 24 & 0xFF));
};

/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putInt = function(i, n) {
  _checkBitsParam(n);
  var bytes = '';
  do {
    n -= 8;
    bytes += String.fromCharCode((i >> n) & 0xFF);
  } while(n > 0);
  return this.putBytes(bytes);
};

/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putSignedInt = function(i, n) {
  // putInt checks n
  if(i < 0) {
    i += 2 << (n - 1);
  }
  return this.putInt(i, n);
};

/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.putBuffer = function(buffer) {
  return this.putBytes(buffer.getBytes());
};

/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */
util.ByteStringBuffer.prototype.getByte = function() {
  return this.data.charCodeAt(this.read++);
};

/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */
util.ByteStringBuffer.prototype.getInt16 = function() {
  var rval = (
    this.data.charCodeAt(this.read) << 8 ^
    this.data.charCodeAt(this.read + 1));
  this.read += 2;
  return rval;
};

/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */
util.ByteStringBuffer.prototype.getInt24 = function() {
  var rval = (
    this.data.charCodeAt(this.read) << 16 ^
    this.data.charCodeAt(this.read + 1) << 8 ^
    this.data.charCodeAt(this.read + 2));
  this.read += 3;
  return rval;
};

/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */
util.ByteStringBuffer.prototype.getInt32 = function() {
  var rval = (
    this.data.charCodeAt(this.read) << 24 ^
    this.data.charCodeAt(this.read + 1) << 16 ^
    this.data.charCodeAt(this.read + 2) << 8 ^
    this.data.charCodeAt(this.read + 3));
  this.read += 4;
  return rval;
};

/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */
util.ByteStringBuffer.prototype.getInt16Le = function() {
  var rval = (
    this.data.charCodeAt(this.read) ^
    this.data.charCodeAt(this.read + 1) << 8);
  this.read += 2;
  return rval;
};

/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */
util.ByteStringBuffer.prototype.getInt24Le = function() {
  var rval = (
    this.data.charCodeAt(this.read) ^
    this.data.charCodeAt(this.read + 1) << 8 ^
    this.data.charCodeAt(this.read + 2) << 16);
  this.read += 3;
  return rval;
};

/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */
util.ByteStringBuffer.prototype.getInt32Le = function() {
  var rval = (
    this.data.charCodeAt(this.read) ^
    this.data.charCodeAt(this.read + 1) << 8 ^
    this.data.charCodeAt(this.read + 2) << 16 ^
    this.data.charCodeAt(this.read + 3) << 24);
  this.read += 4;
  return rval;
};

/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by ceil(n/8).
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */
util.ByteStringBuffer.prototype.getInt = function(n) {
  _checkBitsParam(n);
  var rval = 0;
  do {
    // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
    rval = (rval << 8) + this.data.charCodeAt(this.read++);
    n -= 8;
  } while(n > 0);
  return rval;
};

/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */
util.ByteStringBuffer.prototype.getSignedInt = function(n) {
  // getInt checks n
  var x = this.getInt(n);
  var max = 2 << (n - 2);
  if(x >= max) {
    x -= max << 1;
  }
  return x;
};

/**
 * Reads bytes out into a UTF-8 string and clears them from the buffer.
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a UTF-8 string of bytes.
 */
util.ByteStringBuffer.prototype.getBytes = function(count) {
  var rval;
  if(count) {
    // read count bytes
    count = Math.min(this.length(), count);
    rval = this.data.slice(this.read, this.read + count);
    this.read += count;
  } else if(count === 0) {
    rval = '';
  } else {
    // read all bytes, optimize to only copy when needed
    rval = (this.read === 0) ? this.data : this.data.slice(this.read);
    this.clear();
  }
  return rval;
};

/**
 * Gets a UTF-8 encoded string of the bytes from this buffer without modifying
 * the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of UTF-8 encoded characters.
 */
util.ByteStringBuffer.prototype.bytes = function(count) {
  return (typeof(count) === 'undefined' ?
    this.data.slice(this.read) :
    this.data.slice(this.read, this.read + count));
};

/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */
util.ByteStringBuffer.prototype.at = function(i) {
  return this.data.charCodeAt(this.read + i);
};

/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.setAt = function(i, b) {
  this.data = this.data.substr(0, this.read + i) +
    String.fromCharCode(b) +
    this.data.substr(this.read + i + 1);
  return this;
};

/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */
util.ByteStringBuffer.prototype.last = function() {
  return this.data.charCodeAt(this.data.length - 1);
};

/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */
util.ByteStringBuffer.prototype.copy = function() {
  var c = util.createBuffer(this.data);
  c.read = this.read;
  return c;
};

/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.compact = function() {
  if(this.read > 0) {
    this.data = this.data.slice(this.read);
    this.read = 0;
  }
  return this;
};

/**
 * Clears this buffer.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.clear = function() {
  this.data = '';
  this.read = 0;
  return this;
};

/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */
util.ByteStringBuffer.prototype.truncate = function(count) {
  var len = Math.max(0, this.length() - count);
  this.data = this.data.substr(this.read, len);
  this.read = 0;
  return this;
};

/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */
util.ByteStringBuffer.prototype.toHex = function() {
  var rval = '';
  for(var i = this.read; i < this.data.length; ++i) {
    var b = this.data.charCodeAt(i);
    if(b < 16) {
      rval += '0';
    }
    rval += b.toString(16);
  }
  return rval;
};

/**
 * Converts this buffer to a UTF-16 string (standard JavaScript string).
 *
 * @return a UTF-16 string.
 */
util.ByteStringBuffer.prototype.toString = function() {
  return util.decodeUtf8(this.bytes());
};

/** End Buffer w/BinaryString backing */

/** Buffer w/UInt8Array backing */

/**
 * FIXME: Experimental. Do not use yet.
 *
 * Constructor for an ArrayBuffer-backed byte buffer.
 *
 * The buffer may be constructed from a string, an ArrayBuffer, DataView, or a
 * TypedArray.
 *
 * If a string is given, its encoding should be provided as an option,
 * otherwise it will default to 'binary'. A 'binary' string is encoded such
 * that each character is one byte in length and size.
 *
 * If an ArrayBuffer, DataView, or TypedArray is given, it will be used
 * *directly* without any copying. Note that, if a write to the buffer requires
 * more space, the buffer will allocate a new backing ArrayBuffer to
 * accommodate. The starting read and write offsets for the buffer may be
 * given as options.
 *
 * @param [b] the initial bytes for this buffer.
 * @param options the options to use:
 *          [readOffset] the starting read offset to use (default: 0).
 *          [writeOffset] the starting write offset to use (default: the
 *            length of the first parameter).
 *          [growSize] the minimum amount, in bytes, to grow the buffer by to
 *            accommodate writes (default: 1024).
 *          [encoding] the encoding ('binary', 'utf8', 'utf16', 'hex') for the
 *            first parameter, if it is a string (default: 'binary').
 */
function DataBuffer(b, options) {
  // default options
  options = options || {};

  // pointers for read from/write to buffer
  this.read = options.readOffset || 0;
  this.growSize = options.growSize || 1024;

  var isArrayBuffer = util.isArrayBuffer(b);
  var isArrayBufferView = util.isArrayBufferView(b);
  if(isArrayBuffer || isArrayBufferView) {
    // use ArrayBuffer directly
    if(isArrayBuffer) {
      this.data = new DataView(b);
    } else {
      // TODO: adjust read/write offset based on the type of view
      // or specify that this must be done in the options ... that the
      // offsets are byte-based
      this.data = new DataView(b.buffer, b.byteOffset, b.byteLength);
    }
    this.write = ('writeOffset' in options ?
      options.writeOffset : this.data.byteLength);
    return;
  }

  // initialize to empty array buffer and add any given bytes using putBytes
  this.data = new DataView(new ArrayBuffer(0));
  this.write = 0;

  if(b !== null && b !== undefined) {
    this.putBytes(b);
  }

  if('writeOffset' in options) {
    this.write = options.writeOffset;
  }
}
util.DataBuffer = DataBuffer;

/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */
util.DataBuffer.prototype.length = function() {
  return this.write - this.read;
};

/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */
util.DataBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};

/**
 * Ensures this buffer has enough empty space to accommodate the given number
 * of bytes. An optional parameter may be given that indicates a minimum
 * amount to grow the buffer if necessary. If the parameter is not given,
 * the buffer will be grown by some previously-specified default amount
 * or heuristic.
 *
 * @param amount the number of bytes to accommodate.
 * @param [growSize] the minimum amount, in bytes, to grow the buffer by if
 *          necessary.
 */
util.DataBuffer.prototype.accommodate = function(amount, growSize) {
  if(this.length() >= amount) {
    return this;
  }
  growSize = Math.max(growSize || this.growSize, amount);

  // grow buffer
  var src = new Uint8Array(
    this.data.buffer, this.data.byteOffset, this.data.byteLength);
  var dst = new Uint8Array(this.length() + growSize);
  dst.set(src);
  this.data = new DataView(dst.buffer);

  return this;
};

/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putByte = function(b) {
  this.accommodate(1);
  this.data.setUint8(this.write++, b);
  return this;
};

/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.fillWithByte = function(b, n) {
  this.accommodate(n);
  for(var i = 0; i < n; ++i) {
    this.data.setUint8(b);
  }
  return this;
};

/**
 * Puts bytes in this buffer. The bytes may be given as a string, an
 * ArrayBuffer, a DataView, or a TypedArray.
 *
 * @param bytes the bytes to put.
 * @param [encoding] the encoding for the first parameter ('binary', 'utf8',
 *          'utf16', 'hex'), if it is a string (default: 'binary').
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putBytes = function(bytes, encoding) {
  if(util.isArrayBufferView(bytes)) {
    var src = new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    var len = src.byteLength - src.byteOffset;
    this.accommodate(len);
    var dst = new Uint8Array(this.data.buffer, this.write);
    dst.set(src);
    this.write += len;
    return this;
  }

  if(util.isArrayBuffer(bytes)) {
    var src = new Uint8Array(bytes);
    this.accommodate(src.byteLength);
    var dst = new Uint8Array(this.data.buffer);
    dst.set(src, this.write);
    this.write += src.byteLength;
    return this;
  }

  // bytes is a util.DataBuffer or equivalent
  if(bytes instanceof util.DataBuffer ||
    (typeof bytes === 'object' &&
    typeof bytes.read === 'number' && typeof bytes.write === 'number' &&
    util.isArrayBufferView(bytes.data))) {
    var src = new Uint8Array(bytes.data.byteLength, bytes.read, bytes.length());
    this.accommodate(src.byteLength);
    var dst = new Uint8Array(bytes.data.byteLength, this.write);
    dst.set(src);
    this.write += src.byteLength;
    return this;
  }

  if(bytes instanceof util.ByteStringBuffer) {
    // copy binary string and process as the same as a string parameter below
    bytes = bytes.data;
    encoding = 'binary';
  }

  // string conversion
  encoding = encoding || 'binary';
  if(typeof bytes === 'string') {
    var view;

    // decode from string
    if(encoding === 'hex') {
      this.accommodate(Math.ceil(bytes.length / 2));
      view = new Uint8Array(this.data.buffer, this.write);
      this.write += util.binary.hex.decode(bytes, view, this.write);
      return this;
    }
    if(encoding === 'base64') {
      this.accommodate(Math.ceil(bytes.length / 4) * 3);
      view = new Uint8Array(this.data.buffer, this.write);
      this.write += util.binary.base64.decode(bytes, view, this.write);
      return this;
    }

    // encode text as UTF-8 bytes
    if(encoding === 'utf8') {
      // encode as UTF-8 then decode string as raw binary
      bytes = util.encodeUtf8(bytes);
      encoding = 'binary';
    }

    // decode string as raw binary
    if(encoding === 'binary' || encoding === 'raw') {
      // one byte per character
      this.accommodate(bytes.length);
      view = new Uint8Array(this.data.buffer, this.write);
      this.write += util.binary.raw.decode(view);
      return this;
    }

    // encode text as UTF-16 bytes
    if(encoding === 'utf16') {
      // two bytes per character
      this.accommodate(bytes.length * 2);
      view = new Uint16Array(this.data.buffer, this.write);
      this.write += util.text.utf16.encode(view);
      return this;
    }

    throw new Error('Invalid encoding: ' + encoding);
  }

  throw Error('Invalid parameter: ' + bytes);
};

/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putBuffer = function(buffer) {
  this.putBytes(buffer);
  buffer.clear();
  return this;
};

/**
 * Puts a string into this buffer.
 *
 * @param str the string to put.
 * @param [encoding] the encoding for the string (default: 'utf16').
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putString = function(str) {
  return this.putBytes(str, 'utf16');
};

/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putInt16 = function(i) {
  this.accommodate(2);
  this.data.setInt16(this.write, i);
  this.write += 2;
  return this;
};

/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putInt24 = function(i) {
  this.accommodate(3);
  this.data.setInt16(this.write, i >> 8 & 0xFFFF);
  this.data.setInt8(this.write, i >> 16 & 0xFF);
  this.write += 3;
  return this;
};

/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putInt32 = function(i) {
  this.accommodate(4);
  this.data.setInt32(this.write, i);
  this.write += 4;
  return this;
};

/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putInt16Le = function(i) {
  this.accommodate(2);
  this.data.setInt16(this.write, i, true);
  this.write += 2;
  return this;
};

/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putInt24Le = function(i) {
  this.accommodate(3);
  this.data.setInt8(this.write, i >> 16 & 0xFF);
  this.data.setInt16(this.write, i >> 8 & 0xFFFF, true);
  this.write += 3;
  return this;
};

/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putInt32Le = function(i) {
  this.accommodate(4);
  this.data.setInt32(this.write, i, true);
  this.write += 4;
  return this;
};

/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putInt = function(i, n) {
  _checkBitsParam(n);
  this.accommodate(n / 8);
  do {
    n -= 8;
    this.data.setInt8(this.write++, (i >> n) & 0xFF);
  } while(n > 0);
  return this;
};

/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.putSignedInt = function(i, n) {
  _checkBitsParam(n);
  this.accommodate(n / 8);
  if(i < 0) {
    i += 2 << (n - 1);
  }
  return this.putInt(i, n);
};

/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */
util.DataBuffer.prototype.getByte = function() {
  return this.data.getInt8(this.read++);
};

/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */
util.DataBuffer.prototype.getInt16 = function() {
  var rval = this.data.getInt16(this.read);
  this.read += 2;
  return rval;
};

/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */
util.DataBuffer.prototype.getInt24 = function() {
  var rval = (
    this.data.getInt16(this.read) << 8 ^
    this.data.getInt8(this.read + 2));
  this.read += 3;
  return rval;
};

/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */
util.DataBuffer.prototype.getInt32 = function() {
  var rval = this.data.getInt32(this.read);
  this.read += 4;
  return rval;
};

/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */
util.DataBuffer.prototype.getInt16Le = function() {
  var rval = this.data.getInt16(this.read, true);
  this.read += 2;
  return rval;
};

/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */
util.DataBuffer.prototype.getInt24Le = function() {
  var rval = (
    this.data.getInt8(this.read) ^
    this.data.getInt16(this.read + 1, true) << 8);
  this.read += 3;
  return rval;
};

/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */
util.DataBuffer.prototype.getInt32Le = function() {
  var rval = this.data.getInt32(this.read, true);
  this.read += 4;
  return rval;
};

/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */
util.DataBuffer.prototype.getInt = function(n) {
  _checkBitsParam(n);
  var rval = 0;
  do {
    // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
    rval = (rval << 8) + this.data.getInt8(this.read++);
    n -= 8;
  } while(n > 0);
  return rval;
};

/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */
util.DataBuffer.prototype.getSignedInt = function(n) {
  // getInt checks n
  var x = this.getInt(n);
  var max = 2 << (n - 2);
  if(x >= max) {
    x -= max << 1;
  }
  return x;
};

/**
 * Reads bytes out into a UTF-8 string and clears them from the buffer.
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a UTF-8 string of bytes.
 */
util.DataBuffer.prototype.getBytes = function(count) {
  // TODO: deprecate this method, it is poorly named and
  // this.toString('binary') replaces it
  // add a toTypedArray()/toArrayBuffer() function
  var rval;
  if(count) {
    // read count bytes
    count = Math.min(this.length(), count);
    rval = this.data.slice(this.read, this.read + count);
    this.read += count;
  } else if(count === 0) {
    rval = '';
  } else {
    // read all bytes, optimize to only copy when needed
    rval = (this.read === 0) ? this.data : this.data.slice(this.read);
    this.clear();
  }
  return rval;
};

/**
 * Gets a UTF-8 encoded string of the bytes from this buffer without modifying
 * the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of UTF-8 encoded characters.
 */
util.DataBuffer.prototype.bytes = function(count) {
  // TODO: deprecate this method, it is poorly named, add "getString()"
  return (typeof(count) === 'undefined' ?
    this.data.slice(this.read) :
    this.data.slice(this.read, this.read + count));
};

/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */
util.DataBuffer.prototype.at = function(i) {
  return this.data.getUint8(this.read + i);
};

/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.setAt = function(i, b) {
  this.data.setUint8(i, b);
  return this;
};

/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */
util.DataBuffer.prototype.last = function() {
  return this.data.getUint8(this.write - 1);
};

/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */
util.DataBuffer.prototype.copy = function() {
  return new util.DataBuffer(this);
};

/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.compact = function() {
  if(this.read > 0) {
    var src = new Uint8Array(this.data.buffer, this.read);
    var dst = new Uint8Array(src.byteLength);
    dst.set(src);
    this.data = new DataView(dst);
    this.write -= this.read;
    this.read = 0;
  }
  return this;
};

/**
 * Clears this buffer.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.clear = function() {
  this.data = new DataView(new ArrayBuffer(0));
  this.read = this.write = 0;
  return this;
};

/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */
util.DataBuffer.prototype.truncate = function(count) {
  this.write = Math.max(0, this.length() - count);
  this.read = Math.min(this.read, this.write);
  return this;
};

/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */
util.DataBuffer.prototype.toHex = function() {
  var rval = '';
  for(var i = this.read; i < this.data.byteLength; ++i) {
    var b = this.data.getUint8(i);
    if(b < 16) {
      rval += '0';
    }
    rval += b.toString(16);
  }
  return rval;
};

/**
 * Converts this buffer to a string, using the given encoding. If no
 * encoding is given, 'utf8' (UTF-8) is used.
 *
 * @param [encoding] the encoding to use: 'binary', 'utf8', 'utf16', 'hex',
 *          'base64' (default: 'utf8').
 *
 * @return a string representation of the bytes in this buffer.
 */
util.DataBuffer.prototype.toString = function(encoding) {
  var view = new Uint8Array(this.data, this.read, this.length());
  encoding = encoding || 'utf8';

  // encode to string
  if(encoding === 'binary' || encoding === 'raw') {
    return util.binary.raw.encode(view);
  }
  if(encoding === 'hex') {
    return util.binary.hex.encode(view);
  }
  if(encoding === 'base64') {
    return util.binary.base64.encode(view);
  }

  // decode to text
  if(encoding === 'utf8') {
    return util.text.utf8.decode(view);
  }
  if(encoding === 'utf16') {
    return util.text.utf16.decode(view);
  }

  throw new Error('Invalid encoding: ' + encoding);
};

/** End Buffer w/UInt8Array backing */

/**
 * Creates a buffer that stores bytes. A value may be given to put into the
 * buffer that is either a string of bytes or a UTF-16 string that will
 * be encoded using UTF-8 (to do the latter, specify 'utf8' as the encoding).
 *
 * @param [input] the bytes to wrap (as a string) or a UTF-16 string to encode
 *          as UTF-8.
 * @param [encoding] (default: 'raw', other: 'utf8').
 */
util.createBuffer = function(input, encoding) {
  // TODO: deprecate, use new ByteBuffer() instead
  encoding = encoding || 'raw';
  if(input !== undefined && encoding === 'utf8') {
    input = util.encodeUtf8(input);
  }
  return new util.ByteBuffer(input);
};

/**
 * Fills a string with a particular value. If you want the string to be a byte
 * string, pass in String.fromCharCode(theByte).
 *
 * @param c the character to fill the string with, use String.fromCharCode
 *          to fill the string with a byte value.
 * @param n the number of characters of value c to fill with.
 *
 * @return the filled string.
 */
util.fillString = function(c, n) {
  var s = '';
  while(n > 0) {
    if(n & 1) {
      s += c;
    }
    n >>>= 1;
    if(n > 0) {
      c += c;
    }
  }
  return s;
};

/**
 * Performs a per byte XOR between two byte strings and returns the result as a
 * string of bytes.
 *
 * @param s1 first string of bytes.
 * @param s2 second string of bytes.
 * @param n the number of bytes to XOR.
 *
 * @return the XOR'd result.
 */
util.xorBytes = function(s1, s2, n) {
  var s3 = '';
  var b = '';
  var t = '';
  var i = 0;
  var c = 0;
  for(; n > 0; --n, ++i) {
    b = s1.charCodeAt(i) ^ s2.charCodeAt(i);
    if(c >= 10) {
      s3 += t;
      t = '';
      c = 0;
    }
    t += String.fromCharCode(b);
    ++c;
  }
  s3 += t;
  return s3;
};

/**
 * Converts a hex string into a 'binary' encoded string of bytes.
 *
 * @param hex the hexadecimal string to convert.
 *
 * @return the binary-encoded string of bytes.
 */
util.hexToBytes = function(hex) {
  // TODO: deprecate: "Deprecated. Use util.binary.hex.decode instead."
  var rval = '';
  var i = 0;
  if(hex.length & 1 == 1) {
    // odd number of characters, convert first character alone
    i = 1;
    rval += String.fromCharCode(parseInt(hex[0], 16));
  }
  // convert 2 characters (1 byte) at a time
  for(; i < hex.length; i += 2) {
    rval += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }
  return rval;
};

/**
 * Converts a 'binary' encoded string of bytes to hex.
 *
 * @param bytes the byte string to convert.
 *
 * @return the string of hexadecimal characters.
 */
util.bytesToHex = function(bytes) {
  // TODO: deprecate: "Deprecated. Use util.binary.hex.encode instead."
  return util.createBuffer(bytes).toHex();
};

/**
 * Converts an 32-bit integer to 4-big-endian byte string.
 *
 * @param i the integer.
 *
 * @return the byte string.
 */
util.int32ToBytes = function(i) {
  return (
    String.fromCharCode(i >> 24 & 0xFF) +
    String.fromCharCode(i >> 16 & 0xFF) +
    String.fromCharCode(i >> 8 & 0xFF) +
    String.fromCharCode(i & 0xFF));
};

// base64 characters, reverse mapping
var _base64 =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
var _base64Idx = [
/*43 -43 = 0*/
/*'+',  1,  2,  3,'/' */
   62, -1, -1, -1, 63,

/*'0','1','2','3','4','5','6','7','8','9' */
   52, 53, 54, 55, 56, 57, 58, 59, 60, 61,

/*15, 16, 17,'=', 19, 20, 21 */
  -1, -1, -1, 64, -1, -1, -1,

/*65 - 43 = 22*/
/*'A','B','C','D','E','F','G','H','I','J','K','L','M', */
   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12,

/*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */
   13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,

/*91 - 43 = 48 */
/*48, 49, 50, 51, 52, 53 */
  -1, -1, -1, -1, -1, -1,

/*97 - 43 = 54*/
/*'a','b','c','d','e','f','g','h','i','j','k','l','m' */
   26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,

/*'n','o','p','q','r','s','t','u','v','w','x','y','z' */
   39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51
];

/**
 * Base64 encodes a 'binary' encoded string of bytes.
 *
 * @param input the binary encoded string of bytes to base64-encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output.
 */
util.encode64 = function(input, maxline) {
  // TODO: deprecate: "Deprecated. Use util.binary.base64.encode instead."
  var line = '';
  var output = '';
  var chr1, chr2, chr3;
  var i = 0;
  while(i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    // encode 4 character group
    line += _base64.charAt(chr1 >> 2);
    line += _base64.charAt(((chr1 & 3) << 4) | (chr2 >> 4));
    if(isNaN(chr2)) {
      line += '==';
    } else {
      line += _base64.charAt(((chr2 & 15) << 2) | (chr3 >> 6));
      line += isNaN(chr3) ? '=' : _base64.charAt(chr3 & 63);
    }

    if(maxline && line.length > maxline) {
      output += line.substr(0, maxline) + '\r\n';
      line = line.substr(maxline);
    }
  }
  output += line;
  return output;
};

/**
 * Base64 decodes a string into a 'binary' encoded string of bytes.
 *
 * @param input the base64-encoded input.
 *
 * @return the binary encoded string.
 */
util.decode64 = function(input) {
  // TODO: deprecate: "Deprecated. Use util.binary.base64.decode instead."

  // remove all non-base64 characters
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

  var output = '';
  var enc1, enc2, enc3, enc4;
  var i = 0;

  while(i < input.length) {
    enc1 = _base64Idx[input.charCodeAt(i++) - 43];
    enc2 = _base64Idx[input.charCodeAt(i++) - 43];
    enc3 = _base64Idx[input.charCodeAt(i++) - 43];
    enc4 = _base64Idx[input.charCodeAt(i++) - 43];

    output += String.fromCharCode((enc1 << 2) | (enc2 >> 4));
    if(enc3 !== 64) {
      // decoded at least 2 bytes
      output += String.fromCharCode(((enc2 & 15) << 4) | (enc3 >> 2));
      if(enc4 !== 64) {
        // decoded 3 bytes
        output += String.fromCharCode(((enc3 & 3) << 6) | enc4);
      }
    }
  }

  return output;
};

/**
 * UTF-8 encodes the given UTF-16 encoded string (a standard JavaScript
 * string). Non-ASCII characters will be encoded as multiple bytes according
 * to UTF-8.
 *
 * @param str the string to encode.
 *
 * @return the UTF-8 encoded string.
 */
util.encodeUtf8 = function(str) {
  return unescape(encodeURIComponent(str));
};

/**
 * Decodes a UTF-8 encoded string into a UTF-16 string.
 *
 * @param str the string to decode.
 *
 * @return the UTF-16 encoded string (standard JavaScript string).
 */
util.decodeUtf8 = function(str) {
  return decodeURIComponent(escape(str));
};

// binary encoding/decoding tools
// FIXME: Experimental. Do not use yet.
util.binary = {
  raw: {},
  hex: {},
  base64: {}
};

/**
 * Encodes a Uint8Array as a binary-encoded string. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param bytes the Uint8Array to encode.
 *
 * @return the binary-encoded string.
 */
util.binary.raw.encode = function(bytes) {
  return String.fromCharCode.apply(null, bytes);
};

/**
 * Decodes a binary-encoded string to a Uint8Array. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param str the binary-encoded string to decode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */
util.binary.raw.decode = function(str, output, offset) {
  var out = output;
  if(!out) {
    out = new Uint8Array(str.length);
  }
  offset = offset || 0;
  var j = offset;
  for(var i = 0; i < str.length; ++i) {
    out[j++] = str.charCodeAt(i);
  }
  return output ? (j - offset) : out;
};

/**
 * Encodes a 'binary' string, ArrayBuffer, DataView, TypedArray, or
 * ByteBuffer as a string of hexadecimal characters.
 *
 * @param bytes the bytes to convert.
 *
 * @return the string of hexadecimal characters.
 */
util.binary.hex.encode = util.bytesToHex;

/**
 * Decodes a hex-encoded string to a Uint8Array.
 *
 * @param hex the hexadecimal string to convert.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */
util.binary.hex.decode = function(hex, output, offset) {
  var out = output;
  if(!out) {
    out = new Uint8Array(Math.ceil(hex.length / 2));
  }
  offset = offset || 0;
  var i = 0, j = offset;
  if(hex.length & 1) {
    // odd number of characters, convert first character alone
    i = 1;
    out[j++] = parseInt(hex[0], 16);
  }
  // convert 2 characters (1 byte) at a time
  for(; i < hex.length; i += 2) {
    out[j++] = parseInt(hex.substr(i, 2), 16);
  }
  return output ? (j - offset) : out;
};

/**
 * Base64-encodes a Uint8Array.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output string.
 */
util.binary.base64.encode = function(input, maxline) {
  var line = '';
  var output = '';
  var chr1, chr2, chr3;
  var i = 0;
  while(i < input.byteLength) {
    chr1 = input[i++];
    chr2 = input[i++];
    chr3 = input[i++];

    // encode 4 character group
    line += _base64.charAt(chr1 >> 2);
    line += _base64.charAt(((chr1 & 3) << 4) | (chr2 >> 4));
    if(isNaN(chr2)) {
      line += '==';
    } else {
      line += _base64.charAt(((chr2 & 15) << 2) | (chr3 >> 6));
      line += isNaN(chr3) ? '=' : _base64.charAt(chr3 & 63);
    }

    if(maxline && line.length > maxline) {
      output += line.substr(0, maxline) + '\r\n';
      line = line.substr(maxline);
    }
  }
  output += line;
  return output;
};

/**
 * Decodes a base64-encoded string to a Uint8Array.
 *
 * @param input the base64-encoded input string.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */
util.binary.base64.decode = function(input, output, offset) {
  var out = output;
  if(!out) {
    out = new Uint8Array(Math.ceil(input.length / 4) * 3);
  }

  // remove all non-base64 characters
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

  offset = offset || 0;
  var enc1, enc2, enc3, enc4;
  var i = 0, j = offset;

  while(i < input.length) {
    enc1 = _base64Idx[input.charCodeAt(i++) - 43];
    enc2 = _base64Idx[input.charCodeAt(i++) - 43];
    enc3 = _base64Idx[input.charCodeAt(i++) - 43];
    enc4 = _base64Idx[input.charCodeAt(i++) - 43];

    out[j++] = (enc1 << 2) | (enc2 >> 4);
    if(enc3 !== 64) {
      // decoded at least 2 bytes
      out[j++] = ((enc2 & 15) << 4) | (enc3 >> 2);
      if(enc4 !== 64) {
        // decoded 3 bytes
        out[j++] = ((enc3 & 3) << 6) | enc4;
      }
    }
  }

  // make sure result is the exact decoded length
  return output ?
         (j - offset) :
         out.subarray(0, j);
};

// text encoding/decoding tools
// FIXME: Experimental. Do not use yet.
util.text = {
  utf8: {},
  utf16: {}
};

/**
 * Encodes the given string as UTF-8 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */
util.text.utf8.encode = function(str, output, offset) {
  str = util.encodeUtf8(str);
  var out = output;
  if(!out) {
    out = new Uint8Array(str.length);
  }
  offset = offset || 0;
  var j = offset;
  for(var i = 0; i < str.length; ++i) {
    out[j++] = str.charCodeAt(i);
  }
  return output ? (j - offset) : out;
};

/**
 * Decodes the UTF-8 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */
util.text.utf8.decode = function(bytes) {
  return util.decodeUtf8(String.fromCharCode.apply(null, bytes));
};

/**
 * Encodes the given string as UTF-16 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */
util.text.utf16.encode = function(str, output, offset) {
  var out = output;
  if(!out) {
    out = new Uint8Array(str.length * 2);
  }
  var view = new Uint16Array(out.buffer);
  offset = offset || 0;
  var j = offset;
  var k = offset;
  for(var i = 0; i < str.length; ++i) {
    view[k++] = str.charCodeAt(i);
    j += 2;
  }
  return output ? (j - offset) : out;
};

/**
 * Decodes the UTF-16 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */
util.text.utf16.decode = function(bytes) {
  return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
};

/**
 * Deflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true to return only raw deflate data, false to include zlib
 *          header and trailer.
 *
 * @return the deflated data as a string.
 */
util.deflate = function(api, bytes, raw) {
  bytes = util.decode64(api.deflate(util.encode64(bytes)).rval);

  // strip zlib header and trailer if necessary
  if(raw) {
    // zlib header is 2 bytes (CMF,FLG) where FLG indicates that
    // there is a 4-byte DICT (alder-32) block before the data if
    // its 5th bit is set
    var start = 2;
    var flg = bytes.charCodeAt(1);
    if(flg & 0x20) {
      start = 6;
    }
    // zlib trailer is 4 bytes of adler-32
    bytes = bytes.substring(start, bytes.length - 4);
  }

  return bytes;
};

/**
 * Inflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true if the incoming data has no zlib header or trailer and is
 *          raw DEFLATE data.
 *
 * @return the inflated data as a string, null on error.
 */
util.inflate = function(api, bytes, raw) {
  // TODO: add zlib header and trailer if necessary/possible
  var rval = api.inflate(util.encode64(bytes)).rval;
  return (rval === null) ? null : util.decode64(rval);
};

/**
 * Sets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param obj the storage object, null to remove.
 */
var _setStorageObject = function(api, id, obj) {
  if(!api) {
    throw new Error('WebStorage not available.');
  }

  var rval;
  if(obj === null) {
    rval = api.removeItem(id);
  } else {
    // json-encode and base64-encode object
    obj = util.encode64(JSON.stringify(obj));
    rval = api.setItem(id, obj);
  }

  // handle potential flash error
  if(typeof(rval) !== 'undefined' && rval.rval !== true) {
    var error = new Error(rval.error.message);
    error.id = rval.error.id;
    error.name = rval.error.name;
    throw error;
  }
};

/**
 * Gets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 *
 * @return the storage object entry or null if none exists.
 */
var _getStorageObject = function(api, id) {
  if(!api) {
    throw new Error('WebStorage not available.');
  }

  // get the existing entry
  var rval = api.getItem(id);

  /* Note: We check api.init because we can't do (api == localStorage)
    on IE because of "Class doesn't support Automation" exception. Only
    the flash api has an init method so this works too, but we need a
    better solution in the future. */

  // flash returns item wrapped in an object, handle special case
  if(api.init) {
    if(rval.rval === null) {
      if(rval.error) {
        var error = new Error(rval.error.message);
        error.id = rval.error.id;
        error.name = rval.error.name;
        throw error;
      }
      // no error, but also no item
      rval = null;
    } else {
      rval = rval.rval;
    }
  }

  // handle decoding
  if(rval !== null) {
    // base64-decode and json-decode data
    rval = JSON.parse(util.decode64(rval));
  }

  return rval;
};

/**
 * Stores an item in local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 */
var _setItem = function(api, id, key, data) {
  // get storage object
  var obj = _getStorageObject(api, id);
  if(obj === null) {
    // create a new storage object
    obj = {};
  }
  // update key
  obj[key] = data;

  // set storage object
  _setStorageObject(api, id, obj);
};

/**
 * Gets an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 *
 * @return the item.
 */
var _getItem = function(api, id, key) {
  // get storage object
  var rval = _getStorageObject(api, id);
  if(rval !== null) {
    // return data at key
    rval = (key in rval) ? rval[key] : null;
  }

  return rval;
};

/**
 * Removes an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 */
var _removeItem = function(api, id, key) {
  // get storage object
  var obj = _getStorageObject(api, id);
  if(obj !== null && key in obj) {
    // remove key
    delete obj[key];

    // see if entry has no keys remaining
    var empty = true;
    for(var prop in obj) {
      empty = false;
      break;
    }
    if(empty) {
      // remove entry entirely if no keys are left
      obj = null;
    }

    // set storage object
    _setStorageObject(api, id, obj);
  }
};

/**
 * Clears the local disk storage identified by the given ID.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 */
var _clearItems = function(api, id) {
  _setStorageObject(api, id, null);
};

/**
 * Calls a storage function.
 *
 * @param func the function to call.
 * @param args the arguments for the function.
 * @param location the location argument.
 *
 * @return the return value from the function.
 */
var _callStorageFunction = function(func, args, location) {
  var rval = null;

  // default storage types
  if(typeof(location) === 'undefined') {
    location = ['web', 'flash'];
  }

  // apply storage types in order of preference
  var type;
  var done = false;
  var exception = null;
  for(var idx in location) {
    type = location[idx];
    try {
      if(type === 'flash' || type === 'both') {
        if(args[0] === null) {
          throw new Error('Flash local storage not available.');
        }
        rval = func.apply(this, args);
        done = (type === 'flash');
      }
      if(type === 'web' || type === 'both') {
        args[0] = localStorage;
        rval = func.apply(this, args);
        done = true;
      }
    } catch(ex) {
      exception = ex;
    }
    if(done) {
      break;
    }
  }

  if(!done) {
    throw exception;
  }

  return rval;
};

/**
 * Stores an item on local disk.
 *
 * The available types of local storage include 'flash', 'web', and 'both'.
 *
 * The type 'flash' refers to flash local storage (SharedObject). In order
 * to use flash local storage, the 'api' parameter must be valid. The type
 * 'web' refers to WebStorage, if supported by the browser. The type 'both'
 * refers to storing using both 'flash' and 'web', not just one or the
 * other.
 *
 * The location array should list the storage types to use in order of
 * preference:
 *
 * ['flash']: flash only storage
 * ['web']: web only storage
 * ['both']: try to store in both
 * ['flash','web']: store in flash first, but if not available, 'web'
 * ['web','flash']: store in web first, but if not available, 'flash'
 *
 * The location array defaults to: ['web', 'flash']
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 * @param location an array with the preferred types of storage to use.
 */
util.setItem = function(api, id, key, data, location) {
  _callStorageFunction(_setItem, arguments, location);
};

/**
 * Gets an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 *
 * @return the item.
 */
util.getItem = function(api, id, key, location) {
  return _callStorageFunction(_getItem, arguments, location);
};

/**
 * Removes an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 */
util.removeItem = function(api, id, key, location) {
  _callStorageFunction(_removeItem, arguments, location);
};

/**
 * Clears the local disk storage identified by the given ID.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface if flash is available.
 * @param id the storage ID to use.
 * @param location an array with the preferred types of storage to use.
 */
util.clearItems = function(api, id, location) {
  _callStorageFunction(_clearItems, arguments, location);
};

/**
 * Parses the scheme, host, and port from an http(s) url.
 *
 * @param str the url string.
 *
 * @return the parsed url object or null if the url is invalid.
 */
util.parseUrl = function(str) {
  // FIXME: this regex looks a bit broken
  var regex = /^(https?):\/\/([^:&^\/]*):?(\d*)(.*)$/g;
  regex.lastIndex = 0;
  var m = regex.exec(str);
  var url = (m === null) ? null : {
    full: str,
    scheme: m[1],
    host: m[2],
    port: m[3],
    path: m[4]
  };
  if(url) {
    url.fullHost = url.host;
    if(url.port) {
      if(url.port !== 80 && url.scheme === 'http') {
        url.fullHost += ':' + url.port;
      } else if(url.port !== 443 && url.scheme === 'https') {
        url.fullHost += ':' + url.port;
      }
    } else if(url.scheme === 'http') {
      url.port = 80;
    } else if(url.scheme === 'https') {
      url.port = 443;
    }
    url.full = url.scheme + '://' + url.fullHost;
  }
  return url;
};

/* Storage for query variables */
var _queryVariables = null;

/**
 * Returns the window location query variables. Query is parsed on the first
 * call and the same object is returned on subsequent calls. The mapping
 * is from keys to an array of values. Parameters without values will have
 * an object key set but no value added to the value array. Values are
 * unescaped.
 *
 * ...?k1=v1&k2=v2:
 * {
 *   "k1": ["v1"],
 *   "k2": ["v2"]
 * }
 *
 * ...?k1=v1&k1=v2:
 * {
 *   "k1": ["v1", "v2"]
 * }
 *
 * ...?k1=v1&k2:
 * {
 *   "k1": ["v1"],
 *   "k2": []
 * }
 *
 * ...?k1=v1&k1:
 * {
 *   "k1": ["v1"]
 * }
 *
 * ...?k1&k1:
 * {
 *   "k1": []
 * }
 *
 * @param query the query string to parse (optional, default to cached
 *          results from parsing window location search query).
 *
 * @return object mapping keys to variables.
 */
util.getQueryVariables = function(query) {
  var parse = function(q) {
    var rval = {};
    var kvpairs = q.split('&');
    for(var i = 0; i < kvpairs.length; i++) {
      var pos = kvpairs[i].indexOf('=');
      var key;
      var val;
      if(pos > 0) {
        key = kvpairs[i].substring(0, pos);
        val = kvpairs[i].substring(pos + 1);
      } else {
        key = kvpairs[i];
        val = null;
      }
      if(!(key in rval)) {
        rval[key] = [];
      }
      // disallow overriding object prototype keys
      if(!(key in Object.prototype) && val !== null) {
        rval[key].push(unescape(val));
      }
    }
    return rval;
  };

   var rval;
   if(typeof(query) === 'undefined') {
     // set cached variables if needed
     if(_queryVariables === null) {
       if(typeof(window) !== 'undefined' && window.location && window.location.search) {
          // parse window search query
          _queryVariables = parse(window.location.search.substring(1));
       } else {
          // no query variables available
          _queryVariables = {};
       }
     }
     rval = _queryVariables;
   } else {
     // parse given query
     rval = parse(query);
   }
   return rval;
};

/**
 * Parses a fragment into a path and query. This method will take a URI
 * fragment and break it up as if it were the main URI. For example:
 *    /bar/baz?a=1&b=2
 * results in:
 *    {
 *       path: ["bar", "baz"],
 *       query: {"k1": ["v1"], "k2": ["v2"]}
 *    }
 *
 * @return object with a path array and query object.
 */
util.parseFragment = function(fragment) {
  // default to whole fragment
  var fp = fragment;
  var fq = '';
  // split into path and query if possible at the first '?'
  var pos = fragment.indexOf('?');
  if(pos > 0) {
    fp = fragment.substring(0, pos);
    fq = fragment.substring(pos + 1);
  }
  // split path based on '/' and ignore first element if empty
  var path = fp.split('/');
  if(path.length > 0 && path[0] === '') {
    path.shift();
  }
  // convert query into object
  var query = (fq === '') ? {} : util.getQueryVariables(fq);

  return {
    pathString: fp,
    queryString: fq,
    path: path,
    query: query
  };
};

/**
 * Makes a request out of a URI-like request string. This is intended to
 * be used where a fragment id (after a URI '#') is parsed as a URI with
 * path and query parts. The string should have a path beginning and
 * delimited by '/' and optional query parameters following a '?'. The
 * query should be a standard URL set of key value pairs delimited by
 * '&'. For backwards compatibility the initial '/' on the path is not
 * required. The request object has the following API, (fully described
 * in the method code):
 *    {
 *       path: <the path string part>.
 *       query: <the query string part>,
 *       getPath(i): get part or all of the split path array,
 *       getQuery(k, i): get part or all of a query key array,
 *       getQueryLast(k, _default): get last element of a query key array.
 *    }
 *
 * @return object with request parameters.
 */
util.makeRequest = function(reqString) {
  var frag = util.parseFragment(reqString);
  var req = {
    // full path string
    path: frag.pathString,
    // full query string
    query: frag.queryString,
    /**
     * Get path or element in path.
     *
     * @param i optional path index.
     *
     * @return path or part of path if i provided.
     */
    getPath: function(i) {
      return (typeof(i) === 'undefined') ? frag.path : frag.path[i];
    },
    /**
     * Get query, values for a key, or value for a key index.
     *
     * @param k optional query key.
     * @param i optional query key index.
     *
     * @return query, values for a key, or value for a key index.
     */
    getQuery: function(k, i) {
      var rval;
      if(typeof(k) === 'undefined') {
        rval = frag.query;
      } else {
        rval = frag.query[k];
        if(rval && typeof(i) !== 'undefined') {
           rval = rval[i];
        }
      }
      return rval;
    },
    getQueryLast: function(k, _default) {
      var rval;
      var vals = req.getQuery(k);
      if(vals) {
        rval = vals[vals.length - 1];
      } else {
        rval = _default;
      }
      return rval;
    }
  };
  return req;
};

/**
 * Makes a URI out of a path, an object with query parameters, and a
 * fragment. Uses jQuery.param() internally for query string creation.
 * If the path is an array, it will be joined with '/'.
 *
 * @param path string path or array of strings.
 * @param query object with query parameters. (optional)
 * @param fragment fragment string. (optional)
 *
 * @return string object with request parameters.
 */
util.makeLink = function(path, query, fragment) {
  // join path parts if needed
  path = jQuery.isArray(path) ? path.join('/') : path;

  var qstr = jQuery.param(query || {});
  fragment = fragment || '';
  return path +
    ((qstr.length > 0) ? ('?' + qstr) : '') +
    ((fragment.length > 0) ? ('#' + fragment) : '');
};

/**
 * Follows a path of keys deep into an object hierarchy and set a value.
 * If a key does not exist or it's value is not an object, create an
 * object in it's place. This can be destructive to a object tree if
 * leaf nodes are given as non-final path keys.
 * Used to avoid exceptions from missing parts of the path.
 *
 * @param object the starting object.
 * @param keys an array of string keys.
 * @param value the value to set.
 */
util.setPath = function(object, keys, value) {
  // need to start at an object
  if(typeof(object) === 'object' && object !== null) {
    var i = 0;
    var len = keys.length;
    while(i < len) {
      var next = keys[i++];
      if(i == len) {
        // last
        object[next] = value;
      } else {
        // more
        var hasNext = (next in object);
        if(!hasNext ||
          (hasNext && typeof(object[next]) !== 'object') ||
          (hasNext && object[next] === null)) {
          object[next] = {};
        }
        object = object[next];
      }
    }
  }
};

/**
 * Follows a path of keys deep into an object hierarchy and return a value.
 * If a key does not exist, create an object in it's place.
 * Used to avoid exceptions from missing parts of the path.
 *
 * @param object the starting object.
 * @param keys an array of string keys.
 * @param _default value to return if path not found.
 *
 * @return the value at the path if found, else default if given, else
 *         undefined.
 */
util.getPath = function(object, keys, _default) {
  var i = 0;
  var len = keys.length;
  var hasNext = true;
  while(hasNext && i < len &&
    typeof(object) === 'object' && object !== null) {
    var next = keys[i++];
    hasNext = next in object;
    if(hasNext) {
      object = object[next];
    }
  }
  return (hasNext ? object : _default);
};

/**
 * Follow a path of keys deep into an object hierarchy and delete the
 * last one. If a key does not exist, do nothing.
 * Used to avoid exceptions from missing parts of the path.
 *
 * @param object the starting object.
 * @param keys an array of string keys.
 */
util.deletePath = function(object, keys) {
  // need to start at an object
  if(typeof(object) === 'object' && object !== null) {
    var i = 0;
    var len = keys.length;
    while(i < len) {
      var next = keys[i++];
      if(i == len) {
        // last
        delete object[next];
      } else {
        // more
        if(!(next in object) ||
          (typeof(object[next]) !== 'object') ||
          (object[next] === null)) {
           break;
        }
        object = object[next];
      }
    }
  }
};

/**
 * Check if an object is empty.
 *
 * Taken from:
 * http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object-from-json/679937#679937
 *
 * @param object the object to check.
 */
util.isEmpty = function(obj) {
  for(var prop in obj) {
    if(obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return true;
};

/**
 * Format with simple printf-style interpolation.
 *
 * %%: literal '%'
 * %s,%o: convert next argument into a string.
 *
 * @param format the string to format.
 * @param ... arguments to interpolate into the format string.
 */
util.format = function(format) {
  var re = /%./g;
  // current match
  var match;
  // current part
  var part;
  // current arg index
  var argi = 0;
  // collected parts to recombine later
  var parts = [];
  // last index found
  var last = 0;
  // loop while matches remain
  while((match = re.exec(format))) {
    part = format.substring(last, re.lastIndex - 2);
    // don't add empty strings (ie, parts between %s%s)
    if(part.length > 0) {
      parts.push(part);
    }
    last = re.lastIndex;
    // switch on % code
    var code = match[0][1];
    switch(code) {
    case 's':
    case 'o':
      // check if enough arguments were given
      if(argi < arguments.length) {
        parts.push(arguments[argi++ + 1]);
      } else {
        parts.push('<?>');
      }
      break;
    // FIXME: do proper formating for numbers, etc
    //case 'f':
    //case 'd':
    case '%':
      parts.push('%');
      break;
    default:
      parts.push('<%' + code + '?>');
    }
  }
  // add trailing part of format string
  parts.push(format.substring(last));
  return parts.join('');
};

/**
 * Formats a number.
 *
 * http://snipplr.com/view/5945/javascript-numberformat--ported-from-php/
 */
util.formatNumber = function(number, decimals, dec_point, thousands_sep) {
  // http://kevin.vanzonneveld.net
  // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +     bugfix by: Michael White (http://crestidg.com)
  // +     bugfix by: Benjamin Lupton
  // +     bugfix by: Allan Jensen (http://www.winternet.no)
  // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // *     example 1: number_format(1234.5678, 2, '.', '');
  // *     returns 1: 1234.57

  var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
  var d = dec_point === undefined ? ',' : dec_point;
  var t = thousands_sep === undefined ?
   '.' : thousands_sep, s = n < 0 ? '-' : '';
  var i = parseInt((n = Math.abs(+n || 0).toFixed(c)), 10) + '';
  var j = (i.length > 3) ? i.length % 3 : 0;
  return s + (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
    (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
};

/**
 * Formats a byte size.
 *
 * http://snipplr.com/view/5949/format-humanize-file-byte-size-presentation-in-javascript/
 */
util.formatSize = function(size) {
  if(size >= 1073741824) {
    size = util.formatNumber(size / 1073741824, 2, '.', '') + ' GiB';
  } else if(size >= 1048576) {
    size = util.formatNumber(size / 1048576, 2, '.', '') + ' MiB';
  } else if(size >= 1024) {
    size = util.formatNumber(size / 1024, 0) + ' KiB';
  } else {
    size = util.formatNumber(size, 0) + ' bytes';
  }
  return size;
};

/**
 * Converts an IPv4 or IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv4 or IPv6 address to convert.
 *
 * @return the 4-byte IPv6 or 16-byte IPv6 address or null if the address can't
 *         be parsed.
 */
util.bytesFromIP = function(ip) {
  if(ip.indexOf('.') !== -1) {
    return util.bytesFromIPv4(ip);
  }
  if(ip.indexOf(':') !== -1) {
    return util.bytesFromIPv6(ip);
  }
  return null;
};

/**
 * Converts an IPv4 string representation into bytes (in network order).
 *
 * @param ip the IPv4 address to convert.
 *
 * @return the 4-byte address or null if the address can't be parsed.
 */
util.bytesFromIPv4 = function(ip) {
  ip = ip.split('.');
  if(ip.length !== 4) {
    return null;
  }
  var b = util.createBuffer();
  for(var i = 0; i < ip.length; ++i) {
    var num = parseInt(ip[i], 10);
    if(isNaN(num)) {
      return null;
    }
    b.putByte(num);
  }
  return b.getBytes();
};

/**
 * Converts an IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv6 address to convert.
 *
 * @return the 16-byte address or null if the address can't be parsed.
 */
util.bytesFromIPv6 = function(ip) {
  var blanks = 0;
  ip = ip.split(':').filter(function(e) {
    if(e.length === 0) ++blanks;
    return true;
  });
  var zeros = (8 - ip.length + blanks) * 2;
  var b = util.createBuffer();
  for(var i = 0; i < 8; ++i) {
    if(!ip[i] || ip[i].length === 0) {
      b.fillWithByte(0, zeros);
      zeros = 0;
      continue;
    }
    var bytes = util.hexToBytes(ip[i]);
    if(bytes.length < 2) {
      b.putByte(0);
    }
    b.putBytes(bytes);
  }
  return b.getBytes();
};

/**
 * Converts 4-bytes into an IPv4 string representation or 16-bytes into
 * an IPv6 string representation. The bytes must be in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 or IPv6 string representation if 4 or 16 bytes,
 *         respectively, are given, otherwise null.
 */
util.bytesToIP = function(bytes) {
  if(bytes.length === 4) {
    return util.bytesToIPv4(bytes);
  }
  if(bytes.length === 16) {
    return util.bytesToIPv6(bytes);
  }
  return null;
};

/**
 * Converts 4-bytes into an IPv4 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 string representation or null for an invalid # of bytes.
 */
util.bytesToIPv4 = function(bytes) {
  if(bytes.length !== 4) {
    return null;
  }
  var ip = [];
  for(var i = 0; i < bytes.length; ++i) {
    ip.push(bytes.charCodeAt(i));
  }
  return ip.join('.');
};

/**
 * Converts 16-bytes into an IPv16 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv16 string representation or null for an invalid # of bytes.
 */
util.bytesToIPv6 = function(bytes) {
  if(bytes.length !== 16) {
    return null;
  }
  var ip = [];
  var zeroGroups = [];
  var zeroMaxGroup = 0;
  for(var i = 0; i < bytes.length; i += 2) {
    var hex = util.bytesToHex(bytes[i] + bytes[i + 1]);
    // canonicalize zero representation
    while(hex[0] === '0' && hex !== '0') {
      hex = hex.substr(1);
    }
    if(hex === '0') {
      var last = zeroGroups[zeroGroups.length - 1];
      var idx = ip.length;
      if(!last || idx !== last.end + 1) {
        zeroGroups.push({start: idx, end: idx});
      } else {
        last.end = idx;
        if((last.end - last.start) >
          (zeroGroups[zeroMaxGroup].end - zeroGroups[zeroMaxGroup].start)) {
          zeroMaxGroup = zeroGroups.length - 1;
        }
      }
    }
    ip.push(hex);
  }
  if(zeroGroups.length > 0) {
    var group = zeroGroups[zeroMaxGroup];
    // only shorten group of length > 0
    if(group.end - group.start > 0) {
      ip.splice(group.start, group.end - group.start + 1, '');
      if(group.start === 0) {
        ip.unshift('');
      }
      if(group.end === 7) {
        ip.push('');
      }
    }
  }
  return ip.join(':');
};

/**
 * Estimates the number of processes that can be run concurrently. If
 * creating Web Workers, keep in mind that the main JavaScript process needs
 * its own core.
 *
 * @param options the options to use:
 *          update true to force an update (not use the cached value).
 * @param callback(err, max) called once the operation completes.
 */
util.estimateCores = function(options, callback) {
  if(typeof options === 'function') {
    callback = options;
    options = {};
  }
  options = options || {};
  if('cores' in util && !options.update) {
    return callback(null, util.cores);
  }
  if(typeof navigator !== 'undefined' &&
    'hardwareConcurrency' in navigator &&
    navigator.hardwareConcurrency > 0) {
    util.cores = navigator.hardwareConcurrency;
    return callback(null, util.cores);
  }
  if(typeof Worker === 'undefined') {
    // workers not available
    util.cores = 1;
    return callback(null, util.cores);
  }
  if(typeof Blob === 'undefined') {
    // can't estimate, default to 2
    util.cores = 2;
    return callback(null, util.cores);
  }

  // create worker concurrency estimation code as blob
  var blobUrl = URL.createObjectURL(new Blob(['(',
    function() {
      self.addEventListener('message', function(e) {
        // run worker for 4 ms
        var st = Date.now();
        var et = st + 4;
        while(Date.now() < et);
        self.postMessage({st: st, et: et});
      });
    }.toString(),
  ')()'], {type: 'application/javascript'}));

  // take 5 samples using 16 workers
  sample([], 5, 16);

  function sample(max, samples, numWorkers) {
    if(samples === 0) {
      // get overlap average
      var avg = Math.floor(max.reduce(function(avg, x) {
        return avg + x;
      }, 0) / max.length);
      util.cores = Math.max(1, avg);
      URL.revokeObjectURL(blobUrl);
      return callback(null, util.cores);
    }
    map(numWorkers, function(err, results) {
      max.push(reduce(numWorkers, results));
      sample(max, samples - 1, numWorkers);
    });
  }

  function map(numWorkers, callback) {
    var workers = [];
    var results = [];
    for(var i = 0; i < numWorkers; ++i) {
      var worker = new Worker(blobUrl);
      worker.addEventListener('message', function(e) {
        results.push(e.data);
        if(results.length === numWorkers) {
          for(var i = 0; i < numWorkers; ++i) {
            workers[i].terminate();
          }
          callback(null, results);
        }
      });
      workers.push(worker);
    }
    for(var i = 0; i < numWorkers; ++i) {
      workers[i].postMessage(i);
    }
  }

  function reduce(numWorkers, results) {
    // find overlapping time windows
    var overlaps = [];
    for(var n = 0; n < numWorkers; ++n) {
      var r1 = results[n];
      var overlap = overlaps[n] = [];
      for(var i = 0; i < numWorkers; ++i) {
        if(n === i) {
          continue;
        }
        var r2 = results[i];
        if((r1.st > r2.st && r1.st < r2.et) ||
          (r2.st > r1.st && r2.st < r1.et)) {
          overlap.push(i);
        }
      }
    }
    // get maximum overlaps ... don't include overlapping worker itself
    // as the main JS process was also being scheduled during the work and
    // would have to be subtracted from the estimate anyway
    return overlaps.reduce(function(max, overlap) {
      return Math.max(max, overlap.length);
    }, 0);
  }
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Advanced Encryption Standard (AES) implementation.
 *
 * This implementation is based on the public domain library 'jscrypto' which
 * was written by:
 *
 * Emily Stark (estark@stanford.edu)
 * Mike Hamburg (mhamburg@stanford.edu)
 * Dan Boneh (dabo@cs.stanford.edu)
 *
 * Parts of this code are based on the OpenSSL implementation of AES:
 * http://www.openssl.org
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */
var forge = __webpack_require__(0);
__webpack_require__(3);
__webpack_require__(5);
__webpack_require__(1);

/* AES API */
module.exports = forge.aes = forge.aes || {};

/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */
forge.aes.startEncrypting = function(key, iv, output, mode) {
  var cipher = _createCipher({
    key: key,
    output: output,
    decrypt: false,
    mode: mode
  });
  cipher.start(iv);
  return cipher;
};

/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */
forge.aes.createEncryptionCipher = function(key, mode) {
  return _createCipher({
    key: key,
    output: null,
    decrypt: false,
    mode: mode
  });
};

/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */
forge.aes.startDecrypting = function(key, iv, output, mode) {
  var cipher = _createCipher({
    key: key,
    output: output,
    decrypt: true,
    mode: mode
  });
  cipher.start(iv);
  return cipher;
};

/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */
forge.aes.createDecryptionCipher = function(key, mode) {
  return _createCipher({
    key: key,
    output: null,
    decrypt: true,
    mode: mode
  });
};

/**
 * Creates a new AES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the AES algorithm object.
 */
forge.aes.Algorithm = function(name, mode) {
  if(!init) {
    initialize();
  }
  var self = this;
  self.name = name;
  self.mode = new mode({
    blockSize: 16,
    cipher: {
      encrypt: function(inBlock, outBlock) {
        return _updateBlock(self._w, inBlock, outBlock, false);
      },
      decrypt: function(inBlock, outBlock) {
        return _updateBlock(self._w, inBlock, outBlock, true);
      }
    }
  });
  self._init = false;
};

/**
 * Initializes this AES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */
forge.aes.Algorithm.prototype.initialize = function(options) {
  if(this._init) {
    return;
  }

  var key = options.key;
  var tmp;

  /* Note: The key may be a string of bytes, an array of bytes, a byte
    buffer, or an array of 32-bit integers. If the key is in bytes, then
    it must be 16, 24, or 32 bytes in length. If it is in 32-bit
    integers, it must be 4, 6, or 8 integers long. */

  if(typeof key === 'string' &&
    (key.length === 16 || key.length === 24 || key.length === 32)) {
    // convert key string into byte buffer
    key = forge.util.createBuffer(key);
  } else if(forge.util.isArray(key) &&
    (key.length === 16 || key.length === 24 || key.length === 32)) {
    // convert key integer array into byte buffer
    tmp = key;
    key = forge.util.createBuffer();
    for(var i = 0; i < tmp.length; ++i) {
      key.putByte(tmp[i]);
    }
  }

  // convert key byte buffer into 32-bit integer array
  if(!forge.util.isArray(key)) {
    tmp = key;
    key = [];

    // key lengths of 16, 24, 32 bytes allowed
    var len = tmp.length();
    if(len === 16 || len === 24 || len === 32) {
      len = len >>> 2;
      for(var i = 0; i < len; ++i) {
        key.push(tmp.getInt32());
      }
    }
  }

  // key must be an array of 32-bit integers by now
  if(!forge.util.isArray(key) ||
    !(key.length === 4 || key.length === 6 || key.length === 8)) {
    throw new Error('Invalid key parameter.');
  }

  // encryption operation is always used for these modes
  var mode = this.mode.name;
  var encryptOp = (['CFB', 'OFB', 'CTR', 'GCM'].indexOf(mode) !== -1);

  // do key expansion
  this._w = _expandKey(key, options.decrypt && !encryptOp);
  this._init = true;
};

/**
 * Expands a key. Typically only used for testing.
 *
 * @param key the symmetric key to expand, as an array of 32-bit words.
 * @param decrypt true to expand for decryption, false for encryption.
 *
 * @return the expanded key.
 */
forge.aes._expandKey = function(key, decrypt) {
  if(!init) {
    initialize();
  }
  return _expandKey(key, decrypt);
};

/**
 * Updates a single block. Typically only used for testing.
 *
 * @param w the expanded key to use.
 * @param input an array of block-size 32-bit words.
 * @param output an array of block-size 32-bit words.
 * @param decrypt true to decrypt, false to encrypt.
 */
forge.aes._updateBlock = _updateBlock;

/** Register AES algorithms **/

registerAlgorithm('AES-ECB', forge.cipher.modes.ecb);
registerAlgorithm('AES-CBC', forge.cipher.modes.cbc);
registerAlgorithm('AES-CFB', forge.cipher.modes.cfb);
registerAlgorithm('AES-OFB', forge.cipher.modes.ofb);
registerAlgorithm('AES-CTR', forge.cipher.modes.ctr);
registerAlgorithm('AES-GCM', forge.cipher.modes.gcm);

function registerAlgorithm(name, mode) {
  var factory = function() {
    return new forge.aes.Algorithm(name, mode);
  };
  forge.cipher.registerAlgorithm(name, factory);
}

/** AES implementation **/

var init = false; // not yet initialized
var Nb = 4;       // number of words comprising the state (AES = 4)
var sbox;         // non-linear substitution table used in key expansion
var isbox;        // inversion of sbox
var rcon;         // round constant word array
var mix;          // mix-columns table
var imix;         // inverse mix-columns table

/**
 * Performs initialization, ie: precomputes tables to optimize for speed.
 *
 * One way to understand how AES works is to imagine that 'addition' and
 * 'multiplication' are interfaces that require certain mathematical
 * properties to hold true (ie: they are associative) but they might have
 * different implementations and produce different kinds of results ...
 * provided that their mathematical properties remain true. AES defines
 * its own methods of addition and multiplication but keeps some important
 * properties the same, ie: associativity and distributivity. The
 * explanation below tries to shed some light on how AES defines addition
 * and multiplication of bytes and 32-bit words in order to perform its
 * encryption and decryption algorithms.
 *
 * The basics:
 *
 * The AES algorithm views bytes as binary representations of polynomials
 * that have either 1 or 0 as the coefficients. It defines the addition
 * or subtraction of two bytes as the XOR operation. It also defines the
 * multiplication of two bytes as a finite field referred to as GF(2^8)
 * (Note: 'GF' means "Galois Field" which is a field that contains a finite
 * number of elements so GF(2^8) has 256 elements).
 *
 * This means that any two bytes can be represented as binary polynomials;
 * when they multiplied together and modularly reduced by an irreducible
 * polynomial of the 8th degree, the results are the field GF(2^8). The
 * specific irreducible polynomial that AES uses in hexadecimal is 0x11b.
 * This multiplication is associative with 0x01 as the identity:
 *
 * (b * 0x01 = GF(b, 0x01) = b).
 *
 * The operation GF(b, 0x02) can be performed at the byte level by left
 * shifting b once and then XOR'ing it (to perform the modular reduction)
 * with 0x11b if b is >= 128. Repeated application of the multiplication
 * of 0x02 can be used to implement the multiplication of any two bytes.
 *
 * For instance, multiplying 0x57 and 0x13, denoted as GF(0x57, 0x13), can
 * be performed by factoring 0x13 into 0x01, 0x02, and 0x10. Then these
 * factors can each be multiplied by 0x57 and then added together. To do
 * the multiplication, values for 0x57 multiplied by each of these 3 factors
 * can be precomputed and stored in a table. To add them, the values from
 * the table are XOR'd together.
 *
 * AES also defines addition and multiplication of words, that is 4-byte
 * numbers represented as polynomials of 3 degrees where the coefficients
 * are the values of the bytes.
 *
 * The word [a0, a1, a2, a3] is a polynomial a3x^3 + a2x^2 + a1x + a0.
 *
 * Addition is performed by XOR'ing like powers of x. Multiplication
 * is performed in two steps, the first is an algebriac expansion as
 * you would do normally (where addition is XOR). But the result is
 * a polynomial larger than 3 degrees and thus it cannot fit in a word. So
 * next the result is modularly reduced by an AES-specific polynomial of
 * degree 4 which will always produce a polynomial of less than 4 degrees
 * such that it will fit in a word. In AES, this polynomial is x^4 + 1.
 *
 * The modular product of two polynomials 'a' and 'b' is thus:
 *
 * d(x) = d3x^3 + d2x^2 + d1x + d0
 * with
 * d0 = GF(a0, b0) ^ GF(a3, b1) ^ GF(a2, b2) ^ GF(a1, b3)
 * d1 = GF(a1, b0) ^ GF(a0, b1) ^ GF(a3, b2) ^ GF(a2, b3)
 * d2 = GF(a2, b0) ^ GF(a1, b1) ^ GF(a0, b2) ^ GF(a3, b3)
 * d3 = GF(a3, b0) ^ GF(a2, b1) ^ GF(a1, b2) ^ GF(a0, b3)
 *
 * As a matrix:
 *
 * [d0] = [a0 a3 a2 a1][b0]
 * [d1]   [a1 a0 a3 a2][b1]
 * [d2]   [a2 a1 a0 a3][b2]
 * [d3]   [a3 a2 a1 a0][b3]
 *
 * Special polynomials defined by AES (0x02 == {02}):
 * a(x)    = {03}x^3 + {01}x^2 + {01}x + {02}
 * a^-1(x) = {0b}x^3 + {0d}x^2 + {09}x + {0e}.
 *
 * These polynomials are used in the MixColumns() and InverseMixColumns()
 * operations, respectively, to cause each element in the state to affect
 * the output (referred to as diffusing).
 *
 * RotWord() uses: a0 = a1 = a2 = {00} and a3 = {01}, which is the
 * polynomial x3.
 *
 * The ShiftRows() method modifies the last 3 rows in the state (where
 * the state is 4 words with 4 bytes per word) by shifting bytes cyclically.
 * The 1st byte in the second row is moved to the end of the row. The 1st
 * and 2nd bytes in the third row are moved to the end of the row. The 1st,
 * 2nd, and 3rd bytes are moved in the fourth row.
 *
 * More details on how AES arithmetic works:
 *
 * In the polynomial representation of binary numbers, XOR performs addition
 * and subtraction and multiplication in GF(2^8) denoted as GF(a, b)
 * corresponds with the multiplication of polynomials modulo an irreducible
 * polynomial of degree 8. In other words, for AES, GF(a, b) will multiply
 * polynomial 'a' with polynomial 'b' and then do a modular reduction by
 * an AES-specific irreducible polynomial of degree 8.
 *
 * A polynomial is irreducible if its only divisors are one and itself. For
 * the AES algorithm, this irreducible polynomial is:
 *
 * m(x) = x^8 + x^4 + x^3 + x + 1,
 *
 * or {01}{1b} in hexadecimal notation, where each coefficient is a bit:
 * 100011011 = 283 = 0x11b.
 *
 * For example, GF(0x57, 0x83) = 0xc1 because
 *
 * 0x57 = 87  = 01010111 = x^6 + x^4 + x^2 + x + 1
 * 0x85 = 131 = 10000101 = x^7 + x + 1
 *
 * (x^6 + x^4 + x^2 + x + 1) * (x^7 + x + 1)
 * =  x^13 + x^11 + x^9 + x^8 + x^7 +
 *    x^7 + x^5 + x^3 + x^2 + x +
 *    x^6 + x^4 + x^2 + x + 1
 * =  x^13 + x^11 + x^9 + x^8 + x^6 + x^5 + x^4 + x^3 + 1 = y
 *    y modulo (x^8 + x^4 + x^3 + x + 1)
 * =  x^7 + x^6 + 1.
 *
 * The modular reduction by m(x) guarantees the result will be a binary
 * polynomial of less than degree 8, so that it can fit in a byte.
 *
 * The operation to multiply a binary polynomial b with x (the polynomial
 * x in binary representation is 00000010) is:
 *
 * b_7x^8 + b_6x^7 + b_5x^6 + b_4x^5 + b_3x^4 + b_2x^3 + b_1x^2 + b_0x^1
 *
 * To get GF(b, x) we must reduce that by m(x). If b_7 is 0 (that is the
 * most significant bit is 0 in b) then the result is already reduced. If
 * it is 1, then we can reduce it by subtracting m(x) via an XOR.
 *
 * It follows that multiplication by x (00000010 or 0x02) can be implemented
 * by performing a left shift followed by a conditional bitwise XOR with
 * 0x1b. This operation on bytes is denoted by xtime(). Multiplication by
 * higher powers of x can be implemented by repeated application of xtime().
 *
 * By adding intermediate results, multiplication by any constant can be
 * implemented. For instance:
 *
 * GF(0x57, 0x13) = 0xfe because:
 *
 * xtime(b) = (b & 128) ? (b << 1 ^ 0x11b) : (b << 1)
 *
 * Note: We XOR with 0x11b instead of 0x1b because in javascript our
 * datatype for b can be larger than 1 byte, so a left shift will not
 * automatically eliminate bits that overflow a byte ... by XOR'ing the
 * overflow bit with 1 (the extra one from 0x11b) we zero it out.
 *
 * GF(0x57, 0x02) = xtime(0x57) = 0xae
 * GF(0x57, 0x04) = xtime(0xae) = 0x47
 * GF(0x57, 0x08) = xtime(0x47) = 0x8e
 * GF(0x57, 0x10) = xtime(0x8e) = 0x07
 *
 * GF(0x57, 0x13) = GF(0x57, (0x01 ^ 0x02 ^ 0x10))
 *
 * And by the distributive property (since XOR is addition and GF() is
 * multiplication):
 *
 * = GF(0x57, 0x01) ^ GF(0x57, 0x02) ^ GF(0x57, 0x10)
 * = 0x57 ^ 0xae ^ 0x07
 * = 0xfe.
 */
function initialize() {
  init = true;

  /* Populate the Rcon table. These are the values given by
    [x^(i-1),{00},{00},{00}] where x^(i-1) are powers of x (and x = 0x02)
    in the field of GF(2^8), where i starts at 1.

    rcon[0] = [0x00, 0x00, 0x00, 0x00]
    rcon[1] = [0x01, 0x00, 0x00, 0x00] 2^(1-1) = 2^0 = 1
    rcon[2] = [0x02, 0x00, 0x00, 0x00] 2^(2-1) = 2^1 = 2
    ...
    rcon[9]  = [0x1B, 0x00, 0x00, 0x00] 2^(9-1)  = 2^8 = 0x1B
    rcon[10] = [0x36, 0x00, 0x00, 0x00] 2^(10-1) = 2^9 = 0x36

    We only store the first byte because it is the only one used.
  */
  rcon = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1B, 0x36];

  // compute xtime table which maps i onto GF(i, 0x02)
  var xtime = new Array(256);
  for(var i = 0; i < 128; ++i) {
    xtime[i] = i << 1;
    xtime[i + 128] = (i + 128) << 1 ^ 0x11B;
  }

  // compute all other tables
  sbox = new Array(256);
  isbox = new Array(256);
  mix = new Array(4);
  imix = new Array(4);
  for(var i = 0; i < 4; ++i) {
    mix[i] = new Array(256);
    imix[i] = new Array(256);
  }
  var e = 0, ei = 0, e2, e4, e8, sx, sx2, me, ime;
  for(var i = 0; i < 256; ++i) {
    /* We need to generate the SubBytes() sbox and isbox tables so that
      we can perform byte substitutions. This requires us to traverse
      all of the elements in GF, find their multiplicative inverses,
      and apply to each the following affine transformation:

      bi' = bi ^ b(i + 4) mod 8 ^ b(i + 5) mod 8 ^ b(i + 6) mod 8 ^
            b(i + 7) mod 8 ^ ci
      for 0 <= i < 8, where bi is the ith bit of the byte, and ci is the
      ith bit of a byte c with the value {63} or {01100011}.

      It is possible to traverse every possible value in a Galois field
      using what is referred to as a 'generator'. There are many
      generators (128 out of 256): 3,5,6,9,11,82 to name a few. To fully
      traverse GF we iterate 255 times, multiplying by our generator
      each time.

      On each iteration we can determine the multiplicative inverse for
      the current element.

      Suppose there is an element in GF 'e'. For a given generator 'g',
      e = g^x. The multiplicative inverse of e is g^(255 - x). It turns
      out that if use the inverse of a generator as another generator
      it will produce all of the corresponding multiplicative inverses
      at the same time. For this reason, we choose 5 as our inverse
      generator because it only requires 2 multiplies and 1 add and its
      inverse, 82, requires relatively few operations as well.

      In order to apply the affine transformation, the multiplicative
      inverse 'ei' of 'e' can be repeatedly XOR'd (4 times) with a
      bit-cycling of 'ei'. To do this 'ei' is first stored in 's' and
      'x'. Then 's' is left shifted and the high bit of 's' is made the
      low bit. The resulting value is stored in 's'. Then 'x' is XOR'd
      with 's' and stored in 'x'. On each subsequent iteration the same
      operation is performed. When 4 iterations are complete, 'x' is
      XOR'd with 'c' (0x63) and the transformed value is stored in 'x'.
      For example:

      s = 01000001
      x = 01000001

      iteration 1: s = 10000010, x ^= s
      iteration 2: s = 00000101, x ^= s
      iteration 3: s = 00001010, x ^= s
      iteration 4: s = 00010100, x ^= s
      x ^= 0x63

      This can be done with a loop where s = (s << 1) | (s >> 7). However,
      it can also be done by using a single 16-bit (in this case 32-bit)
      number 'sx'. Since XOR is an associative operation, we can set 'sx'
      to 'ei' and then XOR it with 'sx' left-shifted 1,2,3, and 4 times.
      The most significant bits will flow into the high 8 bit positions
      and be correctly XOR'd with one another. All that remains will be
      to cycle the high 8 bits by XOR'ing them all with the lower 8 bits
      afterwards.

      At the same time we're populating sbox and isbox we can precompute
      the multiplication we'll need to do to do MixColumns() later.
    */

    // apply affine transformation
    sx = ei ^ (ei << 1) ^ (ei << 2) ^ (ei << 3) ^ (ei << 4);
    sx = (sx >> 8) ^ (sx & 255) ^ 0x63;

    // update tables
    sbox[e] = sx;
    isbox[sx] = e;

    /* Mixing columns is done using matrix multiplication. The columns
      that are to be mixed are each a single word in the current state.
      The state has Nb columns (4 columns). Therefore each column is a
      4 byte word. So to mix the columns in a single column 'c' where
      its rows are r0, r1, r2, and r3, we use the following matrix
      multiplication:

      [2 3 1 1]*[r0,c]=[r'0,c]
      [1 2 3 1] [r1,c] [r'1,c]
      [1 1 2 3] [r2,c] [r'2,c]
      [3 1 1 2] [r3,c] [r'3,c]

      r0, r1, r2, and r3 are each 1 byte of one of the words in the
      state (a column). To do matrix multiplication for each mixed
      column c' we multiply the corresponding row from the left matrix
      with the corresponding column from the right matrix. In total, we
      get 4 equations:

      r0,c' = 2*r0,c + 3*r1,c + 1*r2,c + 1*r3,c
      r1,c' = 1*r0,c + 2*r1,c + 3*r2,c + 1*r3,c
      r2,c' = 1*r0,c + 1*r1,c + 2*r2,c + 3*r3,c
      r3,c' = 3*r0,c + 1*r1,c + 1*r2,c + 2*r3,c

      As usual, the multiplication is as previously defined and the
      addition is XOR. In order to optimize mixing columns we can store
      the multiplication results in tables. If you think of the whole
      column as a word (it might help to visualize by mentally rotating
      the equations above by counterclockwise 90 degrees) then you can
      see that it would be useful to map the multiplications performed on
      each byte (r0, r1, r2, r3) onto a word as well. For instance, we
      could map 2*r0,1*r0,1*r0,3*r0 onto a word by storing 2*r0 in the
      highest 8 bits and 3*r0 in the lowest 8 bits (with the other two
      respectively in the middle). This means that a table can be
      constructed that uses r0 as an index to the word. We can do the
      same with r1, r2, and r3, creating a total of 4 tables.

      To construct a full c', we can just look up each byte of c in
      their respective tables and XOR the results together.

      Also, to build each table we only have to calculate the word
      for 2,1,1,3 for every byte ... which we can do on each iteration
      of this loop since we will iterate over every byte. After we have
      calculated 2,1,1,3 we can get the results for the other tables
      by cycling the byte at the end to the beginning. For instance
      we can take the result of table 2,1,1,3 and produce table 3,2,1,1
      by moving the right most byte to the left most position just like
      how you can imagine the 3 moved out of 2,1,1,3 and to the front
      to produce 3,2,1,1.

      There is another optimization in that the same multiples of
      the current element we need in order to advance our generator
      to the next iteration can be reused in performing the 2,1,1,3
      calculation. We also calculate the inverse mix column tables,
      with e,9,d,b being the inverse of 2,1,1,3.

      When we're done, and we need to actually mix columns, the first
      byte of each state word should be put through mix[0] (2,1,1,3),
      the second through mix[1] (3,2,1,1) and so forth. Then they should
      be XOR'd together to produce the fully mixed column.
    */

    // calculate mix and imix table values
    sx2 = xtime[sx];
    e2 = xtime[e];
    e4 = xtime[e2];
    e8 = xtime[e4];
    me =
      (sx2 << 24) ^  // 2
      (sx << 16) ^   // 1
      (sx << 8) ^    // 1
      (sx ^ sx2);    // 3
    ime =
      (e2 ^ e4 ^ e8) << 24 ^  // E (14)
      (e ^ e8) << 16 ^        // 9
      (e ^ e4 ^ e8) << 8 ^    // D (13)
      (e ^ e2 ^ e8);          // B (11)
    // produce each of the mix tables by rotating the 2,1,1,3 value
    for(var n = 0; n < 4; ++n) {
      mix[n][e] = me;
      imix[n][sx] = ime;
      // cycle the right most byte to the left most position
      // ie: 2,1,1,3 becomes 3,2,1,1
      me = me << 24 | me >>> 8;
      ime = ime << 24 | ime >>> 8;
    }

    // get next element and inverse
    if(e === 0) {
      // 1 is the inverse of 1
      e = ei = 1;
    } else {
      // e = 2e + 2*2*2*(10e)) = multiply e by 82 (chosen generator)
      // ei = ei + 2*2*ei = multiply ei by 5 (inverse generator)
      e = e2 ^ xtime[xtime[xtime[e2 ^ e8]]];
      ei ^= xtime[xtime[ei]];
    }
  }
}

/**
 * Generates a key schedule using the AES key expansion algorithm.
 *
 * The AES algorithm takes the Cipher Key, K, and performs a Key Expansion
 * routine to generate a key schedule. The Key Expansion generates a total
 * of Nb*(Nr + 1) words: the algorithm requires an initial set of Nb words,
 * and each of the Nr rounds requires Nb words of key data. The resulting
 * key schedule consists of a linear array of 4-byte words, denoted [wi ],
 * with i in the range 0 ≤ i < Nb(Nr + 1).
 *
 * KeyExpansion(byte key[4*Nk], word w[Nb*(Nr+1)], Nk)
 * AES-128 (Nb=4, Nk=4, Nr=10)
 * AES-192 (Nb=4, Nk=6, Nr=12)
 * AES-256 (Nb=4, Nk=8, Nr=14)
 * Note: Nr=Nk+6.
 *
 * Nb is the number of columns (32-bit words) comprising the State (or
 * number of bytes in a block). For AES, Nb=4.
 *
 * @param key the key to schedule (as an array of 32-bit words).
 * @param decrypt true to modify the key schedule to decrypt, false not to.
 *
 * @return the generated key schedule.
 */
function _expandKey(key, decrypt) {
  // copy the key's words to initialize the key schedule
  var w = key.slice(0);

  /* RotWord() will rotate a word, moving the first byte to the last
    byte's position (shifting the other bytes left).

    We will be getting the value of Rcon at i / Nk. 'i' will iterate
    from Nk to (Nb * Nr+1). Nk = 4 (4 byte key), Nb = 4 (4 words in
    a block), Nr = Nk + 6 (10). Therefore 'i' will iterate from
    4 to 44 (exclusive). Each time we iterate 4 times, i / Nk will
    increase by 1. We use a counter iNk to keep track of this.
   */

  // go through the rounds expanding the key
  var temp, iNk = 1;
  var Nk = w.length;
  var Nr1 = Nk + 6 + 1;
  var end = Nb * Nr1;
  for(var i = Nk; i < end; ++i) {
    temp = w[i - 1];
    if(i % Nk === 0) {
      // temp = SubWord(RotWord(temp)) ^ Rcon[i / Nk]
      temp =
        sbox[temp >>> 16 & 255] << 24 ^
        sbox[temp >>> 8 & 255] << 16 ^
        sbox[temp & 255] << 8 ^
        sbox[temp >>> 24] ^ (rcon[iNk] << 24);
      iNk++;
    } else if(Nk > 6 && (i % Nk === 4)) {
      // temp = SubWord(temp)
      temp =
        sbox[temp >>> 24] << 24 ^
        sbox[temp >>> 16 & 255] << 16 ^
        sbox[temp >>> 8 & 255] << 8 ^
        sbox[temp & 255];
    }
    w[i] = w[i - Nk] ^ temp;
  }

   /* When we are updating a cipher block we always use the code path for
     encryption whether we are decrypting or not (to shorten code and
     simplify the generation of look up tables). However, because there
     are differences in the decryption algorithm, other than just swapping
     in different look up tables, we must transform our key schedule to
     account for these changes:

     1. The decryption algorithm gets its key rounds in reverse order.
     2. The decryption algorithm adds the round key before mixing columns
       instead of afterwards.

     We don't need to modify our key schedule to handle the first case,
     we can just traverse the key schedule in reverse order when decrypting.

     The second case requires a little work.

     The tables we built for performing rounds will take an input and then
     perform SubBytes() and MixColumns() or, for the decrypt version,
     InvSubBytes() and InvMixColumns(). But the decrypt algorithm requires
     us to AddRoundKey() before InvMixColumns(). This means we'll need to
     apply some transformations to the round key to inverse-mix its columns
     so they'll be correct for moving AddRoundKey() to after the state has
     had its columns inverse-mixed.

     To inverse-mix the columns of the state when we're decrypting we use a
     lookup table that will apply InvSubBytes() and InvMixColumns() at the
     same time. However, the round key's bytes are not inverse-substituted
     in the decryption algorithm. To get around this problem, we can first
     substitute the bytes in the round key so that when we apply the
     transformation via the InvSubBytes()+InvMixColumns() table, it will
     undo our substitution leaving us with the original value that we
     want -- and then inverse-mix that value.

     This change will correctly alter our key schedule so that we can XOR
     each round key with our already transformed decryption state. This
     allows us to use the same code path as the encryption algorithm.

     We make one more change to the decryption key. Since the decryption
     algorithm runs in reverse from the encryption algorithm, we reverse
     the order of the round keys to avoid having to iterate over the key
     schedule backwards when running the encryption algorithm later in
     decryption mode. In addition to reversing the order of the round keys,
     we also swap each round key's 2nd and 4th rows. See the comments
     section where rounds are performed for more details about why this is
     done. These changes are done inline with the other substitution
     described above.
  */
  if(decrypt) {
    var tmp;
    var m0 = imix[0];
    var m1 = imix[1];
    var m2 = imix[2];
    var m3 = imix[3];
    var wnew = w.slice(0);
    end = w.length;
    for(var i = 0, wi = end - Nb; i < end; i += Nb, wi -= Nb) {
      // do not sub the first or last round key (round keys are Nb
      // words) as no column mixing is performed before they are added,
      // but do change the key order
      if(i === 0 || i === (end - Nb)) {
        wnew[i] = w[wi];
        wnew[i + 1] = w[wi + 3];
        wnew[i + 2] = w[wi + 2];
        wnew[i + 3] = w[wi + 1];
      } else {
        // substitute each round key byte because the inverse-mix
        // table will inverse-substitute it (effectively cancel the
        // substitution because round key bytes aren't sub'd in
        // decryption mode) and swap indexes 3 and 1
        for(var n = 0; n < Nb; ++n) {
          tmp = w[wi + n];
          wnew[i + (3&-n)] =
            m0[sbox[tmp >>> 24]] ^
            m1[sbox[tmp >>> 16 & 255]] ^
            m2[sbox[tmp >>> 8 & 255]] ^
            m3[sbox[tmp & 255]];
        }
      }
    }
    w = wnew;
  }

  return w;
}

/**
 * Updates a single block (16 bytes) using AES. The update will either
 * encrypt or decrypt the block.
 *
 * @param w the key schedule.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */
function _updateBlock(w, input, output, decrypt) {
  /*
  Cipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[0, Nb-1])
    for round = 1 step 1 to Nr–1
      SubBytes(state)
      ShiftRows(state)
      MixColumns(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
    end for
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    out = state
  end

  InvCipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    for round = Nr-1 step -1 downto 1
      InvShiftRows(state)
      InvSubBytes(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
      InvMixColumns(state)
    end for
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
    out = state
  end
  */

  // Encrypt: AddRoundKey(state, w[0, Nb-1])
  // Decrypt: AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
  var Nr = w.length / 4 - 1;
  var m0, m1, m2, m3, sub;
  if(decrypt) {
    m0 = imix[0];
    m1 = imix[1];
    m2 = imix[2];
    m3 = imix[3];
    sub = isbox;
  } else {
    m0 = mix[0];
    m1 = mix[1];
    m2 = mix[2];
    m3 = mix[3];
    sub = sbox;
  }
  var a, b, c, d, a2, b2, c2;
  a = input[0] ^ w[0];
  b = input[decrypt ? 3 : 1] ^ w[1];
  c = input[2] ^ w[2];
  d = input[decrypt ? 1 : 3] ^ w[3];
  var i = 3;

  /* In order to share code we follow the encryption algorithm when both
    encrypting and decrypting. To account for the changes required in the
    decryption algorithm, we use different lookup tables when decrypting
    and use a modified key schedule to account for the difference in the
    order of transformations applied when performing rounds. We also get
    key rounds in reverse order (relative to encryption). */
  for(var round = 1; round < Nr; ++round) {
    /* As described above, we'll be using table lookups to perform the
      column mixing. Each column is stored as a word in the state (the
      array 'input' has one column as a word at each index). In order to
      mix a column, we perform these transformations on each row in c,
      which is 1 byte in each word. The new column for c0 is c'0:

               m0      m1      m2      m3
      r0,c'0 = 2*r0,c0 + 3*r1,c0 + 1*r2,c0 + 1*r3,c0
      r1,c'0 = 1*r0,c0 + 2*r1,c0 + 3*r2,c0 + 1*r3,c0
      r2,c'0 = 1*r0,c0 + 1*r1,c0 + 2*r2,c0 + 3*r3,c0
      r3,c'0 = 3*r0,c0 + 1*r1,c0 + 1*r2,c0 + 2*r3,c0

      So using mix tables where c0 is a word with r0 being its upper
      8 bits and r3 being its lower 8 bits:

      m0[c0 >> 24] will yield this word: [2*r0,1*r0,1*r0,3*r0]
      ...
      m3[c0 & 255] will yield this word: [1*r3,1*r3,3*r3,2*r3]

      Therefore to mix the columns in each word in the state we
      do the following (& 255 omitted for brevity):
      c'0,r0 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r1 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r2 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r3 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]

      However, before mixing, the algorithm requires us to perform
      ShiftRows(). The ShiftRows() transformation cyclically shifts the
      last 3 rows of the state over different offsets. The first row
      (r = 0) is not shifted.

      s'_r,c = s_r,(c + shift(r, Nb) mod Nb
      for 0 < r < 4 and 0 <= c < Nb and
      shift(1, 4) = 1
      shift(2, 4) = 2
      shift(3, 4) = 3.

      This causes the first byte in r = 1 to be moved to the end of
      the row, the first 2 bytes in r = 2 to be moved to the end of
      the row, the first 3 bytes in r = 3 to be moved to the end of
      the row:

      r1: [c0 c1 c2 c3] => [c1 c2 c3 c0]
      r2: [c0 c1 c2 c3]    [c2 c3 c0 c1]
      r3: [c0 c1 c2 c3]    [c3 c0 c1 c2]

      We can make these substitutions inline with our column mixing to
      generate an updated set of equations to produce each word in the
      state (note the columns have changed positions):

      c0 c1 c2 c3 => c0 c1 c2 c3
      c0 c1 c2 c3    c1 c2 c3 c0  (cycled 1 byte)
      c0 c1 c2 c3    c2 c3 c0 c1  (cycled 2 bytes)
      c0 c1 c2 c3    c3 c0 c1 c2  (cycled 3 bytes)

      Therefore:

      c'0 = 2*r0,c0 + 3*r1,c1 + 1*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 2*r1,c1 + 3*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 1*r1,c1 + 2*r2,c2 + 3*r3,c3
      c'0 = 3*r0,c0 + 1*r1,c1 + 1*r2,c2 + 2*r3,c3

      c'1 = 2*r0,c1 + 3*r1,c2 + 1*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 2*r1,c2 + 3*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 1*r1,c2 + 2*r2,c3 + 3*r3,c0
      c'1 = 3*r0,c1 + 1*r1,c2 + 1*r2,c3 + 2*r3,c0

      ... and so forth for c'2 and c'3. The important distinction is
      that the columns are cycling, with c0 being used with the m0
      map when calculating c0, but c1 being used with the m0 map when
      calculating c1 ... and so forth.

      When performing the inverse we transform the mirror image and
      skip the bottom row, instead of the top one, and move upwards:

      c3 c2 c1 c0 => c0 c3 c2 c1  (cycled 3 bytes) *same as encryption
      c3 c2 c1 c0    c1 c0 c3 c2  (cycled 2 bytes)
      c3 c2 c1 c0    c2 c1 c0 c3  (cycled 1 byte)  *same as encryption
      c3 c2 c1 c0    c3 c2 c1 c0

      If you compare the resulting matrices for ShiftRows()+MixColumns()
      and for InvShiftRows()+InvMixColumns() the 2nd and 4th columns are
      different (in encrypt mode vs. decrypt mode). So in order to use
      the same code to handle both encryption and decryption, we will
      need to do some mapping.

      If in encryption mode we let a=c0, b=c1, c=c2, d=c3, and r<N> be
      a row number in the state, then the resulting matrix in encryption
      mode for applying the above transformations would be:

      r1: a b c d
      r2: b c d a
      r3: c d a b
      r4: d a b c

      If we did the same in decryption mode we would get:

      r1: a d c b
      r2: b a d c
      r3: c b a d
      r4: d c b a

      If instead we swap d and b (set b=c3 and d=c1), then we get:

      r1: a b c d
      r2: d a b c
      r3: c d a b
      r4: b c d a

      Now the 1st and 3rd rows are the same as the encryption matrix. All
      we need to do then to make the mapping exactly the same is to swap
      the 2nd and 4th rows when in decryption mode. To do this without
      having to do it on each iteration, we swapped the 2nd and 4th rows
      in the decryption key schedule. We also have to do the swap above
      when we first pull in the input and when we set the final output. */
    a2 =
      m0[a >>> 24] ^
      m1[b >>> 16 & 255] ^
      m2[c >>> 8 & 255] ^
      m3[d & 255] ^ w[++i];
    b2 =
      m0[b >>> 24] ^
      m1[c >>> 16 & 255] ^
      m2[d >>> 8 & 255] ^
      m3[a & 255] ^ w[++i];
    c2 =
      m0[c >>> 24] ^
      m1[d >>> 16 & 255] ^
      m2[a >>> 8 & 255] ^
      m3[b & 255] ^ w[++i];
    d =
      m0[d >>> 24] ^
      m1[a >>> 16 & 255] ^
      m2[b >>> 8 & 255] ^
      m3[c & 255] ^ w[++i];
    a = a2;
    b = b2;
    c = c2;
  }

  /*
    Encrypt:
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])

    Decrypt:
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
   */
   // Note: rows are shifted inline
  output[0] =
    (sub[a >>> 24] << 24) ^
    (sub[b >>> 16 & 255] << 16) ^
    (sub[c >>> 8 & 255] << 8) ^
    (sub[d & 255]) ^ w[++i];
  output[decrypt ? 3 : 1] =
    (sub[b >>> 24] << 24) ^
    (sub[c >>> 16 & 255] << 16) ^
    (sub[d >>> 8 & 255] << 8) ^
    (sub[a & 255]) ^ w[++i];
  output[2] =
    (sub[c >>> 24] << 24) ^
    (sub[d >>> 16 & 255] << 16) ^
    (sub[a >>> 8 & 255] << 8) ^
    (sub[b & 255]) ^ w[++i];
  output[decrypt ? 1 : 3] =
    (sub[d >>> 24] << 24) ^
    (sub[a >>> 16 & 255] << 16) ^
    (sub[b >>> 8 & 255] << 8) ^
    (sub[c & 255]) ^ w[++i];
}

/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('AES-<mode>', key);
 * forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates a deprecated AES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key and iv may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param options the options to use.
 *          key the symmetric key to use.
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */
function _createCipher(options) {
  options = options || {};
  var mode = (options.mode || 'CBC').toUpperCase();
  var algorithm = 'AES-' + mode;

  var cipher;
  if(options.decrypt) {
    cipher = forge.cipher.createDecipher(algorithm, options.key);
  } else {
    cipher = forge.cipher.createCipher(algorithm, options.key);
  }

  // backwards compatible start API
  var start = cipher.start;
  cipher.start = function(iv, options) {
    // backwards compatibility: support second arg as output buffer
    var output = null;
    if(options instanceof forge.util.ByteBuffer) {
      output = options;
      options = {};
    }
    options = options || {};
    options.output = output;
    options.iv = iv;
    start.call(cipher, options);
  };

  return cipher;
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Cipher base API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */
var forge = __webpack_require__(0);
__webpack_require__(1);

module.exports = forge.cipher = forge.cipher || {};

// registered algorithms
forge.cipher.algorithms = forge.cipher.algorithms || {};

/**
 * Creates a cipher object that can be used to encrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */
forge.cipher.createCipher = function(algorithm, key) {
  var api = algorithm;
  if(typeof api === 'string') {
    api = forge.cipher.getAlgorithm(api);
    if(api) {
      api = api();
    }
  }
  if(!api) {
    throw new Error('Unsupported algorithm: ' + algorithm);
  }

  // assume block cipher
  return new forge.cipher.BlockCipher({
    algorithm: api,
    key: key,
    decrypt: false
  });
};

/**
 * Creates a decipher object that can be used to decrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */
forge.cipher.createDecipher = function(algorithm, key) {
  var api = algorithm;
  if(typeof api === 'string') {
    api = forge.cipher.getAlgorithm(api);
    if(api) {
      api = api();
    }
  }
  if(!api) {
    throw new Error('Unsupported algorithm: ' + algorithm);
  }

  // assume block cipher
  return new forge.cipher.BlockCipher({
    algorithm: api,
    key: key,
    decrypt: true
  });
};

/**
 * Registers an algorithm by name. If the name was already registered, the
 * algorithm API object will be overwritten.
 *
 * @param name the name of the algorithm.
 * @param algorithm the algorithm API object.
 */
forge.cipher.registerAlgorithm = function(name, algorithm) {
  name = name.toUpperCase();
  forge.cipher.algorithms[name] = algorithm;
};

/**
 * Gets a registered algorithm by name.
 *
 * @param name the name of the algorithm.
 *
 * @return the algorithm, if found, null if not.
 */
forge.cipher.getAlgorithm = function(name) {
  name = name.toUpperCase();
  if(name in forge.cipher.algorithms) {
    return forge.cipher.algorithms[name];
  }
  return null;
};

var BlockCipher = forge.cipher.BlockCipher = function(options) {
  this.algorithm = options.algorithm;
  this.mode = this.algorithm.mode;
  this.blockSize = this.mode.blockSize;
  this._finish = false;
  this._input = null;
  this.output = null;
  this._op = options.decrypt ? this.mode.decrypt : this.mode.encrypt;
  this._decrypt = options.decrypt;
  this.algorithm.initialize(options);
};

/**
 * Starts or restarts the encryption or decryption process, whichever
 * was previously configured.
 *
 * For non-GCM mode, the IV may be a binary-encoded string of bytes, an array
 * of bytes, a byte buffer, or an array of 32-bit integers. If the IV is in
 * bytes, then it must be Nb (16) bytes in length. If the IV is given in as
 * 32-bit integers, then it must be 4 integers long.
 *
 * Note: an IV is not required or used in ECB mode.
 *
 * For GCM-mode, the IV must be given as a binary-encoded string of bytes or
 * a byte buffer. The number of bytes should be 12 (96 bits) as recommended
 * by NIST SP-800-38D but another length may be given.
 *
 * @param options the options to use:
 *          iv the initialization vector to use as a binary-encoded string of
 *            bytes, null to reuse the last ciphered block from a previous
 *            update() (this "residue" method is for legacy support only).
 *          additionalData additional authentication data as a binary-encoded
 *            string of bytes, for 'GCM' mode, (default: none).
 *          tagLength desired length of authentication tag, in bits, for
 *            'GCM' mode (0-128, default: 128).
 *          tag the authentication tag to check if decrypting, as a
 *             binary-encoded string of bytes.
 *          output the output the buffer to write to, null to create one.
 */
BlockCipher.prototype.start = function(options) {
  options = options || {};
  var opts = {};
  for(var key in options) {
    opts[key] = options[key];
  }
  opts.decrypt = this._decrypt;
  this._finish = false;
  this._input = forge.util.createBuffer();
  this.output = options.output || forge.util.createBuffer();
  this.mode.start(opts);
};

/**
 * Updates the next block according to the cipher mode.
 *
 * @param input the buffer to read from.
 */
BlockCipher.prototype.update = function(input) {
  if(input) {
    // input given, so empty it into the input buffer
    this._input.putBuffer(input);
  }

  // do cipher operation until it needs more input and not finished
  while(!this._op.call(this.mode, this._input, this.output, this._finish) &&
    !this._finish) {}

  // free consumed memory from input buffer
  this._input.compact();
};

/**
 * Finishes encrypting or decrypting.
 *
 * @param pad a padding function to use in CBC mode, null for default,
 *          signature(blockSize, buffer, decrypt).
 *
 * @return true if successful, false on error.
 */
BlockCipher.prototype.finish = function(pad) {
  // backwards-compatibility w/deprecated padding API
  // Note: will overwrite padding functions even after another start() call
  if(pad && (this.mode.name === 'ECB' || this.mode.name === 'CBC')) {
    this.mode.pad = function(input) {
      return pad(this.blockSize, input, false);
    };
    this.mode.unpad = function(output) {
      return pad(this.blockSize, output, true);
    };
  }

  // build options for padding and afterFinish functions
  var options = {};
  options.decrypt = this._decrypt;

  // get # of bytes that won't fill a block
  options.overflow = this._input.length() % this.blockSize;

  if(!this._decrypt && this.mode.pad) {
    if(!this.mode.pad(this._input, options)) {
      return false;
    }
  }

  // do final update
  this._finish = true;
  this.update();

  if(this._decrypt && this.mode.unpad) {
    if(!this.mode.unpad(this.output, options)) {
      return false;
    }
  }

  if(this.mode.afterFinish) {
    if(!this.mode.afterFinish(this.output, options)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * An API for getting cryptographically-secure random bytes. The bytes are
 * generated using the Fortuna algorithm devised by Bruce Schneier and
 * Niels Ferguson.
 *
 * Getting strong random bytes is not yet easy to do in javascript. The only
 * truish random entropy that can be collected is from the mouse, keyboard, or
 * from timing with respect to page loads, etc. This generator makes a poor
 * attempt at providing random bytes when those sources haven't yet provided
 * enough entropy to initially seed or to reseed the PRNG.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2014 Digital Bazaar, Inc.
 */
var forge = __webpack_require__(0);
__webpack_require__(2);
__webpack_require__(8);
__webpack_require__(7);
__webpack_require__(1);

(function() {

// forge.random already defined
if(forge.random && forge.random.getBytes) {
  module.exports = forge.random;
  return;
}

(function(jQuery) {

// the default prng plugin, uses AES-128
var prng_aes = {};
var _prng_aes_output = new Array(4);
var _prng_aes_buffer = forge.util.createBuffer();
prng_aes.formatKey = function(key) {
  // convert the key into 32-bit integers
  var tmp = forge.util.createBuffer(key);
  key = new Array(4);
  key[0] = tmp.getInt32();
  key[1] = tmp.getInt32();
  key[2] = tmp.getInt32();
  key[3] = tmp.getInt32();

  // return the expanded key
  return forge.aes._expandKey(key, false);
};
prng_aes.formatSeed = function(seed) {
  // convert seed into 32-bit integers
  var tmp = forge.util.createBuffer(seed);
  seed = new Array(4);
  seed[0] = tmp.getInt32();
  seed[1] = tmp.getInt32();
  seed[2] = tmp.getInt32();
  seed[3] = tmp.getInt32();
  return seed;
};
prng_aes.cipher = function(key, seed) {
  forge.aes._updateBlock(key, seed, _prng_aes_output, false);
  _prng_aes_buffer.putInt32(_prng_aes_output[0]);
  _prng_aes_buffer.putInt32(_prng_aes_output[1]);
  _prng_aes_buffer.putInt32(_prng_aes_output[2]);
  _prng_aes_buffer.putInt32(_prng_aes_output[3]);
  return _prng_aes_buffer.getBytes();
};
prng_aes.increment = function(seed) {
  // FIXME: do we care about carry or signed issues?
  ++seed[3];
  return seed;
};
prng_aes.md = forge.md.sha256;

/**
 * Creates a new PRNG.
 */
function spawnPrng() {
  var ctx = forge.prng.create(prng_aes);

  /**
   * Gets random bytes. If a native secure crypto API is unavailable, this
   * method tries to make the bytes more unpredictable by drawing from data that
   * can be collected from the user of the browser, eg: mouse movement.
   *
   * If a callback is given, this method will be called asynchronously.
   *
   * @param count the number of random bytes to get.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return the random bytes in a string.
   */
  ctx.getBytes = function(count, callback) {
    return ctx.generate(count, callback);
  };

  /**
   * Gets random bytes asynchronously. If a native secure crypto API is
   * unavailable, this method tries to make the bytes more unpredictable by
   * drawing from data that can be collected from the user of the browser,
   * eg: mouse movement.
   *
   * @param count the number of random bytes to get.
   *
   * @return the random bytes in a string.
   */
  ctx.getBytesSync = function(count) {
    return ctx.generate(count);
  };

  return ctx;
}

// create default prng context
var _ctx = spawnPrng();

// add other sources of entropy only if window.crypto.getRandomValues is not
// available -- otherwise this source will be automatically used by the prng
var getRandomValues = null;
if(typeof window !== 'undefined') {
  var _crypto = window.crypto || window.msCrypto;
  if(_crypto && _crypto.getRandomValues) {
    getRandomValues = function(arr) {
      return _crypto.getRandomValues(arr);
    };
  }
}
if(forge.options.usePureJavaScript ||
  (!forge.util.isNodejs && !getRandomValues)) {
  // if this is a web worker, do not use weak entropy, instead register to
  // receive strong entropy asynchronously from the main thread
  if(typeof window === 'undefined' || window.document === undefined) {
    // FIXME:
  }

  // get load time entropy
  _ctx.collectInt(+new Date(), 32);

  // add some entropy from navigator object
  if(typeof(navigator) !== 'undefined') {
    var _navBytes = '';
    for(var key in navigator) {
      try {
        if(typeof(navigator[key]) == 'string') {
          _navBytes += navigator[key];
        }
      } catch(e) {
        /* Some navigator keys might not be accessible, e.g. the geolocation
          attribute throws an exception if touched in Mozilla chrome://
          context.

          Silently ignore this and just don't use this as a source of
          entropy. */
      }
    }
    _ctx.collect(_navBytes);
    _navBytes = null;
  }

  // add mouse and keyboard collectors if jquery is available
  if(jQuery) {
    // set up mouse entropy capture
    jQuery().mousemove(function(e) {
      // add mouse coords
      _ctx.collectInt(e.clientX, 16);
      _ctx.collectInt(e.clientY, 16);
    });

    // set up keyboard entropy capture
    jQuery().keypress(function(e) {
      _ctx.collectInt(e.charCode, 8);
    });
  }
}

/* Random API */
if(!forge.random) {
  forge.random = _ctx;
} else {
  // extend forge.random with _ctx
  for(var key in _ctx) {
    forge.random[key] = _ctx[key];
  }
}

// expose spawn PRNG
forge.random.createInstance = spawnPrng;

module.exports = forge.random;

})(typeof(jQuery) !== 'undefined' ? jQuery : null);

})();


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Supported cipher modes.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */
var forge = __webpack_require__(0);
__webpack_require__(1);

forge.cipher = forge.cipher || {};

// supported cipher modes
var modes = module.exports = forge.cipher.modes = forge.cipher.modes || {};

/** Electronic codebook (ECB) (Don't use this; it's not secure) **/

modes.ecb = function(options) {
  options = options || {};
  this.name = 'ECB';
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = new Array(this._ints);
  this._outBlock = new Array(this._ints);
};

modes.ecb.prototype.start = function(options) {};

modes.ecb.prototype.encrypt = function(input, output, finish) {
  // not enough input to encrypt
  if(input.length() < this.blockSize && !(finish && input.length() > 0)) {
    return true;
  }

  // get next block
  for(var i = 0; i < this._ints; ++i) {
    this._inBlock[i] = input.getInt32();
  }

  // encrypt block
  this.cipher.encrypt(this._inBlock, this._outBlock);

  // write output
  for(var i = 0; i < this._ints; ++i) {
    output.putInt32(this._outBlock[i]);
  }
};

modes.ecb.prototype.decrypt = function(input, output, finish) {
  // not enough input to decrypt
  if(input.length() < this.blockSize && !(finish && input.length() > 0)) {
    return true;
  }

  // get next block
  for(var i = 0; i < this._ints; ++i) {
    this._inBlock[i] = input.getInt32();
  }

  // decrypt block
  this.cipher.decrypt(this._inBlock, this._outBlock);

  // write output
  for(var i = 0; i < this._ints; ++i) {
    output.putInt32(this._outBlock[i]);
  }
};

modes.ecb.prototype.pad = function(input, options) {
  // add PKCS#7 padding to block (each pad byte is the
  // value of the number of pad bytes)
  var padding = (input.length() === this.blockSize ?
    this.blockSize : (this.blockSize - input.length()));
  input.fillWithByte(padding, padding);
  return true;
};

modes.ecb.prototype.unpad = function(output, options) {
  // check for error: input data not a multiple of blockSize
  if(options.overflow > 0) {
    return false;
  }

  // ensure padding byte count is valid
  var len = output.length();
  var count = output.at(len - 1);
  if(count > (this.blockSize << 2)) {
    return false;
  }

  // trim off padding bytes
  output.truncate(count);
  return true;
};

/** Cipher-block Chaining (CBC) **/

modes.cbc = function(options) {
  options = options || {};
  this.name = 'CBC';
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = new Array(this._ints);
  this._outBlock = new Array(this._ints);
};

modes.cbc.prototype.start = function(options) {
  // Note: legacy support for using IV residue (has security flaws)
  // if IV is null, reuse block from previous processing
  if(options.iv === null) {
    // must have a previous block
    if(!this._prev) {
      throw new Error('Invalid IV parameter.');
    }
    this._iv = this._prev.slice(0);
  } else if(!('iv' in options)) {
    throw new Error('Invalid IV parameter.');
  } else {
    // save IV as "previous" block
    this._iv = transformIV(options.iv);
    this._prev = this._iv.slice(0);
  }
};

modes.cbc.prototype.encrypt = function(input, output, finish) {
  // not enough input to encrypt
  if(input.length() < this.blockSize && !(finish && input.length() > 0)) {
    return true;
  }

  // get next block
  // CBC XOR's IV (or previous block) with plaintext
  for(var i = 0; i < this._ints; ++i) {
    this._inBlock[i] = this._prev[i] ^ input.getInt32();
  }

  // encrypt block
  this.cipher.encrypt(this._inBlock, this._outBlock);

  // write output, save previous block
  for(var i = 0; i < this._ints; ++i) {
    output.putInt32(this._outBlock[i]);
  }
  this._prev = this._outBlock;
};

modes.cbc.prototype.decrypt = function(input, output, finish) {
  // not enough input to decrypt
  if(input.length() < this.blockSize && !(finish && input.length() > 0)) {
    return true;
  }

  // get next block
  for(var i = 0; i < this._ints; ++i) {
    this._inBlock[i] = input.getInt32();
  }

  // decrypt block
  this.cipher.decrypt(this._inBlock, this._outBlock);

  // write output, save previous ciphered block
  // CBC XOR's IV (or previous block) with ciphertext
  for(var i = 0; i < this._ints; ++i) {
    output.putInt32(this._prev[i] ^ this._outBlock[i]);
  }
  this._prev = this._inBlock.slice(0);
};

modes.cbc.prototype.pad = function(input, options) {
  // add PKCS#7 padding to block (each pad byte is the
  // value of the number of pad bytes)
  var padding = (input.length() === this.blockSize ?
    this.blockSize : (this.blockSize - input.length()));
  input.fillWithByte(padding, padding);
  return true;
};

modes.cbc.prototype.unpad = function(output, options) {
  // check for error: input data not a multiple of blockSize
  if(options.overflow > 0) {
    return false;
  }

  // ensure padding byte count is valid
  var len = output.length();
  var count = output.at(len - 1);
  if(count > (this.blockSize << 2)) {
    return false;
  }

  // trim off padding bytes
  output.truncate(count);
  return true;
};

/** Cipher feedback (CFB) **/

modes.cfb = function(options) {
  options = options || {};
  this.name = 'CFB';
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = null;
  this._outBlock = new Array(this._ints);
  this._partialBlock = new Array(this._ints);
  this._partialOutput = forge.util.createBuffer();
  this._partialBytes = 0;
};

modes.cfb.prototype.start = function(options) {
  if(!('iv' in options)) {
    throw new Error('Invalid IV parameter.');
  }
  // use IV as first input
  this._iv = transformIV(options.iv);
  this._inBlock = this._iv.slice(0);
  this._partialBytes = 0;
};

modes.cfb.prototype.encrypt = function(input, output, finish) {
  // not enough input to encrypt
  var inputLength = input.length();
  if(inputLength === 0) {
    return true;
  }

  // encrypt block
  this.cipher.encrypt(this._inBlock, this._outBlock);

  // handle full block
  if(this._partialBytes === 0 && inputLength >= this.blockSize) {
    // XOR input with output, write input as output
    for(var i = 0; i < this._ints; ++i) {
      this._inBlock[i] = input.getInt32() ^ this._outBlock[i];
      output.putInt32(this._inBlock[i]);
    }
    return;
  }

  // handle partial block
  var partialBytes = (this.blockSize - inputLength) % this.blockSize;
  if(partialBytes > 0) {
    partialBytes = this.blockSize - partialBytes;
  }

  // XOR input with output, write input as partial output
  this._partialOutput.clear();
  for(var i = 0; i < this._ints; ++i) {
    this._partialBlock[i] = input.getInt32() ^ this._outBlock[i];
    this._partialOutput.putInt32(this._partialBlock[i]);
  }

  if(partialBytes > 0) {
    // block still incomplete, restore input buffer
    input.read -= this.blockSize;
  } else {
    // block complete, update input block
    for(var i = 0; i < this._ints; ++i) {
      this._inBlock[i] = this._partialBlock[i];
    }
  }

  // skip any previous partial bytes
  if(this._partialBytes > 0) {
    this._partialOutput.getBytes(this._partialBytes);
  }

  if(partialBytes > 0 && !finish) {
    output.putBytes(this._partialOutput.getBytes(
      partialBytes - this._partialBytes));
    this._partialBytes = partialBytes;
    return true;
  }

  output.putBytes(this._partialOutput.getBytes(
    inputLength - this._partialBytes));
  this._partialBytes = 0;
};

modes.cfb.prototype.decrypt = function(input, output, finish) {
  // not enough input to decrypt
  var inputLength = input.length();
  if(inputLength === 0) {
    return true;
  }

  // encrypt block (CFB always uses encryption mode)
  this.cipher.encrypt(this._inBlock, this._outBlock);

  // handle full block
  if(this._partialBytes === 0 && inputLength >= this.blockSize) {
    // XOR input with output, write input as output
    for(var i = 0; i < this._ints; ++i) {
      this._inBlock[i] = input.getInt32();
      output.putInt32(this._inBlock[i] ^ this._outBlock[i]);
    }
    return;
  }

  // handle partial block
  var partialBytes = (this.blockSize - inputLength) % this.blockSize;
  if(partialBytes > 0) {
    partialBytes = this.blockSize - partialBytes;
  }

  // XOR input with output, write input as partial output
  this._partialOutput.clear();
  for(var i = 0; i < this._ints; ++i) {
    this._partialBlock[i] = input.getInt32();
    this._partialOutput.putInt32(this._partialBlock[i] ^ this._outBlock[i]);
  }

  if(partialBytes > 0) {
    // block still incomplete, restore input buffer
    input.read -= this.blockSize;
  } else {
    // block complete, update input block
    for(var i = 0; i < this._ints; ++i) {
      this._inBlock[i] = this._partialBlock[i];
    }
  }

  // skip any previous partial bytes
  if(this._partialBytes > 0) {
    this._partialOutput.getBytes(this._partialBytes);
  }

  if(partialBytes > 0 && !finish) {
    output.putBytes(this._partialOutput.getBytes(
      partialBytes - this._partialBytes));
    this._partialBytes = partialBytes;
    return true;
  }

  output.putBytes(this._partialOutput.getBytes(
    inputLength - this._partialBytes));
  this._partialBytes = 0;
};

/** Output feedback (OFB) **/

modes.ofb = function(options) {
  options = options || {};
  this.name = 'OFB';
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = null;
  this._outBlock = new Array(this._ints);
  this._partialOutput = forge.util.createBuffer();
  this._partialBytes = 0;
};

modes.ofb.prototype.start = function(options) {
  if(!('iv' in options)) {
    throw new Error('Invalid IV parameter.');
  }
  // use IV as first input
  this._iv = transformIV(options.iv);
  this._inBlock = this._iv.slice(0);
  this._partialBytes = 0;
};

modes.ofb.prototype.encrypt = function(input, output, finish) {
  // not enough input to encrypt
  var inputLength = input.length();
  if(input.length() === 0) {
    return true;
  }

  // encrypt block (OFB always uses encryption mode)
  this.cipher.encrypt(this._inBlock, this._outBlock);

  // handle full block
  if(this._partialBytes === 0 && inputLength >= this.blockSize) {
    // XOR input with output and update next input
    for(var i = 0; i < this._ints; ++i) {
      output.putInt32(input.getInt32() ^ this._outBlock[i]);
      this._inBlock[i] = this._outBlock[i];
    }
    return;
  }

  // handle partial block
  var partialBytes = (this.blockSize - inputLength) % this.blockSize;
  if(partialBytes > 0) {
    partialBytes = this.blockSize - partialBytes;
  }

  // XOR input with output
  this._partialOutput.clear();
  for(var i = 0; i < this._ints; ++i) {
    this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
  }

  if(partialBytes > 0) {
    // block still incomplete, restore input buffer
    input.read -= this.blockSize;
  } else {
    // block complete, update input block
    for(var i = 0; i < this._ints; ++i) {
      this._inBlock[i] = this._outBlock[i];
    }
  }

  // skip any previous partial bytes
  if(this._partialBytes > 0) {
    this._partialOutput.getBytes(this._partialBytes);
  }

  if(partialBytes > 0 && !finish) {
    output.putBytes(this._partialOutput.getBytes(
      partialBytes - this._partialBytes));
    this._partialBytes = partialBytes;
    return true;
  }

  output.putBytes(this._partialOutput.getBytes(
    inputLength - this._partialBytes));
  this._partialBytes = 0;
};

modes.ofb.prototype.decrypt = modes.ofb.prototype.encrypt;

/** Counter (CTR) **/

modes.ctr = function(options) {
  options = options || {};
  this.name = 'CTR';
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = null;
  this._outBlock = new Array(this._ints);
  this._partialOutput = forge.util.createBuffer();
  this._partialBytes = 0;
};

modes.ctr.prototype.start = function(options) {
  if(!('iv' in options)) {
    throw new Error('Invalid IV parameter.');
  }
  // use IV as first input
  this._iv = transformIV(options.iv);
  this._inBlock = this._iv.slice(0);
  this._partialBytes = 0;
};

modes.ctr.prototype.encrypt = function(input, output, finish) {
  // not enough input to encrypt
  var inputLength = input.length();
  if(inputLength === 0) {
    return true;
  }

  // encrypt block (CTR always uses encryption mode)
  this.cipher.encrypt(this._inBlock, this._outBlock);

  // handle full block
  if(this._partialBytes === 0 && inputLength >= this.blockSize) {
    // XOR input with output
    for(var i = 0; i < this._ints; ++i) {
      output.putInt32(input.getInt32() ^ this._outBlock[i]);
    }
  } else {
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if(partialBytes > 0) {
      partialBytes = this.blockSize - partialBytes;
    }

    // XOR input with output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i) {
      this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
    }

    if(partialBytes > 0) {
      // block still incomplete, restore input buffer
      input.read -= this.blockSize;
    }

    // skip any previous partial bytes
    if(this._partialBytes > 0) {
      this._partialOutput.getBytes(this._partialBytes);
    }

    if(partialBytes > 0 && !finish) {
      output.putBytes(this._partialOutput.getBytes(
        partialBytes - this._partialBytes));
      this._partialBytes = partialBytes;
      return true;
    }

    output.putBytes(this._partialOutput.getBytes(
      inputLength - this._partialBytes));
    this._partialBytes = 0;
  }

  // block complete, increment counter (input block)
  inc32(this._inBlock);
};

modes.ctr.prototype.decrypt = modes.ctr.prototype.encrypt;

/** Galois/Counter Mode (GCM) **/

modes.gcm = function(options) {
  options = options || {};
  this.name = 'GCM';
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = new Array(this._ints);
  this._outBlock = new Array(this._ints);
  this._partialOutput = forge.util.createBuffer();
  this._partialBytes = 0;

  // R is actually this value concatenated with 120 more zero bits, but
  // we only XOR against R so the other zeros have no effect -- we just
  // apply this value to the first integer in a block
  this._R = 0xE1000000;
};

modes.gcm.prototype.start = function(options) {
  if(!('iv' in options)) {
    throw new Error('Invalid IV parameter.');
  }
  // ensure IV is a byte buffer
  var iv = forge.util.createBuffer(options.iv);

  // no ciphered data processed yet
  this._cipherLength = 0;

  // default additional data is none
  var additionalData;
  if('additionalData' in options) {
    additionalData = forge.util.createBuffer(options.additionalData);
  } else {
    additionalData = forge.util.createBuffer();
  }

  // default tag length is 128 bits
  if('tagLength' in options) {
    this._tagLength = options.tagLength;
  } else {
    this._tagLength = 128;
  }

  // if tag is given, ensure tag matches tag length
  this._tag = null;
  if(options.decrypt) {
    // save tag to check later
    this._tag = forge.util.createBuffer(options.tag).getBytes();
    if(this._tag.length !== (this._tagLength / 8)) {
      throw new Error('Authentication tag does not match tag length.');
    }
  }

  // create tmp storage for hash calculation
  this._hashBlock = new Array(this._ints);

  // no tag generated yet
  this.tag = null;

  // generate hash subkey
  // (apply block cipher to "zero" block)
  this._hashSubkey = new Array(this._ints);
  this.cipher.encrypt([0, 0, 0, 0], this._hashSubkey);

  // generate table M
  // use 4-bit tables (32 component decomposition of a 16 byte value)
  // 8-bit tables take more space and are known to have security
  // vulnerabilities (in native implementations)
  this.componentBits = 4;
  this._m = this.generateHashTable(this._hashSubkey, this.componentBits);

  // Note: support IV length different from 96 bits? (only supporting
  // 96 bits is recommended by NIST SP-800-38D)
  // generate J_0
  var ivLength = iv.length();
  if(ivLength === 12) {
    // 96-bit IV
    this._j0 = [iv.getInt32(), iv.getInt32(), iv.getInt32(), 1];
  } else {
    // IV is NOT 96-bits
    this._j0 = [0, 0, 0, 0];
    while(iv.length() > 0) {
      this._j0 = this.ghash(
        this._hashSubkey, this._j0,
        [iv.getInt32(), iv.getInt32(), iv.getInt32(), iv.getInt32()]);
    }
    this._j0 = this.ghash(
      this._hashSubkey, this._j0, [0, 0].concat(from64To32(ivLength * 8)));
  }

  // generate ICB (initial counter block)
  this._inBlock = this._j0.slice(0);
  inc32(this._inBlock);
  this._partialBytes = 0;

  // consume authentication data
  additionalData = forge.util.createBuffer(additionalData);
  // save additional data length as a BE 64-bit number
  this._aDataLength = from64To32(additionalData.length() * 8);
  // pad additional data to 128 bit (16 byte) block size
  var overflow = additionalData.length() % this.blockSize;
  if(overflow) {
    additionalData.fillWithByte(0, this.blockSize - overflow);
  }
  this._s = [0, 0, 0, 0];
  while(additionalData.length() > 0) {
    this._s = this.ghash(this._hashSubkey, this._s, [
      additionalData.getInt32(),
      additionalData.getInt32(),
      additionalData.getInt32(),
      additionalData.getInt32()
    ]);
  }
};

modes.gcm.prototype.encrypt = function(input, output, finish) {
  // not enough input to encrypt
  var inputLength = input.length();
  if(inputLength === 0) {
    return true;
  }

  // encrypt block
  this.cipher.encrypt(this._inBlock, this._outBlock);

  // handle full block
  if(this._partialBytes === 0 && inputLength >= this.blockSize) {
    // XOR input with output
    for(var i = 0; i < this._ints; ++i) {
      output.putInt32(this._outBlock[i] ^= input.getInt32());
    }
    this._cipherLength += this.blockSize;
  } else {
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if(partialBytes > 0) {
      partialBytes = this.blockSize - partialBytes;
    }

    // XOR input with output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i) {
      this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
    }

    if(partialBytes === 0 || finish) {
      // handle overflow prior to hashing
      if(finish) {
        // get block overflow
        var overflow = inputLength % this.blockSize;
        this._cipherLength += overflow;
        // truncate for hash function
        this._partialOutput.truncate(this.blockSize - overflow);
      } else {
        this._cipherLength += this.blockSize;
      }

      // get output block for hashing
      for(var i = 0; i < this._ints; ++i) {
        this._outBlock[i] = this._partialOutput.getInt32();
      }
      this._partialOutput.read -= this.blockSize;
    }

    // skip any previous partial bytes
    if(this._partialBytes > 0) {
      this._partialOutput.getBytes(this._partialBytes);
    }

    if(partialBytes > 0 && !finish) {
      // block still incomplete, restore input buffer, get partial output,
      // and return early
      input.read -= this.blockSize;
      output.putBytes(this._partialOutput.getBytes(
        partialBytes - this._partialBytes));
      this._partialBytes = partialBytes;
      return true;
    }

    output.putBytes(this._partialOutput.getBytes(
      inputLength - this._partialBytes));
    this._partialBytes = 0;
  }

  // update hash block S
  this._s = this.ghash(this._hashSubkey, this._s, this._outBlock);

  // increment counter (input block)
  inc32(this._inBlock);
};

modes.gcm.prototype.decrypt = function(input, output, finish) {
  // not enough input to decrypt
  var inputLength = input.length();
  if(inputLength < this.blockSize && !(finish && inputLength > 0)) {
    return true;
  }

  // encrypt block (GCM always uses encryption mode)
  this.cipher.encrypt(this._inBlock, this._outBlock);

  // increment counter (input block)
  inc32(this._inBlock);

  // update hash block S
  this._hashBlock[0] = input.getInt32();
  this._hashBlock[1] = input.getInt32();
  this._hashBlock[2] = input.getInt32();
  this._hashBlock[3] = input.getInt32();
  this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);

  // XOR hash input with output
  for(var i = 0; i < this._ints; ++i) {
    output.putInt32(this._outBlock[i] ^ this._hashBlock[i]);
  }

  // increment cipher data length
  if(inputLength < this.blockSize) {
    this._cipherLength += inputLength % this.blockSize;
  } else {
    this._cipherLength += this.blockSize;
  }
};

modes.gcm.prototype.afterFinish = function(output, options) {
  var rval = true;

  // handle overflow
  if(options.decrypt && options.overflow) {
    output.truncate(this.blockSize - options.overflow);
  }

  // handle authentication tag
  this.tag = forge.util.createBuffer();

  // concatenate additional data length with cipher length
  var lengths = this._aDataLength.concat(from64To32(this._cipherLength * 8));

  // include lengths in hash
  this._s = this.ghash(this._hashSubkey, this._s, lengths);

  // do GCTR(J_0, S)
  var tag = [];
  this.cipher.encrypt(this._j0, tag);
  for(var i = 0; i < this._ints; ++i) {
    this.tag.putInt32(this._s[i] ^ tag[i]);
  }

  // trim tag to length
  this.tag.truncate(this.tag.length() % (this._tagLength / 8));

  // check authentication tag
  if(options.decrypt && this.tag.bytes() !== this._tag) {
    rval = false;
  }

  return rval;
};

/**
 * See NIST SP-800-38D 6.3 (Algorithm 1). This function performs Galois
 * field multiplication. The field, GF(2^128), is defined by the polynomial:
 *
 * x^128 + x^7 + x^2 + x + 1
 *
 * Which is represented in little-endian binary form as: 11100001 (0xe1). When
 * the value of a coefficient is 1, a bit is set. The value R, is the
 * concatenation of this value and 120 zero bits, yielding a 128-bit value
 * which matches the block size.
 *
 * This function will multiply two elements (vectors of bytes), X and Y, in
 * the field GF(2^128). The result is initialized to zero. For each bit of
 * X (out of 128), x_i, if x_i is set, then the result is multiplied (XOR'd)
 * by the current value of Y. For each bit, the value of Y will be raised by
 * a power of x (multiplied by the polynomial x). This can be achieved by
 * shifting Y once to the right. If the current value of Y, prior to being
 * multiplied by x, has 0 as its LSB, then it is a 127th degree polynomial.
 * Otherwise, we must divide by R after shifting to find the remainder.
 *
 * @param x the first block to multiply by the second.
 * @param y the second block to multiply by the first.
 *
 * @return the block result of the multiplication.
 */
modes.gcm.prototype.multiply = function(x, y) {
  var z_i = [0, 0, 0, 0];
  var v_i = y.slice(0);

  // calculate Z_128 (block has 128 bits)
  for(var i = 0; i < 128; ++i) {
    // if x_i is 0, Z_{i+1} = Z_i (unchanged)
    // else Z_{i+1} = Z_i ^ V_i
    // get x_i by finding 32-bit int position, then left shift 1 by remainder
    var x_i = x[(i / 32) | 0] & (1 << (31 - i % 32));
    if(x_i) {
      z_i[0] ^= v_i[0];
      z_i[1] ^= v_i[1];
      z_i[2] ^= v_i[2];
      z_i[3] ^= v_i[3];
    }

    // if LSB(V_i) is 1, V_i = V_i >> 1
    // else V_i = (V_i >> 1) ^ R
    this.pow(v_i, v_i);
  }

  return z_i;
};

modes.gcm.prototype.pow = function(x, out) {
  // if LSB(x) is 1, x = x >>> 1
  // else x = (x >>> 1) ^ R
  var lsb = x[3] & 1;

  // always do x >>> 1:
  // starting with the rightmost integer, shift each integer to the right
  // one bit, pulling in the bit from the integer to the left as its top
  // most bit (do this for the last 3 integers)
  for(var i = 3; i > 0; --i) {
    out[i] = (x[i] >>> 1) | ((x[i - 1] & 1) << 31);
  }
  // shift the first integer normally
  out[0] = x[0] >>> 1;

  // if lsb was not set, then polynomial had a degree of 127 and doesn't
  // need to divided; otherwise, XOR with R to find the remainder; we only
  // need to XOR the first integer since R technically ends w/120 zero bits
  if(lsb) {
    out[0] ^= this._R;
  }
};

modes.gcm.prototype.tableMultiply = function(x) {
  // assumes 4-bit tables are used
  var z = [0, 0, 0, 0];
  for(var i = 0; i < 32; ++i) {
    var idx = (i / 8) | 0;
    var x_i = (x[idx] >>> ((7 - (i % 8)) * 4)) & 0xF;
    var ah = this._m[i][x_i];
    z[0] ^= ah[0];
    z[1] ^= ah[1];
    z[2] ^= ah[2];
    z[3] ^= ah[3];
  }
  return z;
};

/**
 * A continuing version of the GHASH algorithm that operates on a single
 * block. The hash block, last hash value (Ym) and the new block to hash
 * are given.
 *
 * @param h the hash block.
 * @param y the previous value for Ym, use [0, 0, 0, 0] for a new hash.
 * @param x the block to hash.
 *
 * @return the hashed value (Ym).
 */
modes.gcm.prototype.ghash = function(h, y, x) {
  y[0] ^= x[0];
  y[1] ^= x[1];
  y[2] ^= x[2];
  y[3] ^= x[3];
  return this.tableMultiply(y);
  //return this.multiply(y, h);
};

/**
 * Precomputes a table for multiplying against the hash subkey. This
 * mechanism provides a substantial speed increase over multiplication
 * performed without a table. The table-based multiplication this table is
 * for solves X * H by multiplying each component of X by H and then
 * composing the results together using XOR.
 *
 * This function can be used to generate tables with different bit sizes
 * for the components, however, this implementation assumes there are
 * 32 components of X (which is a 16 byte vector), therefore each component
 * takes 4-bits (so the table is constructed with bits=4).
 *
 * @param h the hash subkey.
 * @param bits the bit size for a component.
 */
modes.gcm.prototype.generateHashTable = function(h, bits) {
  // TODO: There are further optimizations that would use only the
  // first table M_0 (or some variant) along with a remainder table;
  // this can be explored in the future
  var multiplier = 8 / bits;
  var perInt = 4 * multiplier;
  var size = 16 * multiplier;
  var m = new Array(size);
  for(var i = 0; i < size; ++i) {
    var tmp = [0, 0, 0, 0];
    var idx = (i / perInt) | 0;
    var shft = ((perInt - 1 - (i % perInt)) * bits);
    tmp[idx] = (1 << (bits - 1)) << shft;
    m[i] = this.generateSubHashTable(this.multiply(tmp, h), bits);
  }
  return m;
};

/**
 * Generates a table for multiplying against the hash subkey for one
 * particular component (out of all possible component values).
 *
 * @param mid the pre-multiplied value for the middle key of the table.
 * @param bits the bit size for a component.
 */
modes.gcm.prototype.generateSubHashTable = function(mid, bits) {
  // compute the table quickly by minimizing the number of
  // POW operations -- they only need to be performed for powers of 2,
  // all other entries can be composed from those powers using XOR
  var size = 1 << bits;
  var half = size >>> 1;
  var m = new Array(size);
  m[half] = mid.slice(0);
  var i = half >>> 1;
  while(i > 0) {
    // raise m0[2 * i] and store in m0[i]
    this.pow(m[2 * i], m[i] = []);
    i >>= 1;
  }
  i = 2;
  while(i < half) {
    for(var j = 1; j < i; ++j) {
      var m_i = m[i];
      var m_j = m[j];
      m[i + j] = [
        m_i[0] ^ m_j[0],
        m_i[1] ^ m_j[1],
        m_i[2] ^ m_j[2],
        m_i[3] ^ m_j[3]
      ];
    }
    i *= 2;
  }
  m[0] = [0, 0, 0, 0];
  /* Note: We could avoid storing these by doing composition during multiply
  calculate top half using composition by speed is preferred. */
  for(i = half + 1; i < size; ++i) {
    var c = m[i ^ half];
    m[i] = [mid[0] ^ c[0], mid[1] ^ c[1], mid[2] ^ c[2], mid[3] ^ c[3]];
  }
  return m;
};

/** Utility functions */

function transformIV(iv) {
  if(typeof iv === 'string') {
    // convert iv string into byte buffer
    iv = forge.util.createBuffer(iv);
  }

  if(forge.util.isArray(iv) && iv.length > 4) {
    // convert iv byte array into byte buffer
    var tmp = iv;
    iv = forge.util.createBuffer();
    for(var i = 0; i < tmp.length; ++i) {
      iv.putByte(tmp[i]);
    }
  }
  if(!forge.util.isArray(iv)) {
    // convert iv byte buffer into 32-bit integer array
    iv = [iv.getInt32(), iv.getInt32(), iv.getInt32(), iv.getInt32()];
  }

  return iv;
}

function inc32(block) {
  // increment last 32 bits of block only
  block[block.length - 1] = (block[block.length - 1] + 1) & 0xFFFFFFFF;
}

function from64To32(num) {
  // convert 64-bit number to two BE Int32s
  return [(num / 0x100000000) | 0, num & 0xFFFFFFFF];
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Node.js module for Forge message digests.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2017 Digital Bazaar, Inc.
 */
var forge = __webpack_require__(0);

module.exports = forge.md = forge.md || {};
forge.md.algorithms = forge.md.algorithms || {};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A javascript implementation of a cryptographically-secure
 * Pseudo Random Number Generator (PRNG). The Fortuna algorithm is followed
 * here though the use of SHA-256 is not enforced; when generating an
 * a PRNG context, the hashing algorithm and block cipher used for
 * the generator are specified via a plugin.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */
var forge = __webpack_require__(0);
__webpack_require__(1);

var _crypto = null;
if(forge.util.isNodejs && !forge.options.usePureJavaScript &&
  !process.versions['node-webkit']) {
  _crypto = __webpack_require__(9);
}

/* PRNG API */
var prng = module.exports = forge.prng = forge.prng || {};

/**
 * Creates a new PRNG context.
 *
 * A PRNG plugin must be passed in that will provide:
 *
 * 1. A function that initializes the key and seed of a PRNG context. It
 *   will be given a 16 byte key and a 16 byte seed. Any key expansion
 *   or transformation of the seed from a byte string into an array of
 *   integers (or similar) should be performed.
 * 2. The cryptographic function used by the generator. It takes a key and
 *   a seed.
 * 3. A seed increment function. It takes the seed and returns seed + 1.
 * 4. An api to create a message digest.
 *
 * For an example, see random.js.
 *
 * @param plugin the PRNG plugin to use.
 */
prng.create = function(plugin) {
  var ctx = {
    plugin: plugin,
    key: null,
    seed: null,
    time: null,
    // number of reseeds so far
    reseeds: 0,
    // amount of data generated so far
    generated: 0,
    // no initial key bytes
    keyBytes: ''
  };

  // create 32 entropy pools (each is a message digest)
  var md = plugin.md;
  var pools = new Array(32);
  for(var i = 0; i < 32; ++i) {
    pools[i] = md.create();
  }
  ctx.pools = pools;

  // entropy pools are written to cyclically, starting at index 0
  ctx.pool = 0;

  /**
   * Generates random bytes. The bytes may be generated synchronously or
   * asynchronously. Web workers must use the asynchronous interface or
   * else the behavior is undefined.
   *
   * @param count the number of random bytes to generate.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return count random bytes as a string.
   */
  ctx.generate = function(count, callback) {
    // do synchronously
    if(!callback) {
      return ctx.generateSync(count);
    }

    // simple generator using counter-based CBC
    var cipher = ctx.plugin.cipher;
    var increment = ctx.plugin.increment;
    var formatKey = ctx.plugin.formatKey;
    var formatSeed = ctx.plugin.formatSeed;
    var b = forge.util.createBuffer();

    // paranoid deviation from Fortuna:
    // reset key for every request to protect previously
    // generated random bytes should the key be discovered;
    // there is no 100ms based reseeding because of this
    // forced reseed for every `generate` call
    ctx.key = null;

    generate();

    function generate(err) {
      if(err) {
        return callback(err);
      }

      // sufficient bytes generated
      if(b.length() >= count) {
        return callback(null, b.getBytes(count));
      }

      // if amount of data generated is greater than 1 MiB, trigger reseed
      if(ctx.generated > 0xfffff) {
        ctx.key = null;
      }

      if(ctx.key === null) {
        // prevent stack overflow
        return forge.util.nextTick(function() {
          _reseed(generate);
        });
      }

      // generate the random bytes
      var bytes = cipher(ctx.key, ctx.seed);
      ctx.generated += bytes.length;
      b.putBytes(bytes);

      // generate bytes for a new key and seed
      ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
      ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));

      forge.util.setImmediate(generate);
    }
  };

  /**
   * Generates random bytes synchronously.
   *
   * @param count the number of random bytes to generate.
   *
   * @return count random bytes as a string.
   */
  ctx.generateSync = function(count) {
    // simple generator using counter-based CBC
    var cipher = ctx.plugin.cipher;
    var increment = ctx.plugin.increment;
    var formatKey = ctx.plugin.formatKey;
    var formatSeed = ctx.plugin.formatSeed;

    // paranoid deviation from Fortuna:
    // reset key for every request to protect previously
    // generated random bytes should the key be discovered;
    // there is no 100ms based reseeding because of this
    // forced reseed for every `generateSync` call
    ctx.key = null;

    var b = forge.util.createBuffer();
    while(b.length() < count) {
      // if amount of data generated is greater than 1 MiB, trigger reseed
      if(ctx.generated > 0xfffff) {
        ctx.key = null;
      }

      if(ctx.key === null) {
        _reseedSync();
      }

      // generate the random bytes
      var bytes = cipher(ctx.key, ctx.seed);
      ctx.generated += bytes.length;
      b.putBytes(bytes);

      // generate bytes for a new key and seed
      ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
      ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
    }

    return b.getBytes(count);
  };

  /**
   * Private function that asynchronously reseeds a generator.
   *
   * @param callback(err) called once the operation completes.
   */
  function _reseed(callback) {
    if(ctx.pools[0].messageLength >= 32) {
      _seed();
      return callback();
    }
    // not enough seed data...
    var needed = (32 - ctx.pools[0].messageLength) << 5;
    ctx.seedFile(needed, function(err, bytes) {
      if(err) {
        return callback(err);
      }
      ctx.collect(bytes);
      _seed();
      callback();
    });
  }

  /**
   * Private function that synchronously reseeds a generator.
   */
  function _reseedSync() {
    if(ctx.pools[0].messageLength >= 32) {
      return _seed();
    }
    // not enough seed data...
    var needed = (32 - ctx.pools[0].messageLength) << 5;
    ctx.collect(ctx.seedFileSync(needed));
    _seed();
  }

  /**
   * Private function that seeds a generator once enough bytes are available.
   */
  function _seed() {
    // update reseed count
    ctx.reseeds = (ctx.reseeds === 0xffffffff) ? 0 : ctx.reseeds + 1;

    // goal is to update `key` via:
    // key = hash(key + s)
    //   where 's' is all collected entropy from selected pools, then...

    // create a plugin-based message digest
    var md = ctx.plugin.md.create();

    // consume current key bytes
    md.update(ctx.keyBytes);

    // digest the entropy of pools whose index k meet the
    // condition 'n mod 2^k == 0' where n is the number of reseeds
    var _2powK = 1;
    for(var k = 0; k < 32; ++k) {
      if(ctx.reseeds % _2powK === 0) {
        md.update(ctx.pools[k].digest().getBytes());
        ctx.pools[k].start();
      }
      _2powK = _2powK << 1;
    }

    // get digest for key bytes
    ctx.keyBytes = md.digest().getBytes();

    // paranoid deviation from Fortuna:
    // update `seed` via `seed = hash(key)`
    // instead of initializing to zero once and only
    // ever incrementing it
    md.start();
    md.update(ctx.keyBytes);
    var seedBytes = md.digest().getBytes();

    // update state
    ctx.key = ctx.plugin.formatKey(ctx.keyBytes);
    ctx.seed = ctx.plugin.formatSeed(seedBytes);
    ctx.generated = 0;
  }

  /**
   * The built-in default seedFile. This seedFile is used when entropy
   * is needed immediately.
   *
   * @param needed the number of bytes that are needed.
   *
   * @return the random bytes.
   */
  function defaultSeedFile(needed) {
    // use window.crypto.getRandomValues strong source of entropy if available
    var getRandomValues = null;
    if(typeof window !== 'undefined') {
      var _crypto = window.crypto || window.msCrypto;
      if(_crypto && _crypto.getRandomValues) {
        getRandomValues = function(arr) {
          return _crypto.getRandomValues(arr);
        };
      }
    }

    var b = forge.util.createBuffer();
    if(getRandomValues) {
      while(b.length() < needed) {
        // max byte length is 65536 before QuotaExceededError is thrown
        // http://www.w3.org/TR/WebCryptoAPI/#RandomSource-method-getRandomValues
        var count = Math.max(1, Math.min(needed - b.length(), 65536) / 4);
        var entropy = new Uint32Array(Math.floor(count));
        try {
          getRandomValues(entropy);
          for(var i = 0; i < entropy.length; ++i) {
            b.putInt32(entropy[i]);
          }
        } catch(e) {
          /* only ignore QuotaExceededError */
          if(!(typeof QuotaExceededError !== 'undefined' &&
            e instanceof QuotaExceededError)) {
            throw e;
          }
        }
      }
    }

    // be sad and add some weak random data
    if(b.length() < needed) {
      /* Draws from Park-Miller "minimal standard" 31 bit PRNG,
      implemented with David G. Carta's optimization: with 32 bit math
      and without division (Public Domain). */
      var hi, lo, next;
      var seed = Math.floor(Math.random() * 0x010000);
      while(b.length() < needed) {
        lo = 16807 * (seed & 0xFFFF);
        hi = 16807 * (seed >> 16);
        lo += (hi & 0x7FFF) << 16;
        lo += hi >> 15;
        lo = (lo & 0x7FFFFFFF) + (lo >> 31);
        seed = lo & 0xFFFFFFFF;

        // consume lower 3 bytes of seed
        for(var i = 0; i < 3; ++i) {
          // throw in more pseudo random
          next = seed >>> (i << 3);
          next ^= Math.floor(Math.random() * 0x0100);
          b.putByte(String.fromCharCode(next & 0xFF));
        }
      }
    }

    return b.getBytes(needed);
  }
  // initialize seed file APIs
  if(_crypto) {
    // use nodejs async API
    ctx.seedFile = function(needed, callback) {
      _crypto.randomBytes(needed, function(err, bytes) {
        if(err) {
          return callback(err);
        }
        callback(null, bytes.toString());
      });
    };
    // use nodejs sync API
    ctx.seedFileSync = function(needed) {
      return _crypto.randomBytes(needed).toString();
    };
  } else {
    ctx.seedFile = function(needed, callback) {
      try {
        callback(null, defaultSeedFile(needed));
      } catch(e) {
        callback(e);
      }
    };
    ctx.seedFileSync = defaultSeedFile;
  }

  /**
   * Adds entropy to a prng ctx's accumulator.
   *
   * @param bytes the bytes of entropy as a string.
   */
  ctx.collect = function(bytes) {
    // iterate over pools distributing entropy cyclically
    var count = bytes.length;
    for(var i = 0; i < count; ++i) {
      ctx.pools[ctx.pool].update(bytes.substr(i, 1));
      ctx.pool = (ctx.pool === 31) ? 0 : ctx.pool + 1;
    }
  };

  /**
   * Collects an integer of n bits.
   *
   * @param i the integer entropy.
   * @param n the number of bits in the integer.
   */
  ctx.collectInt = function(i, n) {
    var bytes = '';
    for(var x = 0; x < n; x += 8) {
      bytes += String.fromCharCode((i >> x) & 0xFF);
    }
    ctx.collect(bytes);
  };

  /**
   * Registers a Web Worker to receive immediate entropy from the main thread.
   * This method is required until Web Workers can access the native crypto
   * API. This method should be called twice for each created worker, once in
   * the main thread, and once in the worker itself.
   *
   * @param worker the worker to register.
   */
  ctx.registerWorker = function(worker) {
    // worker receives random bytes
    if(worker === self) {
      ctx.seedFile = function(needed, callback) {
        function listener(e) {
          var data = e.data;
          if(data.forge && data.forge.prng) {
            self.removeEventListener('message', listener);
            callback(data.forge.prng.err, data.forge.prng.bytes);
          }
        }
        self.addEventListener('message', listener);
        self.postMessage({forge: {prng: {needed: needed}}});
      };
    } else {
      // main thread sends random bytes upon request
      var listener = function(e) {
        var data = e.data;
        if(data.forge && data.forge.prng) {
          ctx.seedFile(data.forge.prng.needed, function(err, bytes) {
            worker.postMessage({forge: {prng: {err: err, bytes: bytes}}});
          });
        }
      };
      // TODO: do we need to remove the event listener when the worker dies?
      worker.addEventListener('message', listener);
    }
  };

  return ctx;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Secure Hash Algorithm with 256-bit digest (SHA-256) implementation.
 *
 * See FIPS 180-2 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */
var forge = __webpack_require__(0);
__webpack_require__(6);
__webpack_require__(1);

var sha256 = module.exports = forge.sha256 = forge.sha256 || {};
forge.md.sha256 = forge.md.algorithms.sha256 = sha256;

/**
 * Creates a SHA-256 message digest object.
 *
 * @return a message digest object.
 */
sha256.create = function() {
  // do initialization as necessary
  if(!_initialized) {
    _init();
  }

  // SHA-256 state contains eight 32-bit integers
  var _state = null;

  // input buffer
  var _input = forge.util.createBuffer();

  // used for word storage
  var _w = new Array(64);

  // message digest object
  var md = {
    algorithm: 'sha256',
    blockLength: 64,
    digestLength: 32,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };

  /**
   * Starts the digest.
   *
   * @return this digest object.
   */
  md.start = function() {
    // up to 56-bit message length for convenience
    md.messageLength = 0;

    // full message length (set md.messageLength64 for backwards-compatibility)
    md.fullMessageLength = md.messageLength64 = [];
    var int32s = md.messageLengthSize / 4;
    for(var i = 0; i < int32s; ++i) {
      md.fullMessageLength.push(0);
    }
    _input = forge.util.createBuffer();
    _state = {
      h0: 0x6A09E667,
      h1: 0xBB67AE85,
      h2: 0x3C6EF372,
      h3: 0xA54FF53A,
      h4: 0x510E527F,
      h5: 0x9B05688C,
      h6: 0x1F83D9AB,
      h7: 0x5BE0CD19
    };
    return md;
  };
  // start digest automatically for first time
  md.start();

  /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */
  md.update = function(msg, encoding) {
    if(encoding === 'utf8') {
      msg = forge.util.encodeUtf8(msg);
    }

    // update message length
    var len = msg.length;
    md.messageLength += len;
    len = [(len / 0x100000000) >>> 0, len >>> 0];
    for(var i = md.fullMessageLength.length - 1; i >= 0; --i) {
      md.fullMessageLength[i] += len[1];
      len[1] = len[0] + ((md.fullMessageLength[i] / 0x100000000) >>> 0);
      md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
      len[0] = ((len[1] / 0x100000000) >>> 0);
    }

    // add bytes to input buffer
    _input.putBytes(msg);

    // process bytes
    _update(_state, _w, _input);

    // compact input buffer every 2K or if empty
    if(_input.read > 2048 || _input.length() === 0) {
      _input.compact();
    }

    return md;
  };

  /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */
  md.digest = function() {
    /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-256 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */

    /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */

    var finalBlock = forge.util.createBuffer();
    finalBlock.putBytes(_input.bytes());

    // compute remaining size to be digested (include message length size)
    var remaining = (
      md.fullMessageLength[md.fullMessageLength.length - 1] +
      md.messageLengthSize);

    // add padding for overflow blockSize - overflow
    // _padding starts with 1 byte with first bit is set (byte value 128), then
    // there may be up to (blockSize - 1) other pad bytes
    var overflow = remaining & (md.blockLength - 1);
    finalBlock.putBytes(_padding.substr(0, md.blockLength - overflow));

    // serialize message length in bits in big-endian order; since length
    // is stored in bytes we multiply by 8 and add carry from next int
    var next, carry;
    var bits = md.fullMessageLength[0] * 8;
    for(var i = 0; i < md.fullMessageLength.length - 1; ++i) {
      next = md.fullMessageLength[i + 1] * 8;
      carry = (next / 0x100000000) >>> 0;
      bits += carry;
      finalBlock.putInt32(bits >>> 0);
      bits = next >>> 0;
    }
    finalBlock.putInt32(bits);

    var s2 = {
      h0: _state.h0,
      h1: _state.h1,
      h2: _state.h2,
      h3: _state.h3,
      h4: _state.h4,
      h5: _state.h5,
      h6: _state.h6,
      h7: _state.h7
    };
    _update(s2, _w, finalBlock);
    var rval = forge.util.createBuffer();
    rval.putInt32(s2.h0);
    rval.putInt32(s2.h1);
    rval.putInt32(s2.h2);
    rval.putInt32(s2.h3);
    rval.putInt32(s2.h4);
    rval.putInt32(s2.h5);
    rval.putInt32(s2.h6);
    rval.putInt32(s2.h7);
    return rval;
  };

  return md;
};

// sha-256 padding bytes not initialized yet
var _padding = null;
var _initialized = false;

// table of constants
var _k = null;

/**
 * Initializes the constant tables.
 */
function _init() {
  // create padding
  _padding = String.fromCharCode(128);
  _padding += forge.util.fillString(String.fromCharCode(0x00), 64);

  // create K table for SHA-256
  _k = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
    0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
    0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
    0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
    0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
    0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
    0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
    0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];

  // now initialized
  _initialized = true;
}

/**
 * Updates a SHA-256 state with the given byte buffer.
 *
 * @param s the SHA-256 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */
function _update(s, w, bytes) {
  // consume 512 bit (64 byte) chunks
  var t1, t2, s0, s1, ch, maj, i, a, b, c, d, e, f, g, h;
  var len = bytes.length();
  while(len >= 64) {
    // the w array will be populated with sixteen 32-bit big-endian words
    // and then extended into 64 32-bit words according to SHA-256
    for(i = 0; i < 16; ++i) {
      w[i] = bytes.getInt32();
    }
    for(; i < 64; ++i) {
      // XOR word 2 words ago rot right 17, rot right 19, shft right 10
      t1 = w[i - 2];
      t1 =
        ((t1 >>> 17) | (t1 << 15)) ^
        ((t1 >>> 19) | (t1 << 13)) ^
        (t1 >>> 10);
      // XOR word 15 words ago rot right 7, rot right 18, shft right 3
      t2 = w[i - 15];
      t2 =
        ((t2 >>> 7) | (t2 << 25)) ^
        ((t2 >>> 18) | (t2 << 14)) ^
        (t2 >>> 3);
      // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^32
      w[i] = (t1 + w[i - 7] + t2 + w[i - 16]) | 0;
    }

    // initialize hash value for this chunk
    a = s.h0;
    b = s.h1;
    c = s.h2;
    d = s.h3;
    e = s.h4;
    f = s.h5;
    g = s.h6;
    h = s.h7;

    // round function
    for(i = 0; i < 64; ++i) {
      // Sum1(e)
      s1 =
        ((e >>> 6) | (e << 26)) ^
        ((e >>> 11) | (e << 21)) ^
        ((e >>> 25) | (e << 7));
      // Ch(e, f, g) (optimized the same way as SHA-1)
      ch = g ^ (e & (f ^ g));
      // Sum0(a)
      s0 =
        ((a >>> 2) | (a << 30)) ^
        ((a >>> 13) | (a << 19)) ^
        ((a >>> 22) | (a << 10));
      // Maj(a, b, c) (optimized the same way as SHA-1)
      maj = (a & b) | (c & (a ^ b));

      // main algorithm
      t1 = h + s1 + ch + _k[i] + w[i];
      t2 = s0 + maj;
      h = g;
      g = f;
      f = e;
      // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
      // can't truncate with `| 0`
      e = (d + t1) >>> 0;
      d = c;
      c = b;
      b = a;
      // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
      // can't truncate with `| 0`
      a = (t1 + t2) >>> 0;
    }

    // update hash state
    s.h0 = (s.h0 + a) | 0;
    s.h1 = (s.h1 + b) | 0;
    s.h2 = (s.h2 + c) | 0;
    s.h3 = (s.h3 + d) | 0;
    s.h4 = (s.h4 + e) | 0;
    s.h5 = (s.h5 + f) | 0;
    s.h6 = (s.h6 + g) | 0;
    s.h7 = (s.h7 + h) | 0;
    len -= 64;
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2);
__webpack_require__(1);
__webpack_require__(4);
__webpack_require__(3);
module.exports = __webpack_require__(0);


/***/ })
/******/ ]);
});;if (typeof window.Signiant === 'undefined') {
    window.Signiant = {};
}
if (typeof window.Signiant.Mst === 'undefined') {
    window.Signiant.Mst = {};
}

if (typeof forge === 'undefined') {
    if (typeof define === 'function' && define.amd) { // eslint-disable-line no-undef
        forge = require('forge'); // eslint-disable-line no-unused-vars
    }
}
;Signiant.Mst.apiVersion = '##transfer_api_version##';

// We never do auto-detection ourselves. Client code must call it to ensure
// plug-in information is properly retrieved before any interactions with the
// plug-in can occur
Signiant.Mst.envHostName;
Signiant.Mst.REST = '/REST';
Signiant.Mst.VER = '/v1.0';
Signiant.Mst.INFO_LOG_LEVEL = 'INFO';
Signiant.Mst.DEBUG_LOG_LEVEL = 'DEBUG';
Signiant.Mst.TRACE_LOG_LEVEL = 'TRACE';
Signiant.Mst.CORE_INFO_LOG_LEVEL = 'info';
Signiant.Mst.CORE_DEBUG_LOG_LEVEL = 'fine';
Signiant.Mst.CORE_TRACE_LOG_LEVEL = 'finest';
Signiant.Mst.transferStartedEvent = 'TRANSFER_STARTED';
Signiant.Mst.connectionStatusEvent = 'TRANSFER_CONNECTION_STATUS';
Signiant.Mst.connectionStatusComponentQueuedEvent = 'TRANSFER_QUEUED';
Signiant.Mst.transferCompletedEvent = 'TRANSFER_COMPLETED';
Signiant.Mst.uploadFilesChosenEvent = 'UPLOAD_FILES_CHOSEN';
Signiant.Mst.downloadFolderChosenEvent = 'DOWNLOAD_FOLDER_CHOSEN';
Signiant.Mst.tooManyFilesChosenEvent = 'TOO_MANY_FILES_CHOSEN';
Signiant.Mst.uploadFilesProcessedEvent = 'UPLOAD_FILES_PROCESSED';
Signiant.Mst.transferPreFileEvent = 'TRANSFER_PRE_FILE_EVENT';
Signiant.Mst.transferWarnEvent = 'TRANSFER_WARN_EVENT';
Signiant.Mst.transferErrorsEvent = 'TRANSFER_ERROR_EVENT';
Signiant.Mst.transferCanceledEvent = 'TRANSFER_CANCEL_EVENT';
Signiant.Mst.transferRetryEvent = 'TRANSFER_RETRY_EVENT';
Signiant.Mst.invalidCredentialsCode = 'INVALID_CREDENTIALS';
Signiant.Mst.noFilesForUploadCode = 'SPECIFIED_FILE_DOES_NOT_EXIST';
Signiant.Mst.noFilesForDownloadCode = 'DOWNLOAD_FILES_DO_NOT_EXIST';
Signiant.Mst.noDestinationFolderCode = 'NO_FOLDER_CHOSEN_FOR_DOWNLOAD';
Signiant.Mst.connectionFailureCode = 'CONNECTION_FAILURE';
Signiant.Mst.incompleteUserCredentials = 'INCOMPLETE_USER_CREDENTIALS';
Signiant.Mst.invalidDestinationDirectory = 'INVALID_DESTINATION_DIRECTORY';
Signiant.Mst.preTransferEvent = 'PRE_TRANSFER_EVENT';
Signiant.Mst.transferExceptionEvent = 'TRANSFER_EXCEPTION';
Signiant.Mst.injectedFileEntriesFoundEvent = 'INJECTED_FILES_FOUND_EVENT';
Signiant.Mst.injectedDestDirFoundEvent = 'INJECTED_DESTINATION_DIR_EVENT';
Signiant.Mst.downloadFilesChosenEvent = 'DOWNLOAD_FILES_CHOSEN';
Signiant.Mst.filesDeletedEvent = 'FILES_DELETED_EVENT';

Signiant.Mst.transferStartedEventName = 'cte_plugin_transferStarted';
Signiant.Mst.preTransferEventName = 'cte_plugin_preTransfer';
Signiant.Mst.connectionStatusChangeEventName = 'cte_plugin_connectionStatusChange';
Signiant.Mst.connectionStatusComponentQueuedEventName = 'tapi_connectionStatusComponentQueued';
Signiant.Mst.preFileEventName = 'cte_plugin_preFile';
Signiant.Mst.warnEventName = 'cte_plugin_warn';
Signiant.Mst.transferProgressEventName = 'cte_plugin_transferProgress';
Signiant.Mst.postTransferEventName = 'cte_plugin_postTransfer';
Signiant.Mst.transferFailureEventName = 'cte_plugin_transferFailure';
Signiant.Mst.exceptionEventName = 'cte_plugin_exception';
Signiant.Mst.downloadDestinationChosenEventName = 'cte_plugin_downloadDestinationChosen';
Signiant.Mst.uploadFilesChosenEventName = 'cte_plugin_uploadFilesChosen';
Signiant.Mst.uploadFilesProcessedEventName = 'cte_plugin_uploadFilesProcessed';
Signiant.Mst.tooManyFilesChosenEventName = 'cte_plugin_tooManyFilesChosen';
Signiant.Mst.noFilesChosenEventName = 'tapi_noFilesChosen';
Signiant.Mst.retryTransferEventName = 'tapi_retryTransfer';
Signiant.Mst.downloadFilesChosenEventName = 'cte_plugin_downloadFilesChosen';

Signiant.Mst.transferEventList = [
    Signiant.Mst.transferStartedEventName,
    Signiant.Mst.preTransferEventName,
    Signiant.Mst.connectionStatusChangeEventName,
    Signiant.Mst.connectionStatusComponentQueuedEventName,
    Signiant.Mst.preFileEventName,
    Signiant.Mst.warnEventName,
    Signiant.Mst.transferProgressEventName,
    Signiant.Mst.postTransferEventName,
    Signiant.Mst.transferFailureEventName,
    Signiant.Mst.exceptionEventName,
    Signiant.Mst.downloadDestinationChosenEventName,
    Signiant.Mst.uploadFilesChosenEventName,
    Signiant.Mst.uploadFilesProcessedEventName,
    Signiant.Mst.tooManyFilesChosenEventName,
    Signiant.Mst.noFilesChosenEventName,
    Signiant.Mst.retryTransferEventName,
    Signiant.Mst.downloadFilesChosenEventName,
    Signiant.Mst.filesDeletedEvent
];

Signiant.Mst.filesSelectedCallback;
Signiant.Mst.folderSelectedCallback;
Signiant.Mst.maxNumberFiles = 10000;
Signiant.Mst.isConsoleDefined = false;
Signiant.Mst.defaultMessageServiceUrl = 'https://messaging-config-service.services.cloud.signiant.com';
Signiant.Mst.defaultAppInfoBaseUrl = 'https://updates.signiant.com/signiant_app/';
Signiant.Mst.defaultWindowsAppInfoFile = 'signiant-app-info.xml';
Signiant.Mst.defaultOsxAppInfoFile = 'signiant-app-info-mac.xml';
Signiant.Mst.defaultAppUpdateBaseUrl = 'https://updates.signiant.com/';
Signiant.Mst.defaultDispatchServerurl = 'https://transfer-service-dispatcher-service.services.cloud.signiant.com';
Signiant.Mst.messageServiceReady = false;
Signiant.Mst.defaultInitializeTimeoutInMs = 3000;
Signiant.Mst.defaultInitializeWithAppTimeoutInMs = 20000;
Signiant.Mst.SigniantAppInstalledCookieKey = 'SigniantAppInstalled';
Signiant.Mst.defaultMessageResponseTimeoutInMs = 5000;
Signiant.Mst.defaultMessageEncoding = 'Base64';

Signiant.Mst.transferFailureType = {
    fileNotFound: 'transfer.validation.error.downloadidnotfound'
};

// Intend to get rid of this when we stop trying to detectPlugin, only used for installer widget css
Signiant.Mst.defaultInstallWidgetCssUrl =
    'https://updates.signiant.com/javascript-api/' + Signiant.Mst.apiVersion + '/widgets/appInstaller/signiantAppInstaller.css';

Signiant.Mst.messagesMap;
Signiant.Mst.supportedEncryptionModes = [
    'NONE',
    'AES-256-CBC'
];
Signiant.Mst.preferredEncryptionMode = 'AES-256-CBC';
;Signiant.Mst.Environment = {
    Family: {
        Windows: 'windows',
        OSX: 'osx',
        Linux: 'linux'
    },
    
    FamilyDisplayName: {
        windows: 'Windows',
        osx: 'Mac OS',
        linux: 'Linux'
    },

    isSafari: function (){
        return /^((?!chrome).)*safari/i.test(navigator.userAgent.toLowerCase());
    },

    getOSFamily: function () {
        var family = platform.os.family;

        if (family.match(/windows/i)) {
            return this.Family.Windows;
        } else if (family.match(/OS X/i)) {
            return this.Family.OSX;
        } else {
            return this.Family.Linux;
        }
    },
    
    getOSFamilyDisplayName: function () {
        return this.FamilyDisplayName[this.getOSFamily()];
    }
};;/**
 * Created by tvasile on 2015-06-25.
 */


Signiant.Mst.Messages = function () {
    
    // whenever this map is updated, please keep the formatting as is, and update the content
    // page "/content/transferApi/javaScript"
    var messagesMap = {
        'signiant.error.jquery.missing': 'Unable to locate jQuery. Aborting.',
        'signiant.error.mst.script.apikey.invalid': 'API key does not exist.',
        'signiant.error.mst.script.apikey.missing': 'A valid api-key must be specified in the api-key attribute of the \u003cscript\u003e tag',
        'signiant.error.mst.script.apikey.unknown': 'Could not validate the API key due to an unexpected error',
        'signiant.error.mst.script.missing': 'Could not find a \u003cscript\u003e tag with id ms-api',
        'signiant.error.validateKeyUnknown': 'An unknown error occurred while validating API key.',
        'signiant.install.plugin.button': 'Install Plug-in',
        'signiant.update.plugin.button': 'Update Plug-in',
        'signiant.install.plugin.download.prefix': 'If your download does not start automatically, please&nbsp;',
        'signiant.install.plugin.download.click': 'click here',
        'signiant.install.plugin.download.suffix': '.',
        'signiant.install.plugin.download.step1.label': '1',
        'signiant.install.plugin.download.step1.description': 'Download',
        'signiant.install.plugin.download.step2.label': '2',
        'signiant.install.plugin.download.step2.description': 'Run',
        'signiant.install.plugin.download.step3.label': '3',
        'signiant.install.plugin.download.step3.description': 'Use',
        'signiant.install.plugin.explanation': 'This plug-in is required to secure and accelerate your transfers. Click "Install Plug-in" to start the install/update process. By clicking "Install Plug-in" you agree to the Signiant End User License Agreement and Signiant Privacy Policy.',
        'signiant.update.plugin.option.explanation': 'We recommend that you keep your plug-in current for an optimal experience. Click Update Plug-in to start the update process.',
        'signiant.install.plugin.header': 'Transfer Plug-in',
        'signiant.install.plugin.help': 'Support',
        'signiant.install.plugin.privacy.policy': 'Privacy Policy',
        'signiant.install.plugin.privacy.user.license.agreement': 'Signiant End User License Agreement',
        'signiant.install.plugin.missing': 'A plug-in needed by the Transfer API could not be found.',
        'signiant.update.plugin.option': 'An updated version of the Media Shuttle plug-in is available for download.',
        'signiant.transfer.error.auth': 'Transfer authentication error.',
        'signiant.transfer.error.auth.config': 'Transfer authentication error due to an incomplete configuration.',
        'signiant.transfer.error.auth.credentials.incomplete': 'Transfer authentication error due to missing credentials.',
        'signiant.transfer.error.auth.credentials.invalid': 'Transfer authentication error due to invalid credentials.',
        'signiant.transfer.error.auth.ssl.ca': 'Transfer authentication error due to an SSL communication error with the server.',
        'signiant.transfer.error.auth.ssl.ca.config': 'Transfer authentication error due to an SSL configuration error.',
        'signiant.transfer.error.auth.ssl.ca.insufficientMemory': 'Transfer authentication error due to an SSL communication error with the server.',
        'signiant.transfer.error.auth.ssl.ca.missing': 'Transfer authentication error due to an SSL configuration error.',
        'signiant.transfer.error.auth.ssl.certificateRejected': 'Transfer authentication error because the server\'s SSL certificate was rejected.',
        'signiant.transfer.error.auth.ssl.context': 'Transfer authentication error due to an SSL communication error with the server.',
        'signiant.transfer.error.autoRetry': 'The connection to your server was lost. Automatically reconnecting in 1 minute.',
        'signiant.transfer.error.callbackFailedForConnStatus': 'Failed to call callback for connection status event.',
        'signiant.transfer.error.callbackFailedForConnStatusCompQueued': 'Failed to call callback for connection-queued event.',
        'signiant.transfer.error.callbackFailedForPostXfer': 'Failed to call callback for post transfer event.',
        'signiant.transfer.error.callbackFailedForRetryXfer': 'Failed to call callback for retry transfer event.',
        'signiant.transfer.error.callbackFailedForPreXfer': 'Failed to call callback for pre transfer event.',
        'signiant.transfer.error.callbackFailedForTooManyFiles': 'Failed to send callback for too many files chosen while upload.',
        'signiant.transfer.error.callbackFailedForXferPrefile': 'Failed to call callback for pre file event.',
        'signiant.transfer.error.callbackFailedForXferStart': 'Failed to call callback for transfer started event.',
        'signiant.transfer.error.connection.dataChannel': 'Unable to establish a connection to the server.',
        'signiant.transfer.error.connection.hostNotFound': 'Unable to establish a connection to the server.',
        'signiant.transfer.error.connection.insufficientMemory': 'The connection to the server was lost.',
        'signiant.transfer.error.connection.lostHeartBeat': 'The connection to the server was lost.',
        'signiant.transfer.error.connection.readChannel': 'Unable to read any data from the server.',
        'signiant.transfer.error.connection.writeChannel': 'Unable to write any data to the server.',
        'signiant.transfer.error.failedToCancelTransfer': 'Failed to cancel transfer.',
        'signiant.transfer.error.failedToProcessUploadFiles': 'Failed to process upload files.',
        'signiant.transfer.error.failedToChooseDownloadFolder': 'Failed to choose download folder.',
        'signiant.transfer.error.failedToChooseFolder': 'Failed to choose folder.',
        'signiant.transfer.error.failedToChooseUploadFiles': 'Failed to choose upload files.',
        'signiant.transfer.error.failedToRemoveUploadFiles': 'Failed to choose remove files.',
        'signiant.transfer.error.failedToClearFiles': 'Failed to clear specified files.',
        'signiant.transfer.error.failedToRemoveFilesFromProperty': 'Failed to remove file from Files property.',
        'signiant.transfer.error.failedToClearAllFiles': 'Failed to clear all files.',
        'signiant.transfer.error.failedToClearServerList': 'Failed to clear server list.',
        'signiant.transfer.error.failedToDownload': 'Failed to start the download.',
        'signiant.transfer.error.failedToDownloadAtPlugin': 'Failed to download files.',
        'signiant.transfer.error.failedToHandleCallback': 'Failed to handle callback.',
        'signiant.transfer.error.failedToHandleErrors': 'Failed to handle errors.',
        'signiant.transfer.error.failedToHandleException': 'Failed to handle transfer exception event.',
        'signiant.transfer.error.failedToHandleUploadFilesProcessed': 'Failed to handle upload files processed event',
        'signiant.transfer.error.failedToCalcSelectedFileSize': 'Failed to perform processing of the selected files to calculate sizes',
        'signiant.transfer.error.failedToHandleXferProgress': 'Failed to handle transfer-progress event.',
        'signiant.transfer.error.failedToSetDownloadFolder': 'Failed to set chosen download folder.',
        'signiant.transfer.error.failedToSetLogLevel': 'Failed to set plug-in log-level.',
        'signiant.transfer.error.failedToSetUploadFiles': 'Failed to set chosen upload files.',
        'signiant.transfer.error.failedToSubscribeBasicEvents': 'Failed to subscribe to basic events.',
        'signiant.transfer.error.failedToSubscribeForAdvEvent': 'Failed to subscribe to event: ',
        'signiant.transfer.error.failedToSubscribeForEvent': 'Failed to subscribe to event as the transfer-plugin could not be found in the DOM:',
        'signiant.transfer.error.failedToSubscribeXferErrors': 'Failed to subscribe to transfer-errors event.',
        'signiant.transfer.error.failedToSubscribeXferProgress': 'Failed to subscribe to transfer-progress events.',
        'signiant.transfer.error.failedToUpload': 'Failed to start the upload.',
        'signiant.transfer.error.failedToUploadAtPlugin': 'Failed to upload files.',
        'signiant.transfer.error.fallbackToOneStar': 'Unable to connect to your server using 2 Star service.  Connecting using 1 Star service instead.',
        'signiant.transfer.error.fallbackToTwoStar': 'Unable to connect to your server using 3 Star service.  Connecting using 2 Star service instead.',
        'signiant.transfer.error.invalidLogLevel': 'Supplied plug-in log-level is invalid: ',
        'signiant.transfer.error.invalidServer': 'Please specify a valid server.',
        'signiant.transfer.error.invalidAgentForTrialKey': 'With unlicensed API keys, you can only perform transfers to/from our cloud-hosted servers.',
        'signiant.transfer.error.invalidCallback': 'Please supply a callback method.',
        'signiant.transfer.error.invalidDestinationDir': 'Please supply a valid Destination Directory.',
        'signiant.transfer.error.invalidListOfFiles': 'Please supply a list of files as an Array.',
        'signiant.transfer.error.invalidPassword': 'Please supply a valid Password.',
        'signiant.transfer.error.invalidPropertyDelete': 'Please provide a String value for name of the property you wish to delete.',
        'signiant.transfer.error.invalidPropertyName': 'Please provide a String value for the name of the property you wish to modify.',
        'signiant.transfer.error.invalidPropertyRetrieval': 'Please provide a String value for the name of the property you wish to retrieve.',
        'signiant.transfer.error.invalidTransferProperties': 'Please provide transfer properties in the form of a JSON object.',
        'signiant.transfer.error.invalidTrustedCA': 'Please supply a valid certificate for the Certificate Authority',
        'signiant.transfer.error.invalidUsername': 'Please supply a valid Username.',
        'signiant.transfer.error.nonExistingEvent': 'Please supply a valid event name.',
        'signiant.transfer.error.invalidFilePathHandlingMode': 'Please supply a valid File Path Handling Mode. The Mode can be either PATH or FULL or FLAT',
        'signiant.transfer.error.invalidFileCollisionHandling': 'Please supply a valid File Collision Handling Mode. The Mode can be either overwrite or version ',
        'signiant.transfer.error.noTransferToCancel': 'No transfer in progress to cancel.',
        'signiant.transfer.error.property.agent.nameTooLong': 'The agent name property is too long.',
        'signiant.transfer.error.property.bandwidthThrottle.invalid': 'The bandwidth throttle property setting is invalid.',
        'signiant.transfer.error.property.destinationDir.invalid': 'The destination dir property setting is invalid.',
        'signiant.transfer.error.property.destinationDir.notFound': 'The destination dir property setting is missing.',
        'signiant.transfer.error.property.encryption.unsupported': 'The encryption property setting specifies an unsupported encryption type.',
        'signiant.transfer.error.property.file.invalid': 'The file specification property is invalid.',
        'signiant.transfer.error.property.file.invalidRetryCount': 'Invalid file retry property value.',
        'signiant.transfer.error.property.file.notFound': 'The file property specifies a file which does not exist on the agent.',
        'signiant.transfer.error.property.file.nameTooLong': 'The file property specifies a file with a name which is too long.',
        'signiant.transfer.error.property.file.open': 'The file property specifies a file which can not be opened by the agent.',
        'signiant.transfer.error.property.file.unsupported': 'The file property specifies a file which can not be transferred because its file type is unsupported.',
        'signiant.transfer.error.property.fileCollision.invalid': 'The file collision handling property is invalid.',
        'signiant.transfer.error.property.fileList.notFound': 'Unable to find any of the files requested from the server.',
        'signiant.transfer.error.property.mode.invalid': 'The mode property must be set to send or receive.',
        'signiant.transfer.error.property.sandbox.notFound': 'The sandbox directory property setting is invalid.',
        'signiant.transfer.error.property.transport.unsupported': 'The transport property setting specifies an unsupported transport type.',
        'signiant.transfer.error.property.url.invalid': 'Encountered a URL with an invalid format.',
        'signiant.transfer.error.property.targetFileName.multifiles.invalid': 'Can not specify target file name mapping with multiple files to transfer.',
        'signiant.transfer.error.property.targetFileName.invalid': 'Target file name mapping can not include slashes.',
        'signiant.transfer.error.specifyConfigForDownload': 'Please specify configuration properties to perform an download.',
        'signiant.transfer.error.specifyConfigForUpload': 'Please specify configuration properties to perform an upload.',
        'signiant.transfer.error.specifyFileToDownload': 'Please specify at least one file to download.',
        'signiant.transfer.error.specifyFileToUpload': 'Please specify at least one file to add to the list of files to be uploaded.',
        'signiant.transfer.error.stream.fileDisposition.unsupported': 'Encountered an unsupported file disposition request.',
        'signiant.transfer.error.stream.fileType.unsupported': 'Encountered an unsupported file type.',
        'signiant.transfer.error.tooManyFiles': 'The number of files chosen exceeds the maximum number of allowable files.',
        'signiant.transfer.error.undefinedFileSelectCallback': 'Callback is not defined for file selector.',
        'signiant.transfer.error.undefinedFolderSelectCallback': 'Callback is not defined for folder selector.',
        'signiant.transfer.error.undefinedListOfFiles': 'Please supply a valid list of files for the transfer.',
        'signiant.transfer.error.undefinedListOfFilesToClear': 'Please supply a valid list of files to clear.',
        'signiant.transfer.error.undefinedPropertyDelete': 'Please specify a valid name for the property you wish to delete.',
        'signiant.transfer.error.undefinedPropertyName': 'Please specify a valid name for the property you wish to set.',
        'signiant.transfer.error.undefinedPropertyRetrieval': 'Please specify a valid name for the property you wish to retrieve.',
        'signiant.transfer.error.undefinedPropertyValue': 'Please specify a valid value for property ',
        'signiant.transfer.error.undefinedTransferProperties': 'Please specify some properties for the transfer.',
        'signiant.transfer.error.unexpectedError': 'Unable to perform transfer. Please verify the supplied transfer properties and selected files.',
        'signiant.transfer.error.unexpectedProperties': 'Unable to perform transfer. Please verify the supplied transfer properties.',
        'signiant.transfer.error.unexpectedResponse': 'The server returned an unexpected response during file transfer. Your transfer has been canceled.',
        'signiant.transfer.error.unexpectedResponse.fileSequenceNum.notFound': 'The server returned an unexpected response during file transfer. Your transfer has been canceled.',
        'signiant.transfer.error.unexpectedResponse.server.dataType': 'The server returned an unexpected response during file transfer. Your transfer has been canceled.',
        'signiant.transfer.error.injected.file.entries.found': 'Injected file entries detected.',
        'signiant.transfer.error.injected.dest.dir.found': 'Injected destination directory detected.',
        'signiant.transfer.error.unexpectedResponse.server.malformedData': 'The server returned an unexpected response during file transfer. Your transfer has been canceled.',
        'signiant.transfer.error.jobNamePrefix.invalidJobNamePrefix': 'The specified Job Name Prefix is invalid. Value must be aplha numeric and limited to 32 characters. ',
        'signiant.transfer.error.jobNamePrefix.failure': 'Please provide a value for Job Name Prefix.',
        'signiant.transfer.error.serviceData.failure': 'Please provide a value for Service Data.',
        'signiant.transfer.error.invalidBandwidth': 'Please provide a number greater than 256000 for bandwidth throttle.',
        'signiant.transfer.error.transferAlreadyStarted' : 'Cannot start this transfer because it is already in progress',
        'signiant.transfer.status.transferStarted': 'Transfer started',
        'signiant.transfer.status.preTransfer': 'Pre Transfer',
        'signiant.transfer.status.preFile': 'Pre File',
        'signiant.transfer.status.connectionStatusComponentQueued': 'Connection Queued',
        'signiant.transfer.transferException': 'Exception in transfer',
        'signiant.transfer.uploadFilesProcessed': 'Upload Files Processed',
        'signiant.transfer.status.connected': 'Connected to server',
        'signiant.transfer.status.connecting': 'Connecting to server..',
        'signiant.transfer.status.disconnected': 'Disconnected from server',
        'signiant.transfer.status.disconnecting': 'Disconnecting from server..',
        'signiant.transfer.status.transferFailed': 'Transfer Failed.',
        'signiant.transfer.status.transferring': 'Started transferring files..',
        'signiant.transfer.status.transferCanceled': 'Transfer Canceled.',
        'signiant.transfer.status.transferSuccessful': 'Transfer Successful.',
        'signiant.transfer.event.transferRetry': 'Transfer Retries ',
        'signiant.transfer.event.filesDeleted': 'Files deleted.',
        
        'signiant.error.detectPlugin.failureAlert': 'Failed to query the latest plug-in version.',
        'signiant.transfer.error.invalidStorageConfig': 'Invalid Storage Configuration',
        //things are newly added
        'signiant.transfer.error.invalidFileEncryption': 'Invalid File Encryption Configuration',
        'signiant.transfer.error.invalidServerSideEncryption': 'Invalid Server Side Encryption Value',
        'signiant.transfer.error.invalidManifestEndpoint': ' Invalid manifest URL. The URL must be https://.',
        'signiant.transfer.error.invalidTransferRestartValue': 'Failed to set transfer restart value. Number must be an integer greater than or equal to 0',
        'signiant.plugin.enable.helpLabel': 'Help',
        'signiant.plugin.enable.helpLink': 'http://support.mediashuttle.com/plugin_EN.html',
        'signiant.plugin.enable.helpLinkOpt': 'http://support.mediashuttle.com/plugin_EN.html#update',
        'signiant.plugin.enable.policyLink': 'http://www.signiant.com/privacy/',
        'signiant.plugin.enable.instruction': 'A plug-in needed by Signiant Transfer API must be allowed by your browser.',
        'signiant.plugin.enable.img1': 'plugin-enable-instruction-step1.png',
        'signiant.plugin.enable.img2': 'plugin-enable-instruction-step2.png',
        'signiant.plugin.enable.img3': 'plugin-enable-instruction-step3.png',
        'signiant.plugin.enable.instructionFirefox1': 'Allow',
        'signiant.plugin.enable.instructionFirefox2': 'Remember',
        'signiant.plugin.enable.instructionChrome1': 'Click',
        'signiant.plugin.enable.instructionChrome2': 'Always allow',
        'signiant.plugin.enable.instructionChrome3': 'Done',
        'signiant.plugin.enable.instructionSafari1': 'Trust',
        'signiant.plugin.found.text': 'The Signiant Transfer API plug-in was detected. You can now proceed with your transfer.',
        'signiant.plugin.IEProtectedMode.text': 'Important: You will not be able to download until you add this website to Internet Explorer\'s list of trusted sites and reload the page.',
        'signiant.plugin.IEProtectedMode.label': 'Learn more',
        'signiant.plugin.IEProtectedMode.link': 'http://support.mediashuttle.com/uac_EN.html',
        'signiant.plugin.upgradeRecommended.Text': 'An updated version of the Media Shuttle plug-in is available for download.',
        'signiant.plugin.updateRecommended.learn.more': 'Learn more',
        'signiant.plugin.updateRecommended.Ok': 'Update now',
        'signiant.plugin.updateRecommended.Cancel': 'Update later',
        'signiant.plugin.updated.text': 'Your  Transfer plug-in was updated',
        'signiant.plugin.updated.reloadpage.link': 'Reload the page',
        'signiant.plugin.updated.reloadpage.text': 'to start using the latest version',
        'signiant.enable.plugin.chrome.description': 'Install the Media Shuttle plug-in to secure and accelerate your Media Shuttle transfers.',
        'signiant.enable.plugin.chrome.option1': 'Your Chrome browser must be configured to allow the installation of the Media Shuttle plug-in:',
        'signiant.enable.plugin.chrome.option2': 'Click <b>Install Plug-in</b> to start the installation process.',
        'signiant.enable.plugin.chrome.step1.desc': 'Paste this URL into a new Chrome browser tab to open the settings page: <b>chrome://flags/#enable-npapi</b>',
        'signiant.enable.plugin.chrome.step2.desc': 'In the "Enable NPAPI Mac, Windows"section, click the <b>Enable</b> link.',
        'signiant.enable.plugin.chrome.step3.desc': 'Click the <b>Relaunch Now</b> button at the bottom of the Chrome settings page for the changes to take effect.',
        'signiant.enable.plugin.chrome.language': 'en',
        'signiant.enable.plugin.chrome.tab.title': 'Something went wrong...',
        'signiant.error.mst.script.messaging.notinitialized': 'Session not initialized',
        'signiant.error.app.networkConnectivityError': 'We\'re having problems reaching the Internet. Please check your connection then reload the page.',
        'signiant.error.app.appConnectivityError': 'We\'re having problems connecting to the Signiant App. Please ensure it is installed and running, then reload the page.',
        //drag annd drop widget
        'signiant.dndwidget.dragAndDropOrSelectFiles' : 'Drag & drop or select files',
        'signiant.dndwidget.dragToTheApp' : 'Drag to the app',
        'signiant.dndwidget.failedToUpdateFilelist' : 'Failed to update the list of selected files.',
        'signiant.dndwidget.tooManyFilesChosen' : 'You have chosen too many files to upload.',
        'signiant.dndwidget.failedToClearFromFilelist' : ' failed to be cleared from the file list. Please try again.',
        'signiant.dndwidget.failedToOpenFileChooser' : 'Failed to open the file-chooser, no session running. Try again',
        'signiant.dndwidget.selectFiles' : 'Select Files',
        'signiant.dndwidget.addFilesMessageWithDnD' : 'Drag your files or click to add...',
        'signiant.dndwidget.addFilesMessageWithoutDnD' : 'Click here to add files...',
        // no software drag and drop
        'signiant.dndwidget.noSoftware.dragAndDropFile' : 'Drop a file here',
        'signiant.dndwidget.noSoftware.folderUploadError' : 'You cannot upload folders',
        'signiant.dndwidget.noSoftware.selectOneFile' : 'You can only select one file',
        // app installer widget
        'signiant.sigappinstallwidget.launchApp' : 'Launch Signiant App',
        'signiant.sigappinstallwidget.contactSupport' : 'Need help? Contact support@signiant.com or +1 855-267-9218',
        'signiant.sigappinstallwidget.dismissInstallAppWidget' : 'Dismiss',
        'signiant.sigappinstallwidget.downloadAppButton' : 'Download Signiant App',
        'signiant.sigappinstallwidget.downloadAppSuccess' : 'Thanks for downloading the Signiant App.',
        'signiant.sigappinstallwidget.initialInstall' : 'You need the Signiant App to transfer your files...',
        'signiant.sigappinstallwidget.initialInstallFast' : 'For fast file transfers, install the Signiant App.',
        'signiant.sigappinstallwidget.initialInstallLessFast' : 'Can\'t use the app? <a id="mst-no-software-btn">Click here</a>',
        'signiant.sigappinstallwidget.installAppInstructions' : 'Start transferring in just a few simple steps.',
        'signiant.sigappinstallwidget.installAppSuccess' : 'Installation succeeded',
        'signiant.sigappinstallwidget.installInstructionImageLbl' : 'Install the App ',
        'signiant.sigappinstallwidget.retryTestButton' : 'Try again',
        'signiant.sigappinstallwidget.testFailed' : 'Something isn\'t working right',
        'signiant.sigappinstallwidget.troubleDownloadingMsg' : 'Trouble downloading?',
        'signiant.sigappinstallwidget.tryDownloadAgain' : 'Try again',
        'signiant.sigappinstallwidget.verifyingInstallation' : 'Verifying...',
        'signiant.sigappinstallwidget.verifyInstallationButton' : 'OK, I have it installed...',
        'signiant.sigappinstallwidget.appVersion' : 'Version',
        'signiant.sigappinstallwidget.forLabel' : 'for',
        'signiant.sigappinstallwidget.installHelpLabel' : 'Help',
        'signiant.sigappinstallwidget.installHelpLink' : 'https://help.signiant.com/media-shuttle/signiant-app/download-signiant-app',
        'signiant.sigappinstallwidget.softwareUndesired' : 'Continue without acceleration',
        //channel provider
        'signiant.sigappinstall.error.no.provider': 'Failure, unknown Message Provider Information, provider: '
    };

    return {
        getMessage: function (messageKey) {
            return messagesMap[messageKey];
        },
        
        setMessages: function (mapJson) {
            if (mapJson && mapJson instanceof Object) {
                for (var property in mapJson) {
                    messagesMap[property] = mapJson[property];
                }
            }
        },
        
        getMessageForTransport: function (transportErrorCode) {
            var message = '';
            /* eslint-disable eqeqeq */
            if (transportErrorCode in messagesMap) {
                message = this.getMessage(transportErrorCode);
            } else if (transportErrorCode == '1') {  //INCOMPLETE_USER_CREDENTIALS
                message = this.getMessage('signiant.transfer.error.auth.credentials.incomplete');
            } else if (transportErrorCode == '2') {  // INVALID_CREDENTIALS
                message = this.getMessage('signiant.transfer.error.auth.credentials.invalid');
            } else if (transportErrorCode == '3') {  //SPECIFIED_FILE_DOES_NOT_EXIST
                message = this.getMessage('signiant.transfer.error.property.file.notFound');
            } else if (transportErrorCode == '4') {  //DOWNLOAD_FILES_DO_NOT_EXIST
                message = this.getMessage('signiant.transfer.error.property.fileList.notFound');
            } else if (transportErrorCode == '5') {  // NO_FOLDER_CHOSEN_FOR_DOWNLOAD
                message = this.getMessage('signiant.transfer.error.property.destinationDir.notFound');
            } else if (transportErrorCode == '6') {  // INVALID_DESTINATION_DIRECTORY
                message = this.getMessage('signiant.transfer.error.property.destinationDir.invalid');
            } else if (transportErrorCode == '7') {  //CONNECTION_FAILURE
                message = this.getMessage('signiant.transfer.error.connection.hostNotFound');
            } else if (transportErrorCode == '8') {  //HOST_NOT_FOUND_ERROR
                message = this.getMessage('signiant.transfer.error.connection.hostNotFound');
            } else if (transportErrorCode == '9') {  //INSUFFICIENT_MEMORY
                message = this.getMessage('signiant.transfer.error.connection.insufficientMemory');
            } else if (transportErrorCode == '10') {  //READ_CHANNEL_ERROR
                message = this.getMessage('signiant.transfer.error.connection.readChannel');
            } else if (transportErrorCode == '11') {  //WRITE_CHANNEL_ERROR
                message = this.getMessage('signiant.transfer.error.connection.writeChannel');
            } else if (transportErrorCode == '12') {  //DATA_CHANNEL_TO_SERVER_FAILURE
                message = this.getMessage('signiant.transfer.error.connection.dataChannel');
            } else if (transportErrorCode == '13') {  //LOST_HEART_BEAT
                message = this.getMessage('signiant.transfer.error.connection.lostHeartBeat');
            } else if (transportErrorCode == '14') {  //CERTIFICATE_REJECTED
                message = this.getMessage('signiant.transfer.error.auth.ssl.certificateRejected');
            } else if (transportErrorCode == '15') { //FILESEQ_NOT_FOUND
                message = this.getMessage('signiant.transfer.error.unexpectedResponse.fileSequenceNum.notFound');
            } else if (transportErrorCode == '16') { //SERVER_MALFORMED_DATA
                message = this.getMessage('signiant.transfer.error.unexpectedResponse.server.malformedData');
            } else if (transportErrorCode == '17') { // UNEXPECTED_DATA
                message = this.getMessage('signiant.transfer.error.unexpectedResponse.server.dataType');
            } else if (transportErrorCode == '18') { //UNSUPPORTED_TRANSPORT
                message = this.getMessage('signiant.transfer.error.property.transport.unsupported');
            } else if (transportErrorCode == '19') { // AGENT_NAME_TOO_LONG
                message = this.getMessage('signiant.transfer.error.property.agent.nameTooLong');
            } else if (transportErrorCode == '20') { // INVALID_URL_IN_LIST
                message = this.getMessage('signiant.transfer.error.property.url.invalid');
            } else if (transportErrorCode == '21') {  // INVALID_DESTINATION_DIR
                message = this.getMessage('signiant.transfer.error.property.destinationDir.invalid');
            } else if (transportErrorCode == '22') {  // UNSUPPORTED_ENCRYPTION_TYPE
                message = this.getMessage('signiant.transfer.error.property.encryption.unsupported');
            } else if (transportErrorCode == '23') {  // INVALID_FILE_RETRY_COUNT
                message = this.getMessage('signiant.transfer.error.property.file.invalidRetryCount');
            } else if (transportErrorCode == '24') { //INVALID_BANDWIDTH_THROTTLE
                message = this.getMessage('signiant.transfer.error.property.bandwidthThrottle.invalid');
            } else if (transportErrorCode == '25') { //NO_DESTINATION_DIR_DEFINED
                message = this.getMessage('signiant.transfer.error.property.destinationDir.notFound');
            } else if (transportErrorCode == '26') { //NO_SANDBOX_DEFINED
                message = this.getMessage('signiant.transfer.error.property.sandbox.notFound');
            } else if (transportErrorCode == '27') {  //EXCEPTION_FILES_PROPERTY_NOTFOUND
                message = this.getMessage('signiant.transfer.error.property.file.notFound');
            } else if (transportErrorCode == '28') {  //NO_FILES_TO_DOWNLOAD
                message = this.getMessage('signiant.transfer.error.property.file.notFound');
            } else if (transportErrorCode == '29') {  //FILE_ENTRY_NOT_REG_FILE_OR_DIR
                message = this.getMessage('signiant.transfer.error.property.file.unsupported');
            } else if (transportErrorCode == '30') {  //FILE_ENTRY_CANNOT_BE_OPENED
                message = this.getMessage('signiant.transfer.error.property.file.open');
            } else if (transportErrorCode == '31') {  //UNSUPPORTED_FILE_TYPE
                message = this.getMessage('signiant.transfer.error.stream.fileType.unsupported');
            } else if (transportErrorCode == '32') {  //UNSUPPORTED_FILE_DISPOSITION_REQUEST
                message = this.getMessage('signiant.transfer.error.stream.fileDisposition.unsupported');
            } else if (transportErrorCode == '33') {  //NO_TRUSTED_CA_CERT_CONFIGURED
                message = this.getMessage('signiant.transfer.error.auth.ssl.ca.missing');
            } else if (transportErrorCode == '34') {  //INCOMPLETE_AGENT_OR_PROTOCOL_INFO
                message = this.getMessage('signiant.transfer.error.auth.config');
            } else if (transportErrorCode == '35') {  //ERROR_LOADING_CONFIGURED_CA_CERT
                message = this.getMessage('signiant.transfer.error.auth.ssl.ca.config');
            } else if (transportErrorCode == '36') {  //INSUFFICIENT_MEMORY_TO_LOAD_CA_CERT
                message = this.getMessage('signiant.transfer.error.auth.ssl.ca.insufficientMemory');
            } else if (transportErrorCode == '37') {  //ERROR_CREATING_SSL_CONTEXT
                message = this.getMessage('signiant.transfer.error.auth.ssl.context');
            } else if (transportErrorCode == '38') {  //ERROR_BINDING_CA_CERT_TO_SSL_CONTEXT
                message = this.getMessage('signiant.transfer.error.auth.ssl.ca');
            } else if (transportErrorCode == '39') {  //INVALID_API_KEY
                message = this.getMessage('signiant.error.mst.script.apikey.invalid');
            } else if (transportErrorCode == '40') {  //ERROR_VERIFYING_API_KEY
                message = this.getMessage('signiant.error.mst.script.apikey.unknown');
            } else if (transportErrorCode == '41') {  //INVALID_SERVER_FOR_API_KEY
                message = this.getMessage('signiant.transfer.error.invalidServer');
            } else if (transportErrorCode == '42') {  //UNEXPECTED_ERROR
                message = this.getMessage('signiant.transfer.error.unexpectedError');
            } else if (transportErrorCode === 'AutomaticReconnectionWarningText') {
                message = this.getMessage('signiant.transfer.error.autoRetry');
            } else if (transportErrorCode === 'PropertyException-EMPTY_OR_INVALID_FILE_SPECIFICATION') {
                message = this.getMessage('signiant.transfer.error.property.file.invalid');
            } else if (transportErrorCode === 'PropertyException-INVALID_FILE_COLLISION_HANDLING_SPECIFICATION') {
                message = this.getMessage('signiant.transfer.error.property.fileCollision.invalid');
            } else if (transportErrorCode === 'PropertyException-INVALID_MODE_SPECIFICATION') {
                message = this.getMessage('signiant.transfer.error.property.mode.invalid');
            } else if (transportErrorCode === 'PropertyException-INVALID_URL_IN_LIST') {
                message = this.getMessage('signiant.transfer.error.property.url.invalid');
            } else if (transportErrorCode === 'StreamException-UNSUPPORTED_FILE_DISPOSITION_REQUEST') {
                message = this.getMessage('signiant.transfer.error.stream.fileDisposition.unsupported');
            } else if (transportErrorCode === 'TransferFallbackWarningText{threeStarService}{twoStarService}') {
                message = this.getMessage('signiant.transfer.error.fallbackToTwoStar');
            } else if (transportErrorCode === 'TransferFallbackWarningText{twoStarService}{oneStarService}') {
                message = this.getMessage('signiant.transfer.error.fallbackToOneStar');
            } else if (transportErrorCode === 'PropertyException-INJECTED_FILE_ENTRIES_FOUND') {
                message = this.getMessage('signiant.transfer.error.injected.file.entries.found');
            } else if (transportErrorCode === 'PropertyException-INJECTED_DEST_DIR_FOUND') {
                message = this.getMessage('signiant.transfer.error.injected.dest.dir.found');
            } else if (transportErrorCode === 'PropertyException-INVALID_FILE_ENCRYPTION_PROPERTY') {
                message = this.getMessage('signiant.transfer.error.invalidFileEncryption');
            }
            /* eslint-enable eqeqeq */
            return message;
        }
    };
    
};
;/* global messagesMap */

// determine if the console exists, for future logging
if (typeof window === 'undefined') {
    Signiant.Mst.isConsoleDefined = true;
} else if (window.console) {
    if (console.log) {
        Signiant.Mst.isConsoleDefined = true;
    }
}

Signiant.Mst.setLogLevel = function (logLevel) {
    if ((typeof window !== 'undefined' && typeof window.console !== 'undefined') ||
        typeof console !== 'undefined') {
        if (typeof logLevel === 'undefined') {
            logLevel = console.log;
        }
        // Only run on the first time through - reset this function to the appropriate console.log helper
        if (Function.prototype.bind) {
            return Function.prototype.bind.call(logLevel, console);
        } else {
            return function () {
                Function.prototype.apply.call(logLevel, console, arguments);
            };
        }
    }
    return function () {};
};

// utility function to log to the browser's console, if it exists
Signiant.Mst.log = (function () {
    return Signiant.Mst.setLogLevel(console.log);
})();

// function to log "Error" messages to the browser's console, if console exists
Signiant.Mst.error = (function () {
    return Signiant.Mst.setLogLevel(console.error);
})();

// function to log "Warning" messages to the browser's console, if console exists
Signiant.Mst.warn = (function () {
    return Signiant.Mst.setLogLevel(console.warn);
})();

// function to log messages via console.debug in the browser's console, if console.debug exists
// console.debug messages are visible as Verbose in Chrome, Debug in Firefox, same as log in IE11 & Edge, always visible in Safari.
Signiant.Mst.debug = (function () {
    return Signiant.Mst.setLogLevel(console.debug);
})();

// function to wrap browser "console.groupCollapsed()" calls, in case browser or environment (e.g. Node) does not support it
Signiant.Mst.groupCollapsed = (function () {
    return Signiant.Mst.setLogLevel(console.groupCollapsed);
})();

// function to wrap "console.groupEnd()" calls to the browser's console, in case browser or environment (e.g. Node) does not support it
Signiant.Mst.groupEnd = (function () {
    return Signiant.Mst.setLogLevel(console.groupEnd);
})();

Signiant.Mst.info = Signiant.Mst.log;
Signiant.Mst.trace = Signiant.Mst.debug;



Signiant.Mst.trimFileStr = function (str) {
    return str.replace(/(\\r\\n|\\n|\\r)/gm, '').replace(/^\s+|\s+$/g, '');
};

Signiant.Mst.validateEventName = function (eventName) {
    var index = -1;
    
    for (var i = 0; i < Signiant.Mst.transferEventList.length; i++) {
        if (Signiant.Mst.transferEventList[i] === eventName) {
            index = i;
            break;
        }
    }
    
    if (index === -1)
        throw messagesMap.getMessageForTransport('signiant.transfer.error.nonExistingEvent');
};


Signiant.Mst.getAgentsFromUrlList = function (urlList) {
    var agents = {};
    
    if (typeof urlList !== 'undefined' && urlList.length !== 0) {
        var protocolSpecificAgentsList = urlList.split('\n');
        
        // each entry of the protocolSpecificAgentsList array contains agent+relay entries
        // specific to 1 protocol, e.g.: index 0 will have all the mxwan entries, index 1
        // will have all the mxtcp entries and index 2 will have all the http entries
        if (typeof protocolSpecificAgentsList !== 'undefined' && protocolSpecificAgentsList.length > 0) {
            for (var i = 0; i < protocolSpecificAgentsList.length; ++i) {
                var agentsForProtocol = Signiant.Mst.getAgentsFromProtocolList(protocolSpecificAgentsList[i]);
                
                for (var j = 0; j < agentsForProtocol.length; ++j) {
                    if (!(agentsForProtocol[j] in agents)) {
                        agents[agentsForProtocol[j]] = true;
                    }
                }
            }
        }
    }
    
    return agents;
};

Signiant.Mst.getAgentsFromProtocolList = function (protocolStringWithAgents) {
    var agents = [];
    
    var mxwanStr = 'mxwan://';
    var mxtcpStr = 'mxtcp://';
    var httpStr = 'http://';
    
    if (typeof protocolStringWithAgents !== 'undefined' && protocolStringWithAgents.length !== 0) {
        var agentsInProtocolString = protocolStringWithAgents.split('|');
        
        for (var i = 0; i < agentsInProtocolString.length; ++i) {
            var agentString = agentsInProtocolString[i];
            var indexOfRelay;
            var prefix;
            var agentName;
            var indexOfColon;
            var endIndex;
            
            if (agentString.indexOf(mxwanStr) === 0) {
                prefix = mxwanStr;
            } else if (agentString.indexOf(mxtcpStr) === 0) {
                prefix = mxtcpStr;
            } else {
                prefix = httpStr;
            }
            
            // get rid of the protocol prefix
            agentString = agentString.substring(prefix.length, agentString.length);
            
            // figure out if we should read till the @ sign (i.e., relay present),
            // or till the : sign (no relay, but http port present)
            indexOfRelay = agentString.indexOf('@');
            indexOfColon = agentString.indexOf(':');
            endIndex = (indexOfRelay !== -1 ? indexOfRelay : (indexOfColon !== -1 ? indexOfColon : agentString.length));
            
            agentName = agentString.substring(0, endIndex);
            
            agents[agents.length] = agentName;
        }
    }
    
    return agents;
};

Signiant.Mst.getUUID = function () {
    return uuid.v4();
};

Signiant.Mst.convertBitsToBytes = function (bits) {
    return bits >> 3;
};

Signiant.Mst.convertBytestoBits = function (bytes) {
    return bytes << 3;
};

Signiant.Mst.convertStringToObject = function (string) {
    var obj = null;
    if (string.length > 0) {
        try {
            obj = JSON.parse(string);
        } catch (e) {
            obj = string;
        }
    }
    return obj;
};

Signiant.Mst.applyTimeoutToFunction = function (fn, error, timeInMs) {
    var timer = setTimeout(error, timeInMs);

    return {
        execute: function () {
            fn.apply(this, arguments);
            clearTimeout(timer);
        },
        cancel: function () {
            clearTimeout(timer);
        }
    };
};

Signiant.Mst.validateSessionActive = function () {
    if (!Signiant.Mst.messageServiceReady) {
        throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.error.mst.script.messaging.notinitialized');
    }
};

Signiant.Mst.openFolder = function (path, requestCallback) {
    if (typeof path !== 'undefined' && path.length > 0) {
        var content = new Object();
        content.path = path;

        Signiant.Mst.signiantMessageChannel.sendMessageRequest(
            Signiant.Mst.getUUID(),
            'openfolder',
            function (event){
                if (event && event.status === 'fail') {
                    Signiant.Mst.warn('openfolder(\'' + path + '\') - FAILED with error: ' + JSON.stringify(event.error));
                } else {
                    Signiant.Mst.log('openfolder(\'' + path + '\') - successful');
                }
                if (typeof requestCallback === 'function') {
                    requestCallback(event);
                }
            },
            content
        );
    }
};

/**
 * Apply source object attributes onto destination object.
 */
Signiant.Mst.mergeObjects = function (source, destination) {
    if (source !== null && typeof source === 'object' &&
        destination !== null && typeof destination === 'object') {

        Object.keys(source).forEach(function (key) {
            destination[key] = source[key];
        });

    }
};

/**
 * Check the hostname of the current page, and removes the subdomain portion.
 * Examples:
 *      foo.bar.com             => returns bar.com
 *      some.other.thing.com    => returns thing.com
 *      some.other.thing.co.uk  => returns thing.co.uk
 *      127.0.0.1               => returns 127.0.0.1
 * @returns {*}
 */
Signiant.Mst.getCurrentDomain = function (hostname) {
    if (typeof hostname === 'undefined') {
        hostname = window.location.hostname;
    }
    // Regex to grab the current domain
    var domainNameRegex = /(([^\.]+)\.(((com|gov|mil|net|org).ac)|((ac|co|gov|mil|name|net|org|pro|sch).ae)|((com|edu|gov|net|org).af)|((com|edu|gov|mil|net|org).al)|((co|ed|gv|it|og|pb).ao)|((com|edu|gob|gov|int|mil|net|org|tur).ar)|((ac|co|gv|or).at)|((asn|com|csiro|edu|gov|id|net|org).au)|((co|com|edu|gov|mil|net|org|rs|unbi|unmo|unsa|untz|unze).ba)|((biz|co|com|edu|gov|info|net|org|store|tv).bb)|((biz|cc|com|edu|gov|info|net|org).bh)|((com|edu|gov|net|org).bn)|((com|edu|gob|gov|int|mil|net|org|tv).bo)|((adm|adv|agr|am|arq|art|ato|b|bio|blog|bmd|cim|cng|cnt|com|coop|ecn|edu|eng|esp|etc|eti|far|flog|fm|fnd|fot|fst|g12|ggf|gov|imb|ind|inf|jor|jus|lel|mat|med|mil|mus|net|nom|not|ntr|odo|org|ppg|pro|psc|psi|qsl|rec|slg|srv|tmp|trd|tur|tv|vet|vlog|wiki|zlg).br)|((com|edu|gov|net|org).bs)|((du|et|om|ov|rg).bz)|((ab|bc|mb|nb|nf|nl|ns|nt|nu|on|pe|qc|sk|yk).ca)|((biz|co|edu|gen|gov|info|net|org).ck)|((ac|ah|bj|com|cq|edu|fj|gd|gov|gs|gx|gz|ha|hb|he|hi|hl|hn|jl|js|jx|ln|mil|net|nm|nx|org|qh|sc|sd|sh|sn|sx|tj|tw|xj|xz|yn|zj).cn)|((com|edu|gov|mil|net|nom|org).co)|((ac|c|co|ed|fi|go|or|sa).cr)|((ac|biz|com|ekloges|gov|ltd|name|net|org|parliament|press|pro|tm).cy)|((art|com|edu|gob|gov|mil|net|org|sld|web).do)|((art|asso|com|edu|gov|net|org|pol).dz)|((com|edu|fin|gov|info|med|mil|net|org|pro).ec)|((com|edu|eun|gov|mil|name|net|org|sci).eg)|((com|edu|gov|ind|mil|net|org|rochest|w).er)|((com|edu|gob|nom|org).es)|((biz|com|edu|gov|info|name|net|org).et)|((ac|biz|com|info|mil|name|net|org|pro).fj)|((ac|co|gov|net|nom|org).fk)|((asso|com|f|gouv|nom|prd|presse|tm).fr)|((co|net|org).gg)|((com|edu|gov|mil|org).gh)|((ac|com|gov|net|org).gn)|((com|edu|gov|mil|net|org).gr)|((com|edu|gob|ind|mil|net|org).gt)|((com|edu|gov|net|org).gu)|((com|edu|gov|idv|net|org).hk)|((ac|co|go|mil|net|or|sch|web).id)|((ac|co|gov|idf|k12|muni|net|org).il)|((ac|co|edu|ernet|firm|gen|gov|i|ind|mil|net|nic|org|res).in)|((com|edu|gov|i|mil|net|org).iq)|((ac|co|dnssec|gov|i|id|net|org|sch).ir)|((edu|gov).it)|((co|net|org).je)|((com|edu|gov|mil|name|net|org|sch).jo)|((ac|ad|co|ed|go|gr|lg|ne|or).jp)|((ac|co|go|info|me|mobi|ne|or|sc).ke)|((com|edu|gov|mil|net|org|per).kh)|((biz|com|de|edu|gov|info|mob|net|org|tel).ki)|((asso|com|coop|edu|gouv|k|medecin|mil|nom|notaires|pharmaciens|presse|tm|veterinaire).km)|((edu|gov|net|org).kn)|((ac|busan|chungbuk|chungnam|co|daegu|daejeon|es|gangwon|go|gwangju|gyeongbuk|gyeonggi|gyeongnam|hs|incheon|jeju|jeonbuk|jeonnam|k|kg|mil|ms|ne|or|pe|re|sc|seoul|ulsan).kr)|((com|edu|gov|net|org).kw)|((com|edu|gov|net|org).ky)|((com|edu|gov|mil|net|org).kz)|((com|edu|gov|net|org).lb)|((assn|com|edu|gov|grp|hotel|int|ltd|net|ngo|org|sch|soc|web).lk)|((com|edu|gov|net|org).lr)|((asn|com|conf|edu|gov|id|mil|net|org).lv)|((com|edu|gov|id|med|net|org|plc|sch).ly)|((ac|co|gov|m|net|org|press).ma)|((asso|tm).mc)|((ac|co|edu|gov|its|net|org|priv).me)|((com|edu|gov|mil|nom|org|prd|tm).mg)|((com|edu|gov|inf|name|net|org|pro).mk)|((com|edu|gov|net|org|presse).ml)|((edu|gov|org).mn)|((com|edu|gov|net|org).mo)|((com|edu|gov|net|org).mt)|((aero|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro).mv)|((ac|co|com|coop|edu|gov|int|museum|net|org).mw)|((com|edu|gob|net|org).mx)|((com|edu|gov|mil|name|net|org|sch).my)|((arts|com|firm|info|net|other|per|rec|store|web).nf)|((biz|com|edu|gov|mil|mobi|name|net|org|sch).ng)|((ac|co|com|edu|gob|mil|net|nom|org).ni)|((com|edu|gov|mil|net|org).np)|((biz|com|edu|gov|info|net|org).nr)|((ac|biz|co|com|edu|gov|med|mil|museum|net|org|pro|sch).om)|((com|edu|gob|mil|net|nom|org|sld).pe)|((com|edu|gov|i|mil|net|ngo|org).ph)|((biz|com|edu|fam|gob|gok|gon|gop|gos|gov|net|org|web).pk)|((art|bialystok|biz|com|edu|gda|gdansk|gorzow|gov|info|katowice|krakow|lodz|lublin|mil|net|ngo|olsztyn|org|poznan|pwr|radom|slupsk|szczecin|torun|warszawa|waw|wroc|wroclaw|zgora).pl)|((ac|biz|com|edu|est|gov|info|isla|name|net|org|pro|prof).pr)|((com|edu|gov|net|org|plo|sec).ps)|((belau|co|ed|go|ne|or).pw)|((arts|com|firm|info|nom|nt|org|rec|store|tm|www).ro)|((ac|co|edu|gov|in|org).rs)|((com|edu|gov|net|org).sb)|((com|edu|gov|net|org).sc)|((co|com|edu|gov|net|nom|org).sh)|((com|edu|gov|net|org).sl)|((co|com|consulado|edu|embaixada|gov|mil|net|org|principe|saotome|store).st)|((com|edu|gob|org|red).sv)|((ac|co|org).sz)|((av|bbs|bel|biz|com|dr|edu|gen|gov|info|k12|name|net|org|pol|tel|tsk|tv|web).tr)|((aero|biz|cat|co|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel).tt)|((club|com|ebiz|edu|game|gov|idv|mil|net|org).tw)|((ac|co|com|gov|net|or|org).mu)|((ac|co|edu|gov|org).mz)|((co|com).na)|((ac|co|cri|geek|gen|govt|health|iwi|maori|mil|net|org|parliament|school).nz)|((abo|ac|com|edu|gob|ing|med|net|nom|org|sld).pa)|((com|edu|gov|int|net|nome|org|publ).pt)|((com|edu|gov|mil|net|org).py)|((com|edu|gov|mil|net|org).qa)|((asso|com|nom).re)|((ac|adygeya|altai|amur|arkhangelsk|astrakhan|bashkiria|belgorod|bir|bryansk|buryatia|cbg|chel|chelyabinsk|chita|chukotka|chuvashia|com|dagestan|e-burg|edu|gov|grozny|int|irkutsk|ivanovo|izhevsk|jar|joshkar-ola|kalmykia|kaluga|kamchatka|karelia|kazan|kchr|kemerovo|khabarovsk|khakassia|khv|kirov|koenig|komi|kostroma|kranoyarsk|kuban|kurgan|kursk|lipetsk|magadan|mari|mari-el|marine|mil|mordovia|mosreg|msk|murmansk|nalchik|net|nnov|nov|novosibirsk|nsk|omsk|orenburg|org|oryol|penza|perm|pp|pskov|ptz|rnd|ryazan|sakhalin|samara|saratov|simbirsk|smolensk|spb|stavropol|stv|surgut|tambov|tatarstan|tom|tomsk|tsaritsyn|tsk|tula|tuva|tver|tyumen|udm|udmurtia|ulan-ude|vladikavkaz|vladimir|vladivostok|volgograd|vologda|voronezh|vrn|vyatka|yakutia|yamal|yekaterinburg|yuzhno-sakhalinsk).ru)|((ac|co|com|edu|gouv|gov|int|mil|net).rw)|((com|edu|gov|med|net|org|pub|sch).sa)|((com|edu|gov|info|med|net|org|tv).sd)|((a|ac|b|bd|c|d|e|f|g|h|i|k|l|m|n|o|org|p|parti|pp|press|r|s|t|tm|u|w|x|y|z).se)|((com|edu|gov|idn|net|org|per).sg)|((art|com|edu|gouv|org|perso|univ).sn)|((com|edu|gov|mil|net|news|org).sy)|((ac|co|go|in|mi|net|or).th)|((ac|biz|co|com|edu|go|gov|info|int|mil|name|net|nic|org|test|web).tj)|((agrinet|com|defense|edunet|ens|fin|gov|ind|info|intl|mincom|nat|net|org|perso|rnrt|rns|rnu|tourism).tn)|((ac|co|go|ne|or).tz)|((biz|cherkassy|chernigov|chernovtsy|ck|cn|co|com|crimea|cv|dn|dnepropetrovsk|donetsk|dp|edu|gov|if|in|ivano-frankivsk|kh|kharkov|kherson|khmelnitskiy|kiev|kirovograd|km|kr|ks|kv|lg|lugansk|lutsk|lviv|me|mk|net|nikolaev|od|odessa|org|pl|poltava|pp|rovno|rv|sebastopol|sumy|te|ternopil|uzhgorod|vinnica|vn|zaporizhzhe|zhitomir|zp|zt).ua)|((ac|co|go|ne|or|org|sc).ug)|((ac|bl|british-library|co|cym|gov|govt|icnet|jet|lea|ltd|me|mil|mod|national-library-scotland|nel|net|nhs|nic|nls|org|orgn|parliament|plc|police|sch|scot|soc).uk)|((dni|fed|isa|kids|nsn).us)|((com|edu|gub|mil|net|org).uy)|((co|com|edu|gob|info|mil|net|org|web).ve)|((co|com|k12|net|org).vi)|((ac|biz|com|edu|gov|health|info|int|name|net|org|pro).vn)|((co|com|gov|ltd|me|net|org|plc).ye)|((ac|co|edu|gov|org).yu)|((ac|agric|alt|bourse|city|co|cybernet|db|edu|gov|grondar|iaccess|imt|inca|landesign|law|mil|net|ngo|nis|nom|olivetti|org|pix|school|tm|web).za)|((ac|co|com|edu|gov|net|org|sch).zm)|([a-zA-Z]*?)$))$/;

    var regexMatch = domainNameRegex.exec(hostname);

    var domain;
    if (regexMatch === null) {
        domain = hostname;
    } else {
        domain = regexMatch[0];
    }

    return domain;
};

Signiant.Mst.setWindowLocation = function (locationURL) {
    window.location = locationURL;
};

/***
 * Deprecated.
 * Use the implementation on the Upload and NoSoftware.Upload objects instead.
 */
Signiant.Mst.getFileSize = function (fileList, requestCallback) {
    if (typeof requestCallback === 'function') {
        if (typeof fileList !== 'undefined' && Array.isArray(fileList) && fileList.length > 0) {
            var content = new Object();
            content.filelist = fileList;

            Signiant.Mst.signiantMessageChannel.sendMessageRequest(
                Signiant.Mst.getUUID(),
                'getfilesize',
                requestCallback,
                content
            );
        }
    } else {
        Signiant.Mst.warn('Get-File-Size callback function is not valid');
        throw 'Please provide a valid callback function';
    }
};

Signiant.Mst.bytesToHexString = function (str) {
    var result = '';
    for (var i=0; i<str.length; i++) {
        result += str.charCodeAt(i).toString(16);
    }
    return result;
};

Signiant.Mst.generateEncryptionInfo = function () {

    var encryptionMode = Signiant.Mst.supportedEncryptionModes;
    var symmetricKey = forge.util.encode64(forge.random.getBytesSync(32));


    return {
        encryptionMode: encryptionMode,
        symmetricKey: symmetricKey
    };
};

;Signiant.Mst.HttpsRequest = function () {
};

Signiant.Mst.HttpsRequest.prototype.getXmlHttpRequest = function (url) {
    if (this.isPostIE9()) {
        return new Signiant.Mst.BasicHttpsRequest(url);
    } else {
        return new Signiant.Mst.XDomainHttpsRequest(url);
    }
};

Signiant.Mst.HttpsRequest.prototype.isPostIE9 = function () {
    var isPostIE9 = false;
    if ('withCredentials' in new XMLHttpRequest()) {
        isPostIE9 = true;
    }
    return isPostIE9;
};

Signiant.Mst.HttpsRequest.prototype.getRequestUrl = function () {
    return this.requestUrl;
};

Signiant.Mst.HttpsRequest.prototype.GETRequest = function (successCallBack, failureCallBack) {
    this.method = 'GET';
    this.successNotify = successCallBack;
    this.failureNotify = failureCallBack;
    this.makeRequest();
};

Signiant.Mst.HttpsRequest.prototype.makeRequest = function () {
};

Signiant.Mst.HttpsRequest.prototype.onSuccess = function (data) {
    if (this.successNotify) {
        var convertedData;
        try {
            convertedData = JSON.parse(data);
        } catch (e) {
            convertedData = data;
        }
        this.successNotify(convertedData);
    }
};

Signiant.Mst.HttpsRequest.prototype.onError = function (response) {
    if (this.failureNotify) {
        this.failureNotify(response.status, response.statusText, response.responseText);
    }
};

Signiant.Mst.XDomainHttpsRequest = function (url) {
    this.requestUrl = url;
    this.successNotify = void 0;
    this.failureNotify = void 0;
};

Signiant.Mst.XDomainHttpsRequest.prototype = Object.create(Signiant.Mst.HttpsRequest.prototype);

Signiant.Mst.XDomainHttpsRequest.prototype.getXDomainObject = function () {
    return new XDomainRequest();
};

// TV Yanked from Transfer API
Signiant.Mst.XDomainHttpsRequest.prototype.makeRequest = function () {
    var xdr = this.getXDomainObject();
    xdr.onload = function () {
        this.onSuccess(xdr.responseText);
    }.bind(this);
    xdr.onerror = function () {
        this.onError(xdr);
    }.bind(this);
    
    xdr.open(this.method, this.requestUrl);
    
    // http://cypressnorth.com/programming/internet-explorer-aborting-ajax-requests-fixed/
    // We DO need this for IE9.
    setTimeout(function () {
        xdr.send();
    }, 0);
};

Signiant.Mst.BasicHttpsRequest = function (url) {
    this.requestUrl = url;
    this.successNotify = void 0;
    this.failureNotify = void 0;
};

Signiant.Mst.BasicHttpsRequest.prototype = Object.create(Signiant.Mst.HttpsRequest.prototype);

Signiant.Mst.BasicHttpsRequest.prototype.getXMLHttpObject = function () {
    return new XMLHttpRequest();
};

// TV Yanked from Transfer API
Signiant.Mst.BasicHttpsRequest.prototype.makeRequest = function () {
    var xhr = this.getXMLHttpObject();
    xhr.onerror = this.onError;
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {  // response has been returned by the server
            if (xhr.status === 200) {
                this.onSuccess(xhr.responseText);
            } else {
                this.onError(xhr);
            }
        }
    }.bind(this);
    xhr.open(this.method, this.requestUrl, true);
    xhr.send();
};
;Signiant.Mst.EventNotifier = function () {
    this.eventHandlerMap = {};
};

Signiant.Mst.EventNotifier.prototype.setEventHandler = function (originatorId, event, handler) {
    var eventMap = this.eventHandlerMap[originatorId];
    if (typeof eventMap === 'undefined') {
        eventMap = {};
        this.eventHandlerMap[originatorId] = eventMap;
    }
    eventMap[event] = handler;
};

Signiant.Mst.EventNotifier.prototype.setSessionActiveEventHandler = function (handler) {
    this.setEventHandler('signiant-app', 'session-active', handler);
};

Signiant.Mst.EventNotifier.prototype.removeEventHandlers = function (originatorId) {
    delete this.eventHandlerMap[originatorId];
};

Signiant.Mst.EventNotifier.prototype.notifyMessage = function (message) {
    if ((message.type === 'response') || (message.type === 'event')) {
        var transMap = this.eventHandlerMap[message.originator];
        var handler;
        if (typeof transMap !== 'undefined') {
            handler = transMap[message.context];
        }

        var content = message.content;
        if (typeof message.content === 'string') {
            content = Signiant.Mst.convertStringToObject(content);
        }

        if (typeof handler !== 'undefined') {
            handler(content);
        }
    }
};

Signiant.Mst.EventNotifier.prototype.removeAllEventHandlers = function () {
    this.eventHandlerMap = {};
};
;/* eslint-disable no-unused-vars */

Signiant.Mst.MessageChannel = function (params) {};

Signiant.Mst.MessageChannel.prototype.initialize = function (callback) {};

Signiant.Mst.MessageChannel.prototype.setEventHandler = function (originatorId, event, handler) {};

Signiant.Mst.MessageChannel.prototype.setSessionActiveEventHandler = function (handler) {};

Signiant.Mst.MessageChannel.prototype.setErrorCallback = function (callback) {};

Signiant.Mst.MessageChannel.prototype.removeEventHandlers = function (originatorId) {};

Signiant.Mst.MessageChannel.prototype.onMessage = function (message) {};

Signiant.Mst.MessageChannel.prototype.sendMessageRequest = function (originator, requestName, requestCallback, content) {
    Signiant.Mst.validateSessionActive();

    if (typeof requestCallback === 'function') {
        this.setEventHandler(originator, requestName, requestCallback);
    }

    var messageId = Signiant.Mst.getUUID();
    var msg = {
        messageid: messageId,
        originator: originator,
        currentpart: 1,
        totalparts: 1,
        type: 'request',
        context: requestName,
        content: content
    };
    Signiant.Mst.debug('Send message: ' + JSON.stringify(msg));
    this.publish(msg);
};

Signiant.Mst.MessageChannel.prototype.notifyMessage = function (message) {};

Signiant.Mst.MessageChannel.prototype.publish = function (message) {};

Signiant.Mst.MessageChannel.prototype.reset = function () {};

Signiant.Mst.MessageChannel.prototype.getProviderInfo = function () {};

Signiant.Mst.MessageChannel.prototype.unsubscribeFromChannels = function () {};

Signiant.Mst.MessageChannel.prototype.getChannelParams = function () {};

Signiant.Mst.MessageChannel.prototype.updateSettings = function (settings) {};

/* eslint-enable no-unused-vars */
;Signiant.Mst.MessageChannelProvider = function (params) {
    this.channelParams = params;
    this.eventNotifier = new Signiant.Mst.EventNotifier();
    this.errorCallback;
    this.sessionId;
};

Signiant.Mst.MessageChannelProvider.prototype = Object.create(Signiant.Mst.MessageChannel.prototype);

Signiant.Mst.MessageChannelProvider.prototype.setEventHandler = function (originatorId, event, handler) {
    this.eventNotifier.setEventHandler(originatorId, event, handler);
};

Signiant.Mst.MessageChannelProvider.prototype.setSessionActiveEventHandler = function (handler) {
    this.eventNotifier.setSessionActiveEventHandler(handler);
};

Signiant.Mst.MessageChannelProvider.prototype.removeEventHandlers = function (originatorId) {
    this.eventNotifier.removeEventHandlers(originatorId);
};

Signiant.Mst.MessageChannelProvider.prototype.setErrorCallback = function (callback) {
    this.errorCallback = callback;
};

Signiant.Mst.MessageChannelProvider.prototype.notifyMessage = function (message) {
    Signiant.Mst.debug('Receive message: ' + JSON.stringify(message));
    this.eventNotifier.notifyMessage(message);
};

Signiant.Mst.MessageChannelProvider.prototype.getChannelParams = function () {
    return this.channelParams;
};

Signiant.Mst.MessageChannelProvider.prototype.removeAllEventHandlers = function () {
    this.eventNotifier.removeAllEventHandlers();
};

Signiant.Mst.MessageChannelProvider.prototype.reset = function () {
    this.removeAllEventHandlers();
    this.unsubscribeFromChannels();
};
;/**
 * NullChannel provider. Does nothing but adheres to the expected interface.
 */

Signiant.Mst.NullChannel = function () {};
Signiant.Mst.NullChannel.prototype = Object.create(Signiant.Mst.MessageChannelProvider.prototype);

for (var prop in Signiant.Mst.NullChannel.prototype) {
    Signiant.Mst.NullChannel.prototype[prop] = function () {};
};Signiant.Mst.MessageChannelPubNub = function (params) {
    Signiant.Mst.MessageChannelProvider.call(this, params);
    this.pubnub = null;
};

Signiant.Mst.MessageChannelPubNub.prototype = Object.create(Signiant.Mst.MessageChannelProvider.prototype);

Signiant.Mst.MessageChannelPubNub.prototype.publish = function () {};

Signiant.Mst.MessageChannelPubNub.prototype.initializePubNub = function () {};

Signiant.Mst.MessageChannelPubNub.prototype.getProviderInfo = function () {
    return 'pubnub';
};
;/* global PUBNUB */

/**
 * A PubNub provider that operates on two channels (one for publish, one for subscribe).
 * @constructor
 */
Signiant.Mst.DualChannelPubNub = function (params) {
    Signiant.Mst.MessageChannelPubNub.call(this, params);
};

Signiant.Mst.DualChannelPubNub.prototype = Object.create(Signiant.Mst.MessageChannelPubNub.prototype);

Signiant.Mst.DualChannelPubNub.prototype.initializePubNub = function () {
    return PUBNUB.init({
        publish_key: this.channelParams.providerinfo.pubkey,
        subscribe_key: this.channelParams.providerinfo.subkey,
        auth_key: this.channelParams.subtoken,
        ssl: this.channelParams.providerinfo.usessl,
        heartbeat: this.channelParams.providerinfo.heartbeat,
        timeout: this.channelParams.providerinfo.timeout,
        restore:true
    });
};

Signiant.Mst.DualChannelPubNub.prototype.initialize = function (callback) {
    this.pubnub = this.initializePubNub();
    this.pubnub.subscribe({
        channel: this.channelParams.subchannel,
        message: callback
    });

    // Subscribe to the publish channel so that it can listen on the presence of the app
    this.pubnub.subscribe({
        channel: this.channelParams.pubchannel,
        presence: function (event) {
            if (this.pubnub.get_uuid() !== event.uuid
                && (event.action === 'leave' || event.action === 'timeout')) {
                
                Signiant.Mst.warn('Lost connection to the Signiant App.');
                if (typeof this.errorCallback === 'function') {
                    this.errorCallback();
                }
            }
        }.bind(this),
        message: function () {}//To swallow own messages, there is no operation done here.
    });

    Signiant.Mst.log('Sub Channel - ' + this.channelParams.pubchannel +
                     ', Pub Channel - ' + this.channelParams.subchannel);
};

Signiant.Mst.DualChannelPubNub.prototype.publish = function (message) {
    this.pubnub.publish({
        channel: this.channelParams.pubchannel,
        message: message,
        error: Signiant.Mst.connectivity.networkConnectivityErrorCallback
    });
};

Signiant.Mst.DualChannelPubNub.prototype.unsubscribeFromChannels = function () {
    Signiant.Mst.log('unsubscribe from pubnub');
    if (this.pubnub !== null) {
        this.pubnub.unsubscribe({
            channel: this.channelParams.subchannel
        });

        this.pubnub.unsubscribe({
            channel: this.channelParams.pubchannel
        });
    }
};

;/* global PUBNUB */

/**
 * A PubNub provider that operates on a single channel for subscribing.
 * @constructor
 */
Signiant.Mst.SingleChannelPubNub = function (params) {
    Signiant.Mst.MessageChannelPubNub.call(this, params);
};

Signiant.Mst.SingleChannelPubNub.prototype = Object.create(Signiant.Mst.MessageChannelPubNub.prototype);

Signiant.Mst.SingleChannelPubNub.prototype.initializePubNub = function () {
    return PUBNUB.init({
        subscribe_key: this.channelParams.providerinfo.subkey,
        publish_key: this.channelParams.providerinfo.pubkey,
        auth_key: this.channelParams.token,
        ssl: this.channelParams.providerinfo.usessl,
        heartbeat: this.channelParams.providerinfo.heartbeat,
        timeout: this.channelParams.providerinfo.timeout,
        restore:true
    });
};

Signiant.Mst.SingleChannelPubNub.prototype.initialize = function (callback) {
    this.pubnub = this.initializePubNub();
    this.pubnub.subscribe({
        channel: this.channelParams.channel,
        message: callback
    });

    Signiant.Mst.log('Channel: ' + this.channelParams.channel);
};

Signiant.Mst.SingleChannelPubNub.prototype.unsubscribeFromChannels = function () {
    if (this.pubnub !== null) {
        this.pubnub.unsubscribe({
            channel: this.channelParams.channel
        });
    }
};

Signiant.Mst.SingleChannelPubNub.prototype.publish = function (message) {
    Signiant.Mst.log('On publish: ' + JSON.stringify(message));

    this.pubnub.publish({
        channel: this.channelParams.channel,
        message: message,
        error: Signiant.Mst.connectivity.networkConnectivityErrorCallback
    });
};

;
Signiant.Mst.MessageChannelDecorator = function (msgChannel) {
    this.msgChannel = msgChannel; //MessageChannel object
    this.messageCallback = function () {};
};

Signiant.Mst.MessageChannelDecorator.prototype = Object.create(Signiant.Mst.MessageChannel.prototype);


Signiant.Mst.MessageChannelDecorator.prototype.initialize = function (callback) {
    if (typeof callback === 'function') {
        this.messageCallback = callback;
    }
    this.msgChannel.initialize(this.onMessage.bind(this));
};

Signiant.Mst.MessageChannelDecorator.prototype.setEventHandler = function (originatorId, event, handler) {
    this.msgChannel.setEventHandler(originatorId, event, handler);
};

Signiant.Mst.MessageChannelDecorator.prototype.setSessionActiveEventHandler = function (handler) {
    this.msgChannel.setSessionActiveEventHandler(handler);
};

Signiant.Mst.MessageChannelDecorator.prototype.removeEventHandlers = function (originatorId) {
    this.msgChannel.removeEventHandlers(originatorId);
};

Signiant.Mst.MessageChannelDecorator.prototype.notifyMessage = function (message) {
    this.msgChannel.notifyMessage(message);
};

Signiant.Mst.MessageChannelDecorator.prototype.reset = function () {
    this.msgChannel.reset();
};

Signiant.Mst.MessageChannelDecorator.prototype.unsubscribeFromChannels = function () {
    this.msgChannel.unsubscribeFromChannels();
};

Signiant.Mst.MessageChannelDecorator.prototype.getProviderInfo = function () {
    return this.msgChannel.getProviderInfo();
};

Signiant.Mst.MessageChannelDecorator.prototype.publish = function (message) {
    return this.msgChannel.publish(message);
};

Signiant.Mst.MessageChannelDecorator.prototype.getChannelParams = function () {
    return this.msgChannel.getChannelParams();
};

Signiant.Mst.MessageChannelDecorator.prototype.updateSettings = function (settings) {
    return this.msgChannel.updateSettings(settings);
};

Signiant.Mst.MessageChannelDecorator.prototype.setErrorCallback = function (callback) {
    return this.msgChannel.setErrorCallback(callback);
};


;Signiant.Mst.SizeMessageChannelDecorator = function (msgChannel) {
    Signiant.Mst.MessageChannelDecorator.call(this, msgChannel);
    this.defaultCharacterSize = 2;
    this.DefaultMaxMsgSize = 5000;
    this.HeaderSize = 2000;
    this.encodeExpansionSize = 6; //expect string to expand x6 when html-encoded
    this.messageMap = {};
    this.lengthLimit;
    this.calculateMaxMsgLength();
};

Signiant.Mst.SizeMessageChannelDecorator.prototype = Object.create(Signiant.Mst.MessageChannelDecorator.prototype);

Signiant.Mst.SizeMessageChannelDecorator.prototype.initialize = function (callback) {
    if (callback) {
        Signiant.Mst.MessageChannelDecorator.prototype.initialize.call(this, callback);
    }
};

Signiant.Mst.SizeMessageChannelDecorator.prototype.assembleMessage = function (msgMap) {
    var fullMessage = {
        messageid: msgMap[0].messageid,
        originator: msgMap[0].originator,
        type: msgMap[0].type,
        context: msgMap[0].context,
        content: ''
    };
    msgMap.forEach(
        function (value){
            fullMessage.content += value.content;
        }.bind(this)
    );

    return fullMessage;
};

Signiant.Mst.SizeMessageChannelDecorator.prototype.publish = function (message) {
    var contents = this.splitMessageContent(message.content);

    contents.forEach(
        function (value, index, array) {
            var fullRequest = {
                messageid: message.messageid,
                originator: message.originator,
                currentpart: (index+1),
                totalparts: array.length,
                type: 'request',
                context: message.context,
                content: value
            };
            this.msgChannel.publish(fullRequest);
        }.bind(this)
    );
};

Signiant.Mst.SizeMessageChannelDecorator.prototype.splitMessageContent = function (content) {
    var contents = [];
    if (typeof content === 'undefined' || content === null){
        contents = [''];
    } else {
        contents = (JSON.stringify(content)).match(new RegExp('(.|[\\r\\n]){1,'+
            Math.floor((this.lengthLimit/this.defaultCharacterSize))+'}', 'g'));
        //divided by defaultCharacterSize to handle unicode characters
    }
    return contents;
};

Signiant.Mst.SizeMessageChannelDecorator.prototype.pushIntoMessageMap = function (message) {
    var msgMap = this.messageMap[message.messageid];
    if (typeof msgMap === 'undefined') {
        msgMap = new Array(message.totalparts);     // Using length in isMessageComplete function
        this.messageMap[message.messageid] = msgMap;
    }
    msgMap[message.currentpart - 1] = message;

    if (this.isMessageComplete(msgMap)) {
        var fullMessage = this.assembleMessage(msgMap);
        this.messageCallback(fullMessage);
        delete this.messageMap[message.messageid];
    }
};

Signiant.Mst.SizeMessageChannelDecorator.prototype.isMessageComplete = function (msgMap) {
    for (var i=0; i<msgMap.length; i++){
        if (typeof msgMap[i] === 'undefined'){
            return false;
        }
    }
    return true;
};

Signiant.Mst.SizeMessageChannelDecorator.prototype.onMessage = function (message) {
    if (typeof message.totalparts === 'undefined' || message.totalparts === 1) {
        this.messageCallback(message);
    } else {
        this.pushIntoMessageMap(message);
    }
};

Signiant.Mst.SizeMessageChannelDecorator.prototype.providerInfoExists = function () {
    var exists = false;
    var channelParams = this.getChannelParams();
    if (channelParams && channelParams.providerinfo) {
        exists = true;
    }
    return exists;
};

Signiant.Mst.SizeMessageChannelDecorator.prototype.isValidProviderMaxSize = function () {
    var isValid = false;
    if (this.providerInfoExists()) {
        var channelParams = this.getChannelParams();
        var providerMaxSize = channelParams.providerinfo.maxsize;
        if (typeof providerMaxSize === 'number' && providerMaxSize > 0) {
            isValid = true;
        }
    }
    return isValid;
};

//this function changes the provider info, so "initialize()" makes sure it only gets called once
Signiant.Mst.SizeMessageChannelDecorator.prototype.calculateMaxMsgLength = function () {

    var lengthLimit = Signiant.Mst.configuration.messageLength;
    if (lengthLimit === null) {
        lengthLimit = this.DefaultMaxMsgSize;
        if (this.isValidProviderMaxSize()) {
            var providerMaxSize = this.getChannelParams().providerinfo.maxsize;
            var calcSize = (providerMaxSize - this.HeaderSize) / this.encodeExpansionSize;
            calcSize = Math.floor(calcSize);
            if (calcSize > 0) {
                lengthLimit = calcSize;
            } else {
                Signiant.Mst.warn('Cannot set max message size to: ' + providerMaxSize + ', value is too small. Using size: ' + lengthLimit);
            }
        } else {
            Signiant.Mst.warn('Cannot set max message size to: ' + providerMaxSize + ', value is invalid. Using size: ' + lengthLimit);
        }
    }

    if (this.providerInfoExists()) {
        this.getChannelParams().providerinfo.maxsize = lengthLimit;
    }

    this.lengthLimit = lengthLimit;
};

;
Signiant.Mst.EncryptionMessageChannelDecorator = function (msgChannel, symmetricKey, encryptionMode) {
    Signiant.Mst.MessageChannelDecorator.call(this, msgChannel);
    this.symmetricKey = forge.util.decode64(symmetricKey);
    this.encryptionMode = encryptionMode;
    this.enabled = true;
};

Signiant.Mst.EncryptionMessageChannelDecorator.prototype = Object.create(Signiant.Mst.MessageChannelDecorator.prototype);

Signiant.Mst.EncryptionMessageChannelDecorator.prototype.onMessage = function (message) {
    if (message.content && this.enabled === true) {
        var decryptedContent = this.decryptMessageContent(JSON.parse(message.content));

        try {
            message.content = JSON.parse(decryptedContent);
        } catch (e) {
            message.content = decryptedContent;

            Signiant.Mst.error('JSON parsing string "' + decryptedContent + '" failed' + ', FAILURE: ' + e);
        }
    }

    this.messageCallback(message);
};

Signiant.Mst.EncryptionMessageChannelDecorator.prototype.publish = function (message) {
    if (message.content && this.enabled === true) {
        message.content = this.encryptMessageContent(JSON.stringify(message.content));
    }

    this.msgChannel.publish(message);
};

Signiant.Mst.EncryptionMessageChannelDecorator.prototype.encryptMessageContent = function (message) {
    var symmetricKey = this.getSymmetricKey();
    var iv = forge.random.getBytesSync(16);
    var clearTextBuffer = forge.util.createBuffer(message, 'utf8');

    var result = this.encryptWithAesCbc(symmetricKey, iv, clearTextBuffer);

    return {
        iv: forge.util.encode64(iv),
        cipherText: forge.util.encode64(result)
    };
};

Signiant.Mst.EncryptionMessageChannelDecorator.prototype.decryptMessageContent = function (message) {
    var symmetricKey = this.getSymmetricKey();
    var iv = forge.util.decode64(message.iv);
    var cipherText = forge.util.decode64(message.cipherText);
    var cipherBuffer = forge.util.createBuffer(cipherText);

    return this.decryptWithAesCbc(symmetricKey, iv, cipherBuffer);
};

Signiant.Mst.EncryptionMessageChannelDecorator.prototype.getSymmetricKey = function () {
    return this.symmetricKey;
};

Signiant.Mst.EncryptionMessageChannelDecorator.prototype.encryptWithAesCbc = function (symmetricKey, iv, clearTextBuffer) {
    var cipher = forge.cipher.createCipher('AES-CBC', symmetricKey);
    cipher.start({iv: iv});
    cipher.update(clearTextBuffer, 'utf8');

    if (!cipher.finish()) {
        throw new Error('Message encryption failed');
    }

    return cipher.output.data;
};

Signiant.Mst.EncryptionMessageChannelDecorator.prototype.decryptWithAesCbc = function (symmetricKey, iv, cipherBuffer) {
    var decipher = forge.cipher.createDecipher('AES-CBC', symmetricKey);
    decipher.start({iv: iv});
    decipher.update(cipherBuffer);

    if (!decipher.finish()) {
        throw new Error('Message decryption failed ');
    }

    return decipher.output;
};

Signiant.Mst.EncryptionMessageChannelDecorator.prototype.updateSettings = function (settings) {
    var param = settings.encrypt;
    if (typeof param !== 'undefined') {
        if (param) {
            Signiant.Mst.log('Enabling message encryption');
            this.enabled = true;
        } else {
            this.enabled = false;
        }
    }
    return this.msgChannel.updateSettings(settings);
};
;
Signiant.Mst.NoSoftwareMessageChannelDecorator = function (msgChannel) {
    Signiant.Mst.MessageChannelDecorator.call(this, msgChannel);
};

Signiant.Mst.NoSoftwareMessageChannelDecorator.prototype = Object.create(Signiant.Mst.MessageChannelDecorator.prototype);

Signiant.Mst.NoSoftwareMessageChannelDecorator.prototype.sendMessageRequest = function (
    originator, requestName, requestCallback) {

    if (typeof requestCallback === 'function') {
        this.setEventHandler(originator, requestName, requestCallback);
    }

    var msg = {
        context: requestName
    };
    
    Signiant.Mst.log('Send message: ' + JSON.stringify(msg));
    this.publish(msg);
};

Signiant.Mst.NoSoftwareMessageChannelDecorator.prototype.onMessage = function (message) {
    var generateTapiEventFromServiceEvent = function (serviceEvent) {
        var translatedMessage = {};
        translatedMessage.content = message;

        if (serviceEvent.name === 'PROGRESS') {
            translatedMessage.context = Signiant.Mst.transferProgressEventName;
        } else if (serviceEvent.name === 'COMPLETED') {
            translatedMessage.context = Signiant.Mst.postTransferEventName;
            translatedMessage.content.status = 'SUCCESSFUL';
        } else if (serviceEvent.name === 'CANCELLED') {
            translatedMessage.context = Signiant.Mst.postTransferEventName;
            translatedMessage.transferSize = serviceEvent.bytesTransferred;
            translatedMessage.content.status = 'CANCELLED';
        }

        return translatedMessage;
    };

    var translatedMessage = generateTapiEventFromServiceEvent(message);
    translatedMessage.originator = message.transferId;
    translatedMessage.type = 'event';

    this.messageCallback(translatedMessage);
};

;Signiant.Mst.ChannelProviderFactory = function (params) {
    this.preferredInfo;
    if (typeof params !== 'undefined') {
        this.encryptionInfo = params.encryptionInfo;
    }
};

Signiant.Mst.ChannelProviderFactory.prototype.getProvider = function () {};

Signiant.Mst.ChannelProviderFactory.prototype.getPreferredProvider = function (info) {
    var config = info;
    if (info && Array.isArray(info.providers)) {
        info.providers.every(function (provider) {
            if (this.isKnownProvider(provider)) {
                config = provider;
                return false;
            } else {
                return true;
            }
        }.bind(this));
        
    }
    return config;
};

Signiant.Mst.ChannelProviderFactory.prototype.isPubNub = function (info) {
    return info.provider === 'pubnub';
};

Signiant.Mst.ChannelProviderFactory.prototype.isWebsocket = function (info) {
    return info.provider === 'websocket';
};


Signiant.Mst.ChannelProviderFactory.prototype.isKnownProvider = function (info) {
    return this.isPubNub(info) || this.isWebsocket(info);
};
;Signiant.Mst.SingleChannelProviderFactory = function (params) {
    Signiant.Mst.ChannelProviderFactory.call(this, params);
};

Signiant.Mst.SingleChannelProviderFactory.prototype = Object.create(Signiant.Mst.ChannelProviderFactory.prototype);

Signiant.Mst.SingleChannelProviderFactory.prototype.getProvider = function (pvdInfo) {
    this.preferredInfo = this.getPreferredProvider(pvdInfo);
    var provider;

    if (this.isPubNub(pvdInfo)) {
        provider = this.buildDecorator(new Signiant.Mst.SingleChannelPubNub(pvdInfo));
    } else {
        throw new Error('Failure, unknown Message Provider Information ,provider: ' + pvdInfo.provider);
    }

    return provider;
};

Signiant.Mst.SingleChannelProviderFactory.prototype.buildDecorator = function (provider) {
    var sizeDecorator = new Signiant.Mst.SizeMessageChannelDecorator(provider);
    return new Signiant.Mst.NoSoftwareMessageChannelDecorator(sizeDecorator);
};
;Signiant.Mst.DualChannelProviderFactory = function (params) {
    this.providerInfoList = [];
    this.sessionId = Signiant.Mst.getUUID();
    this.legacyPubNubInfo;
    Signiant.Mst.ChannelProviderFactory.call(this, params);
};

Signiant.Mst.DualChannelProviderFactory.prototype = Object.create(Signiant.Mst.ChannelProviderFactory.prototype);

Signiant.Mst.DualChannelProviderFactory.prototype.getProvider = function (pvdInfo) {
    this.parseProvidersFromConfig(pvdInfo);
    var provider = new Signiant.Mst.AggregateChannelProvider(pvdInfo, this.encryptionInfo);
    provider.sessionId = this.sessionId;
    if (this.legacyPubNubInfo) {
        provider.addProvider(this.buildChannel(this.legacyPubNubInfo, provider));
    } else if (this.providerInfoList.length > 0) {
        this.providerInfoList.forEach(function (providerInfoObj) {
            provider.addProvider(this.buildChannel(providerInfoObj, provider));
        }.bind(this));
    } else {
        throw new Error(Signiant.Mst.messagesMap.getMessage('signiant.sigappinstall.error.no.provider') + JSON.stringify(pvdInfo));
    }

    return provider;
};

Signiant.Mst.DualChannelProviderFactory.prototype.buildDecorator = function (provider) {
    var sizeDecorator = new Signiant.Mst.SizeMessageChannelDecorator(provider);
    var encryptDecorator = new Signiant.Mst.EncryptionMessageChannelDecorator(sizeDecorator, this.encryptionInfo.symmetricKey, Signiant.Mst.preferredEncryptionMode);
    encryptDecorator.updateSettings({encrypt: false});
    return encryptDecorator;
};

Signiant.Mst.DualChannelProviderFactory.prototype.buildChannel = function (providerConfig, provider) {
    var channel;
    if (this.isPubNub(providerConfig)) {
        channel = this.buildDecorator(new Signiant.Mst.DualChannelPubNub(providerConfig));
        provider.legacyParam = JSON.parse(JSON.stringify(channel.getChannelParams()));
    } else if (this.isWebsocket(providerConfig)) {
        var websocketAggregate = new Signiant.Mst.WebsocketAggregateChannel(providerConfig, this.sessionId, this.encryptionInfo);
        channel = this.buildDecorator(websocketAggregate);
    }
    return channel;
};

Signiant.Mst.DualChannelProviderFactory.prototype.parseProvidersFromConfig = function (pvdInfo) {
    if (pvdInfo) {
        if (Array.isArray(pvdInfo.providers)) {  // new messaging service
            pvdInfo.providers.forEach(function (providerInfoObj) {
                if (this.isKnownProvider(providerInfoObj)) {
                    this.providerInfoList.push(JSON.parse(JSON.stringify(providerInfoObj)));
                }
            }.bind(this));
        } else { //legacy messaging service
            if (this.isPubNub(pvdInfo)) {
                this.legacyPubNubInfo = JSON.parse(JSON.stringify(pvdInfo));
            }
        }
    } else {
        throw new Error(Signiant.Mst.messagesMap.getMessage('signiant.sigappinstall.error.no.provider') + pvdInfo);
    }
};;/**
 * An aggregate channel that serves as a container for sub-channels and collapses to the first subchannel that becomes active
 * At which point this aggregate acts as a simple pass-through decorator to the sub-channel
 */


Signiant.Mst.AggregateChannelProvider = function (params, encryptionInfo) {
    this.channelParams = params;
    this.providers = [];
    this.foundActiveProvider = false;
    this.encryptionInfo = encryptionInfo;
    this.legacyParam;
    this.providersParams = [];
};

Signiant.Mst.AggregateChannelProvider.prototype = Object.create(Signiant.Mst.MessageChannel.prototype);

Signiant.Mst.AggregateChannelProvider.prototype.addProvider = function (provider) {
    this.providers.push(provider);
    this.providersParams.push(provider.getChannelParams());
};

Signiant.Mst.AggregateChannelProvider.prototype.initialize = function () {
    this.providers.forEach(function (provider) {
        provider.initialize(provider.notifyMessage);
    });
};

Signiant.Mst.AggregateChannelProvider.prototype.setSessionActiveEventHandler = function (handler) {
    var webSocketProvider = this.getWebSocketProvider(this.providers);
    for (var i = 0; i < this.providers.length; i++) {
        var provider = this.providers[i];
        provider.setSessionActiveEventHandler(function (activeProvider, data) {
            if (!this.foundActiveProvider) {
                if (activeProvider.getProviderInfo() === 'pubnub') {
                    Signiant.Mst.googleAnalytics.sendEvent(Signiant.Mst.GoogleAnalytics.Constants.Category.transferApi,
                        Signiant.Mst.GoogleAnalytics.Constants.Action.pubnubConnectionApp);

                    if (webSocketProvider) {
                        this.setSessionWebSocketHandler(webSocketProvider)
                            .then(function (webSocketActiveProvider) {
                                this.postSetSessionActiveHandler(webSocketActiveProvider.activeProvider, webSocketActiveProvider.data, handler);

                                Signiant.Mst.googleAnalytics.sendEvent(Signiant.Mst.GoogleAnalytics.Constants.Category.transferApi,
                                    Signiant.Mst.GoogleAnalytics.Constants.Action.pubnubToWebsocketSwitchApp);
                            }.bind(this))
                            .catch(function () {
                                this.postSetSessionActiveHandler(activeProvider, data, handler);
                            }.bind(this));
                    } else {
                        this.postSetSessionActiveHandler(activeProvider, data, handler);
                    }
                } else {
                    this.postSetSessionActiveHandler(activeProvider, data, handler);
                }
            }
        }.bind(this, provider));
    }
};

Signiant.Mst.AggregateChannelProvider.prototype.getWebSocketProvider = function (providers) {
    var webSocketProvider = providers.filter(function (provider) {
        return provider.getChannelParams().provider === 'websocket';
    });
    return webSocketProvider[0];
};

Signiant.Mst.AggregateChannelProvider.prototype.setSessionWebSocketHandler = function (webSocketProvider) {
    webSocketProvider.initialize(webSocketProvider.notifyMessage);
    return new Promise(function (resolve, reject) {
        var timeout = setTimeout(function () {
            Signiant.Mst.log('WebSocket connection timeout!');
            reject();
        }, 1000);

        webSocketProvider.setSessionActiveEventHandler(function (activeProvider, data) {
            Signiant.Mst.log('WebSocket is active provider.');
            clearTimeout(timeout);
            resolve({
                activeProvider : activeProvider,
                data: data
            });
        }.bind(this, webSocketProvider));
    });
};

Signiant.Mst.AggregateChannelProvider.prototype.postSetSessionActiveHandler = function (activeProvider, data, handler) {
    Signiant.Mst.log('Active communication method: ' + activeProvider.getProviderInfo());
    this.foundActiveProvider = true;

    activeProvider.setErrorCallback(Signiant.Mst.configuration.appCommunicationErrorCallback);
    this.removeOtherProviders(activeProvider);
    this.upgradeToEncryptedChannel(data);

    handler(data);
};

Signiant.Mst.AggregateChannelProvider.prototype.setEventHandler = function (originatorId, event, handler) {
    this.providers.forEach(function (provider) {
        provider.setEventHandler(originatorId, event, handler);
    });
};

Signiant.Mst.AggregateChannelProvider.prototype.removeOtherProviders = function (activeProvider) {
    this.providers.forEach(function (provider) {
        if (provider !== activeProvider) {
            provider.reset();
        }
    });
    this.providers = [activeProvider];
};

Signiant.Mst.AggregateChannelProvider.prototype.removeEventHandlers = function (originatorId) {
    this.providers.forEach(function (provider) {
        provider.removeEventHandlers(originatorId);
    });
};

Signiant.Mst.AggregateChannelProvider.prototype.onMessage = function (message) {
    Signiant.Mst.error('Error onMessage: ' + message);
};

Signiant.Mst.AggregateChannelProvider.prototype.notifyMessage = function (message) {
    Signiant.Mst.error('Error notifyMessage: ' + message);
};

Signiant.Mst.AggregateChannelProvider.prototype.publish = function (message) {
    this.providers.forEach(function (provider) {
        provider.publish(message);
    });
};

Signiant.Mst.AggregateChannelProvider.prototype.reset = function () {
    this.providers.forEach(function (provider) {
        provider.reset();
    });
};


Signiant.Mst.AggregateChannelProvider.prototype.getProviderInfo = function () {
    if (this.foundActiveProvider) {
        return this.providers[0].getProviderInfo();
    }
};

Signiant.Mst.AggregateChannelProvider.prototype.unsubscribeFromChannels = function () {
    this.providers.forEach(function (provider) {
        provider.unsubscribeFromChannels();
    });
};

Signiant.Mst.AggregateChannelProvider.prototype.getChannelParams = function () {
    var param = this.legacyParam || this.channelParams;
    if (this.providersParams.length > 0) {
        param.providers = JSON.parse(JSON.stringify(this.providersParams));
    }
    param.encryptionInfo = this.encryptionInfo;
    param.sessionid = this.sessionId;
    return param;
};

Signiant.Mst.AggregateChannelProvider.prototype.upgradeToEncryptedChannel = function (data) {
    if (data.app_encryption === Signiant.Mst.preferredEncryptionMode) {
        Signiant.Mst.log('Using encryption: ' + data.app_encryption + ' to send messages to Signiant App');
        this.updateSettings({encrypt: true});
    } else {
        Signiant.Mst.warn('TAPI and App do not support same encryption. Sending plain messages to Signiant App');
    }
};

Signiant.Mst.AggregateChannelProvider.prototype.updateSettings = function (settings) {
    this.providers.forEach(function (provider) {
        provider.updateSettings(settings);
    });
};

Signiant.Mst.AggregateChannelProvider.prototype.setErrorCallback = function (callback) {
    this.providers.forEach(function (provider) {
        provider.setErrorCallback(callback);
    });
};
;/**
 * A channel provider implemented with websockets
 *
 */

Signiant.Mst.WebsocketChannel = function (params, url, sessionId, encryptionInfo) {
    Signiant.Mst.MessageChannelProvider.call(this, params);

    this.websocket = null;
    this.connected = false;
    this.url = url;
    this.sessionId = sessionId;
    this.encryptionInfo = encryptionInfo;
};

Signiant.Mst.WebsocketChannel.prototype = Object.create(Signiant.Mst.MessageChannelProvider.prototype);


Signiant.Mst.WebsocketChannel.prototype.initialize = function (callback) {
    if ('WebSocket' in window) {
        try {
            this.msgCallback = callback;
            this.startWebsocket();
        } catch (err) {
            Signiant.Mst.error('Error initializing websocket channel: ' + err);
        }
    } else {
        Signiant.Mst.warn('WebSocket is NOT supported by your Browser - will use alternate messaging method');
    }
};

Signiant.Mst.WebsocketChannel.prototype.publish = function (message) {
    if (this.websocket) {
        this.websocket.send(JSON.stringify(message));
    }
};

Signiant.Mst.WebsocketChannel.prototype.onMessage = function (evt) {
    if (this.msgCallback) {
        try {
            var messageParsed = JSON.parse(evt.data);
            this.msgCallback(messageParsed);
        } catch (e) {
            Signiant.Mst.debug('WebsocketChannel cannot handle message' + evt.data + ': ' + e.message);
        }
    }
};

Signiant.Mst.WebsocketChannel.prototype.getProviderInfo = function () {
    return 'websocket';
};

Signiant.Mst.WebsocketChannel.prototype.reset = function () {
    this.unsubscribeFromChannels();
};

Signiant.Mst.WebsocketChannel.prototype.unsubscribeFromChannels = function () {
    this.errorCallback = null;
    this.msgCallback = null;
    this.connected = false;

    if (this.websocket) {
        this.websocket.close();
        this.websocket = null;
    }
};

Signiant.Mst.WebsocketChannel.prototype.startWebsocket = function () {
    this.websocket = new WebSocket(this.url);
    this.websocket.onerror = this.onSocketError.bind(this);
    this.websocket.onmessage = this.onHandshakeMessage.bind(this);
    this.websocket.onopen = this.onSocketOpen.bind(this);
    this.websocket.onclose = this.onSocketClose.bind(this);
};


Signiant.Mst.WebsocketChannel.prototype.onHandshakeMessage = function (evt) {
    var messageParsed = JSON.parse(evt.data);
    if (this.isAckAckMessageFromApp(messageParsed)) {
        Signiant.Mst.log('WebsocketChannel ' + this.websocket.url + ' is connected');
        //route all further messages through the normal mechanism
        this.websocket.onmessage = this.onMessage.bind(this);
        this.connected = true;

        //send ack^3 before calling onMessage()
        this.sendAckAckAcktoApp();

        //this should trigger active provider event
        this.onMessage(evt);
    } else {
        Signiant.Mst.warn('WebSocketChannel '+ this.websocket.url + ' received unexpected handshake message: ', evt.data);
        this.websocket.close();
    }
};


Signiant.Mst.WebsocketChannel.prototype.onSocketError = function (evt) {
    this.connected = false;
    if (typeof this.errorCallback === 'function') {
        this.errorCallback(evt);
    }
};

Signiant.Mst.WebsocketChannel.prototype.onSocketOpen = function () {
    this.sendAcktoApp();
};

Signiant.Mst.WebsocketChannel.prototype.onSocketClose = function (evt) {
    this.connected = false;
    this.websocket = null;
    if (typeof this.errorCallback === 'function') {
        this.errorCallback(evt);
    }
};


Signiant.Mst.WebsocketChannel.prototype.sendAcktoApp = function () {
    var handshakemsg = this.getChannelParams();
    handshakemsg.apiVersion = Signiant.Mst.apiVersion;
    handshakemsg.sessionid = this.sessionId;
    this.publish(handshakemsg);
};

Signiant.Mst.WebsocketChannel.prototype.isAckAckMessageFromApp = function (message) {
    var goodmessage = false;
    if (message) {
        if (message.context === 'session-active') {
            if (message.content) {
                if (message.content.app_api_version && message.content.app_encryption
                    && message.content.app_version) {
                    goodmessage = true;
                }
            }
        }
    }
    return goodmessage;
};

Signiant.Mst.WebsocketChannel.prototype.sendAckAckAcktoApp = function () {
    var ackackackMsg = {
        provider: this.getProviderInfo(),
        encryptionInfo: this.encryptionInfo
    };

    var fullRequest = {
        type: 'request',
        context: 'ackackack',
        content: ackackackMsg
    };
    this.publish(fullRequest);
};

;/**
 * An aggregate channel provider that opens N WebSocket channels and chooses the first that makes a connection
 * At which point this object acts as a simple pass-through decorator to the winning WebSocket channel
 */

Signiant.Mst.WebsocketAggregateChannel = function (params, sessionId, encryptionInfo) {
    this.channelParams = params;
    this.sessionId = sessionId;
    this.subChannels = [];
    this.haveActiveChannel = false;
    this.encryptionInfo = encryptionInfo;
    this.errorCallback;

    //Create N child WebSocket channels. The first to connect will be the 'winner'
    if (params.providerinfo && Array.isArray(params.providerinfo.ports)) {
        var portNumbers = [];
        var pvdinfo = params.providerinfo;
        var ports = pvdinfo.ports;
        var url = pvdinfo.serviceurl;
        if (!url) {
            url = Signiant.Mst.WebsocketAggregateChannel.DEFAULT_SOCKET_URL;
            Signiant.Mst.warn('No WebSocket url found in config. Using default ', url);
        }

        for (var i=0; i<ports.length; i+=1) {
            for (var j=0; j<pvdinfo.range; j+=1) {
                var currentPort = ports[i] + j;
                var socketurl = ('wss://' + url + ':' + currentPort);
                var socketChannel = new Signiant.Mst.WebsocketChannel(params, socketurl, this.sessionId, this.encryptionInfo);
                this.subChannels.push(socketChannel);

                portNumbers.push(currentPort);
            }
        }
        Signiant.Mst.groupEnd(); // to avoid nesting groups
        Signiant.Mst.groupCollapsed('Set up App communication');
        Signiant.Mst.log('Attempt WebSocket communication using ports: ', portNumbers.toString());
    }
};
Signiant.Mst.WebsocketAggregateChannel.prototype = Object.create(Signiant.Mst.MessageChannel.prototype);

Signiant.Mst.WebsocketAggregateChannel.DEFAULT_SOCKET_URL = 'transfer.software';

Signiant.Mst.WebsocketAggregateChannel.prototype.initialize = function (callback) {
    this.messageCallback = callback;
    this.subChannels.forEach(function (socketChannel) {
        socketChannel.initialize(this.onMessage.bind(this, socketChannel));
    }.bind(this));
};


Signiant.Mst.WebsocketAggregateChannel.prototype.setEventHandler = function (originatorId, event, handler) {
    this.subChannels.forEach(function (subChannel) {
        subChannel.setEventHandler(originatorId, event, handler);
    });
};


Signiant.Mst.WebsocketAggregateChannel.prototype.setSessionActiveEventHandler = function (handler) {
    this.subChannels.forEach(function (subChannel) {
        subChannel.setSessionActiveEventHandler(handler);
    });
};


Signiant.Mst.WebsocketAggregateChannel.prototype.removeOtherProviders = function (chosenProvider) {
    Signiant.Mst.debug('WebsocketAggregate removingOtherProviders');
    this.subChannels.forEach(function (provider) {
        if (provider !== chosenProvider) {
            provider.reset();
        }
    });
    this.subChannels = [chosenProvider];
};


Signiant.Mst.WebsocketAggregateChannel.prototype.removeEventHandlers = function (originatorId) {
    this.subChannels.forEach(function (subChannel) {
        subChannel.removeEventHandlers(originatorId);
    });
};


Signiant.Mst.WebsocketAggregateChannel.prototype.onMessage = function (sourceWSChannel, message) {
    if (sourceWSChannel && message) {
        if (sourceWSChannel.isAckAckMessageFromApp(message)) {
            //The given WebSocket channel, aka sourceWSChannel, has become active. Release any other subchannels.
            //From here on in WebsocketAggregateChannel acts as a pass-through decorator of sourceWSChannel.
            if (!this.haveActiveChannel) {
                Signiant.Mst.debug('WebsocketAggregate recognizes active WebSocket as: ' + sourceWSChannel.getProviderInfo() + ' ' + sourceWSChannel.websocket.url);

                this.haveActiveChannel = true;
                sourceWSChannel.setErrorCallback(Signiant.Mst.configuration.appCommunicationErrorCallback);
                this.removeOtherProviders(sourceWSChannel);
            } else {
                Signiant.Mst.error('WebsocketAggregate asked to recognize ', sourceWSChannel.websocket.url, ' as active, but it already has one: ', this.subChannels[0].websocket.url);
            }
        }
    }

    //Pass the message up the chain
    if (this.messageCallback) {
        this.messageCallback(message);
    }
};


Signiant.Mst.WebsocketAggregateChannel.prototype.notifyMessage = function (message) {
    Signiant.Mst.debug('WebsocketAggregate notifyMessage() ' + JSON.stringify(message));
    this.subChannels.forEach(function (subChannel) {
        subChannel.notifyMessage(message);
    });
};


Signiant.Mst.WebsocketAggregateChannel.prototype.reset = function () {
    Signiant.Mst.debug('WebsocketAggregate reset()');
    this.subChannels.forEach(function (subChannel) {
        subChannel.reset();
    });
};

Signiant.Mst.WebsocketAggregateChannel.prototype.unsubscribeFromChannels = function () {
    this.subChannels.forEach(function (subChannel) {
        subChannel.unsubscribeFromChannels();
    });
};


Signiant.Mst.WebsocketAggregateChannel.prototype.getProviderInfo = function () {
    var info = '';
    if (this.haveActiveChannel) {
        info = this.subChannels[0].getProviderInfo();
    }
    return info;
};


Signiant.Mst.WebsocketAggregateChannel.prototype.publish = function (message) {
    this.subChannels.forEach(function (subChannel) {
        subChannel.publish(message);
    });
};


Signiant.Mst.WebsocketAggregateChannel.prototype.updateSettings = function (settings) {
    this.subChannels.forEach(function (subChannel) {
        subChannel.updateSettings(settings);
    });
};


Signiant.Mst.WebsocketAggregateChannel.prototype.setErrorCallback = function (callback) {
    this.subChannels.forEach(function (subChannel) {
        subChannel.setErrorCallback(callback);
    });
};

Signiant.Mst.WebsocketAggregateChannel.prototype.getChannelParams = function () {
    return this.channelParams;
};

;Signiant.Mst.transferState = {
    IDLE : 'IDLE'                     /*!< Transfer hasn't started yet; initial state. */
    ,START_PENDING : 'START_PENDING'  /*!< "Transfer start" has been called. Waiting for tecl to start transfer */
    ,STARTED : 'STARTED'              /*!< Transfer has begun to initialize. */
    ,CONNECTING : 'CONNECTING'        /*!< Trying to connect with the server. */
    ,CONNECTED : 'CONNECTED'          /*!< Connection established with the server. */
    ,QUEUED : 'QUEUED'                /*!< The server is busy; request put in the queue. */
    ,TRANSFERRING : 'TRANSFERRING'    /*!< Transferring files. */
    ,DISCONNECTING : 'DISCONNECTING'  /*!< Transfer finished; trying to disconnect with the server. */
    ,DISCONNECTED : 'DISCONNECTED'    /*!< Transfer finished; disconnecting with server. */
    ,CANCELLING : 'CANCELLING'        /*!< Transfer cancellation requested. */
    ,CANCEL_PENDING : 'CANCEL_PENDING'
    ,FAILURE : 'FAILURE'              /*!< Error during the transfer; final state. */
    ,CANCELLED : 'CANCELLED'          /*!< Transfer canceled; final state. */
    ,SUCCESSFUL : 'SUCCESSFUL'        /*!< Transfer finished successfully; final state. */
};

Signiant.Mst.TransferType = {
    Upload: 'UPLOAD',
    Download: 'DOWNLOAD'
};

Signiant.Mst.Transfer = function () {

    Signiant.Mst.Transfer.usernamePropName = 'com.signiant.interactivetransfer.engine.user';
    Signiant.Mst.Transfer.passwordPropName = 'com.signiant.interactivetransfer.engine.password';
    Signiant.Mst.Transfer.caCertPropName = 'com.signiant.interactivetransfer.engine.ca_certificate';
    Signiant.Mst.Transfer.certValidatePropName = 'com.signiant.interactivetransfer.engine.certificatevalidate';
    Signiant.Mst.Transfer.encryptPropName = 'com.signiant.interactivetransfer.engine.encrypt';
    Signiant.Mst.Transfer.restartsPropName = 'com.signiant.interactivetransfer.engine.restarts';
    Signiant.Mst.Transfer.aggressivePropName = 'com.signiant.interactivetransfer.engine.udp.aggressive';
    Signiant.Mst.Transfer.followSymLinksPropName = 'com.signiant.interactivetransfer.engine.follow_symlinks';
    Signiant.Mst.Transfer.modePropName = 'com.signiant.interactivetransfer.engine.mode';
    Signiant.Mst.Transfer.urlListPropName = 'com.signiant.interactivetransfer.engine.url_list';
    Signiant.Mst.Transfer.filesPropName = 'com.signiant.interactivetransfer.engine.files';
    Signiant.Mst.Transfer.destinationPropName = 'com.signiant.interactivetransfer.engine.destination_dir';
    Signiant.Mst.Transfer.streamsPropName = 'com.signiant.interactivetransfer.engine.streams';
    Signiant.Mst.Transfer.packageidPropName = 'com.signiant.interactivetransfer.engine.header.packageid';
    Signiant.Mst.Transfer.filePathHandlingModePropName = 'com.signiant.interactivetransfer.engine.dir_handling_mode';
    Signiant.Mst.Transfer.fileCollisionHandlingPropName =
        'com.signiant.interactivetransfer.engine.file_collision_handling';
    Signiant.Mst.Transfer.jobNamePrefixPropName = 'com.signiant.interactivetransfer.engine.header.jobnameprefix';
    Signiant.Mst.Transfer.serviceDataPropName = 'com.signiant.interactivetransfer.engine.service_data';
    Signiant.Mst.Transfer.loggingPropName = 'com.signiant.interactivetransfer.engine.logging';
    Signiant.Mst.Transfer.probeLB = 'com.signiant.interactivetransfer.engine.probelb';
    Signiant.Mst.Transfer.storageConfig = 'com.signiant.interactivetransfer.engine.storage.config';
    Signiant.Mst.Transfer.signature = 'com.signiant.interactivetransfer.engine.signature';
    Signiant.Mst.Transfer.fileEncryption = 'com.signiant.interactivetransfer.engine.file_crypt_config';
    Signiant.Mst.Transfer.subFolder = 'com.signiant.interactivetransfer.engine.subfolder';
    Signiant.Mst.Transfer.targetFileName = 'com.signiant.interactivetransfer.engine.target_file_name';
    Signiant.Mst.Transfer.apiKey = 'com.signiant.interactivetransfer.engine.api_key';
    Signiant.Mst.Transfer.bandwidthThrottle = 'com.signiant.interactivetransfer.engine.bandwidth_throttle';
    Signiant.Mst.Transfer.jsIdPropName = 'com.signiant.interactivetransfer.engine.jsId';
    Signiant.Mst.Transfer.serverSideEncryption = 'com.signiant.interactivetransfer.engine.server_side_encryption';
    Signiant.Mst.Transfer.generateManifest = 'com.signiant.interactivetransfer.engine.generate_manifest';
    Signiant.Mst.Transfer.processManifestEndpoint = 'com.signiant.interactivetransfer.engine.process_manifest_endpoint';
    Signiant.Mst.Transfer.processManifestToken = 'com.signiant.interactivetransfer.engine.process_manifest_token';
    Signiant.Mst.Transfer.messagingProvider = 'com.signiant.interactivetransfer.engine.messaging_provider';
    Signiant.Mst.Transfer.useUdpPortRange = 'com.signiant.interactivetransfer.engine.udp.use_portrange';

    Signiant.Mst.Transfer.jobNamePrefix = 'MediaShuttleAPI_';

    Signiant.Mst.Transfer.filePathModeFlat = 'FLAT';
    Signiant.Mst.Transfer.filePathModePath = 'PATH';
    Signiant.Mst.Transfer.filePathModeFull = 'FULL';
    Signiant.Mst.Transfer.fileCollisionModeVersion = 'version';
    Signiant.Mst.Transfer.fileCollisionModeOverwrite = 'overwrite';

    Signiant.Mst.Transfer.mxwanStr = 'mxwan://';
    Signiant.Mst.Transfer.mxtcpStr = 'mxtcp://';
    Signiant.Mst.Transfer.httpStr = 'http://';
    Signiant.Mst.Transfer.httpPortStr = ':8080';
    Signiant.Mst.Transfer.defaultTcpUdpPortStr = ':49221';
    Signiant.Mst.Transfer.minBandwidth = 256000;
    Signiant.Mst.Transfer.encryptionKey = 'key';
    Signiant.Mst.Transfer.encryptionIv = 'iv';
    Signiant.Mst.Transfer.yesStr = 'yes';

    var transfer = {};

    transfer.id = Signiant.Mst.getUUID();
    transfer.originator = Signiant.Mst.getUUID();
    transfer.transferProperties = {};
    transfer.transferProperties[Signiant.Mst.Transfer.jsIdPropName] = transfer.id;
    transfer.basicEventsSubscribedCallback;
    transfer.progressEventsCallback;
    transfer.transferErrorsEventsCallback;
    transfer.advancedEventCallbacksMap = {};
    transfer.lastTransferError;
    transfer.logLevel = Signiant.Mst.INFO_LOG_LEVEL;
    transfer.eventSubscriptionMap = {};
    transfer.filesSelectedCallback;
    transfer.currentTransferState = Signiant.Mst.transferState.IDLE;

    /**
     * Maintain full list of file objects to pass back to the user on the uploadFilesChosen callback
     * because the Signiant App only passes back the selected files, not the full list.
     */
    transfer.completeFileList = [];

    transfer.getTransferId = function () {
        return transfer.id;
    };

    transfer.getTransferIdTag = function () {
        return ' [transfer ID: ' + transfer.id + '] ';
    };

    transfer.getMessagingIdentifier = function () {
        return transfer.originator;
    };

    transfer.setProperty = function (name, value) {
        if (typeof name === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.undefinedPropertyName');
        }
        if (typeof value === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.undefinedPropertyValue') +
            name + '.';
        }

        if (typeof name !== 'string') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidPropertyName');
        }

        transfer.transferProperties[name] = value;
    };

    transfer.getProperty = function (name) {
        if (typeof name === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.undefinedPropertyRetrieval');
        }

        if (typeof name !== 'string') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidPropertyRetrieval');
        }

        return transfer.transferProperties [name];
    };

    transfer.deleteProperty = function (name) {
        if (typeof name === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.undefinedPropertyDelete');
        }

        if (typeof name !== 'string') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidPropertyDelete');
        }

        if (transfer.transferProperties[name]) {
            delete transfer.transferProperties[name];
        }
    };

    transfer.setTransferProperties = function (jsonProperties) {
        if (typeof jsonProperties === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.undefinedTransferProperties');
        }

        if (typeof jsonProperties !== 'object') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidTransferProperties');
        }

        transfer.transferProperties = jsonProperties;
        Signiant.Mst.log('New transfer properties: ' + JSON.stringify(transfer.transferProperties) +
                         transfer.getTransferIdTag()
        );
    };

    transfer.getTransferProperties = function () {
        return transfer.transferProperties;
    };

    transfer.resetTransferProperties = function () {
        transfer.transferProperties = {};
    };

    transfer.setTrustedCA = function (trustedCACert) {
        if (typeof trustedCACert === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidTrustedCA');
        } else {
            trustedCACert = trustedCACert.trim();

            if (trustedCACert.length === 0) {
                throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidTrustedCA');
            }
        }

        trustedCACert = transfer.formatTrustedCACert(trustedCACert);

        transfer.setProperty(Signiant.Mst.Transfer.caCertPropName, trustedCACert);

        var certSnippet = transfer.getProperty(Signiant.Mst.Transfer.caCertPropName);
        certSnippet = (certSnippet.substr(0,45) + ' ... ' + certSnippet.substr(certSnippet.length-45,certSnippet.length)).replace(/(\r\n|\n|\r)/gm,'');
        Signiant.Mst.log('Set-Trusted-CA: New CA certificate: ' + certSnippet + transfer.getTransferIdTag());
    };

    transfer.getTrustedCA = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.caCertPropName);
    };

    transfer.getProbeLB = function () {
        var val = false;
        var prop = transfer.getProperty(Signiant.Mst.Transfer.probeLB);
        if (prop === 'YES' || prop === 'yes') {
            val = true;
        }
        return val;
    };

    transfer.setProbeLB = function (probe) {
        var setProbe = 'no';
        if (probe === true) {
            setProbe = 'yes';
        }
        Signiant.Mst.log('Setting probeLB to: ' + setProbe);
        transfer.setProperty(Signiant.Mst.Transfer.probeLB, setProbe);
    };

    transfer.getStorageConfig = function () {
        var storageConfig = transfer.getProperty(Signiant.Mst.Transfer.storageConfig);
        if (storageConfig !== null && typeof storageConfig === 'string') {
            storageConfig = JSON.parse(storageConfig);
        }
        return storageConfig;
    };

    transfer.setStorageConfig = function (storageConfig) {
        var value = storageConfig;
        if (typeof storageConfig === 'object') {
            value = JSON.stringify(storageConfig);
        } else if (typeof storageConfig === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidStorageConfig');
        }

        transfer.setProperty(Signiant.Mst.Transfer.storageConfig, value);
    };

    transfer.getConfigId = function () {
        var storageConfig = this.getStorageConfig();
        if (storageConfig) {
            return storageConfig.configId;
        }

        return null;
    };

    transfer.setConfigId = function (configId) {
        var storageConfig = this.getStorageConfig() || {};
        storageConfig.configId = configId;

        this.setStorageConfig(storageConfig);
    };

    transfer.getSignature = function () {
        return this.getProperty(Signiant.Mst.Transfer.signature);
    };

    transfer.setSignature = function (signature) {
        this.setProperty(Signiant.Mst.Transfer.signature, signature);

        var storageConfig = this.getStorageConfig() || {};
        storageConfig.signature = signature;

        this.setStorageConfig(storageConfig);
    };

    transfer.deleteFileEncryption = function () {
        transfer.deleteProperty(Signiant.Mst.Transfer.fileEncryption);
        Signiant.Mst.log('File encryption removed' + transfer.getTransferIdTag());
    };

    transfer.setFileEncryption = function (config) {
        var configStr = transfer.parseFileEncryptionConfig(config);
        transfer.setProperty(Signiant.Mst.Transfer.fileEncryption, configStr);
        Signiant.Mst.log('File encryption set' + transfer.getTransferIdTag());
    };

    transfer.parseFileEncryptionConfig = function (config) {
        if (typeof config !== 'undefined' && config.length !== 0) {
            var configJson = config;
            if (typeof config === 'string' || config instanceof String) {
                configJson = JSON.parse(config);
            }

            var key = configJson[Signiant.Mst.Transfer.encryptionKey];
            var iv = configJson[Signiant.Mst.Transfer.encryptionIv];
            if (typeof key !== 'undefined' && typeof iv !== 'undefined'
                  && key.length === 64 && iv.length === 32) {

                var checkKey = /[0-9A-Fa-f]{64}/g;
                var checkIv = /[0-9A-Fa-f]{32}/g;

                var containsKey = checkKey.test(key);
                var containsIv = checkIv.test(iv);

                if (containsKey && containsIv) {
                    return JSON.stringify(configJson);
                }
            }
        }
        throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidFileEncryption');
    };

    transfer.getFileEncryption = function () {
        var value = transfer.getProperty(Signiant.Mst.Transfer.fileEncryption);
        if ((typeof value === 'string' || value instanceof String) && value.length !== 0) {
            value = JSON.parse(value);
        }
        return value;
    };

    transfer.setSubFolder = function (subFolder) {
        Signiant.Mst.log('subFolder set: ' + subFolder + transfer.getTransferIdTag());
        transfer.setProperty(Signiant.Mst.Transfer.subFolder, subFolder);
    };

    transfer.getSubFolder = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.subFolder);
    };

    transfer.setApiKey = function (key) {
        Signiant.Mst.log('API Key set ' + key  + transfer.getTransferIdTag());
        transfer.setProperty(Signiant.Mst.Transfer.apiKey, key);
    };

    transfer.getApiKey = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.apiKey);
    };

    transfer.setTargetFileName = function (targetFileName) {
        Signiant.Mst.log('target File Name set \'' + targetFileName + '\'' + transfer.getTransferIdTag());
        if (targetFileName.indexOf('/') > -1 || targetFileName.indexOf('\\') > -1) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.property.targetFileName.invalid');
        }
        transfer.setProperty(Signiant.Mst.Transfer.targetFileName, targetFileName);
    };

    transfer.getTargetFileName = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.targetFileName);
    };

    transfer.formatTrustedCACert = function (trustedCACertRaw) {

        //var certSnippet = (trustedCACertRaw.substr(0,40) + ' ... ' + trustedCACertRaw.substr(trustedCACertRaw.length-40,trustedCACertRaw.length)).replace(/(\r\n|\n|\r)/gm,'');
        //Signiant.Mst.log('Formatting supplied CA certificate: ' + certSnippet);

        var pemHeader = '-----BEGIN CERTIFICATE-----';
        var pemFooter = '-----END CERTIFICATE-----';
        var pemCharsPerLine = 64;
        var lineFeed = '\n';
        var trustedCACert = '';

        if (typeof trustedCACertRaw === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidTrustedCA');
        } else {
            trustedCACertRaw = trustedCACertRaw.trim();

            if (trustedCACertRaw.length === 0) {
                throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidTrustedCA');
            }
        }

        var indexOfPemHeader = trustedCACertRaw.indexOf(pemHeader, 0);

        if (indexOfPemHeader !== 0) {
            Signiant.Mst.log('Supplied CA certificate is missing the PEM header!');
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidTrustedCA');
        } else {
            var indexOfPemFooter = trustedCACertRaw.indexOf(pemFooter, 0);

            if (indexOfPemFooter <= 0 || (indexOfPemFooter < (trustedCACertRaw.length - pemFooter.length))) {
                Signiant.Mst.warn('Supplied CA certificate is missing the PEM footer or the footer is in the wrong place!');
                throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidTrustedCA');
            } else {
                // remove the pemHeader and pemFooter from the raw string
                trustedCACertRaw =
                    trustedCACertRaw.substring(pemHeader.length, (trustedCACertRaw.length - pemFooter.length));

                // begin creating the formatted certificate
                trustedCACert += pemHeader + lineFeed;

                // remove all invalid (non-Base64) characters and insert a linefeed
                // every 64 characters
                var numBase64CharsInCurrLine = 0;
                var base64 = new Signiant.Mst.Base64();
                for (var i = 0; i < trustedCACertRaw.length; ++i) {
                    var certChar = trustedCACertRaw.charAt(i);

                    // if it's a base64 character, add it to the formatted cert
                    if (base64.isBase64Char(certChar)) {
                        trustedCACert += certChar;
                        numBase64CharsInCurrLine++;
                    }

                    // a linefeed is added every 64 characters
                    if (numBase64CharsInCurrLine !== 0 &&
                        (numBase64CharsInCurrLine % pemCharsPerLine) === 0) {
                        trustedCACert += lineFeed;
                        numBase64CharsInCurrLine = 0;
                    }
                }


                if (!(/\n$/.test(trustedCACert))){
                    trustedCACert += lineFeed;
                }
                trustedCACert += pemFooter;
            }
        }

        return trustedCACert;
    };

    transfer.removeBandwidthThrottle = function () {
        transfer.setBandwidthThrottle(0);
    };

    transfer.setBandwidthThrottle = function (bps) {
        if (isNaN(bps) || (bps < Signiant.Mst.Transfer.minBandwidth && bps !== 0)) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidBandwidth');
        }

        transfer.setProperty(Signiant.Mst.Transfer.bandwidthThrottle, Signiant.Mst.convertBitsToBytes(bps).toString());
        transfer.applyBandwidthThrottle(bps);

    };

    transfer.getBandwidthThrottle = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.bandwidthThrottle);
    };

    transfer.handleSetBandwidth = function (bandwidthResponse) {
        Signiant.Mst.log('Handle set bandwidth response: ' + bandwidthResponse.status);
    };

    transfer.applyBandwidthThrottle = function (bps) {
        if (!transfer.isTransferIdle()) {
            try {
                transfer.sendMessageRequest(
                    'setbandwidth',
                    transfer.handleSetBandwidth,
                    {
                        bandwidth: bps.toString()
                    }
                );
            } catch (e) {
                Signiant.Mst.error('Set-Bandwidth: Failed to set bandwidth, FAILURE: ' + e + transfer.getTransferIdTag());
            }
        }
    };

    transfer.setServer = function (server, serverRelayArr) {
        var mxwanProtocolStr = '';
        var mxtcpProtocolStr = '';
        var httpProtocolStr = '';


        if (typeof server === 'undefined' || server === '') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidServer');
        }

        var serverProtocolList = transfer.getServer();

        if (typeof serverProtocolList !== 'undefined') {
            var serverUrlArray = serverProtocolList.split('\n');

            if (typeof serverRelayArr === 'undefined' || serverRelayArr === '') {
                if (serverProtocolList.indexOf(server) !== -1) {
                    return;
                }
                var i;

                for (i = 0; i < serverUrlArray.length; i++) {
                    if (serverUrlArray[i].indexOf(Signiant.Mst.Transfer.mxwanStr) !== -1)
                        mxwanProtocolStr = serverUrlArray[i] + '|' + Signiant.Mst.Transfer.mxwanStr + server;
                    if (serverUrlArray[i].indexOf(Signiant.Mst.Transfer.mxtcpStr) !== -1)
                        mxtcpProtocolStr = serverUrlArray[i] + '|' + Signiant.Mst.Transfer.mxtcpStr + server;
                    if (serverUrlArray[i].indexOf(Signiant.Mst.Transfer.httpStr) !== -1)
                        httpProtocolStr = serverUrlArray[i] + '|' + Signiant.Mst.Transfer.httpStr + server +
                            Signiant.Mst.Transfer.httpPortStr;
                }
            } else {
                for (i = 0; i < serverUrlArray.length; i++) {
                    var serverProtocol = '';
                    if (serverUrlArray[i].indexOf(Signiant.Mst.Transfer.mxwanStr) !== -1) {
                        serverProtocol =
                            transfer.generateServerProtocolStr(server, serverRelayArr, Signiant.Mst.Transfer.mxwanStr,
                                                               Signiant.Mst.Transfer.defaultTcpUdpPortStr
                            );

                        if (!transfer.doesRelayExistInServerList(serverUrlArray[i], serverProtocol)) {
                            mxwanProtocolStr = serverUrlArray[i] + '|' + serverProtocol;
                        } else {
                            return;
                        }
                    }
                    if (serverUrlArray[i].indexOf(Signiant.Mst.Transfer.mxtcpStr) !== -1) {
                        serverProtocol =
                            transfer.generateServerProtocolStr(server, serverRelayArr, Signiant.Mst.Transfer.mxtcpStr,
                                                               Signiant.Mst.Transfer.defaultTcpUdpPortStr
                            );

                        if (!transfer.doesRelayExistInServerList(serverUrlArray[i], serverProtocol)) {
                            mxtcpProtocolStr = serverUrlArray[i] + '|' + serverProtocol;
                        } else {
                            return;
                        }
                    }
                    if (serverUrlArray[i].indexOf(Signiant.Mst.Transfer.httpStr) !== -1) {
                        serverProtocol =
                            transfer.generateServerProtocolStr(server, serverRelayArr, Signiant.Mst.Transfer.httpStr,
                                                               Signiant.Mst.Transfer.httpPortStr
                            );

                        if (!transfer.doesRelayExistInServerList(serverUrlArray[i], serverProtocol)) {
                            httpProtocolStr = serverUrlArray[i] + '|' + serverProtocol;
                        } else {
                            return;
                        }
                    }
                }
            }
        } else {
            if (typeof serverRelayArr === 'undefined' || serverRelayArr === '') {
                mxwanProtocolStr = Signiant.Mst.Transfer.mxwanStr + server;
                mxtcpProtocolStr = Signiant.Mst.Transfer.mxtcpStr + server;
                httpProtocolStr = Signiant.Mst.Transfer.httpStr + server + Signiant.Mst.Transfer.httpPortStr;
            } else {
                mxwanProtocolStr =
                    transfer.generateServerProtocolStr(server, serverRelayArr, Signiant.Mst.Transfer.mxwanStr,
                                                       Signiant.Mst.Transfer.defaultTcpUdpPortStr
                    );
                mxtcpProtocolStr =
                    transfer.generateServerProtocolStr(server, serverRelayArr, Signiant.Mst.Transfer.mxtcpStr,
                                                       Signiant.Mst.Transfer.defaultTcpUdpPortStr
                    );
                httpProtocolStr =
                    transfer.generateServerProtocolStr(server, serverRelayArr, Signiant.Mst.Transfer.httpStr,
                                                       Signiant.Mst.Transfer.httpPortStr
                    );
            }
        }

        serverProtocolList = mxwanProtocolStr + '\n' + mxtcpProtocolStr + '\n' + httpProtocolStr;

        transfer.setProperty(Signiant.Mst.Transfer.urlListPropName, serverProtocolList);
        Signiant.Mst.log('Set-Server: ' + transfer.getProperty(Signiant.Mst.Transfer.urlListPropName).replace(/(\r\n|\n|\r)/gm,' ') +
            transfer.getTransferIdTag()
        );
    };

    transfer.getServer = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.urlListPropName);
    };

    transfer.generateServerProtocolStr = function (server, serverRelayArr, protocolStr, portStr) {
        var serverProtocolStr = '';
        var endOfLineCounter = 1;
        var arrLength = serverRelayArr.length;
        for (var i = 0; i < arrLength; i++) {
            var serverRelay = '@' + serverRelayArr[i] + portStr;
            serverProtocolStr += protocolStr + server + serverRelay;
            if (endOfLineCounter !== arrLength)
                serverProtocolStr += '|';

            endOfLineCounter++;
        }

        return serverProtocolStr;
    };

    transfer.doesRelayExistInServerList = function (existingServerRelays, newServerRelay) {
        if (existingServerRelays.indexOf(newServerRelay) !== -1)
            return true;
    };

    transfer.clearServerList = function () {
        try {
            transfer.deleteProperty(Signiant.Mst.Transfer.urlListPropName);
        } catch (e) {
            Signiant.Mst.error('Clear-Server-List: Failed to clear server list, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToClearServerList');
        }
    };

    transfer.setCredentials = function (username, password) {
        if (typeof username === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidUsername');
        }
        if (typeof password === 'undefined') {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidPassword');
        }

        transfer.setProperty(Signiant.Mst.Transfer.usernamePropName, username);
        transfer.setProperty(Signiant.Mst.Transfer.passwordPropName, password);

        Signiant.Mst.log('Set-Credentials: username=' + username + transfer.getTransferIdTag());
        if (username !== transfer.getProperty(Signiant.Mst.Transfer.usernamePropName)) {
            Signiant.Mst.warn('Set-Credentials: username mismatch, set as ' + username +
                ', retrieved as ' + transfer.getProperty(Signiant.Mst.Transfer.usernamePropName) +
                transfer.getTransferIdTag()
            );
        }
    };

    transfer.setDestinationDir = function (destinationDir) {
        if (typeof destinationDir === 'undefined' || destinationDir.length === 0) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidDestinationDir');
        }

        transfer.setProperty(Signiant.Mst.Transfer.destinationPropName, destinationDir);
        Signiant.Mst.log('Set-Destination-Dir: New destination directory: ' +
                         transfer.getProperty(Signiant.Mst.Transfer.destinationPropName) + transfer.getTransferIdTag()
        );
    };

    transfer.getDestinationDir = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.destinationPropName);
    };

    transfer.setLogLevel = function (level) {
        var logLevel = level.toUpperCase();
        var coreLevel = Signiant.Mst.CORE_INFO_LOG_LEVEL;
        transfer.logLevel = logLevel;
        if (Signiant.Mst.INFO_LOG_LEVEL === logLevel) {
            coreLevel = Signiant.Mst.CORE_INFO_LOG_LEVEL;
        } else if (Signiant.Mst.DEBUG_LOG_LEVEL === logLevel) {
            coreLevel = Signiant.Mst.CORE_DEBUG_LOG_LEVEL;
        } else if (Signiant.Mst.TRACE_LOG_LEVEL === logLevel) {
            coreLevel = Signiant.Mst.CORE_TRACE_LOG_LEVEL;
        } else {
            transfer.logLevel = Signiant.Mst.INFO_LOG_LEVEL;
        }

        transfer.setProperty(Signiant.Mst.Transfer.loggingPropName, coreLevel);
    };

    transfer.getLogLevel = function () {
        return transfer.logLevel;
    };

    transfer.enableManifestGeneration = function () {
        transfer.setProperty(Signiant.Mst.Transfer.generateManifest, 'true');
    };

    transfer.disableManifestGeneration = function () {
        transfer.setProperty(Signiant.Mst.Transfer.generateManifest, 'false');
    };

    transfer.getManifestGeneration = function () {
        var result = transfer.getProperty(Signiant.Mst.Transfer.generateManifest);
        if (result !== 'true') {
            result = 'false';
        }
        return result;
    };

    transfer.setProcessManifestEndpoint = function (endpointUrl) {
        transfer.validateProcessManifestEndpoint(endpointUrl);
        transfer.setProperty(Signiant.Mst.Transfer.processManifestEndpoint, endpointUrl);
    };

    transfer.getProcessManifestEndpoint = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.processManifestEndpoint);
    };

    transfer.validateProcessManifestEndpoint = function (endpoint) {
        if (typeof endpoint !== 'undefined' && endpoint.indexOf('https://') === -1) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidManifestEndpoint');
        }
    };

    transfer.setProcessManifestToken = function (token) {
        transfer.setProperty(Signiant.Mst.Transfer.processManifestToken, token);
    };

    transfer.getProcessManifestToken = function () {
        transfer.getProperty(Signiant.Mst.Transfer.processManifestToken);
    };

    transfer.enableMultiportTransfer = function () {
        Signiant.Mst.log('Enable multi-port transfer: ' + transfer.getTransferIdTag());
        transfer.setProperty(Signiant.Mst.Transfer.useUdpPortRange, Signiant.Mst.Transfer.yesStr);
    };

    transfer.disableMultiportTransfer = function () {
        Signiant.Mst.log('Disable multi-port transfer: ' + transfer.getTransferIdTag());
        transfer.deleteProperty(Signiant.Mst.Transfer.useUdpPortRange);
    };

    transfer.isMultiportTransferEnabled = function () {
        return (transfer.getProperty(Signiant.Mst.Transfer.useUdpPortRange) === Signiant.Mst.Transfer.yesStr);
    };

    //Specified files get appended to the list of files in property
    transfer.setFiles = function (fileNameArray) {
        if (typeof fileNameArray === 'undefined' || fileNameArray.length === 0) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.undefinedListOfFiles');
        }

        if (!Array.isArray(fileNameArray)) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidListOfFiles');
        }

        var currentFiles = transfer.getProperty(Signiant.Mst.Transfer.filesPropName);
        var currentFilesArray = [];
        var newFilesArray = [];

        if (typeof currentFiles === 'undefined') {
            currentFiles = '';
        } else {
            currentFilesArray = currentFiles.split('\n');
        }

        var fileExists = false;
        for (var i = 0; i < fileNameArray.length; ++i, fileExists = false) {
            fileNameArray[i] = Signiant.Mst.trimFileStr(fileNameArray[i]);
            for (var j = 0; j < currentFilesArray.length; ++j) {
                if (fileNameArray[i] === currentFilesArray[j]) {
                    fileExists = true;
                    break;
                }
            }

            if (fileExists === false) {
                newFilesArray.push(fileNameArray[i]);
            }
        }

        for (var k = 0; k < newFilesArray.length; ++k) {
            if (currentFiles.length === 0) {
                currentFiles += newFilesArray[k];
            } else {
                currentFiles += ('\n' + newFilesArray[k]);
            }
        }
        transfer.setProperty(Signiant.Mst.Transfer.filesPropName, currentFiles);
    };

    transfer.addToCompleteFileData = function (newFiles) {
        var currFiles = transfer.completeFileList;
        if (typeof newFiles !== 'undefined' && newFiles !== null && newFiles.length > 0) {
            newFiles.forEach(function (newFile) {
                var isDuplicateFile = currFiles.some(function (currentFile) {
                    return currentFile.path === newFile.path;
                });

                if (!isDuplicateFile) {
                    transfer.completeFileList.push(newFile);
                }
            });
        }
    };

    transfer.removeFromCompleteFileData = function (files) {
        if (typeof files !== 'undefined' && files !== null && files.length > 0) {
            for (var i = 0; i < files.length; i++) {
                for (var j = 0; j < transfer.completeFileList.length; j++) {
                    if (files[i] === transfer.completeFileList[j].path) {
                        transfer.completeFileList.splice(j, 1);
                    }
                }
            }
        }
    };

    transfer.getFiles = function () {
        var files = transfer.getProperty(Signiant.Mst.Transfer.filesPropName);
        return (typeof files === 'undefined') ? [] : files.split('\n');
    };

    transfer.removeFromFilesProperty = function (fileArray) {
        //noinspection Eslint
        try {
            for (var k = 0; k < fileArray.length; k++) {
                var array = transfer.getFiles();

                var index = -1;
                for (var i = 0; i < array.length; i++) {
                    if (array[i] === fileArray[k]) {
                        index = i;
                        break;
                    }
                }

                if (index !== -1) {
                    array.splice(index, 1);
                    transfer.deleteFilesProperty();

                    if (array.length !== 0) {
                        transfer.setFiles(array);
                    }
                    Signiant.Mst.log('Selected file (' + fileArray[k] +
                                     ') has been cleared from the file list' + transfer.getTransferIdTag()
                    );
                } else {
                    Signiant.Mst.log('Selected file (' + fileArray[k] +
                                     ') to clear was not in the file list' + transfer.getTransferIdTag()
                    );
                }
            }
        } catch (e) {
            Signiant.Mst.error('Remove-From-Files-Property: Failed to remove specifed files from Files property, FAILURE: ' + e +
                transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToRemoveFilesFromProperty');
        }
    };

    transfer.deleteFilesProperty = function () {
        transfer.deleteProperty(Signiant.Mst.Transfer.filesPropName);
    };

    // base "abstract" definition to be overridden by the child upload and download module
    transfer.clearAllFiles = function () {
    };

    // base "abstract" definition to be overridden by the child upload and download module
    transfer.clearFiles = function (filesArray) { // eslint-disable-line no-unused-vars
    };

    transfer.retry = function () {
    };

    transfer.isTransferIdle = function () {
        var idle = false;
        if (transfer.currentTransferState === Signiant.Mst.transferState.IDLE
            || transfer.currentTransferState === Signiant.Mst.transferState.SUCCESSFUL
            || transfer.currentTransferState === Signiant.Mst.transferState.FAILURE
            || transfer.currentTransferState === Signiant.Mst.transferState.CANCELLED) {
            idle = true;
        }
        return idle;
    };

    transfer.isTransferCancelling = function () {
        var cancelling = false;
        if (transfer.currentTransferState === Signiant.Mst.transferState.CANCEL_PENDING
            || transfer.currentTransferState === Signiant.Mst.transferState.CANCELLING) {
            cancelling = true;
        }
        return cancelling;
    };

    transfer.cancel = function () {
        if (! transfer.isTransferIdle() && !transfer.isTransferCancelling()) {
            Signiant.Mst.log('Transfer canceled' + transfer.getTransferIdTag());
            try {
                transfer.sendMessageRequest(
                    'canceltransfer',
                    transfer.handleCancelTransferResponse,
                    null
                );
            } catch (e) {
                Signiant.Mst.error('Failed to cancel transfer, FAILURE: ' + e + transfer.getTransferIdTag());
            }
            transfer.currentTransferState = Signiant.Mst.transferState.CANCEL_PENDING;
        } else {
            //Error thrown due to no transfer in progress to cancel
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.noTransferToCancel');
        }
    };

    transfer.handleCancelTransferResponse = function (response) {
        Signiant.Mst.log('Handle cancel transfer response: ' + response.status);
        var status = response.status;
        if (status === 'fail') {
            if (transfer.currentTransferState === Signiant.Mst.transferState.CANCEL_PENDING) {
                transfer.currentTransferState = Signiant.Mst.transferState.TRANSFERRING;
            }
        } else {
            transfer.currentTransferState = Signiant.Mst.transferState.CANCELLING;
        }

    };

    transfer.sendMessageRequest = function (requestName, requestCallback, content) {
        var messageChannel = this.messageChannel || Signiant.Mst.signiantMessageChannel;
        messageChannel.sendMessageRequest(transfer.getMessagingIdentifier(), requestName, requestCallback, content);
    };

    transfer.setJobNamePrefix = function (value) {
        if (typeof value === 'undefined' || value.length === 0) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.jobNamePrefix.failure');
        }

        if (value.match(/^[a-zA-Z0-9_]{1,32}$/)) {
            transfer.setProperty(Signiant.Mst.Transfer.jobNamePrefixPropName, value);
            Signiant.Mst.log('Set-JobName-Prefix: ' +
                             transfer.getProperty(Signiant.Mst.Transfer.jobNamePrefixPropName) +
                             transfer.getTransferIdTag()
            );
        } else {
            Signiant.Mst.error('Failed to set the Job Name Prefix');
            throw Signiant.Mst.messagesMap.getMessage('signiant.transfer.error.jobNamePrefix.invalidJobNamePrefix');
        }
    };

    transfer.setServiceData = function (value) {
        if (typeof value === 'undefined' || value.length === 0) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.serviceData.failure');
        }

        transfer.setProperty(Signiant.Mst.Transfer.serviceDataPropName, value);
        Signiant.Mst.log('Set-Service-Data: ' +
            transfer.getProperty(Signiant.Mst.Transfer.serviceDataPropName) + ' = ' + value  + transfer.getTransferIdTag()
        );

    };

    transfer.getServiceData = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.serviceDataPropName);
    };

    transfer.subscribeForTransferEvents = function (messageChannel) {
        messageChannel = messageChannel || Signiant.Mst.signiantMessageChannel;
        this.messageChannel = messageChannel;

        var originator = transfer.getMessagingIdentifier();

        messageChannel.setEventHandler(
            originator,
            'canceltransfer',
            transfer.handleCancelTransferResponse
        );

        messageChannel.setEventHandler(
            originator,
            Signiant.Mst.warnEventName,
            transfer.handleTransferErrors
        );
        messageChannel.setEventHandler(
            originator,
            Signiant.Mst.transferStartedEventName,
            transfer.handleTransferStartedEvent
        );
        messageChannel.setEventHandler(
            originator,
            Signiant.Mst.preTransferEventName,
            transfer.handlePreTransfer
        );
        messageChannel.setEventHandler(
            originator,
            Signiant.Mst.connectionStatusChangeEventName,
            transfer.handleConnectionStatusChange
        );
        messageChannel.setEventHandler(
            originator,
            Signiant.Mst.preFileEventName,
            transfer.handlePreFileEvent
        );
        messageChannel.setEventHandler(
            originator,
            Signiant.Mst.transferProgressEventName,
            transfer.handleTransferProgress
        );
        messageChannel.setEventHandler(
            originator,
            Signiant.Mst.postTransferEventName,
            transfer.handlePostTransferEvent
        );
        messageChannel.setEventHandler(
            originator,
            Signiant.Mst.retryTransferEventName,
            transfer.handleRetryTransferEvent
        );
        messageChannel.setEventHandler(
            originator,
            Signiant.Mst.connectionStatusComponentQueuedEventName,
            transfer.handleConnectionStatusComponentQueued
        );

    };

    transfer.handleTransferStartedEvent = function () {
        Signiant.Mst.log('transferStarted event is fired' + transfer.getTransferIdTag());
        try {
            if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                transfer.basicEventsSubscribedCallback(
                    transfer,
                    Signiant.Mst.transferStartedEvent,
                    Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.transferStarted')
                );
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.transferStartedEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.transferStartedEventName](transfer);
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Transfer-Started-Event: Failed to call callback for transfer-started event' +
                transfer.getTransferIdTag() + ', FAILURE: ' + e);
        }
        transfer.currentTransferState = Signiant.Mst.transferState.STARTED;
    };

    transfer.handlePreTransfer = function (protocolObject) {
        Signiant.Mst.log('preTransferEvent event is fired, ProtocolName: ' + protocolObject.protocol +
            transfer.getTransferIdTag()
        );
        try {
            if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                transfer.basicEventsSubscribedCallback(
                    transfer,
                    Signiant.Mst.preTransferEvent,
                    Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.preTransfer'),
                    protocolObject.protocol
                );
            }
            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.preTransferEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.preTransferEventName](
                    transfer,
                    protocolObject.protocol,
                    protocolObject.connectedServer
                );
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Pre-Transfer-Event: Failed to call callback for pre-transfer event' +
                transfer.getTransferIdTag() + ', FAILURE: ' + e);
        }
    };

    transfer.handleConnectionStatusChange = function (statusObject) {
        Signiant.Mst.log('connectionStatusChange event is fired, Status: ' + statusObject.status + transfer.getTransferIdTag()
        );

        var message = '';
        if (statusObject.status === 'CONNECTING'){
            transfer.currentTransferState = Signiant.Mst.transferState.CONNECTING;
            Signiant.Mst.connectionStatusEvent = 'CONNECTING';
            message = Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.connecting');
            Signiant.Mst.googleAnalytics.startTimer(Signiant.Mst.GoogleAnalytics.Constants.Category.transfers,
                                                    Signiant.Mst.GoogleAnalytics.Constants.Action.transferConnectionTime);
        } else if (statusObject.status === 'CONNECTED'){
            transfer.currentTransferState = Signiant.Mst.transferState.CONNECTED;
            Signiant.Mst.connectionStatusEvent = 'CONNECTED';
            message = Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.connected');
            Signiant.Mst.googleAnalytics.endTimer(Signiant.Mst.GoogleAnalytics.Constants.Category.transfers,
                                                    Signiant.Mst.GoogleAnalytics.Constants.Action.transferConnectionTime);
        } else if (statusObject.status === 'TRANSFERRING'){
            transfer.currentTransferState = Signiant.Mst.transferState.TRANSFERRING;
            Signiant.Mst.connectionStatusEvent = 'TRANSFERRING';
            message = Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.transferring');
        } else if (statusObject.status === 'DISCONNECTING'){
            transfer.currentTransferState = Signiant.Mst.transferState.DISCONNECTING;
            Signiant.Mst.connectionStatusEvent = 'DISCONNECTING';
            message = Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.disconnecting');
        } else if (statusObject.status === 'DISCONNECTED'){
            transfer.currentTransferState = Signiant.Mst.transferState.DISCONNECTED;
            Signiant.Mst.connectionStatusEvent = 'DISCONNECTED';
            message = Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.disconnected');
        } else if (statusObject.status === 'QUEUED'){
            transfer.currentTransferState = Signiant.Mst.transferState.QUEUED;
            Signiant.Mst.connectionStatusEvent = 'CONNECTION_QUEUED';
            message = Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.connectionStatusComponentQueued');
        }

        try {
            if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                transfer.basicEventsSubscribedCallback(transfer, Signiant.Mst.connectionStatusEvent, message);
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.connectionStatusChangeEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.connectionStatusChangeEventName](transfer,
                                                                                                 statusObject.status
                );
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Connection-Status-Event: Failed to call callback for connection-status event' +
                transfer.getTransferIdTag() + ', FAILURE: ' + e);
        }
    };

    transfer.handleConnectionStatusComponentQueued = function (etatimeObject) {
        var etaTime = (typeof etatimeObject === 'undefined' || typeof etatimeObject.etatime  === 'undefined') ?
                            undefined : etatimeObject.etatime; // eslint-disable-line no-undefined
        Signiant.Mst.log('connectionStatusComponentQueued event is fired, EtaTime: ' + etaTime +
            + transfer.getTransferIdTag()
        );
        try {
            if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                transfer.basicEventsSubscribedCallback(transfer, Signiant.Mst.connectionStatusComponentQueuedEvent,
                                                       Signiant.Mst.messagesMap.getMessageForTransport(
                                                           'signiant.transfer.status.connectionStatusComponentQueued'),
                                                       etaTime
                );
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.connectionStatusComponentQueuedEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.connectionStatusComponentQueuedEventName](transfer,
                                                                                                          etaTime
                );
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Connection-Status-Component-Queued-Event: Failed to call callback for ' +
                'connection-status-component-queued event, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.callbackFailedForConnStatusCompQueued');
        }
    };

    transfer.handlePreFileEvent = function (fileObject) {
        Signiant.Mst.log('preFile event is fired, FileName: ' + fileObject.fileName + transfer.getTransferIdTag()
        );
        try {
            if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                transfer.basicEventsSubscribedCallback(transfer, Signiant.Mst.transferPreFileEvent,
                                                       Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.preFile'),
                                                       fileObject.fileName
                );
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.preFileEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.preFileEventName](transfer, fileObject.fileName);
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Pre-File-Event: Failed to call callback for pre-file event' +
                transfer.getTransferIdTag() + ', FAILURE: ' + e);
        }
    };

    transfer.handleTransferErrors = function (errorObject) {
        Signiant.Mst.warn('Warn event was fired' + transfer.getTransferIdTag() +
            ', errorCode: ' + errorObject.errorCode + ', Message: ' + errorObject.shortMessage +
            ((errorObject.propertyName !== '')?', propertyName:' + errorObject.propertyName: '')
        );
        try {
            var errorMessage = Signiant.Mst.messagesMap.getMessageForTransport(errorObject.errorCode);
            Signiant.Mst.error('Error (' + errorObject.errorCode + '): ' + errorMessage);

            transfer.lastTransferError = errorObject.errorCode;

            if (typeof transfer.transferErrorsEventsCallback === 'function') {
                //slightly-complicated regex - match PropertyException that does NOT contain
                //'INJECTED_FILE_ENTRIES_FOUND' nor 'INJECTED_DEST_DIR_FOUND'
                if (errorObject.errorCode.match(/^((?!PropertyException-INJECTED_(FILE_ENTRIES|DEST_DIR)_FOUND).)*$/)) {
                    var error = transfer.getExternalErrorCode(errorObject.errorCode);
                    transfer.transferErrorsEventsCallback(transfer, error, errorMessage, errorObject.propertyName);
                }
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.warnEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.warnEventName](transfer, errorObject.errorCode,
                                                                               errorObject.shortMessage,
                                                                               errorObject.propertyName,
                                                                               errorMessage
                );
            }

            //need to test <u>specific</u> INJECTED exceptions
            if (errorObject.errorCode === 'PropertyException-INJECTED_FILE_ENTRIES_FOUND') {
                if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                    transfer.basicEventsSubscribedCallback(transfer, Signiant.Mst.injectedFileEntriesFoundEvent,
                                                           Signiant.Mst.messagesMap.getMessageForTransport(errorObject.errorCode)
                    );
                }
            } else if (errorObject.errorCode === 'PropertyException-INJECTED_DEST_DIR_FOUND') {
                if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                    transfer.basicEventsSubscribedCallback(transfer, Signiant.Mst.injectedDestDirFoundEvent,
                                                           Signiant.Mst.messagesMap.getMessageForTransport(errorObject.errorCode)
                    );
                }
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Transfer-Errors: Failed to handle errors, FAILURE: ' + e + transfer.getTransferIdTag());
        }

    };

    transfer.validateTargetFileName = function () {
        var targetFileName = transfer.getTargetFileName();
        if (targetFileName && (targetFileName.length > 0)) {
            var files = transfer.getFiles();
            if (files && (files.length > 1)) {
                Signiant.Mst.error('Start-Upload: Failed to start upload' +
                    ', signiant.transfer.error.property.targetFileName.multifiles.invalid' + transfer.getTransferIdTag());
                throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.property.targetFileName.multifiles.invalid');
            }
        }
    };

    transfer.validateApiKeyPresent = function () {
        var apiKey = transfer.getApiKey();
        if (typeof apiKey === 'undefined') {
            Signiant.Mst.error('No Api Key provided' + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.error.mst.script.apikey.invalid');
        }
    };

    transfer.validateDestinationDir = function () {
        var destinationDir = transfer.getDestinationDir();
        if (typeof destinationDir === 'undefined' || destinationDir.length === 0) {
            Signiant.Mst.error('No destination directory provided' + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.property.destinationDir.notFound');
        }
    };

    transfer.validateFileEncryptionConfig = function () {
        var encryptConfig = transfer.getFileEncryption();
        if (typeof encryptConfig !== 'undefined' && encryptConfig.length !== 0) {
            transfer.parseFileEncryptionConfig(encryptConfig);
        }
    };

    transfer.getLastError = function () {
        if (typeof transfer.lastTransferError === 'undefined') {
            transfer.lastTransferError = '';
        }
        return transfer.lastTransferError;
    };

    transfer.resetLastError = function () {
        transfer.lastTransferError = '';
    };

    transfer.getExternalErrorCode = function (errorCode) {
        if (errorCode === 'InvalidAuthenticationException-INCOMPLETE_USER_CREDENTIALS') {
            return Signiant.Mst.incompleteUserCredentials;
        } else if (errorCode === 'PropertyException-FILE_ENTRY_NOT_FOUND') {
            return Signiant.Mst.noFilesForUploadCode;
        } else if (errorCode === 'PropertyException-NO_FILES_TO_DOWNLOAD') {
            return Signiant.Mst.noFilesForDownloadCode;
        } else if (errorCode === 'PropertyException-NO_DESTINATION_DIR_DEFINED') {
            return Signiant.Mst.noDestinationFolderCode;
        } else if (errorCode === 'ConnectionAbortedException-READ_CHANNEL_FAILURE') {
            return Signiant.Mst.connectionFailureCode;
        } else if (errorCode === 'InvalidAuthenticationException-INVALID_CREDENTIALS') {
            return Signiant.Mst.invalidCredentialsCode;
        } else if (errorCode === 'PropertyException-INVALID_DESTINATION_DIR') {
            return Signiant.Mst.invalidDestinationDirectory;
        } else {
            return Signiant.Mst.transferErrorsEvent;
        }
    };

    transfer.handleTransferProgress = function (progressObject) {
        try {
            Signiant.Mst.log('transferProgress event is fired' + transfer.getTransferIdTag() +
                progressObject.bytesSent + ' (bytes sent), ' +
                progressObject.totalBytes + ' (total bytes), ' +
                progressObject.eta + ' (time remaining), ' +
                progressObject.formatRate + ' (rate)'
            );

            if (typeof transfer.progressEventsCallback === 'function') {
                transfer.progressEventsCallback(
                    transfer,
                    progressObject.bytesSent,
                    progressObject.totalBytes,
                    progressObject.eta
                );
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.transferProgressEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.transferProgressEventName](
                    transfer,
                    progressObject.bytesSent,
                    progressObject.totalBytes,
                    progressObject.eta,
                    progressObject.formatRate,
                    progressObject.rawRate
                );
            }
        } catch (e) {
            Signiant.Mst.error('Handle Transfer Progress: Failed to handle transfer-progress event, FAILURE: ' + e +
                transfer.getTransferIdTag());
        }
    };

    transfer.handlePostTransferEvent = function (finalObject) {
        finalObject.status = (finalObject.status === 'SUCCESS') ? 'SUCCESSFUL' : finalObject.status;
        Signiant.Mst.log('postTransfer event is fired, Status: '+ finalObject.status + transfer.getTransferIdTag());

        try {
            var event;
            var messageKey;
            if (finalObject.status === 'FAILURE') {
                transfer.currentTransferState = Signiant.Mst.transferState.FAILURE;
                event = Signiant.Mst.transferErrorsEvent;
                messageKey = 'signiant.transfer.status.transferFailed';
            } else if (finalObject.status === 'CANCELLED') {
                transfer.currentTransferState = Signiant.Mst.transferState.CANCELLED;
                event = Signiant.Mst.transferCanceledEvent;
                messageKey = 'signiant.transfer.status.transferCanceled';
            } else if (finalObject.status === 'SUCCESSFUL') {
                transfer.currentTransferState = Signiant.Mst.transferState.SUCCESSFUL;
                event = Signiant.Mst.transferCompletedEvent;
                messageKey = 'signiant.transfer.status.transferSuccessful';
            }
            if (typeof transfer.basicEventsSubscribedCallback === 'function'){
                transfer.basicEventsSubscribedCallback(transfer, event,
                                                       Signiant.Mst.messagesMap.getMessageForTransport(messageKey));
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.postTransferEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.postTransferEventName](
                    transfer,
                    finalObject.status,
                    finalObject.destination,
                    finalObject.sandbox,
                    finalObject.transferSize,
                    finalObject.logfile,
                    finalObject.fileNamePairsAfterCollisionJSONArr
                );
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Post-Transfer-Event: Failed to call callback for post-transfer event, FAILURE: ' +
                e + transfer.getTransferIdTag());
        }
    };

    transfer.handleRetryTransferEvent = function (retryObject) {
        var countstr = retryObject.currentretry + ' out of ' + retryObject.maxretries + ' times';
        Signiant.Mst.log('retryTransfer event is fired: ' + countstr + transfer.getTransferIdTag());
        try {
            if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                transfer.basicEventsSubscribedCallback(transfer, Signiant.Mst.transferRetryEvent,
                                                       Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.event.transferRetry') +
                                                       countstr
                );
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.retryTransferEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.retryTransferEventName](transfer, retryObject);
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Retry-Transfer-Event: Failed to call callback for retry-transfer event, FAILURE: ' +
                e + transfer.getTransferIdTag());
        }
    };


    transfer.handleTransferFailure = function (transferFailureMessage) {
        Signiant.Mst.log('transferFailure event is fired' + transfer.getTransferIdTag());
        try {
            if (typeof transfer.transferErrorsEventsCallback === 'function') {
                if (typeof transferFailureMessage === 'undefined') {
                    transferFailureMessage =
                        Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.status.transferFailed');
                }
                transfer.transferErrorsEventsCallback(transfer, Signiant.Mst.transferErrorsEvent, transferFailureMessage);
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.transferFailureEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.transferFailureEventName](transfer, transferFailureMessage);
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Transfer-Failure: Failed to handle transfer errors event, FAILURE: ' + e +
                transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToHandleErrors');
        }
    };

    transfer.handleTransferException = function (message) {
        // NOTE "exception" event is NOT triggered by the Media Shuttle plug-in
        Signiant.Mst.warn('exception: ' + message);
        try {
            if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                transfer.basicEventsSubscribedCallback(transfer, Signiant.Mst.transferExceptionEvent,
                                                       Signiant.Mst.messagesMap.getMessage('signiant.transfer.transferException'),
                                                       message
                );
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.exceptionEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.exceptionEventName](transfer, message);
            }
        } catch (e) {
            Signiant.Mst.error('Handle-Transfer-Exception: Failed to handle transfer exception event, FAILURE: ' + e +
                transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToHandleException');
        }
    };

    // base "abstract" definition to be overridden by the child Download module
    transfer.handleDownloadFolderChosen = function (folder) { // eslint-disable-line no-unused-vars
    },

    // base "abstract" definition to be overridden by the child Upload module
    // eslint-disable-line no-alert
    transfer.handleUploadFilesChosen = function (filesJSON) { // eslint-disable-line no-unused-vars
    },

    transfer.handleUploadFilesProcessed = function (files) { // eslint-disable-line no-unused-vars
        Signiant.Mst.log('uploadFilesProcessed event is fired, Files: ' + files + transfer.getTransferIdTag());

        try {
            if (files.length > 0 && files !== '[]') {
                Signiant.Mst.log('uploadFilesProcessed: ' + files + transfer.getTransferIdTag());
            }
            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.uploadFilesProcessedEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.uploadFilesProcessedEventName](transfer, files);
            }
        } catch (e) {
            Signiant.Mst.error(
                'Handle-Transfer-Failure: Failed to handle errors, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToHandleUploadFilesProcessed');
        }
    };

    transfer.handleTooManyFilesChosen = function () {
        try {
            if (typeof transfer.filesSelectedCallback === 'function') {
                transfer.filesSelectedCallback(Signiant.Mst.tooManyFilesChosenEvent, [], transfer);
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.tooManyFilesChosenEventName] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.tooManyFilesChosenEventName](transfer);
            }
        } catch (e) {
            Signiant.Mst.error('Upload-Too-Many-Files-Chosen: Failed to send callback for too many files chosen to ' +
                'upload, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.callbackFailedForTooManyFiles');
        }
    };

    transfer.subscribeForBasicEvents = function (callback) {
        try {
            transfer.basicEventsSubscribedCallback = callback;
            Signiant.Mst.debug('Subscribe-Basic-Events ' + transfer.getTransferIdTag());
        } catch (e) {
            Signiant.Mst.error('Subscribe-Basic-Events: Failed to subscribe to basic events, FAILURE: ' + e +
                transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToSubscribeBasicEvents');
        }
    };

    transfer.subscribeForTransferProgress = function (callback) {
        try {
            transfer.progressEventsCallback = callback;
            Signiant.Mst.debug('Subscribe-For-Transfer-Progress ' + transfer.getTransferIdTag());
        } catch (e) {
            Signiant.Mst.error('Subscribe-For-Transfer-Progress: Failed to subscribe to transfer-progress events, FAILURE: ' +
                e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToSubscribeXferProgress');
        }
    };

    transfer.subscribeForTransferErrors = function (callback) {
        try {
            transfer.transferErrorsEventsCallback = callback;
            Signiant.Mst.debug('Subscribe-For-Transfer-Errors ' + transfer.getTransferIdTag());
        } catch (e) {
            Signiant.Mst.error('Subscribe-For-Transfer-Errors: Failed to subscribe to transfer-errors event' +
                ', FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToSubscribeXferErrors');
        }
    };

    transfer.subscribeForAdvancedEvents = function (eventName, callback) {
        if (typeof callback === 'undefined')
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidCallback');

        Signiant.Mst.validateEventName(eventName);

        try {
            transfer.advancedEventCallbacksMap[eventName] = callback;
        } catch (e) {
            Signiant.Mst.error('Subscribe-Advanced-Events: Failed to subscribe to advanced-events, FAILURE: ' + e +
                transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport(
                'signiant.transfer.error.failedToSubscribeForAdvEvent' + eventName
            );
        }
    };

    transfer.handleTransferRequestResponse = function (response) {
        Signiant.Mst.log('Transfer Request Response callback invoked: ' + JSON.stringify(response));
        var status = response.status;
        Signiant.Mst.log('Start transfer status: ' + status + transfer.getTransferIdTag());
        if (status === 'fail') {
            Signiant.Mst.error(response.error.message);
            transfer.handleTransferFailure(response.error.message);
            var statusObject = {'status': 'FAILURE', 'tranferSize': '0'};
            transfer.handlePostTransferEvent(statusObject);
            transfer.currentTransferState = Signiant.Mst.transferState.FAILURE;
        }
    };

    transfer.sendFilesRemovedMessage = function (filePathList) {
        if (typeof filePathList !== 'undefined' && Array.isArray(filePathList) !== false && filePathList.length !== 0) {
            var fileList = new Array();
            filePathList.forEach(function (filePath) {
                var item = {
                    path : filePath
                };
                fileList.push(item);
            });

            var content = new Object();
            content.filelist = fileList;

            transfer.sendMessageRequest(
                'filesdeletedevent',
                null,
                content
            );
        }
    };

    transfer.version = function () {
//  TO-DO TV Get App Version
//        return transfer.plugin.version();
    };

    transfer.setDefaults = function () {
        transfer.setProperty(Signiant.Mst.Transfer.certValidatePropName, 'yes');
        transfer.setProperty(Signiant.Mst.Transfer.encryptPropName, 'STRONG');
        transfer.setProperty(Signiant.Mst.Transfer.restartsPropName, '4');
        transfer.setProperty(Signiant.Mst.Transfer.aggressivePropName, '2');
        transfer.setProperty(Signiant.Mst.Transfer.followSymLinksPropName, 'yes');
        transfer.setProperty(Signiant.Mst.Transfer.streamsPropName, '4');
        transfer.setProperty(Signiant.Mst.Transfer.fileCollisionHandlingPropName,
                             Signiant.Mst.Transfer.fileCollisionModeVersion
        );
        transfer.setProperty(Signiant.Mst.Transfer.jobNamePrefixPropName, Signiant.Mst.Transfer.jobNamePrefix);
        transfer.setProperty(Signiant.Mst.Transfer.probeLB, 'no');
        transfer.setProperty(Signiant.Mst.Transfer.usernamePropName, 'default');
        transfer.setProperty(Signiant.Mst.Transfer.passwordPropName, 'default');
        transfer.setProperty(Signiant.Mst.Transfer.bandwidthThrottle, '0');
        transfer.setLogLevel(Signiant.Mst.Transfer.loggingPropName, Signiant.Mst.INFO_LOG_LEVEL);
    };

    transfer.getTransferType = function () {
        return this.transferType;
    };

    transfer.setMessagingProvider = function () {
        if (Signiant.Mst.signiantMessageChannel) {
            transfer.setProperty(Signiant.Mst.Transfer.messagingProvider, Signiant.Mst.signiantMessageChannel.getProviderInfo());
        }
    };

    transfer.getRestarts = function () {
        return this.getProperty(Signiant.Mst.Transfer.restartsPropName);
    };

    transfer.setRestarts = function (num) {
        var count = parseInt(num);
        if (isNaN(count) || count < 0) {
            Signiant.Mst.error('Set-Restarts-Error: Failed to pass valid parameter: ' + num);
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidTransferRestartValue');

        } else {
            this.setProperty(Signiant.Mst.Transfer.restartsPropName, count.toString());
            Signiant.Mst.log('Setting restarts to: ' + count + ' ' + transfer.getTransferIdTag());
        }
    };


    // initialize defaults
    transfer.setDefaults();

    return transfer;
};

Signiant.Mst.Upload = function () {
    var transfer = new Signiant.Mst.Transfer();

    transfer.transferType = Signiant.Mst.TransferType.Upload;

    transfer.startUpload = function () {

        try {

            if (!transfer.isTransferIdle()) {
                throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.transferAlreadyStarted');
            }

            transfer.validateTargetFileName();
            transfer.validateApiKeyPresent();
            transfer.validateFileEncryptionConfig();
            transfer.validateProcessManifestEndpoint(transfer.getProcessManifestEndpoint());

            transfer.resetLastError();
            transfer.transferProperties[Signiant.Mst.Transfer.modePropName] = 'SEND';
            transfer.transferProperties[Signiant.Mst.Transfer.jsIdPropName] = Signiant.Mst.App.isTransferManifestSupported() ?
                transfer.id :transfer.originator;

            transfer.subscribeForTransferEvents();
            transfer.setMessagingProvider();

            transfer.sendMessageRequest(
                'upload',
                transfer.handleTransferRequestResponse,
                transfer.getTransferProperties()
            );

        } catch (e) {
            Signiant.Mst.error('Start-Upload: Failed to start upload, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToUpload');
        }
        transfer.currentTransferState = Signiant.Mst.transferState.START_PENDING;
    };

    transfer.supportsNativeDragAndDrop = function () {
        return false;
    };

    transfer.calcSelectedFileSize = function () {
        try {
//            transfer.subscribeForPluginEvent(Signiant.Mst.uploadFilesProcessedEventName,transfer.handleUploadFilesProcessed);
    // transfer.plugin.processUploadFiles();
        } catch (e) {
            Signiant.Mst.error('Calc-Selected-File-Size: Failed to calculate sizes of the selected files, FAILURE: ' + e +
                transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToCalcSelectedFileSize');
        }
    };

    transfer.setFilesToUpload = function (fileNameArray) {
        if (typeof fileNameArray === 'undefined' || fileNameArray.length === 0) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.specifyFileToUpload');
        }

        transfer.setFiles(fileNameArray);

        Signiant.Mst.log('Set-Files-To-Upload: ' +
            transfer.getProperty(Signiant.Mst.Transfer.filesPropName).replace(/\n/g,', ') +
            transfer.getTransferIdTag()
        );
    };

    transfer.clearFiles = function (filesArray) {
        if (typeof filesArray === 'undefined' || Array.isArray(filesArray) === false || filesArray.length === 0) {
            return;
        }

        try {
            transfer.removeFromFilesProperty(filesArray);
            transfer.removeFromCompleteFileData(filesArray);
            transfer.sendFilesRemovedMessage(filesArray);

            //send an event to the client
            if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                transfer.basicEventsSubscribedCallback(transfer,
                                                       Signiant.Mst.filesDeletedEvent,
                                                       Signiant.Mst.messagesMap.getMessage('signiant.transfer.event.filesDeleted'),
                                                       filesArray);
            }

            if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.filesDeletedEvent] === 'function') {
                transfer.advancedEventCallbacksMap[Signiant.Mst.filesDeletedEvent](transfer, filesArray);
            }

        } catch (e) {
            Signiant.Mst.error('Clear-Files: Failed to clear specified files, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToClearFiles');
        }
    };

    transfer.clearAllFiles = function () {
        transfer.clearFiles(transfer.getFiles());
    };

    transfer.chooseUploadFiles = function (callback) {
        try {

            // register for file select event with handleuploadfileschosen
            Signiant.Mst.signiantMessageChannel.setEventHandler(
                transfer.getMessagingIdentifier(),
                'fileselect',
                transfer.handleUploadFilesChosen
            );

            transfer.filesSelectedCallback = callback;
            transfer.sendMessageRequest(
                'openfileselect',
                null,
                null
            );
        } catch (e) {
            Signiant.Mst.error('chooseUploadFiles: Failed to choose upload file, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToChooseUploadFiles');
        }
    };

    transfer.handleUploadFilesChosen = function (event) {
        try {
            var prevLength = transfer.completeFileList.length;

            transfer.addToCompleteFileData(event.filelist);
            var currentFiles = transfer.completeFileList;

            if (typeof currentFiles !== 'undefined' && currentFiles!== null && currentFiles.length > 0) {

                if (currentFiles.length > Signiant.Mst.maxNumberFiles) {
                    Signiant.Mst.error('Too many upload files chosen (' + currentFiles.length + '), maximum = ' + Signiant.Mst.maxNumberFiles + transfer.getTransferIdTag());
                    transfer.completeFileList.splice(prevLength, currentFiles.length);
                    transfer.handleTooManyFilesChosen();
                } else {
                    var filenames = [];
                    for (var i = 0; i < currentFiles.length; i++) {
                        filenames.push(currentFiles[i].name);
                    }
                    var filelist = JSON.stringify(filenames);

                    Signiant.Mst.log(
                        'uploadFilesChosen: ' + filelist.substr(0,240) + ((filelist.length > 240) ? '...' : '') +
                        transfer.getTransferIdTag()
                    );

                    if (typeof transfer.filesSelectedCallback === 'function') {
                        transfer.filesSelectedCallback(Signiant.Mst.uploadFilesChosenEvent, currentFiles, transfer);
                    }

                    if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.uploadFilesChosenEventName] === 'function') {
                        transfer.advancedEventCallbacksMap[Signiant.Mst.uploadFilesChosenEventName](transfer, currentFiles);
                    }
                }
            } else {
                if (event.resultCode === 'fail') {
                    Signiant.Mst.error('uploadFilesChosen failed for:' + transfer.getTransferIdTag() + 'error: ' + JSON.stringify(event.error));
                } else {
                    Signiant.Mst.log('uploadFilesChosen: no files chosen or file dialog cancelled' + transfer.getTransferIdTag());
                }

                if (typeof transfer.filesSelectedCallback === 'function') {
                    transfer.filesSelectedCallback(Signiant.Mst.noFilesChosenEventName, [], transfer);
                }
                if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.noFilesChosenEventName] === 'function') {
                    transfer.advancedEventCallbacksMap[Signiant.Mst.noFilesChosenEventName](transfer, '[]');
                }
            }
        } catch (e) {
            Signiant.Mst.error('Upload-Files-Chosen: Failed to set chosen upload files, FAILURE: ' + e + transfer.getTransferIdTag());
        }
    };

    transfer.openAppDropZone = function (callback) {
        if (typeof callback !== 'function') {
            throw Signiant.Mst.messagesMap.getMessageForTransport(
                'signiant.transfer.error.undefinedFileSelectCallback'
            );
        }
        Signiant.Mst.signiantMessageChannel.setEventHandler(
            transfer.getMessagingIdentifier(),
            'fileselect',
            transfer.handleUploadFilesChosen
        );

        transfer.filesSelectedCallback = callback;

        transfer.sendMessageRequest(
            'opendragbubble',
            null,
            null
        );
    };

    transfer.openAppDropZoneWithSelectFiles = function (callback) {
        if (typeof callback !== 'function') {
            throw Signiant.Mst.messagesMap.getMessageForTransport(
                'signiant.transfer.error.undefinedFileSelectCallback'
            );
        }
        Signiant.Mst.signiantMessageChannel.setEventHandler(
            transfer.getMessagingIdentifier(),
            'fileselect',
            transfer.handleUploadFilesChosen
        );

        transfer.filesSelectedCallback = callback;

        transfer.sendMessageRequest(
            'openfileselectbubble',
            null,
            null
        );
    };

    transfer.setServerSideEncryption = function (value) {
        Signiant.Mst.log('Server side encryption: ' + value);
        if (value === true) {
            value = 'yes';
        } else {
            value = 'no';
        }
        transfer.setProperty(Signiant.Mst.Transfer.serverSideEncryption, value);
    };

    transfer.getServerSideEncryption = function () {
        return ('yes' === transfer.getProperty(Signiant.Mst.Transfer.serverSideEncryption));
    };

    transfer.getFileSize = function (fileList, requestCallback) {
        if (typeof requestCallback === 'function') {
            if (typeof fileList !== 'undefined' && Array.isArray(fileList) && fileList.length > 0) {
                var content = new Object();
                content.filelist = fileList;

                Signiant.Mst.signiantMessageChannel.sendMessageRequest(
                    Signiant.Mst.getUUID(),
                    'getfilesize',
                    requestCallback,
                    content
                );
            }
        } else {
            Signiant.Mst.warn('Get-File-Size callback function is not valid');
            throw 'Please provide a valid callback function';
        }
    };

    return transfer;
};

Signiant.Mst.Download = function () {
    var transfer = new Signiant.Mst.Transfer();

    transfer.transferType = Signiant.Mst.TransferType.Download;
    transfer.downloadFolderSelectedCallback;

    transfer.startDownload = function () {

        try {
            if (!transfer.isTransferIdle()) {
                throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.transferAlreadyStarted');
            }

            transfer.validateApiKeyPresent();
            transfer.validateDestinationDir();
            transfer.validateDownloadFiles(transfer.getFiles());
            transfer.validateFileEncryptionConfig();
            transfer.validateProcessManifestEndpoint(transfer.getProcessManifestEndpoint());

            transfer.resetLastError();
            transfer.transferProperties[Signiant.Mst.Transfer.modePropName] = 'RECEIVE';
            transfer.subscribeForTransferEvents();
            transfer.setMessagingProvider();
            transfer.sendMessageRequest(
                'download',
                transfer.handleTransferRequestResponse,
                transfer.getTransferProperties()
            );
        } catch (e) {
            Signiant.Mst.error('Start-Download: Failed to start download, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToDownload');
        }
        transfer.currentTransferState = Signiant.Mst.transferState.START_PENDING;
    };

    transfer.subscribeDownloadFilesChosenEvent = function (callback) {
        transfer.filesSelectedCallback = callback;
    };

    transfer.validateDownloadFiles = function (fileNameArray) {
        if (typeof fileNameArray === 'undefined' || fileNameArray.length === 0) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.specifyFileToDownload');
        }

        if (fileNameArray.length > Signiant.Mst.maxNumberFiles) {
            transfer.handleTooManyFilesChosen();
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.tooManyFiles');
        }
    };

    transfer.setFilesToDownload = function (fileNameArray) {
        transfer.setFiles(fileNameArray);
        Signiant.Mst.log('Set-Files-To-Download: ' +
                         transfer.getProperty(Signiant.Mst.Transfer.filesPropName).replace(/\n/g,', ') +
                         transfer.getTransferIdTag()
        );
        if (typeof transfer.filesSelectedCallback === 'function') {
            transfer.filesSelectedCallback(Signiant.Mst.downloadFilesChosenEvent, transfer);
        }

    };

    transfer.setDownloadFolder = function (folder) {
        transfer.setDestinationDir(folder);
    };

    transfer.clearAllFiles = function () {
        try {
            transfer.deleteFilesProperty();
        } catch (e) {
            Signiant.Mst.error('Clear-All-Files: Failed to clear all files, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToClearAllFiles');
        }
    };

    transfer.clearFiles = function (filesArray) {
        if (typeof filesArray === 'undefined' || Array.isArray(filesArray) === false || filesArray.length === 0) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.undefinedListOfFilesToClear');
        }

        try {
            transfer.removeFromFilesProperty(filesArray);
        } catch (e) {
            Signiant.Mst.error('Clear-Files: Failed to clear specified files, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToClearFiles');
        }
    };

    transfer.chooseDownloadFolder = function (callback) {
        try {
            // register for folder select event with handleDownloadFolderChosen
            Signiant.Mst.signiantMessageChannel.setEventHandler(
                transfer.getMessagingIdentifier(),
                'folderselect',
                transfer.handleDownloadFolderChosen
            );

            transfer.downloadFolderSelectedCallback = callback;
            transfer.sendMessageRequest(
                'openfolderselect',
                null,
                null
            );
        } catch (e) {
            Signiant.Mst.error('Choose-Download-Folder: Failed to choose folder, FAILURE: ' + e + transfer.getTransferIdTag());
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToChooseFolder');
        }
    };

    transfer.handleDownloadFolderChosen = function (event) {
        try {
            var folderArray = event.folderlist;
            if (typeof folderArray !== 'undefined' && folderArray !== null && folderArray.length > 0) {
                Signiant.Mst.log('downloadFolderChosen: ' + folderArray[0].path + transfer.getTransferIdTag());
                if (typeof transfer.downloadFolderSelectedCallback === 'function') {
                    transfer.downloadFolderSelectedCallback(Signiant.Mst.downloadFolderChosenEvent, folderArray[0].path,
                                                            transfer
                    );
                }
                if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.downloadDestinationChosenEventName] === 'function') {
                    transfer.advancedEventCallbacksMap[Signiant.Mst.downloadDestinationChosenEventName](transfer,
                                                                                                        folderArray[0].path
                    );
                }
            } else {
                if (event.resultCode === 'fail') {
                    Signiant.Mst.error('downloadFolderChosen failed for:' + transfer.getTransferIdTag() + 'error: ' + JSON.stringify(event.error));
                } else {
                    Signiant.Mst.info('downloadFolderChosen: no folders chosen or file dialog cancelled' + transfer.getTransferIdTag());
                }

                if (typeof transfer.downloadFolderSelectedCallback === 'function') {
                    transfer.downloadFolderSelectedCallback(Signiant.Mst.downloadFolderChosenEvent, '', transfer);
                }
                if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.downloadDestinationChosenEventName] === 'function') {
                    transfer.advancedEventCallbacksMap[Signiant.Mst.downloadDestinationChosenEventName](transfer, '');
                }
            }
        } catch (e) {
            Signiant.Mst.error('Download-Folder-Chosen: Failed to set chosen download folder, FAILURE: ' + e + transfer.getTransferIdTag());
        }
    };

    transfer.setFilePathHandlingMode = function (mode) {
        if (typeof mode === 'undefined' || mode.length === 0) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidFilePathHandlingMode');
        }
        if (mode !== Signiant.Mst.Transfer.filePathModeFlat && mode !== Signiant.Mst.Transfer.filePathModePath &&
            mode !== Signiant.Mst.Transfer.filePathModeFull) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidFilePathHandlingMode');
        }
        transfer.setProperty(Signiant.Mst.Transfer.filePathHandlingModePropName, mode);
        Signiant.Mst.log('Set-Dir-Handling-Mode: ' +
            transfer.getProperty(Signiant.Mst.Transfer.filePathHandlingModePropName) +
            + transfer.getTransferIdTag()
        );
    };

    transfer.getFilePathHandlingMode = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.filePathHandlingModePropName);
    };

    transfer.setFileCollisionHandlingMode = function (mode) {
        if (typeof mode === 'undefined' || mode.length === 0) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidFileCollisionHandling');
        }
        if (mode !== Signiant.Mst.Transfer.fileCollisionModeVersion &&
            mode !== Signiant.Mst.Transfer.fileCollisionModeOverwrite) {
            throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidFileCollisionHandling');
        }
        transfer.setProperty(Signiant.Mst.Transfer.fileCollisionHandlingPropName, mode);
        Signiant.Mst.log('Set-File-Collision-Handling: ' +
            transfer.getProperty(Signiant.Mst.Transfer.fileCollisionHandlingPropName) +
            transfer.getTransferIdTag()
        );
    };

    transfer.getFileCollisionHandlingMode = function () {
        return transfer.getProperty(Signiant.Mst.Transfer.fileCollisionHandlingPropName);
    };

    return transfer;
};
;Signiant.Mst.App = {};

Signiant.Mst.App.Registration = function (channelObject) {
    this.channelStr = (new Signiant.Mst.Base64()).base64Encode(JSON.stringify(channelObject));
    this.successCallback = void 0;
    this.failureCallback = void 0;
};

Signiant.Mst.App.Registration.prototype.setSuccessCallback = function (callback) {
    this.successCallback = callback;
};

Signiant.Mst.App.Registration.prototype.setFailureCallback = function (callback) {
    this.failureCallback = callback;
};

Signiant.Mst.App.Registration.prototype.initApp = function () {
    var iframe = document.createElement('iframe');
    iframe.id = 'iframeID-' + Signiant.Mst.getUUID();
    iframe.style.display = 'none';
    var protocolHandler = 'sigclient://msg=' + this.channelStr;
    if (Signiant.Mst.Environment.isSafari()){
        initAppSafari(iframe, protocolHandler);
    } else {
        initAppNonSafari(iframe, protocolHandler);
    }
};

function initAppSafari (iframe, protocolHandler) {
    //Temporary fix for Safari 10 not liking the way we launch the app with non-urlencoded protocol handler string
    document.body.appendChild(iframe);
    var doc = iframe.contentWindow.document;
    doc.open();
    doc.write('<a id="app_link" href="' + protocolHandler + '"></a>');
    doc.close();
    var link = doc.getElementById('app_link');
    link.click();
}

function initAppNonSafari (iframe, protocolHandler) {
    iframe.src = protocolHandler;
    document.body.appendChild(iframe);
}

Signiant.Mst.App.Registration.prototype.onSuccess = function (object) {
    if (typeof this.successCallback !== 'undefined') {
        this.successCallback(object);
    }
};

Signiant.Mst.App.Registration.prototype.onFailure = function (object) {
    if (typeof this.failureCallback !== 'undefined') {
        this.failureCallback(object);
    }
};

Signiant.Mst.App.getDownloadLinks = function (success, failure) {
    return new Promise(function (resolve, reject) {
        Signiant.Mst.App.fetchAppInfo()
            .then(function (appInfo) {
                var appInfoJSON = Signiant.Mst.App.convertAppInfoToJSON(appInfo);
                var downloadLinks = Signiant.Mst.App.buildDownloadLinks(appInfoJSON);
                if (typeof success === 'function') {
                    success(downloadLinks);
                }
                resolve(downloadLinks);
            })
            .catch(
                function (reason) {
                    if (typeof failure === 'function') {
                        failure(reason);
                    }
                    reject(reason);
                }
            );
    });
};

Signiant.Mst.App.convertAppInfoToJSON = function (appInfo) {
    var elementNodeType = 1;
    var result = {};
    
    var parser = new DOMParser();
    var doc = parser.parseFromString(appInfo, 'application/xml');
    var parent = doc.getElementsByTagName('signiant-app')[0];
    
    for (var i = 0; i < parent.childNodes.length; i++) {
        var childNode = parent.childNodes[i];
        if (childNode.nodeType === elementNodeType) {
            //element type
            var osName = childNode.nodeName;
            var properties = {};
            for (var j = 0; j < childNode.childNodes.length; j++) {
                var subChildNode = childNode.childNodes[j];
                if (subChildNode.nodeType === elementNodeType) {
                    var propertyName = subChildNode.nodeName;
                    var propertyValue = subChildNode.firstChild.data.trim();
                    properties[propertyName] = propertyValue;
                }
            }
            result[osName] = properties;
        }
    }
    
    return result;
};

Signiant.Mst.App.getPlatformAppInfoUrl = function () {
    var family = Signiant.Mst.Environment.getOSFamily();

    if (family === Signiant.Mst.Environment.Family.Windows) {
        return Signiant.Mst.configuration.appInfoBaseUrl + Signiant.Mst.configuration.windowsAppInfoFile;
    } else if (family === Signiant.Mst.Environment.Family.OSX) {
        return Signiant.Mst.configuration.appInfoBaseUrl + Signiant.Mst.configuration.osxAppInfoFile;
    } else { // default to Windows for now
        return Signiant.Mst.configuration.appInfoBaseUrl + Signiant.Mst.configuration.windowsAppInfoFile;
    }
};

Signiant.Mst.App.fetchAppInfo = function () {
    return new Promise(function (resolve, reject) {
        var httpRequest = new Signiant.Mst.HttpsRequest().getXmlHttpRequest(Signiant.Mst.App.getPlatformAppInfoUrl());
        httpRequest.GETRequest(resolve, reject);
    });
};

Signiant.Mst.App.buildDownloadLinks = function (appInfoJSON) {
    var appUpdateBaseUrl = Signiant.Mst.configuration.appUpdateBaseUrl;
    var buildUrlFromAppInfo = function (appInfo) {
        return appUpdateBaseUrl + appInfo.location + '/' + appInfo.file;
    };

    var osFamily = Signiant.Mst.Environment.getOSFamily();
    if (typeof appInfoJSON[osFamily] === 'undefined') {
        osFamily = Signiant.Mst.Environment.Family.Windows;
    }

    var recommended = {
        os: osFamily,
        url: buildUrlFromAppInfo(appInfoJSON[osFamily]),
        md5: appInfoJSON[osFamily].md5,
        version: appInfoJSON[osFamily].version
    };

    var all = {};
    Object.keys(appInfoJSON).forEach(function (os) {
        all[os] = {
            url: buildUrlFromAppInfo(appInfoJSON[os]),
            md5: appInfoJSON[os].md5
        };
    });

    return {
        recommended: recommended,
        all: all
    };
};

Signiant.Mst.App.unknownVersion = '1.0';
Signiant.Mst.App.Configuration = {
    appVersion: Signiant.Mst.App.unknownVersion,
    appApiVersion: Signiant.Mst.App.unknownVersion,
    messageEncoding: Signiant.Mst.defaultMessageEncoding,
    messageEncryption: void 0
};

Signiant.Mst.App.setConfiguration = function (appData) {
    if (appData !== null && typeof appData === 'object') {
        Signiant.Mst.log('Received App configuration: ' + JSON.stringify(appData));

        if (typeof appData.app_version === 'string') {
            Signiant.Mst.App.Configuration.appVersion = appData.app_version;
        }

        if (typeof appData.app_api_version === 'string') {
            Signiant.Mst.App.Configuration.appApiVersion = appData.app_api_version;
        }

    } else {
        Signiant.Mst.log('No App configuration received, using default');
    }
};

Signiant.Mst.App.Capability = {};
Signiant.Mst.App.Capability.dragAndDropCapability = 'dragAndDropCapability';
Signiant.Mst.App.Capability.openFolderCapability = 'openFolderCapability';
Signiant.Mst.App.Capability.triggerAppUpgradeCapability = 'triggerAppUpgradeCapability';
Signiant.Mst.App.Capability.transferManifestCapability = 'transferManifestCapability';

Signiant.Mst.App.CapabilitySupport = {
    dragAndDropCapability: [
        { osFamily: Signiant.Mst.Environment.Family.Windows, apiVersion: '>=1.0' },
        { osFamily: Signiant.Mst.Environment.Family.OSX, apiVersion: '>=1.1' }
    ],
    openFolderCapability: [
        {osFamily: Signiant.Mst.Environment.Family.Windows, apiVersion: '>=1.4' },
        {osFamily: Signiant.Mst.Environment.Family.OSX, apiVersion: '>=1.4' }
    ],
    triggerAppUpgradeCapability: [
        {osFamily: Signiant.Mst.Environment.Family.Windows, apiVersion: '>=1.5' },
        {osFamily: Signiant.Mst.Environment.Family.OSX, apiVersion: '>=1.5' }
    ],
    transferManifestCapability: [
        {osFamily: Signiant.Mst.Environment.Family.Windows, apiVersion: '>=1.6' },
        {osFamily: Signiant.Mst.Environment.Family.OSX, apiVersion: '>=1.6' }
    ]
};

Signiant.Mst.App.supportsCapability = function (capability) {
    var appConfig = Signiant.Mst.App.Configuration,
        osFamily = Signiant.Mst.Environment.getOSFamily(),
        capabilitySupport = Signiant.Mst.App.CapabilitySupport[capability],
        requiredApiVersion;

    if (typeof capabilitySupport === 'undefined') {
        return false;
    }

    for (var i = 0; i < capabilitySupport.length; i++) {
        if (osFamily === capabilitySupport[i].osFamily) {
            requiredApiVersion = capabilitySupport[i].apiVersion;
            break;
        }
    }

    return Signiant.Mst.App.verifyVersion(appConfig.appApiVersion, requiredApiVersion);
};

Signiant.Mst.App.supportsOpenFolderCapability = function () {
    return Signiant.Mst.App.supportsCapability(Signiant.Mst.App.Capability.openFolderCapability);
};

Signiant.Mst.App.supportsTriggerAppUpgradeCapability = function (){
    return Signiant.Mst.App.supportsCapability(Signiant.Mst.App.Capability.triggerAppUpgradeCapability);
};

Signiant.Mst.App.verifyVersion = function (version, range) {
    // semver-ify the version by ensuring it meets the minimum MAJOR.MINOR.PATCH format (1.0 => 1.0.0)
    var delim = '.',
        v = version.split(delim);

    if (v.length < 3) {
        for (var i = 3 - v.length; i > 0; i--) {
            v.push('0');
        }

        version = v.join(delim);
    }
    // eslint-disable-next-line no-undef
    return semver.satisfies(version, range);
};

Signiant.Mst.App.isDragAndDropSupported = function (userAgent) {
    if (!Signiant.Mst.App.supportsCapability(Signiant.Mst.App.Capability.dragAndDropCapability)
        || isOSXVersionLessThan1010(userAgent)) {
        return false;
    }
    return true;
};

Signiant.Mst.App.triggerAppUpgrade = function (requestCallback) {

    Signiant.Mst.signiantMessageChannel.sendMessageRequest(
        Signiant.Mst.getUUID(),
        'triggerappupgrade',
        function () {
            if (typeof requestCallback === 'function') {
                requestCallback();
            }
        },
        null
    );
};

Signiant.Mst.App.isTransferManifestSupported = function () {
    return Signiant.Mst.App.supportsCapability(Signiant.Mst.App.Capability.transferManifestCapability);
};

function isOSXVersionLessThan1010 (userAgent) {
    var reg = new RegExp('.*macintosh.*mac os x 10[._][8-9].*$');
    var result = userAgent.toLowerCase().match(reg);
    return (result !== null);
}


;Signiant.Mst.GoogleAnalytics = function (ga) {
    this.ga = ga;
    this.timingMap = {};
    this.MAX_TIME_IN_MS = 1 * 60 * 1000;
    this.initialize();
};

Signiant.Mst.GoogleAnalytics.Constants = {
    Category : {
        appDetection : 'AppDetection',
        transfers : 'Transfers',
        transferApi : 'TransferApi'
    },
    Action : {
        sendInteractiveRequest : 'send-interactive-request',
        receiveInteractiveResponse : 'receive-interactive-response',
        responseTimeOut : 'interactive-response-timeout',
        transferConnectionTime : 'transfer-connection-time',
        interactiveSessionResponse : 'interactive-session-response',
        messageChannelConfig : 'message-channel-config',
        pubnubToWebsocketSwitchApp : 'pubnub-to-websocket-switch-app',
        pubnubConnectionApp : 'pubnub-connection-app'
    },
    Label : {
        defaultEmptyLabel : 'none',
        roundTrip : 'round-trip'
    },
    Dimension : {
        TransferAPI : 'dimension1',
        TransferApiMajorVersion : 'dimension2',
        PortalType : 'dimension3',
        InstalledSoftwareVersion : 'dimension5'
    },
    DimensionValue: {
        defaultEmptyVersion: 'unknown'
    }
};


Signiant.Mst.GoogleAnalytics.prototype.initialize = function () {
    var dimensions = {};
    dimensions[Signiant.Mst.GoogleAnalytics.Constants.Dimension.TransferAPI] = Signiant.Mst.apiVersion;
    dimensions[Signiant.Mst.GoogleAnalytics.Constants.Dimension.TransferApiMajorVersion] =
        Signiant.Mst.apiVersion.split('.')[0];
    this.setDimensions(dimensions);
};

Signiant.Mst.GoogleAnalytics.prototype.setDimensions = function (object) {
    if (typeof object === 'undefined') {
        return;
    }
    this.send('set', object);
};

Signiant.Mst.GoogleAnalytics.prototype.sendEvent = function (category, action, label, value) {
    var options = {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: Signiant.Mst.GoogleAnalytics.Constants.Label.defaultEmptyLabel
    };

    if (typeof label !== 'undefined') {
        options.eventLabel = label;
    }

    if (typeof value !== 'undefined') {
        options.eventValue = value;
    }

    this.send('send', options);
};

Signiant.Mst.GoogleAnalytics.prototype.startTimer = function (category, action, label) {
    if (typeof this.ga === 'undefined' || typeof category === 'undefined' || typeof action === 'undefined') {
        return;
    }
    if (typeof this.timingMap[category] === 'undefined') {
        this.timingMap[category] = {};
    }

    var timingData = { startTime: this.getCurrentTime(),
        label : (typeof label === 'undefined') ? Signiant.Mst.GoogleAnalytics.Constants.Label.defaultEmptyLabel : label};

    this.timingMap[category][action] = timingData;
};

Signiant.Mst.GoogleAnalytics.prototype.endTimer = function (category, action, maxTimeInMs) {
    var time = this.getTimingData(category, action, maxTimeInMs);
    if (typeof time !== 'undefined') {
        this.sendEvent(category, action, this.timingMap[category][action].label);
        var timingData = {
            hitType: 'timing',
            timingCategory: category,
            timingVar: action,
            timingLabel : this.timingMap[category][action].label,
            timingValue: time
        };

        this.send('send', timingData);
        this.timingMap[category][action] = null;
    }
};

Signiant.Mst.GoogleAnalytics.prototype.getCurrentTime = function () {
    return (new Date()).getTime();
};

Signiant.Mst.GoogleAnalytics.prototype.getTimingData = function (category, action, maxTimeInMs) {
    if (typeof this.timingMap[category] === 'undefined'
        || typeof this.timingMap[category][action] === 'undefined'
        || this.timingMap[category][action] === null) {
        return;
    }

    var time = this.getCurrentTime() - this.timingMap[category][action].startTime;
    var maxTime = (typeof maxTimeInMs !== 'undefined') ? maxTimeInMs : this.MAX_TIME_IN_MS;
    return (time <= maxTime) ? time : maxTime;
};

Signiant.Mst.GoogleAnalytics.prototype.send = function (type, option, value) {
    if (typeof this.ga !== 'undefined') {
        this.ga(type, option, value);
    }
};

Signiant.Mst.GoogleAnalytics.prototype.updateAnalyticsAppVersion = function () {
    var version = Signiant.Mst.GoogleAnalytics.Constants.DimensionValue.defaultEmptyVersion;
    if (Signiant.Mst.App.Configuration.appVersion !== Signiant.Mst.App.unknownVersion) {
        version = Signiant.Mst.App.Configuration.appVersion;
    }
    this.send('set', Signiant.Mst.GoogleAnalytics.Constants.Dimension.InstalledSoftwareVersion, version);
};
;Signiant.Mst.Base64 = function () {
    this.keyChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
};

// local function; no need to expose
Signiant.Mst.Base64.prototype.isBase64Char = function (candidateChar) {
    var isBase64 = false;
    if (typeof candidateChar !== 'undefined' && candidateChar.length === 1) {
        var charAsciiCode = candidateChar.charCodeAt(0);
        // 0-9, a-z, A-Z, +, / and = are valid characters in Base64 encoding
        if (charAsciiCode === 43 // + sign
            || charAsciiCode === 47  // forward slash (/)
            || charAsciiCode === 61  // = sign
            || (charAsciiCode >= 48 && charAsciiCode <= 57)   // 0-9
            || (charAsciiCode >= 65 && charAsciiCode <= 90)   // A-Z
            || (charAsciiCode >= 97 && charAsciiCode <= 122)  // a-z
        ) {
            isBase64 = true;
        }
    }
    return isBase64;
};

Signiant.Mst.Base64.prototype.base64Encode = function (input) {
    var output = '';
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    var keyChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var encodedInput = this.encode_utf8(input);
    
    while (i < encodedInput.length) {
        
        chr1 = encodedInput.charCodeAt(i++);
        chr2 = encodedInput.charCodeAt(i++);
        chr3 = encodedInput.charCodeAt(i++);
        
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output = output + keyChar.charAt(enc1) + keyChar.charAt(enc2) + keyChar.charAt(enc3) + keyChar.charAt(enc4);
        
    }
    return output;
};

Signiant.Mst.Base64.prototype.base64Decode = function (input) {
    var output = '';
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
    
    while (i < input.length) {
        enc1 = this.keyChar.indexOf(input.charAt(i++));
        enc2 = this.keyChar.indexOf(input.charAt(i++));
        enc3 = this.keyChar.indexOf(input.charAt(i++));
        enc4 = this.keyChar.indexOf(input.charAt(i++));
        
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        
        output = output + String.fromCharCode(chr1);
        
        if (enc3 !== 64) {
            output = output + String.fromCharCode(chr2);
        }
        if (enc4 !== 64) {
            output = output + String.fromCharCode(chr3);
        }
    }
    output = this.decode_utf8(output);
    return output;
};

Signiant.Mst.Base64.prototype.encode_utf8 = function (string) {
    string = string.replace(/\r\n/g, '\n');
    var utftext = '';
    
    for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        
        if (c < 128) {
            utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
        }  else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
        }
    }
    return utftext;
};

Signiant.Mst.Base64.prototype.decode_utf8 = function (utftext) {
    var string = '';
    var i = 0;
    var c,
        c2,
        c3;
    
    while (i < utftext.length) {
        
        c = utftext.charCodeAt(i);
        
        if (c < 128) {
            string += String.fromCharCode(c);
            i++;
        } else if ((c > 191) && (c < 224)) {
            c2 = utftext.charCodeAt(i + 1);
            string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
            i += 2;
        } else {
            c2 = utftext.charCodeAt(i + 1);
            c3 = utftext.charCodeAt(i + 2);
            string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
            i += 3;
        }
        
    }
    
    return string;
};;Signiant.Mst.connectivity = (function () {
    var timeout = null,
        errorCallbackHasBeenCalled = false;
    
    
    var networkConnectivityErrorCallback = function () {
        if (errorCallbackHasBeenCalled === false && Signiant.Mst.configuration.networkConnectivityErrorCallback) {
            Signiant.Mst.configuration.networkConnectivityErrorCallback();
            errorCallbackHasBeenCalled = true;
        }
    };

    var offlineEventHandler = function () {
        if (timeout === null) {
            timeout = setTimeout(
                networkConnectivityErrorCallback,
                Signiant.Mst.configuration.networkConnectivityTimeoutInMs
            );
        }
    };

    var onlineEventHandler = function () {
        clearTimeout(timeout);
        timeout = null;

        if (errorCallbackHasBeenCalled === true) {
            errorCallbackHasBeenCalled = false;
            Signiant.Mst.configuration.networkConnectivityRestoredCallback();
        }
    };

    var beforeUnloadEventHandler = function () {
        if (Signiant.Mst.signiantMessageChannel) {
            Signiant.Mst.signiantMessageChannel.reset();
        }
    };

    document.addEventListener('offline', offlineEventHandler);
    document.addEventListener('online', onlineEventHandler);
    document.addEventListener('beforeunload', beforeUnloadEventHandler);

    window.addEventListener('offline', offlineEventHandler);
    window.addEventListener('online', onlineEventHandler);
    window.addEventListener('beforeunload', beforeUnloadEventHandler);

    return {
        defaultNetworkConnectivityTimeoutInMs:10000,
        defaultNetworkConnectivityErrorCallback: function () {
            Signiant.Mst.warn('Network appears to be down');
            alert(Signiant.Mst.messagesMap.getMessageForTransport('signiant.error.app.networkConnectivityError'));
        },
        defaultNetworkConnectivityRestoredCallback: function () {
            Signiant.Mst.log('Network connection has been restored');
        },
        networkConnectivityErrorCallback: networkConnectivityErrorCallback
    };
})();
;
Signiant.Mst.getMessageChannelFactory = function (providerInfo) {
    function isSingleChannel (providerInfo) {
        return typeof providerInfo.channel !== 'undefined';
    }

    var factory;
    if (isSingleChannel(providerInfo)) {
        factory = new Signiant.Mst.SingleChannelProviderFactory();
    } else {
        var eInfo = Signiant.Mst.generateEncryptionInfo();
        factory = new Signiant.Mst.DualChannelProviderFactory({ encryptionInfo: eInfo});
    }
    return factory;
};

Signiant.Mst.fetchMessageChannelProvider = function (messageServiceUrl) {
    if (typeof Signiant.Mst.signiantMessageChannel !== 'undefined') {
        Signiant.Mst.signiantMessageChannel.reset();
    }

    if (!messageServiceUrl) {
        var pubChannel = Signiant.Mst.getUUID();
        var subChannel = Signiant.Mst.getUUID();
        messageServiceUrl = Signiant.Mst.configuration.messageServiceUrl
            + '/channel?pubname=' + pubChannel + '&subname=' + subChannel + '&apiversion=' + Signiant.Mst.apiVersion;
    }

    return new Promise(function (resolve, reject) {
        var httpRequest = new Signiant.Mst.HttpsRequest();

        var req = httpRequest.getXmlHttpRequest(messageServiceUrl);
        req.GETRequest(function (providerInfo) {
            Signiant.Mst.debug('Response from message service: ', JSON.stringify(providerInfo));

            var factory = Signiant.Mst.getMessageChannelFactory(providerInfo);
            if (factory) {
                var provider = factory.getProvider(providerInfo);
                resolve(provider);
            } else {
                reject(new Error('Could not get valid provider info from url: ' + messageServiceUrl));
            }

        }, function (errorCode, statusText, responseText) {
            var errorBody;
            try {
                var errorContent = JSON.parse(responseText);
                errorBody = errorContent.error;
            } catch (exception) {
                //no-op?
            }
            var errorMessage = 'status: ' + statusText;
            if (errorBody) {
                errorMessage += ' , ' + errorBody;
            }
            reject(errorMessage);
        });
    });
};

Signiant.Mst.initialize = function (success, failure, options) {
    if (typeof options === 'undefined') {
        options = {};
    }

    if (typeof options.timeout === 'undefined') {
        options.timeout = Signiant.Mst.defaultInitializeTimeoutInMs;
    }
    
    if (typeof options.withAppTimeout === 'undefined') {
        options.withAppTimeout = Signiant.Mst.defaultInitializeWithAppTimeoutInMs;
    }

    if (typeof options.failPreemptivelyIfAppNotInstalled === 'undefined') {
        options.failPreemptivelyIfAppNotInstalled = false;
    }

    if (typeof options.googleAnalytics !== 'undefined') {
        Signiant.Mst.googleAnalytics = new Signiant.Mst.GoogleAnalytics(options.googleAnalytics);
    }

    var appInstalledCookieValue = Signiant.Mst.cookieUtility.getCookieValue(Signiant.Mst.SigniantAppInstalledCookieKey);

    // If app does not appear to be installed and user wants to fail fast, do so
    if (appInstalledCookieValue === null && options.failPreemptivelyIfAppNotInstalled === true) {
        var failureReason = new Error('App does not appear to be installed yet');
        failure(failureReason);
        return;
    }

    // If app appears to have previously been installed, use withAppTimeout instead of timeout
    var errorTimeout = options.timeout;
    if (appInstalledCookieValue !== null) {
        errorTimeout = options.withAppTimeout;
    }

    //fetch dual channel
    Signiant.Mst.fetchMessageChannelProvider()
        .then(function (provider) {
            return Signiant.Mst.setupAppRegistrationOrTimeout(provider, errorTimeout);
        })
        .then(success, function (reason) {
            Signiant.Mst.error('Fatal Error: Failure to Initialize Messaging Service - ' + reason);
            failure(reason);
        });
};

Signiant.Mst.defaultAppCommunicationErrorCallback = function () {
    Signiant.Mst.warn('Received App connectivity error');
    alert(Signiant.Mst.messagesMap.getMessageForTransport('signiant.error.app.appConnectivityError'));
};

Signiant.Mst.configuration = {
    networkConnectivityErrorCallback: Signiant.Mst.connectivity.defaultNetworkConnectivityErrorCallback,
    networkConnectivityRestoredCallback: Signiant.Mst.connectivity.defaultNetworkConnectivityRestoredCallback,
    networkConnectivityTimeoutInMs: Signiant.Mst.connectivity.defaultNetworkConnectivityTimeoutInMs,
    appCommunicationErrorCallback: Signiant.Mst.defaultAppCommunicationErrorCallback,
    appInfoBaseUrl: Signiant.Mst.defaultAppInfoBaseUrl,
    windowsAppInfoFile: Signiant.Mst.defaultWindowsAppInfoFile,
    osxAppInfoFile: Signiant.Mst.defaultOsxAppInfoFile,
    appUpdateBaseUrl: Signiant.Mst.defaultAppUpdateBaseUrl,
    messageServiceUrl: Signiant.Mst.defaultMessageServiceUrl,
    messageLength: null,
    installWidgetCss: Signiant.Mst.defaultInstallWidgetCssUrl,
    dispatcherServiceUrl: Signiant.Mst.defaultDispatchServerurl
};

Signiant.Mst.configure = function (options) {
    Signiant.Mst.mergeObjects(options, Signiant.Mst.configuration);
};

Signiant.Mst.setupAppRegistrationOrTimeout = function (provider, errorTimeout) {
    return new Promise (function (resolve, reject) {
        var timeout = setTimeout(function () {
            reject('Did not receive startup message from Signiant App within ' + errorTimeout + ' ms');
        }, errorTimeout);

        Signiant.Mst.setupAppRegistration(provider)
            .then(function () {
                clearTimeout(timeout);
                resolve();
            });

    });
};

Signiant.Mst.sessionActive = function (appData) {
    Signiant.Mst.groupEnd();
    Signiant.Mst.log('Received Session Ready from App (via '+Signiant.Mst.signiantMessageChannel.getProviderInfo()+')');
    Signiant.Mst.App.setConfiguration(appData);
    Signiant.Mst.googleAnalytics.updateAnalyticsAppVersion();
    Signiant.Mst.googleAnalytics.endTimer(Signiant.Mst.GoogleAnalytics.Constants.Category.appDetection,
                                          Signiant.Mst.GoogleAnalytics.Constants.Action.receiveInteractiveResponse);
    Signiant.Mst.googleAnalytics.sendEvent(Signiant.Mst.GoogleAnalytics.Constants.Category.appDetection,
                                           Signiant.Mst.GoogleAnalytics.Constants.Action.interactiveSessionResponse,
                                           Signiant.Mst.signiantMessageChannel.getProviderInfo());
    Signiant.Mst.messageServiceReady = true;
    Signiant.Mst.cookieUtility.setCookie(Signiant.Mst.SigniantAppInstalledCookieKey, 'true', {}, true);
};

Signiant.Mst.getMessageChannel = function (provider) {
    Signiant.Mst.signiantMessageChannel = provider;
    Signiant.Mst.signiantMessageChannel.initialize();
    Signiant.Mst.log('Websocket Message Channel initialized');

    return provider;
};

Signiant.Mst.manipulateAppMessageSettings = function (original) {
    //have to do a deep copy otherwise original will be changed
    var object;
    try {
        object = JSON.parse(JSON.stringify(original));
        object.apiVersion = Signiant.Mst.apiVersion;
        object.pubchannel = original.subchannel;
        object.subchannel = original.pubchannel;
        if (typeof object.providers !== 'undefined' && Array.isArray(object.providers)) {
            object.providers.forEach(function (provider) {
                if (provider.pubchannel && provider.subchannel) {
                    var temp = provider.pubchannel;
                    provider.pubchannel = provider.subchannel;
                    provider.subchannel = temp;
                }
            });
        }
    } catch (e) {
        Signiant.Mst.error('Error parsing message channel settings');
        object = void 0;
    }
    return object;
};

Signiant.Mst.waitForActiveSession = function (provider) {
    return new Promise(function (resolve) {
        provider.setSessionActiveEventHandler(function (appData) {
            Signiant.Mst.sessionActive(appData);
            resolve(appData);
        });
    });
};

Signiant.Mst.setupAppRegistration = function (provider) {
    var channelParams = Signiant.Mst.manipulateAppMessageSettings(provider.getChannelParams());
    if (typeof channelParams !== 'undefined') {
        Signiant.Mst.log('Launching Signiant App');
        Signiant.Mst.googleAnalytics.startTimer(Signiant.Mst.GoogleAnalytics.Constants.Category.appDetection,
                                                Signiant.Mst.GoogleAnalytics.Constants.Action.receiveInteractiveResponse,
                                                Signiant.Mst.GoogleAnalytics.Constants.Label.roundTrip);
        var appRegister = new Signiant.Mst.App.Registration(channelParams);

        var p = Signiant.Mst.waitForActiveSession(provider);
        Signiant.Mst.getMessageChannel(provider);
        Signiant.Mst.log('PubNub Message Channel initialized');
        appRegister.initApp();
        return p;
    } else {
        return Promise.reject('Error launching app');
    }
};

Signiant.Mst.setMaxFiles = function (maxFiles) {
    var isValid = false;
    var errValue = maxFiles;
    if (typeof maxFiles === 'number') {
        if ((maxFiles % 1) === 0 && maxFiles > 0) {
            Signiant.Mst.log('Max number of files set to ' + maxFiles);
            Signiant.Mst.maxNumberFiles = maxFiles;
            isValid = true;
        }
    } else {
        errValue = '\"' + maxFiles + '\"';
    }
    if (isValid === false) {
        Signiant.Mst.warn('Value of max number of files is not a valid number: ' + errValue
                         + '. Using value: ' + Signiant.Mst.maxNumberFiles
        );
    }
};

;Signiant.Mst.cookieUtility =  (function () {
    var FAR_IN_FUTURE = 365 * 100 * 24 * 60 * 60 * 1000;

    var getDateInFarFuture = function () {
        var date = new Date();

        date.setTime(date.getTime() + FAR_IN_FUTURE);

        return date.toUTCString();
    };

    var constructCookieString = function (cookieKey, cookieValue, cookieOptions) {
        var cookie = '';
        cookie += cookieKey + '=' + cookieValue;

        if (cookieOptions.expiry !== '' && cookieOptions.expiry !== null) {
            var expireString = 'expires=' + cookieOptions.expiry;
            cookie += '; ' + expireString;
        }

        if (cookieOptions.domain !== '' && cookieOptions.domain !== null) {
            var domainString = 'domain=' + cookieOptions.domain;
            cookie += '; ' + domainString;
        }

        cookie += '; ' + 'path=/;';

        return cookie;
    };

    return {
        /*
            Putting 'force' as a flag for now. If more flags are required, change to an options object.
         */
        setCookie: function (cookieKey, cookieValue, cookieOptionsOverride, force) {
            if (typeof cookieKey === 'undefined' || typeof cookieValue === 'undefined') {
                throw new Error('Invalid cookie being set. cookieKey: ' + cookieKey + ' cookieValue: ' + cookieValue);
            }

            var cookieOptions = {
                expiry: getDateInFarFuture(),
                domain: Signiant.Mst.getCurrentDomain()
            };

            Signiant.Mst.mergeObjects(cookieOptionsOverride, cookieOptions);

            this.addCookieToDocumentCookie(constructCookieString(cookieKey, cookieValue, cookieOptions));

            // If the browser refused to set the cookie for the given domain,
            // force the cookie to be set domain-less
            if (force === true) {
                if (this.getCookieValue(cookieKey) === null) {
                    cookieOptions.domain = '';
                    this.addCookieToDocumentCookie(constructCookieString(cookieKey, cookieValue, cookieOptions));
                }
            }
        },

        addCookieToDocumentCookie: function (newCookieString) {
            document.cookie = newCookieString;
        },

        getCookieValue: function (cookieKey) {
            var cookies = document.cookie;
            cookies = cookies.replace(/; /g, ';');
            var individualCookies = cookies.split(';');

            for (var i = 0; i < individualCookies.length; i++) {
                var aCookie = individualCookies[i].split('=');
                if (aCookie[0] === cookieKey) {
                    return aCookie[1];
                }
            }
            return null;
        },

        deleteCookie: function (cookieKey) {
            document.cookie = cookieKey + '=; path=/; domain=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = cookieKey + '=; path=/; domain=' + Signiant.Mst.getCurrentDomain() +
                '; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
    };
})();;/**
 * The Signiant.Mst.NoSoftware namespace provides functionality for transferring files without installing the Signiant
 * App. The Upload and Download objects in this namespace can be used exactly the same way as the Upload and Download
 * objects of the regular (with App) Signiant.Mst namespace, e.g.
 *
 *    var upload;
 *    if (dontWantToUseSoftware) {
 *        upload = = new Signiant.Mst.NoSoftware.Upload();
 *    } else {
 *        upload = new Signiant.Mst.Upload();
 *    }
 *    upload.chooseUploadFiles(...);
 *    upload.startUpload();
 */
Signiant.Mst.NoSoftware = (function () {

    function ensureTransferStarted (transfer) {
        if (!transfer.started) {
            transfer.handleTransferStartedEvent();
            transfer.handlePreTransfer({
                protocol: 'http'
            });

            transfer.handleConnectionStatusChange({
                status: 'TRANSFERRING'
            });

            transfer.getFiles().forEach(function (file) {
                transfer.handlePreFileEvent({fileName : file});
            });

            transfer.started = true;
        }
    }

    function getTransferUrl (transfer) {
        return new Promise(function (resolve, reject) {
            var xmlHttp = new XMLHttpRequest();
            xmlHttp.open('POST', Signiant.Mst.configuration.dispatcherServiceUrl + '/transfer', true);

            xmlHttp.onreadystatechange = function () {
                if (xmlHttp.readyState === XMLHttpRequest.DONE) {
                    if (xmlHttp.status !== 200) {
                        reject(xmlHttp.responseText);
                    } else {
                        resolve(JSON.parse(xmlHttp.responseText).transferUrl);
                    }
                }
            };

            xmlHttp.setRequestHeader('Content-Type', 'application/json');
            xmlHttp.send(JSON.stringify({apiKey: transfer.getApiKey()}));
        });
    }

    function getMessageChannelProvider () {
        var channelName = Signiant.Mst.getUUID();
        var messagingServiceUrl = Signiant.Mst.configuration.messageServiceUrl
            + '/channel/noSoftwareTransferService/' + channelName;

        return  Signiant.Mst.fetchMessageChannelProvider(messagingServiceUrl)
            .catch(function () {
                Signiant.Mst.log(
                    'Failed to retrieve messaging provider credentials - will continue without UI events'
                );
                return new Signiant.Mst.NullChannel();
            });
    }

    return {
        Download: function () {
            var transfer = new Signiant.Mst.Download();
            transfer.transferType = Signiant.Mst.TransferType.Download;
            transfer.started = false;

            transfer.getMessagingIdentifier = function () {
                return transfer.getTransferId();
            };

            transfer.startDownload = function () {
                return Promise.all([getTransferUrl(transfer), getMessageChannelProvider()])
                    .then(function (values) {
                        transfer.started = false;

                        var transferUrl = values[0];

                        var msgChannel = values[1];
                        msgChannel.initialize(msgChannel.notifyMessage);

                        transfer.subscribeForTransferEvents(msgChannel);
                        return startDownload(
                            transfer.messageChannel,
                            transferUrl
                        );
                    }).catch(function (err) {
                        transfer.handleTransferFailure(err);
                    });
            };

            /**
             * No-op; taken care of by the browser. Just triggers the event that allows other flows to continue.
             * The folder name provided by the callback function will be "Browser Downloads Directory", regardless
             * of where the file is actually going to be downloaded.
             */
            transfer.chooseDownloadFolder = function (callback) {
                if (typeof callback === 'function') {
                    callback(Signiant.Mst.downloadFolderChosenEvent, 'Browser Downloads Directory', transfer);
                }

                var advancedCallback = transfer.advancedEventCallbacksMap[Signiant.Mst.downloadDestinationChosenEventName];
                if (typeof advancedCallback === 'function') {
                    advancedCallback(transfer, 'Browser Downloads Directory');
                }
            };

            var superHandleTransferProgress = transfer.handleTransferProgress.bind(transfer);
            transfer.handleTransferProgress = function (progressObject) {
                // trigger start event only after first progress event
                ensureTransferStarted(transfer);
                superHandleTransferProgress(progressObject);
            };

            var superPostTransfer = transfer.handlePostTransferEvent.bind(transfer);
            transfer.handlePostTransferEvent = function (completionEvent) {
                ensureTransferStarted(transfer);
                superPostTransfer(completionEvent);

                transfer.messageChannel.removeEventHandlers(transfer.getTransferId());
            };

            function startDownload (messageChannelProvider, transferUrl) {

                var queryString = buildQueryString(messageChannelProvider);
                var transferConfigUrl = transferUrl + '/file/transferConfig' + queryString;
                var downloadUrl = transferUrl + '/file' + queryString;

                return publishTransferConfig(transferConfigUrl)
                    .then(function () {
                        Signiant.Mst.setWindowLocation(downloadUrl);
                    });
            }

            function buildQueryString (messageChannelProvider) {
                var queryString = '?' +
                    'transferId=' + transfer.getTransferId() + '&' +
                    'apiKey=' + transfer.getApiKey();

                if (messageChannelProvider.getChannelParams() &&
                    messageChannelProvider.getChannelParams().channel &&
                    messageChannelProvider.getChannelParams().token) {
                    queryString += '&' +
                        'channelName=' + messageChannelProvider.getChannelParams().channel + '&' +
                        'channelToken=' + messageChannelProvider.getChannelParams().token;
                }

                return queryString;
            }

            function publishTransferConfig (transferUrl) {
                return new Promise(function (resolve, reject) {

                    var xmlhttp = new XMLHttpRequest();
                    xmlhttp.onreadystatechange = function () {
                        if (xmlhttp.readyState === XMLHttpRequest.DONE) {

                            if (xmlhttp.status === 200) {
                                resolve();
                            } else if (xmlhttp.status === 404){
                                reject(Signiant.Mst.transferFailureType.fileNotFound);
                            } else {
                                reject();
                            }
                        }
                    };

                    xmlhttp.open('POST', transferUrl, true);
                    xmlhttp.setRequestHeader('Content-type', 'application/json');
                    xmlhttp.send(JSON.stringify(transfer.getTransferProperties()));
                });
            }

            return transfer;
        },

        Upload: function () {
            var transfer = new Signiant.Mst.Upload();
            transfer.transferType = Signiant.Mst.TransferType.Upload;
            transfer.transferProperties[Signiant.Mst.Transfer.modePropName] = 'SEND';

            transfer.started = false;

            transfer.getMessagingIdentifier = function () {
                return transfer.getTransferId();
            };

            transfer.startUpload = function () {
                if (!transfer.fileHandles) {
                    throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.specifyFileToUpload');
                }

                transfer.validateApiKeyPresent();

                transfer.resetLastError();

                return Promise.all([getTransferUrl(transfer), getMessageChannelProvider()])
                    .then(function (values) {
                        var transferUrl = values[0];
                        var msgChannel = values[1];

                        msgChannel.initialize(msgChannel.notifyMessage);

                        transfer.started = false;

                        transfer.subscribeForTransferEvents(msgChannel);
                        ensureTransferStarted(transfer);

                        return startUpload(
                            this,
                            transferUrl,
                            transfer.messageChannel
                        );
                    }.bind(this))
                    .catch(function (err) {
                        transfer.handleTransferFailure(err);
                    });
            };

            var superCancel = transfer.cancel;
            transfer.cancel = function () {
                superCancel();

                if (transfer.rawRequest) {
                    transfer.rawRequest.abort();
                }
            };

            transfer.supportsNativeDragAndDrop = function () {
                return true;
            };

            transfer.getMaxFiles = function () {
                return 1;
            };

            /***
             * Allows the user to select a file for upload. Must be called from a user initiated click or
             * the browser will not open the file picker
             * @param callback
             */
            transfer.chooseUploadFiles = function (callback) {
                transfer.filesSelectedCallback = callback;

                var fileChooser = document.createElement('input');
                fileChooser.type = 'file';
                fileChooser.style.display = 'none';
                fileChooser.className = 'fileChooser ' + transfer.getTransferId();
                fileChooser.onchange = function () {
                    transfer.handleFilesChosen(this.files);
                };

                document.body.appendChild(fileChooser);
                fileChooser.click();
            };

            transfer.clearFiles = function (filesArray) {
                if (typeof filesArray === 'undefined' || Array.isArray(filesArray) === false || filesArray.length === 0) {
                    return;
                }

                try {
                    transfer.removeFromFilesProperty(filesArray);
                    transfer.removeFromCompleteFileData(filesArray);
                    removeFileHandles(filesArray);

                    if (typeof transfer.basicEventsSubscribedCallback === 'function') {
                        transfer.basicEventsSubscribedCallback(
                            transfer,
                            Signiant.Mst.filesDeletedEvent,
                            Signiant.Mst.messagesMap.getMessage('signiant.transfer.event.filesDeleted'),
                            filesArray
                        );
                    }

                    if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.filesDeletedEvent] === 'function') {
                        transfer.advancedEventCallbacksMap[Signiant.Mst.filesDeletedEvent](transfer, filesArray);
                    }

                } catch (e) {
                    Signiant.Mst.error('Failed to clear specified files, FAILURE: ' + e + transfer.getTransferIdTag());
                    throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.failedToClearFiles');
                }
            };

            transfer.setFiles = function (fileNameArray) {
                if (!Array.isArray(fileNameArray)) {
                    throw Signiant.Mst.messagesMap.getMessageForTransport('signiant.transfer.error.invalidListOfFiles');
                }

                transfer.setProperty(Signiant.Mst.Transfer.filesPropName, fileNameArray.join('\n'));
            };

            transfer.getFileSize = function (fileList, requestCallback) {
                requestCallback({
                    filelist: transfer.completeFileList
                });
            };

            transfer.handleFilesChosen = function (fileList) {
                transfer.fileHandles = [];
                transfer.completeFileList = [];
                for (var i = 0; i < fileList.length; i++) {
                    transfer.fileHandles.push(fileList[i]);
                    transfer.completeFileList.push(convertBrowserFileToTAPIFile(transfer.fileHandles[i]));
                }

                Signiant.Mst.log('uploadFilesChosen: ' + transfer.completeFileList + transfer.getTransferIdTag());

                if (typeof transfer.filesSelectedCallback === 'function') {
                    transfer.filesSelectedCallback(Signiant.Mst.uploadFilesChosenEvent, transfer.completeFileList, transfer);
                }

                if (typeof transfer.advancedEventCallbacksMap[Signiant.Mst.uploadFilesChosenEventName] === 'function') {
                    transfer.advancedEventCallbacksMap[Signiant.Mst.uploadFilesChosenEventName](transfer, transfer.completeFileList);
                }
            };


            function convertBrowserFileToTAPIFile (browserFile) {
                return {
                    path: browserFile.name,
                    name: browserFile.name,
                    size: String(browserFile.size),
                    isDirectory: false     // browserFile cannot be a directory
                };
            }

            function removeFileHandle (fileName) {
                if (!transfer.fileHandles) {
                    return;
                }

                for (var i = 0; i < transfer.fileHandles.length; i++) {
                    if (transfer.fileHandles[i].name === fileName) {
                        transfer.fileHandles.splice(0, 1);
                        return;
                    }
                }
            }

            function removeFileHandles (fileNames) {
                for (var i = 0; i < fileNames.length; i++) {
                    removeFileHandle(fileNames[i]);
                }
            }

            function computeTransferSize (transfer) {
                var size = 0;

                for (var x = 0 ; x < transfer.fileHandles.length ; x++) {
                    size += transfer.fileHandles[x].size;
                }

                return size;
            }

            function buildQueryString (messageChannelProvider) {
                var queryString = '?transferId=' + transfer.getTransferId();

                if (messageChannelProvider.getChannelParams() &&
                    messageChannelProvider.getChannelParams().channel &&
                    messageChannelProvider.getChannelParams().token) {
                    queryString += '&' +
                        'channelName=' + messageChannelProvider.getChannelParams().channel + '&' +
                        'channelToken=' + messageChannelProvider.getChannelParams().token;
                }

                return queryString;
            }

            function startUpload (transfer, transferUrl, messageChannelProvider) {
                return new Promise(function (resolve, reject) {
                    var uploadUrl = transferUrl + '/file';
                    var queryString = buildQueryString(messageChannelProvider);

                    var xmlhttp = new XMLHttpRequest();
                    xmlhttp.open('POST', uploadUrl + queryString, true);
                    xmlhttp.onreadystatechange = function () {
                        if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                            if (xmlhttp.status === 0 || xmlhttp.status === 200) {
                                resolve();
                            } else {
                                reject(xmlhttp.responseText);
                            }
                        }
                    };

                    var formData = new FormData();
                    // Transfer config must be before the file for the transfer service
                    formData.append('transferConfig', JSON.stringify(transfer.getTransferProperties()));
                    formData.append('size', computeTransferSize(transfer));
                    formData.append('file', transfer.fileHandles[0]);

                    xmlhttp.send(formData);
                    transfer.rawRequest = xmlhttp;
                });
            }

            return transfer;
        }
    };
})();
;// our "main" function
(function () {
    // Global Scope Objects
    Signiant.Mst.messagesMap = new Signiant.Mst.Messages();
    // Message handler Interface
    Signiant.Mst.signiantMessageChannel = void 0;
    Signiant.Mst.googleAnalytics = new Signiant.Mst.GoogleAnalytics();
})();;Signiant.Mst.SigAppInstallWidget = function (targetDomElement, options) {
    var transferApi;
    var target = targetDomElement;
    var googleAnalytics;
    var GoogleAnalyticsConstants = {
        category : {
            AppDetection : 'AppDetection'
        },
        action : {
            step0 : 'install-0-display-overlay',
            step1 : 'install-1-download-app',
            step2 : 'install-2-is-app-installed',
            step3 : 'install-3-verifying-install',
            step4 : 'install-4-app-installed',
            stepError : 'install-error-something-wrong'
        },
        label : {
            displayOverlay : 'display-overlay',
            iHaveTheApp : 'i-have-the-app',
            downloadTheApp : 'download-the-app',
            ihaveItInstalled : 'i-have-it-installed',
            tryAgain : 'try-again',
            dismiss : 'dismiss',
            autodismiss : 'auto-dismiss',
            displaySuccessOverlay: 'display-install-success-overlay',
            tryDownloadAgain : 'try-download-again',
            needHelp : 'need-help',
            selectNoClient: 'select-no-client'
        }
    };

    var cssUrl = 'https://updates.signiant.com/javascript-api/2.7.7/widgets/' +
        'appInstaller/signiantAppInstaller.css';

    var appVerificationDurationInMs = 60000;

    if (typeof options === 'undefined') {
        options = {};
    }

    // Transfer API namespace - so that we do not have to use global Signiant.Mst namespace to reference it
    if (typeof options.signiantNamespace !== 'undefined') {
        transferApi = options.signiantNamespace;
    } else {
        transferApi = Signiant.Mst;
    }

    // Default messages
    var messages = {
        launchApp: transferApi.messagesMap.getMessage
                            ('signiant.sigappinstallwidget.launchApp'),
        contactSupport: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.contactSupport'),
        dismissInstallAppWidget: transferApi.messagesMap.getMessage
                            ('signiant.sigappinstallwidget.dismissInstallAppWidget'),
        downloadAppButton: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.downloadAppButton'),
        downloadAppSuccess: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.downloadAppSuccess'),
        initialInstallFast: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.initialInstallFast'),
        initialInstallLessFast: transferApi.messagesMap.getMessage
                            ('signiant.sigappinstallwidget.initialInstallLessFast'),
        installAppInstructions: transferApi.messagesMap.getMessage
                            ('signiant.sigappinstallwidget.installAppInstructions'),
        learnMore: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.learnMore'),
        installAppSuccess: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.installAppSuccess'),
        installInstructionImageLbl: transferApi.messagesMap.getMessage
                            ('signiant.sigappinstallwidget.installInstructionImageLbl'),
        retryTestButton: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.retryTestButton'),
        testFailed: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.testFailed'),
        troubleDownloadingMsg: transferApi.messagesMap.getMessage
                            ('signiant.sigappinstallwidget.troubleDownloadingMsg'),
        tryDownloadAgain: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.tryDownloadAgain'),
        verifyingInstallation: transferApi.messagesMap.getMessage
                            ('signiant.sigappinstallwidget.verifyingInstallation'),
        verifyInstallationButton: transferApi.messagesMap.getMessage
                            ('signiant.sigappinstallwidget.verifyInstallationButton'),
        appVersion: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.appVersion'),
        forLabel: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.forLabel'),
        installHelpLabel: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.installHelpLabel'),
        installHelpLink: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.installHelpLink'),
        softwareUndesired: transferApi.messagesMap.getMessage('signiant.sigappinstallwidget.softwareUndesired')
    };

    // Override default messages with those provided by user
    if (typeof options.customMessages !== 'undefined') {
        overrideObjectAttributes(messages, options.customMessages);
    }

    // Location of CSS file
    if (typeof options.cssUrl !== 'undefined') {
        //We should allow for null here, in-case end user wants to have no CSS loaded
        cssUrl = options.cssUrl;
    }

    if (typeof options.googleAnalytics !== 'undefined') {
        googleAnalytics = new transferApi.GoogleAnalytics(options.googleAnalytics);
    }

    // Get the download links from Transfer API to try to use
    var downloadLinkPromise = transferApi.App.getDownloadLinks();

    // Attach install widget CSS to the current DOM
    linkInstallWidgetStylesheet(cssUrl);

    // Create the installer content parent div
    var getWidgetContainer = function () {
        var element = null;
        if (typeof target === 'string') {
            element = document.getElementById(target);
        } else if (target instanceof jQuery) {
            element = target[0];
        } else {
            element = target;
        }

        var widgetContainer = document.getElementById('mst-install-widget');
        if (null === widgetContainer) {
            widgetContainer = document.createElement('div');
            widgetContainer.setAttribute('class', 'mst-install-widget-app-install-overlay');
            widgetContainer.setAttribute('id', 'mst-install-widget');
            element.appendChild(widgetContainer);
        }
        return widgetContainer;
    };

    var setWidgetContainerContent = function (content) {
        var widgetContainer = getWidgetContainer();
        widgetContainer.innerHTML = content;
    };

    var hideInstallAppWidget = function () {
        var element = document.getElementById('mst-install-widget');
        if (null !== element && null !== element.parentNode)  {
            element.parentNode.removeChild(element);
        }
    };

    var step1 = {
        show: function () {
            sendGoogleAnalytics(GoogleAnalyticsConstants.action.step0, GoogleAnalyticsConstants.label.displayOverlay);
            downloadLinkPromise.then(function (downloadLinks) {
                setWidgetContainerContent(step1.getPromptInstallScreenContent(downloadLinks));
                document.getElementById('mst-install-widget-download-app-btn').onclick = function (){
                    sendGoogleAnalytics(GoogleAnalyticsConstants.action.step1,
                                                            GoogleAnalyticsConstants.label.downloadTheApp);
                    step2.show();
                };
                document.getElementById('mst-install-widget-app-installed-btn').onclick = function () {
                    sendGoogleAnalytics(GoogleAnalyticsConstants.action.step1,
                                                            GoogleAnalyticsConstants.label.iHaveTheApp);
                    step1.handleSigniantAppAlreadyInstalled();
                };
                document.getElementById('mst-install-widget-step1-need-help-link').onclick = function () {
                    sendGoogleAnalytics(GoogleAnalyticsConstants.action.step1,
                                                            GoogleAnalyticsConstants.label.needHelp);
                };
                if (typeof options.transferWithoutAppCallback === 'function') {
                    document.getElementById('mst-no-software-btn').onclick = function () {
                        sendGoogleAnalytics(GoogleAnalyticsConstants.action.step1,
                                                            GoogleAnalyticsConstants.label.selectNoClient);
                        step1.handleSoftwareUndesired();
                    };
                }
            });
        },

        getPromptInstallScreenContent: function (downloadLinks) {
            var downloadAppLink = '<div><a href="' + downloadLinks.recommended.url + '" class="mst-install-widget-btn ' +
                                    'mst-install-widget-btn-blue mst-install-widget-btn-lg" id="mst-install-widget-download-app-btn">'
                                    + messages.downloadAppButton + '</a></div>';
            var launchSigniantApp = '<div><a id="mst-install-widget-app-installed-btn">' + messages.launchApp + '</a></div>'
            return '<div class="mst-install-widget-app-install-content">' +
                        '<div class="mst-install-widget-header-message">' + messages.initialInstallFast + '</div>' +
                        '<div class="mst-install-widget-app-install-options">' +
                            downloadAppLink +
                            launchSigniantApp +
                        '</div>' +
                        step1.generateNCSHtml() +
                        '<div class="mst-install-widget-footer" id="mst-install-widget-step1-need-help-link">' +
                            '<a href="' + messages.installHelpLink + '" class="mst-install-widget-help-link" ' +
                                    'target="_blank">' + messages.installHelpLabel + '</a>' +
                        '</div>' +
                    '</div>';
        },

        generateNCSHtml: function () {
            if (typeof options.transferWithoutAppCallback === 'function') {
                return'<div>' + messages.initialInstallLessFast + '</div>';
            }

            return '';
        },
    
        handleSigniantAppAlreadyInstalled: function () {
            hideInstallAppWidget();
            if (typeof options.dismissInstallAppCallback === 'function') {
                options.dismissInstallAppCallback();
            }
        },

        handleSoftwareUndesired: function () {
            hideInstallAppWidget();
            if (typeof options.transferWithoutAppCallback === 'function') {
                options.transferWithoutAppCallback();
            }
        }

    };
    
    var step2 = {
        show: function () {
            downloadLinkPromise.then(function (downloadLinks) {
                setWidgetContainerContent(step2.downloadSigniantAppSuccessScreen(downloadLinks));
                document.getElementById('mst-install-widget-step2-need-help-link').onclick = function () {
                    sendGoogleAnalytics(GoogleAnalyticsConstants.action.step2,GoogleAnalyticsConstants.label.needHelp);
                };
                document.getElementById('mst-install-widget-try-download-again').onclick = function () {
                    sendGoogleAnalytics(GoogleAnalyticsConstants.action.step2,
                                GoogleAnalyticsConstants.label.tryDownloadAgain);
                };
                step2.setupTestButton();
            });
        },
        
        downloadSigniantAppSuccessScreen: function (downloadLinks) {
            return '<div class="mst-install-widget-app-post-install-content">' +
                    '<div class="mst-install-widget-verify top">' +
                        '<div class="mst-install-widget-message-medium">' +
                            messages.troubleDownloadingMsg + ' ' +
                            '<a href="' + downloadLinks.recommended.url +
                            '" id="mst-install-widget-try-download-again">' + messages.tryDownloadAgain + '</a>' +
                        '</div>' +
                    '</div>' +
                    '<div class="mst-install-widget-verify middle">' +
                        '<div class="mst-install-widget-install-app-suggestions mst-install-widget-centered">' +
                            '<div class="mst-install-widget-install-app-suggestions-lbl">' +
                                '<span class="mst-install-widget-header-message">' +
                                    messages.installInstructionImageLbl +
                                '</span>' +
                            '</div>' +
                            '<div class="mst-install-widget-install-app-suggestions-img-' +
                                transferApi.Environment.getOSFamily() + ' mst-install-widget-centered"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="mst-install-widget-verify bottom">' +
                        '<div class="mst-install-widget-app-verify-link" id="mst-install-widget-test">' +
                                                                messages.verifyInstallationButton + '</div>' +
                    '</div>' +
                    '<div class="mst-install-widget-footer" id="mst-install-widget-step2-need-help-link">' +
                        '<a href="' + messages.installHelpLink +
                '" class="mst-install-widget-help-link" target="_blank">' + messages.installHelpLabel + '</a>' +
                    '</div>' +
                '</div>';
        },
    
        /**
         * Setup the test button text and style(when coming back from a test call), and reattach the event handler
         */
        setupTestButton: function () {
            var testBtn = document.getElementById('mst-install-widget-test');
            testBtn.innerHTML = messages.verifyInstallationButton;
            testBtn.setAttribute('class', 'mst-install-widget-app-verify-link');
            testBtn.onclick = function (){
                sendGoogleAnalytics(GoogleAnalyticsConstants.action.step2,
                                        GoogleAnalyticsConstants.label.ihaveItInstalled);
                step3.show();
            };
        }
    };

    var step3 = {
        show: function () {
            setWidgetContainerContent(step3.buildVerifyingInstallationScreen());
            document.getElementById('mst-install-widget-step3-need-help-link').onclick = function () {
                sendGoogleAnalytics(GoogleAnalyticsConstants.action.step3,GoogleAnalyticsConstants.label.needHelp);
            };
            step3.testInstallation();
        },

        buildVerifyingInstallationScreen: function () {
            return '<div class="mst-install-widget-app-install-content">' +
                        '<div class="mst-install-widget-header-message">' + messages.verifyingInstallation +
                            '<div class="mst-install-widget-waiting mst-install-widget-centered"></div>' +
                        '</div>' +
                        '<progress id="mst-install-widget-verification-progress"' +
                                    'class="mst-widget-install-progress-discreet" value="0"></progress>' +
                        '<div class="mst-install-widget-footer" id="mst-install-widget-step3-need-help-link">' +
                            '<a href="' + messages.installHelpLink + '" ' +
                    'class="mst-install-widget-help-link" target="_blank">' + messages.installHelpLabel + '</a>' +
                        '</div>' +
                        '<div class="mst-install-widget-centered mst-install-widget-contact-support-message">' +
                            messages.contactSupport +
                        '</div>' +
                    '</div>';
        },

        /**
         * Run the initialize transfer API call to try and establish a connection.
         * On failure, show the user that the test failed and allow them to retry.
         * On success, show the install succesfull screen
         */
        testInstallation: function () {
            step3.startProgressBar(appVerificationDurationInMs);
            transferApi.initialize(
                step4.show,
                stepError.show,
                {
                    timeout: appVerificationDurationInMs,
                    withAppTimeout: appVerificationDurationInMs
                });
        },

        startProgressBar: function (time) {
            var value = 0;
            var stepSize = 1000;

            step3.animateProgress = setInterval(function () {
                step3.updateProgressBar(time, value += stepSize);
            }, stepSize);
        },

        updateProgressBar: function (maxValue, currentValue) {
            var progress = document.getElementById('mst-install-widget-verification-progress');
            var nextValue = currentValue / maxValue;

            if (progress !== null) {
                progress.value = nextValue;
            }

            if (nextValue >= 1 || progress === null) {
                clearTimeout(step3.animateProgress);
            }
        }
    };

    var step4 = {

        show: function () {
            sendGoogleAnalytics(GoogleAnalyticsConstants.action.step4, GoogleAnalyticsConstants.label.displaySuccessOverlay);
            setWidgetContainerContent(step4.buildInstallationSuccessfulScreen());
            step4.dismissTimer = setTimeout(function () {
                sendGoogleAnalytics(GoogleAnalyticsConstants.action.step4, GoogleAnalyticsConstants.label.autodismiss);
                step4.handleInstallAppComplete();
            }, 10000);
            document.getElementById('mst-install-widget-dismiss-widget-btn').onclick = function(){
                sendGoogleAnalytics(GoogleAnalyticsConstants.action.step4, GoogleAnalyticsConstants.label.dismiss);
                step4.handleInstallAppComplete();
            };
        },
    
        buildInstallationSuccessfulScreen: function () {
            return '<div class="mst-install-widget-app-install-content">' +
                '<div class="mst-install-widget-header-message">' + messages.installAppSuccess + '</div>' +
                '<div id="mst-install-widget-dismiss-widget-btn" class="mst-install-widget-clickable ' +
                                    'mst-install-widget-message-medium">' + messages.dismissInstallAppWidget +
                '</div>' +
                '</div>';
        },
        
        handleInstallAppComplete: function () {
            if (null !== step4.dismissTimer) {
                clearTimeout(step4.dismissTimer);
            }
            hideInstallAppWidget();
            if (typeof options.installAppCompleteCallback === 'function') {
                options.installAppCompleteCallback();
            }
        }
        
    };

    var stepError = {
        show: function () {
            setWidgetContainerContent(stepError.buildAppVerificationErrorScreen());
            document.getElementById('mst-install-widget-retry-verification').onclick = function (){
                sendGoogleAnalytics(GoogleAnalyticsConstants.action.stepError,GoogleAnalyticsConstants.label.tryAgain);
                step2.show();
            };
            document.getElementById('mst-install-widget-stepError-need-help-link').onclick = function () {
                sendGoogleAnalytics(GoogleAnalyticsConstants.action.stepError,GoogleAnalyticsConstants.label.needHelp);
            };
        },

        buildAppVerificationErrorScreen: function () {
            return '<div class="mst-install-widget-app-install-content">' +
                '<div class="mst-install-widget-header-message">' + messages.testFailed + '</div>' +
                '<div class="mst-install-widget-btn mst-install-widget-btn-blue mst-install-widget-btn-lg ' +
                            'mst-install-widget-btn-spaced" id="mst-install-widget-retry-verification">'
                + messages.retryTestButton + '</div>' +
                '<div class="mst-install-widget-footer" id="mst-install-widget-stepError-need-help-link">' +
                    '<a href="' + messages.installHelpLink + '" class="mst-install-widget-help-link" target="_blank">'+
                                        messages.installHelpLabel + '</a>' +
                '</div>' +
                '<div class="mst-install-widget-centered mst-install-widget-contact-support-message">' +
                messages.contactSupport +
                '</div>' +
                '</div>';
        }
    };
    
    /**
     * If attribute from 'original' exists in 'overrides',
     * replace original value with overriden value.
     */
    function overrideObjectAttributes (original, overrides) {
        Object.keys(original).forEach(function (key) {
            if (typeof overrides[key] !== 'undefined') {
                original[key] = overrides[key];
            }
        });
    }
    
    function linkInstallWidgetStylesheet (cssUrl) {
        if (cssUrl !== null) {
            var installWidgetStylesheet = document.createElement('link');
            installWidgetStylesheet.setAttribute('rel', 'stylesheet');
            installWidgetStylesheet.setAttribute('href', cssUrl);
            var head = document.getElementsByTagName('head')[0];
            if (null !== head.firstChild) {
                head.insertBefore(installWidgetStylesheet, head.firstChild);
            } else {
                head.appendChild(installWidgetStylesheet);
            }
        }
    }

    function sendGoogleAnalytics (action, label, value) {
        if (typeof googleAnalytics !== 'undefined') {
            googleAnalytics.sendEvent(GoogleAnalyticsConstants.category.AppDetection, action, label, value);
        }
    }
    
    var widget = {};
    widget.showInstallerWindow = step1.show;
    widget.step1 = step1;
    widget.step2 = step2;
    widget.step3 = step3;
    widget.step4 = step4;
    widget.stepError = stepError;
    return widget;
};;/**
 The detectPlugin global function should no longer be used.
 It currently runs through a flow to get the user up and running
 with the Signiant App. It is only included here to provide
 backward-compatibility with existing customers.
 */

/**
 * callbacks: success
 *            error
 *            downloadViewShown
 *            googleAnalytics
 * allowOptionalPluginUpgradeFlag: Previously used to indicate
 *  if we should try to update their plugin. No longer used anywhere.
 */
detectPlugin = function (callbacks, allowOptionalPluginUpgradeFlag) { // eslint-disable-line no-unused-vars
    var googleAnalytics;
    
    if (callbacks) {
        if (callbacks.success && typeof callbacks.success === 'function') {
            Signiant.Mst.detectPluginSuccess = callbacks.success;
        }
        if (callbacks.error && typeof callbacks.error === 'function') {
            Signiant.Mst.detectPluginError = callbacks.error;
        }
        if (callbacks.downloadViewShown && typeof callbacks.downloadViewShown === 'function') {
            Signiant.Mst.detectPluginDownloadViewShown = callbacks.downloadViewShown;
        }
        if (typeof callbacks.googleAnalytics !== 'undefined') {
            googleAnalytics = callbacks.googleAnalytics;
        }
    }

    var retryInitialize = function () {
        Signiant.Mst.initialize(Signiant.Mst.detectPluginSuccess, failure, {
            timeout: 20000,
            googleAnalytics : googleAnalytics
        });
    };

    var failure = function () {
        var options = {
            dismissInstallAppCallback: retryInitialize,
            installAppCompleteCallback: Signiant.Mst.detectPluginSuccess,
            cssUrl: Signiant.Mst.configuration.installWidgetCss,
            googleAnalytics : googleAnalytics
        };
        var installAppWidgetDivId = 'mst-install-app-widget';
        var installAppWidgetDiv = document.getElementById(installAppWidgetDivId);
        if (installAppWidgetDiv === null) {
            installAppWidgetDiv = document.createElement('div');
            installAppWidgetDiv.id = 'mst-install-app-widget';
            document.body.appendChild(installAppWidgetDiv);
        }
        var widget = new Signiant.Mst.SigAppInstallWidget(installAppWidgetDivId, options);
        widget.showInstallerWindow();
        if (typeof Signiant.Mst.detectPluginDownloadViewShown === 'function') {
            Signiant.Mst.detectPluginDownloadViewShown();
        }
    };

    Signiant.Mst.initialize(Signiant.Mst.detectPluginSuccess, failure, {
        failPreemptivelyIfAppNotInstalled: true,
        googleAnalytics : googleAnalytics
    });
};